
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("C9t7g", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $eSUdr = parcelRequire("eSUdr");


var $inPa6 = parcelRequire("inPa6");


var $5izcQ = parcelRequire("5izcQ");


var $9kbAI = parcelRequire("9kbAI");


var $eYEH3 = parcelRequire("eYEH3");


var $hHhbz = parcelRequire("hHhbz");

var $gHaxX = parcelRequire("gHaxX");


var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $lAFHW = parcelRequire("lAFHW");


var $culkJ = parcelRequire("culkJ");





var $8C5kA = parcelRequire("8C5kA");


var $dh538 = parcelRequire("dh538");

const $b3ea6dd191ed3e50$export$7613f0bd7ffe380c = (icon, label, fallbackUrl, options)=>{
    const { labelElem: labelElem, apsKey: apsKey, ref: ref, analyticsName: analyticsName, menuItemId: menuItemId } = options ?? {};
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return (0, $42omo.useMemo)(()=>({
            type: 'link',
            icon: icon,
            label: formatMessage(label),
            labelElem: labelElem,
            apsKey: apsKey,
            fallbackUrl: fallbackUrl,
            ref: ref,
            analyticsName: analyticsName,
            ...(0, $dh538.fg)('navx-515-l1-dnd-support') ? {
                menuItemId: menuItemId
            } : {}
        }), [
        apsKey,
        fallbackUrl,
        formatMessage,
        icon,
        label,
        labelElem,
        ref,
        analyticsName,
        menuItemId
    ]);
};



var $cgtv4 = parcelRequire("cgtv4");

const $614604228efdb790$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    label: {
        id: "navigation.global-shortcuts.apps.jira",
        defaultMessage: "Jira"
    }
});


const $e306a0f1948559b4$var$icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.JiraIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true
});
const $e306a0f1948559b4$export$b34e755010aed2b2 = (fallbackUrl, options = {})=>(0, $b3ea6dd191ed3e50$export$7613f0bd7ffe380c)($e306a0f1948559b4$var$icon, (0, $614604228efdb790$export$defe85febe8b728c).label, fallbackUrl, {
        apsKey: (0, $culkJ.Products).JIRA_SOFTWARE,
        analyticsName: (0, $culkJ.Products).JIRA_SOFTWARE,
        ...options
    });


/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $fFa3V = parcelRequire("fFa3V");


var $gtD4K = parcelRequire("gtD4K");


var $2Pg7f = parcelRequire("2Pg7f");


var $2Nwuj = parcelRequire("2Nwuj");


var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");

const $0968601a95585f25$export$b503daf34075584 = [
    'jira',
    'confluence'
];
const $0968601a95585f25$export$cebe16b091a89fcc = [
    'JIRA_SOFTWARE',
    'CONFLUENCE'
];





const $8640c6d7c63a6659$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    invitedLozenge: {
        id: "cross-join-nudges.invited-app-shortcuts.invited-lozenge",
        defaultMessage: "Invited"
    },
    popupMainTextWithCollaborators: {
        id: "cross-join-nudges.invited-app-shortcuts.popup-main-text-with-collaborators",
        defaultMessage: "You're invited to join your team"
    },
    popupMainTextWithoutCollaborators: {
        id: "cross-join-nudges.invited-app-shortcuts.popup-main-text-without-collaborators",
        defaultMessage: "Don't lose access, accept invite now"
    },
    popupAcceptInviteButton: {
        id: "cross-join-nudges.invited-app-shortcuts.popup-accept-invite-button",
        defaultMessage: "Accept invite"
    },
    popupCollaboratorsTooltip: {
        id: "cross-join-nudges.invited-app-shortcuts.popup-collaborators-tooltip",
        defaultMessage: "{numberOfCollaborators} more {numberOfCollaborators, plural, one {teammate} other {teammates}} are using {app}"
    },
    jira: {
        id: "cross-join-nudges.invited-app-shortcuts.jira",
        defaultMessage: "Jira"
    },
    confluence: {
        id: "cross-join-nudges.invited-app-shortcuts.confluence",
        defaultMessage: "Confluence"
    }
});



const $511e8e2f0dc221c0$export$f45e7800f1f61594 = (apsKey)=>{
    if (!apsKey) return false;
    return (0, $0968601a95585f25$export$cebe16b091a89fcc).includes(apsKey);
};
const $511e8e2f0dc221c0$export$b8c071b2cc567f75 = (apsKey)=>{
    switch(apsKey){
        case 'JIRA_SOFTWARE':
            return 'jira';
        case 'CONFLUENCE':
            return 'confluence';
        default:
            // This should never happen, throw it just in case if we add a new APS key without adding a new app key
            throw new Error(`Invalid APS key: ${apsKey}`);
    }
};





const $65ddfdee4001ff48$export$a5c3144306783a42 = /*#__PURE__*/ (0, $42omo.createContext)({
    impressedProducts: {
        JIRA_SOFTWARE: false,
        CONFLUENCE: false
    }
});






var $3pfAb = parcelRequire("3pfAb");




const $8e76a58f4a588ff2$export$85183a312807388d = (0, $3pfAb.FabricChannel).growth;
const $8e76a58f4a588ff2$export$43a7f5e28cb0f314 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isViewedInvitedAppShortcutsFired = (0, $42omo.useRef)(false);
    /**
	 * Fire an analytics event when the user views the invited app shortcuts.
	 */ const fireViewedInvitedAppShortcuts = (0, $42omo.useCallback)((apps)=>{
        if (isViewedInvitedAppShortcutsFired.current) return;
        createAnalyticsEvent({
            eventType: 'screen',
            name: 'invitedAppShortcuts',
            attributes: {
                apps: apps
            }
        }).fire($8e76a58f4a588ff2$export$85183a312807388d);
        isViewedInvitedAppShortcutsFired.current = true;
    }, [
        createAnalyticsEvent
    ]);
    const fireViewedInvitedAppShortcutPopup = (0, $42omo.useCallback)(({ app: app, collaborators: collaborators })=>{
        createAnalyticsEvent({
            eventType: 'screen',
            name: 'invitedAppShortcutPopup',
            attributes: {
                app: app,
                collaborators: collaborators
            }
        }).fire($8e76a58f4a588ff2$export$85183a312807388d);
    }, [
        createAnalyticsEvent
    ]);
    const fireLinkClickedAcceptInvite = (0, $42omo.useCallback)(({ app: app })=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'acceptInvite',
            attributes: {
                app: app
            }
        }).fire($8e76a58f4a588ff2$export$85183a312807388d);
    }, [
        createAnalyticsEvent
    ]);
    const fireViewedMoreCollaboratorsTooltip = (0, $42omo.useCallback)(({ app: app, collaborators: collaborators })=>{
        createAnalyticsEvent({
            eventType: 'screen',
            name: 'moreCollaboratorsTooltip',
            attributes: {
                app: app,
                collaborators: collaborators
            }
        }).fire($8e76a58f4a588ff2$export$85183a312807388d);
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireViewedInvitedAppShortcuts: fireViewedInvitedAppShortcuts,
        fireViewedInvitedAppShortcutPopup: fireViewedInvitedAppShortcutPopup,
        fireLinkClickedAcceptInvite: fireLinkClickedAcceptInvite,
        fireViewedMoreCollaboratorsTooltip: fireViewedMoreCollaboratorsTooltip
    };
};


/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gMc0m = parcelRequire("gMc0m");







var $3gadb = parcelRequire("3gadb");

var $afneb = parcelRequire("afneb");




const $a9b6255e0132bb39$var$styles = {
    root: "_2rkofajl _11c8dcr7 _vchhusvi _p12f1mjv _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna"
}; /**
    * As truncate is deprecated, we need to use a custom tooltip component to ensure the tooltip can show the message in one line.
    */ 
const $a9b6255e0132bb39$var$CustomTooltip = /*#__PURE__*/ (0, $42omo.forwardRef)(function CustomTooltip({ children: children, className: className, ...rest }, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $afneb.default), {
        ...rest,
        // The passed classname is mostly used for integration testing (`.Tooltip`)
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $gMc0m.default)([
            $a9b6255e0132bb39$var$styles.root,
            className
        ]),
        ref: ref,
        testId: "invited-app-collaborators-tooltip",
        children: children
    });
});
const $a9b6255e0132bb39$export$cb6b49c74b6579bc = ({ children: children, currentApsKey: currentApsKey, currentAppCollaborators: currentAppCollaborators })=>{
    const { fireViewedMoreCollaboratorsTooltip: fireViewedMoreCollaboratorsTooltip } = (0, $8e76a58f4a588ff2$export$43a7f5e28cb0f314)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const appMessage = (0, $42omo.useMemo)(()=>{
        switch(currentApsKey){
            case 'JIRA_SOFTWARE':
                return (0, $8640c6d7c63a6659$export$defe85febe8b728c).jira;
            case 'CONFLUENCE':
                return (0, $8640c6d7c63a6659$export$defe85febe8b728c).confluence;
        }
    }, [
        currentApsKey
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        position: "right",
        component: $a9b6255e0132bb39$var$CustomTooltip,
        onShow: ()=>fireViewedMoreCollaboratorsTooltip({
                app: (0, $511e8e2f0dc221c0$export$b8c071b2cc567f75)(currentApsKey),
                collaborators: currentAppCollaborators.length
            }),
        content: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $8640c6d7c63a6659$export$defe85febe8b728c).popupCollaboratorsTooltip,
            values: {
                numberOfCollaborators: currentAppCollaborators.length - 1,
                app: formatMessage(appMessage)
            }
        }),
        children: children
    });
};


/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 








var $7sObp = parcelRequire("7sObp");





var $jTxSS = parcelRequire("jTxSS");


var $hTKp4 = parcelRequire("hTKp4");



const $5acee1e1684ee9fc$var$OFFSET_TO_THE_RIGHT_OF_ITEM = 30;
const $5acee1e1684ee9fc$var$OFFSET_FROM_BOTTOM_OF_VIEWPORT = 5;
const $5acee1e1684ee9fc$var$ESCAPE_KEY = 'Escape'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $5acee1e1684ee9fc$var$PopupWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { top: top, left: left, isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1vj9tq": (0, $7sObp.default)(__cmplp.top, "px"),
            "--_lr32lc": (0, $7sObp.default)(__cmplp.left, "px")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1mok _154i1ter _1ltv1rza _kqsw1n9t _1pbyyi3g _16qs130s",
            __cmplp.isVisible ? "_3um0ewfl" : "_3um015vq",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $5acee1e1684ee9fc$var$Card = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasCollaborators: hasCollaborators, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itia51 _2rko1mok _kqswh2mm _bfhkvuon _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.hasCollaborators ? "_1bsb1178" : "_1bsbp3fh",
            __cmplp.className
        ])
    });
});
const $5acee1e1684ee9fc$export$872e174e62e92fd = ({ children: children, currentApsKey: currentApsKey, currentAppCollaborators: currentAppCollaborators, onMouseEnterPopup: onMouseEnterPopup, onMouseLeavePopup: onMouseLeavePopup, trigger: trigger })=>{
    const { fireViewedInvitedAppShortcutPopup: fireViewedInvitedAppShortcutPopup } = (0, $8e76a58f4a588ff2$export$43a7f5e28cb0f314)();
    const [popupPosition, setPopupPosition] = (0, $42omo.useState)({
        top: -1000,
        left: -1000,
        height: 0
    });
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const hasCollaborators = currentAppCollaborators.length > 0;
    const popupContainerCallbackRef = (0, $42omo.useCallback)((element)=>{
        const document1 = (0, $hTKp4.getDocument)();
        if (element && trigger.current && document1) {
            const popupClientRect = element.getBoundingClientRect();
            const triggerClientRect = trigger.current?.getBoundingClientRect();
            let top = triggerClientRect.top - popupClientRect.height / 2 + triggerClientRect.height / 2; // Check if the rendered popup would be cut off at the bottom and reposition upwards
            const bottom = top + popupClientRect.height;
            const boundaryY = document1.documentElement.clientHeight;
            if (bottom >= boundaryY) top = top - (bottom - boundaryY) - $5acee1e1684ee9fc$var$OFFSET_FROM_BOTTOM_OF_VIEWPORT;
            setPopupPosition({
                top: top,
                left: triggerClientRect.right + $5acee1e1684ee9fc$var$OFFSET_TO_THE_RIGHT_OF_ITEM,
                height: popupClientRect.height
            });
            setIsVisible(true);
        }
    }, [
        trigger
    ]);
    const handleEscKeyPress = (0, $42omo.useCallback)((e)=>{
        if (e.key === $5acee1e1684ee9fc$var$ESCAPE_KEY) onMouseLeavePopup();
    }, [
        onMouseLeavePopup
    ]);
    (0, $42omo.useEffect)(()=>{
        // Ensure the component is cleaned up when pressing escape key
        const document1 = (0, $hTKp4.getDocument)();
        const unbind = document1 ? (0, $fFa3V.bind)(document1, {
            type: 'keydown',
            listener: handleEscKeyPress
        }) : ()=>{};
        return ()=>unbind();
    }, [
        handleEscKeyPress
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isVisible) fireViewedInvitedAppShortcutPopup({
            app: (0, $511e8e2f0dc221c0$export$b8c071b2cc567f75)(currentApsKey),
            collaborators: currentAppCollaborators.length
        });
    }, [
        isVisible,
        fireViewedInvitedAppShortcutPopup,
        currentApsKey,
        currentAppCollaborators.length
    ]);
    return trigger.current ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, $l998X.jsx)("div", {
        onMouseEnter: onMouseEnterPopup,
        onFocus: onMouseEnterPopup,
        onMouseLeave: onMouseLeavePopup,
        onBlur: onMouseLeavePopup,
        children: /*#__PURE__*/ (0, $l998X.jsx)($5acee1e1684ee9fc$var$PopupWrapper, {
            "data-testid": "invited-app-popup",
            role: "tooltip",
            top: popupPosition.top,
            left: popupPosition.left,
            isVisible: isVisible,
            children: /*#__PURE__*/ (0, $l998X.jsx)($5acee1e1684ee9fc$var$Card, {
                ref: popupContainerCallbackRef,
                hasCollaborators: hasCollaborators,
                children: children
            })
        })
    }), document.body) : null;
};


/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $5nBzc = parcelRequire("5nBzc");





/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 











const $cc078a6e6fa955bc$var$PHASE_1_DURATION_MS = 400; // Phase 1: Grow from 0 to 100% (stretching from left to right)
const $cc078a6e6fa955bc$var$PHASE_2_DURATION_MS = 600; // Phase 2: Shrink from 100% to content width (edge moving from left to right)
const $cc078a6e6fa955bc$var$PHASE_3_DURATION_MS = 600; // Phase 3: Width stays at content width, isBold transitions to false
const $cc078a6e6fa955bc$var$PHASE_2_TRANSITION_DELAY_MS = 1; // Delay before phase 2 transition starts
const $cc078a6e6fa955bc$var$PHASE_3_BOLD_TRANSITION_DELAY_MS = 6; // Delay before isBold transitions to false in phase 3
const $cc078a6e6fa955bc$var$WIDTH_MEASUREMENT_BUFFER_PX = 2; // Buffer added to measured width to prevent truncation
// Animation timing function constants
const $cc078a6e6fa955bc$var$PHASE_1_TIMING_FUNCTION = 'cubic-bezier(0.6, 0.01, 0.8, 0.6)'; // Phase 1 easing curve
const $cc078a6e6fa955bc$var$PHASE_2_TIMING_FUNCTION = 'cubic-bezier(0.33, 1, 0.68, 1)'; // Phase 2 easing curve
// Total animation time: PHASE_1_DURATION_MS + PHASE_2_DURATION_MS + PHASE_3_DURATION_MS
const $cc078a6e6fa955bc$var$DEFAULT_INITIAL_ANIMATION_DELAY = 2000; // ms - default delay before animation starts
const $cc078a6e6fa955bc$var$widthAnimationPhase1 = null;
const $cc078a6e6fa955bc$var$styles = {
    wrapper: "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1osq _1ul9idpf _1wpz1fhb",
    wrapperPhase1: "_1bah1y6m",
    wrapperPhase2: "_1bahesu3",
    animatedContainer: "_1reo15vq _18m915vq _1bsbidpf _1e0c1txw",
    animatedContainerHidden: "_tzy4idpf _3um015vq",
    animatedContainerAnimating: "_y44v11pi",
    animatedContainerPhase2Start: "_y44vglyw _1bsb1osq",
    animatedContainerPhase2: "_v5641lto _1bsbmezn",
    animatedContainerPhase3: "_1bsbmezn",
    animatedContainerComplete: "_1bsb1wug"
};
const $cc078a6e6fa955bc$var$AnimatedLozenge = /*#__PURE__*/ (0, $42omo.memo)(({ children: children, testId: testId, appearance: appearance = 'default', initialAnimationDelay: initialAnimationDelay = $cc078a6e6fa955bc$var$DEFAULT_INITIAL_ANIMATION_DELAY, style: style })=>{
    const [phase, setPhase] = (0, $42omo.useState)('phase1');
    const [contentWidth, setContentWidth] = (0, $42omo.useState)(null);
    const [isReadyToAnimate, setIsReadyToAnimate] = (0, $42omo.useState)(false);
    const [shouldTransitionBold, setShouldTransitionBold] = (0, $42omo.useState)(false);
    const [shouldStartPhase2Transition, setShouldStartPhase2Transition] = (0, $42omo.useState)(false);
    const [hasStartedAnimation, setHasStartedAnimation] = (0, $42omo.useState)(false);
    const animatedContainerRef = (0, $42omo.useRef)(null);
    const lozengeWrapperRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        // Measure the natural content width after initial render
        requestAnimationFrame(()=>{
            if (lozengeWrapperRef.current) {
                // Find the Lozenge's first span element
                const lozengeSpan = lozengeWrapperRef.current.querySelector('span');
                if (lozengeSpan) {
                    // Temporarily remove all width constraints to measure natural width
                    const originalWidth = lozengeSpan.style.width;
                    const originalMaxWidth = lozengeSpan.style.maxWidth;
                    const originalDisplay = lozengeSpan.style.display;
                    const originalPosition = lozengeSpan.style.position;
                    const originalVisibility = lozengeSpan.style.visibility;
                    const originalTop = lozengeSpan.style.top;
                    const originalLeft = lozengeSpan.style.left; // Temporarily move off-screen and remove ALL constraints
                    lozengeSpan.style.position = 'absolute';
                    lozengeSpan.style.visibility = 'hidden';
                    lozengeSpan.style.width = 'auto';
                    lozengeSpan.style.maxWidth = 'none';
                    lozengeSpan.style.display = 'inline-flex';
                    lozengeSpan.style.top = '-9999px';
                    lozengeSpan.style.left = '-9999px';
                    lozengeSpan.style.minWidth = 'auto'; // Remove maxWidth from inner text span
                    const textSpan = lozengeSpan.querySelector('span');
                    const originalTextMaxWidth = textSpan?.style.maxWidth || '';
                    const originalTextWidth = textSpan?.style.width || '';
                    const originalTextMinWidth = textSpan?.style.minWidth || '';
                    if (textSpan) {
                        textSpan.style.maxWidth = 'none';
                        textSpan.style.width = 'auto';
                        textSpan.style.minWidth = 'auto';
                    } // Force reflow multiple times to ensure styles are applied
                    lozengeSpan.offsetHeight;
                    textSpan?.offsetHeight;
                    lozengeSpan.offsetHeight;
                    textSpan?.offsetHeight; // Measure using scrollWidth to get the full content width (including any overflow)
                    // Use the maximum of scrollWidth and offsetWidth to ensure we get the full width
                    // Add a small buffer to account for rounding errors and ensure no truncation
                    const measuredWidth = Math.max(lozengeSpan.scrollWidth, lozengeSpan.offsetWidth, textSpan ? Math.max(textSpan.scrollWidth, textSpan.offsetWidth) : 0);
                    const naturalWidth = Math.ceil(measuredWidth) + $cc078a6e6fa955bc$var$WIDTH_MEASUREMENT_BUFFER_PX; // Restore original styles
                    lozengeSpan.style.width = originalWidth;
                    lozengeSpan.style.maxWidth = originalMaxWidth;
                    lozengeSpan.style.display = originalDisplay;
                    lozengeSpan.style.position = originalPosition;
                    lozengeSpan.style.visibility = originalVisibility;
                    lozengeSpan.style.top = originalTop;
                    lozengeSpan.style.left = originalLeft;
                    lozengeSpan.style.minWidth = '';
                    if (textSpan) {
                        textSpan.style.maxWidth = originalTextMaxWidth;
                        textSpan.style.width = originalTextWidth;
                        textSpan.style.minWidth = originalTextMinWidth;
                    }
                    setContentWidth(naturalWidth);
                    setIsReadyToAnimate(true);
                }
            }
        });
    }, []);
    (0, $42omo.useEffect)(()=>{
        // Only start animation once we have measured the content width
        if (!isReadyToAnimate) return;
         // Hide lozenge during initial delay
        const initialDelayTimer = setTimeout(()=>{
            setHasStartedAnimation(true);
        }, initialAnimationDelay); // Initial delay: configurable before animation starts
        // Phase 1: 0% to 100% (first PHASE_1_DURATION_MS)
        // Phase 2: 100% to content width (next PHASE_2_DURATION_MS + PHASE_2_TRANSITION_DELAY_MS delay)
        // Phase 3: Width stays at content width, isBold transitions to false (next PHASE_3_DURATION_MS + PHASE_3_BOLD_TRANSITION_DELAY_MS delay)
        // Complete: Animation finished
        // Total animation time: initialAnimationDelay + PHASE_1_DURATION_MS + PHASE_2_DURATION_MS + PHASE_3_DURATION_MS
        const phase1Timer = setTimeout(()=>{
            setPhase('phase2'); // Use requestAnimationFrame to ensure animation has completed before starting transition
            requestAnimationFrame(()=>{
                setShouldStartPhase2Transition(true);
            });
        }, initialAnimationDelay + $cc078a6e6fa955bc$var$PHASE_1_DURATION_MS);
        const phase2Timer = setTimeout(()=>{
            setPhase('phase3'); // Wait PHASE_3_BOLD_TRANSITION_DELAY_MS after phase3 starts before transitioning isBold (to match the transition delay)
            setTimeout(()=>{
                setShouldTransitionBold(true);
            }, $cc078a6e6fa955bc$var$PHASE_3_BOLD_TRANSITION_DELAY_MS);
        }, initialAnimationDelay + $cc078a6e6fa955bc$var$PHASE_1_DURATION_MS + $cc078a6e6fa955bc$var$PHASE_2_DURATION_MS);
        const phase3Timer = setTimeout(()=>{
            setPhase('complete');
        }, initialAnimationDelay + $cc078a6e6fa955bc$var$PHASE_1_DURATION_MS + $cc078a6e6fa955bc$var$PHASE_2_DURATION_MS + $cc078a6e6fa955bc$var$PHASE_3_DURATION_MS);
        return ()=>{
            clearTimeout(initialDelayTimer);
            clearTimeout(phase1Timer);
            clearTimeout(phase2Timer);
            clearTimeout(phase3Timer);
        };
    }, [
        isReadyToAnimate,
        initialAnimationDelay
    ]);
    const currentAppearance = phase === 'phase1' || phase === 'phase2' ? 'inprogress' : appearance; // Keep isBold true until width animation has settled (300ms into phase3)
    const currentIsBold = !shouldTransitionBold;
    const isAnimatingPhase1 = phase === 'phase1' && isReadyToAnimate;
    const contentWidthPx = contentWidth !== null ? `${contentWidth}px` : undefined; // Force Lozenge to stretch during phase 1 and shrink during phase 2 by directly modifying its first span element
    (0, $42omo.useEffect)(()=>{
        if (!hasStartedAnimation) return;
        const lozengeSpan = lozengeWrapperRef.current?.querySelector('span');
        if (!lozengeSpan) return;
        if (phase === 'phase1' && isAnimatingPhase1) {
            // Phase 1: Stretch Lozenge to wrapper width
            // Remove maxWidth constraints to prevent truncation
            lozengeSpan.style.maxWidth = 'none';
            const textSpan = lozengeSpan.querySelector('span');
            if (textSpan) textSpan.style.maxWidth = 'none';
            let animationFrameId;
            const updateLozengeWidth = ()=>{
                if (animatedContainerRef.current) {
                    const wrapperElement = animatedContainerRef.current.parentElement;
                    const wrapperWidth = wrapperElement?.offsetWidth || 0;
                    if (wrapperWidth > 0) {
                        lozengeSpan.style.width = `${wrapperWidth}px`;
                        lozengeSpan.style.display = 'flex';
                    }
                } // Continue updating while in phase 1
                if (phase === 'phase1' && isAnimatingPhase1) animationFrameId = requestAnimationFrame(updateLozengeWidth);
            };
            animationFrameId = requestAnimationFrame(updateLozengeWidth);
            return ()=>{
                if (animationFrameId) cancelAnimationFrame(animationFrameId);
            };
        } else if (phase === 'phase2') // Phase 2: Transition from wrapper width to content width, right-aligned
        {
            if (contentWidth !== null && animatedContainerRef.current) {
                const wrapperElement = animatedContainerRef.current.parentElement;
                const wrapperWidth = wrapperElement?.offsetWidth || 0; // Remove maxWidth constraints to prevent truncation
                lozengeSpan.style.maxWidth = 'none';
                const textSpan = lozengeSpan.querySelector('span');
                if (textSpan) textSpan.style.maxWidth = 'none';
                 // Set initial width to wrapper width (from phase 1) and ensure right alignment
                lozengeSpan.style.width = `${wrapperWidth}px`;
                lozengeSpan.style.display = 'flex';
                lozengeSpan.style.marginLeft = 'auto'; // Use requestAnimationFrame to ensure the initial width is set before transition
                requestAnimationFrame(()=>{
                    // Transition to content width (shrinks from left to right)
                    lozengeSpan.style.transition = `width ${$cc078a6e6fa955bc$var$PHASE_2_DURATION_MS}ms ${$cc078a6e6fa955bc$var$PHASE_2_TIMING_FUNCTION} ${$cc078a6e6fa955bc$var$PHASE_2_TRANSITION_DELAY_MS}ms`;
                    lozengeSpan.style.width = `${contentWidth}px`;
                });
            }
        } else if (phase === 'phase3' || phase === 'complete') // Phase 3 and complete: Keep content width, remove transition, maintain right alignment
        {
            if (contentWidth !== null) {
                // Remove maxWidth constraints to prevent truncation
                lozengeSpan.style.maxWidth = 'none';
                const textSpan = lozengeSpan.querySelector('span');
                if (textSpan) textSpan.style.maxWidth = 'none';
                lozengeSpan.style.transition = '';
                lozengeSpan.style.width = `${contentWidth}px`;
                lozengeSpan.style.display = '';
                lozengeSpan.style.marginLeft = 'auto';
            }
        }
    }, [
        phase,
        isAnimatingPhase1,
        hasStartedAnimation,
        contentWidth
    ]);
    // CSS variables for dynamic values - must be set via style prop
    // Only set --content-width if we have a measured value
    const cssVariables = {
        ...contentWidthPx && {
            '--content-width': contentWidthPx
        },
        // Set animation delay dynamically when animating phase 1
        ...isAnimatingPhase1 && {
            animationDelay: `${initialAnimationDelay}ms`
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            $cc078a6e6fa955bc$var$styles.wrapper,
            phase === 'phase1' && $cc078a6e6fa955bc$var$styles.wrapperPhase1,
            (phase === 'phase2' || phase === 'phase3' || phase === 'complete') && $cc078a6e6fa955bc$var$styles.wrapperPhase2
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            ref: animatedContainerRef,
            style: cssVariables,
            className: (0, $gMc0m.default)([
                $cc078a6e6fa955bc$var$styles.animatedContainer,
                !hasStartedAnimation && $cc078a6e6fa955bc$var$styles.animatedContainerHidden,
                isAnimatingPhase1 && $cc078a6e6fa955bc$var$styles.animatedContainerAnimating,
                phase === 'phase2' && !shouldStartPhase2Transition && $cc078a6e6fa955bc$var$styles.animatedContainerPhase2Start,
                phase === 'phase2' && shouldStartPhase2Transition && $cc078a6e6fa955bc$var$styles.animatedContainerPhase2,
                phase === 'phase3' && $cc078a6e6fa955bc$var$styles.animatedContainerPhase3,
                phase === 'complete' && $cc078a6e6fa955bc$var$styles.animatedContainerComplete
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                ref: lozengeWrapperRef,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                    appearance: currentAppearance,
                    isBold: currentIsBold,
                    style: style,
                    testId: testId,
                    children: children
                })
            })
        })
    });
});
$cc078a6e6fa955bc$var$AnimatedLozenge.displayName = 'AnimatedLozenge';
var $cc078a6e6fa955bc$export$2e2bcd8739ae039 = $cc078a6e6fa955bc$var$AnimatedLozenge;


const $606c22c7c79fc55a$var$styles = {
    container: "_1e0c11p5 _yv0e5bpd _4cvr1h6o _1bsb1osq",
    lozengeContainer: "_1e0c1txw _1bahesu3 _4cvr1h6o _1ul9idpf"
};
const $606c22c7c79fc55a$export$f60dc2630a14000a = ({ label: label, apsKey: apsKey })=>{
    const { impressedProducts: impressedProducts } = (0, $42omo.useContext)((0, $65ddfdee4001ff48$export$a5c3144306783a42)); // TODO: replace the text with i18n messages from the PR https://bitbucket.org/atlassian/atlassian-frontend-monorepo/pull-requests/270365
    const lozengeText = 'Invited';
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        className: (0, $gMc0m.default)([
            $606c22c7c79fc55a$var$styles.container
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                children: label
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $606c22c7c79fc55a$var$styles.lozengeContainer
                ]),
                children: impressedProducts[apsKey] ? /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                    appearance: "inprogress",
                    children: lozengeText
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $cc078a6e6fa955bc$export$2e2bcd8739ae039), {
                    appearance: "new",
                    children: lozengeText
                })
            })
        ]
    });
};


const $eb94a7a15b9af3a3$export$a06354f64c80dd3d = ({ shortcutsConfig: shortcutsConfig, resolverResult: resolverResult, hoverDelayTimeMs: hoverDelayTimeMs = 300, excludeLastFromRefs: excludeLastFromRefs = 0, children: children })=>{
    const { fireViewedInvitedAppShortcuts: fireViewedInvitedAppShortcuts, fireLinkClickedAcceptInvite: fireLinkClickedAcceptInvite } = (0, $8e76a58f4a588ff2$export$43a7f5e28cb0f314)(); // the popup shown state
    const [isPopupShown, setIsPopupShown] = (0, $42omo.useState)(false);
    const closePopupTimerRef = (0, $42omo.useRef)(null); // refs for the shortcut items
    const jiraShortcutRef = (0, $42omo.useRef)(null);
    const confluenceShortcutRef = (0, $42omo.useRef)(null); // Store unbind functions for cleanup
    const unbindFunctionsRef = (0, $42omo.useRef)(new Map()); // Ref for the current shortcut item
    // the current shortcut item is unset when the popup is hidden after a delay
    const [currentShortcutRef, setCurrentShortcutRef] = (0, $42omo.useState)(); // map of the shortcut items to their refs
    const shortcutRefs = (0, $42omo.useMemo)(()=>({
            JIRA_SOFTWARE: jiraShortcutRef,
            CONFLUENCE: confluenceShortcutRef
        }), // Refs are stable, no dependencies needed
    []);
    const showPopup = (0, $42omo.useCallback)(()=>{
        setIsPopupShown(true);
    }, [
        setIsPopupShown
    ]);
    const hidePopup = (0, $42omo.useCallback)(()=>{
        setIsPopupShown(false);
        setCurrentShortcutRef(undefined);
    }, [
        setIsPopupShown,
        setCurrentShortcutRef
    ]);
    const clearClosePopupTimer = (0, $42omo.useCallback)(()=>{
        if (closePopupTimerRef.current) {
            clearTimeout(closePopupTimerRef.current);
            closePopupTimerRef.current = null;
        }
    }, []);
    const startClosePopupTimer = (0, $42omo.useCallback)(()=>{
        clearClosePopupTimer();
        closePopupTimerRef.current = setTimeout(()=>{
            hidePopup();
        }, hoverDelayTimeMs);
    }, [
        clearClosePopupTimer,
        hoverDelayTimeMs,
        hidePopup
    ]); /**
                                                            * @param targetRef - the ref to the shortcut item
                                                            * @returns a handler for the mouse over event on the shortcut item
                                                            */ 
    const handleMouseOverWithRef = (0, $42omo.useCallback)((targetRef)=>()=>{
            // clear the close popup timer to avoid closing the popup
            // when moving the mouse from the popup to the shortcut item
            clearClosePopupTimer();
            setCurrentShortcutRef(targetRef);
            showPopup();
        }, [
        clearClosePopupTimer,
        showPopup
    ]); /**
                                          * @param targetRef - the ref to the shortcut item
                                          * @returns a handler for the mouse leave event on the shortcut item
                                          */ 
    const handleMouseLeaveWithRef = (0, $42omo.useCallback)(()=>()=>{
            if (currentShortcutRef?.current) currentShortcutRef.current.style.backgroundColor = '';
            startClosePopupTimer();
        }, [
        currentShortcutRef,
        startClosePopupTimer
    ]); /**
                                                   * @param targetRef - the ref to the shortcut item
                                                   * @returns a callback ref for a shortcut item
                                                   */ 
    const createShortcutRef = (0, $42omo.useCallback)((targetRef)=>(node)=>{
            // Cleanup previous element if it exists
            const existingUnbind = unbindFunctionsRef.current.get(targetRef);
            if (existingUnbind) {
                existingUnbind();
                unbindFunctionsRef.current.delete(targetRef);
            } // Store the new element
            // oxlint-disable-next-line no-param-reassign
            targetRef.current = node; // Attach listeners to new element
            if (node) {
                const mouseoverListener = handleMouseOverWithRef(targetRef);
                const focusListener = handleMouseOverWithRef(targetRef);
                const mouseleaveListener = handleMouseLeaveWithRef();
                const blurListener = handleMouseLeaveWithRef(); // Use bind-event-listener to bind all events and get an unbind function
                const unbind = (0, $fFa3V.bindAll)(node, [
                    {
                        type: 'mouseover',
                        listener: mouseoverListener
                    },
                    {
                        type: 'focus',
                        listener: focusListener
                    },
                    {
                        type: 'mouseleave',
                        listener: mouseleaveListener
                    },
                    {
                        type: 'blur',
                        listener: blurListener
                    }
                ]); // Store the unbind function for cleanup
                unbindFunctionsRef.current.set(targetRef, unbind);
            }
        }, [
        handleMouseOverWithRef,
        handleMouseLeaveWithRef
    ]);
    /**
   * Handles the popup shown event
   * @returns a handler for the popup shown event
   */ const handleOnMouseEnterPopup = (0, $42omo.useCallback)(()=>{
        // clear the close popup timer to avoid closing the popup too early
        clearClosePopupTimer();
        if (currentShortcutRef?.current) {
            // Get the parent element of the shortcut item
            const { parentElement: parentElement } = currentShortcutRef.current;
            if (parentElement) // reference the background color variable from the design system
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/4ff76dcfb3ce12b4344e5345be748ce472ac56e7/platform/packages/design-system/navigation-system/src/ui/menu-item/menu-item.tsx#lines-166
            parentElement.style.backgroundColor = "var(--ds-surface-hovered, #F0F1F2)";
        } // ensure the popup is shown when mouse leaves the shortcut item and over the popup
        showPopup();
    }, [
        clearClosePopupTimer,
        showPopup,
        currentShortcutRef
    ]); /**
                                                              * Handles the popup closed event
                                                              * @returns a handler for the popup closed event
                                                              */ 
    const handleOnMouseLeavePopup = (0, $42omo.useCallback)(()=>{
        if (currentShortcutRef?.current) {
            // Get the parent element of the shortcut item
            const { parentElement: parentElement } = currentShortcutRef.current;
            if (parentElement) parentElement.style.backgroundColor = '';
        }
        startClosePopupTimer();
    }, [
        currentShortcutRef,
        startClosePopupTimer
    ]);
    const referrableShortcuts = (0, $42omo.useMemo)(()=>{
        const entries = Object.entries(shortcutsConfig);
        const max = Math.min(entries.length, resolverResult ? Object.values(resolverResult.invitedApps ?? {}).filter((app)=>app?.eligible).length : // TODO(PUMA-1269) Cleanup this fallback once resolverResult is always provided:
        (0, $0968601a95585f25$export$cebe16b091a89fcc).length);
        const refsLimit = max - excludeLastFromRefs;
        let createdRefsCount = 0;
        return entries.reduce((acc, [key, shortcut])=>{
            // only add ref to shortcuts that are within the refs limit
            // and if it is a link and the aps key is allowed
            if (createdRefsCount < refsLimit && shortcut.type === 'link' && shortcut.apsKey && (resolverResult ? resolverResult.invitedApps?.[(0, $511e8e2f0dc221c0$export$b8c071b2cc567f75)(shortcut.apsKey)]?.eligible : // TODO(PUMA-1269) Cleanup this fallback once resolverResult is always provided:
            (0, $0968601a95585f25$export$cebe16b091a89fcc).includes(shortcut.apsKey))) {
                const apsKey = shortcut.apsKey;
                const targetRef = shortcutRefs[apsKey];
                acc[key] = {
                    ...shortcut,
                    ref: targetRef ? createShortcutRef(targetRef) : undefined,
                    labelElem: /*#__PURE__*/ (0, $l998X.jsx)((0, $606c22c7c79fc55a$export$f60dc2630a14000a), {
                        apsKey: apsKey,
                        label: shortcut.label
                    })
                }; // oxlint-disable-next-line no-plusplus
                createdRefsCount++;
            } else acc[key] = shortcut;
            return acc;
        }, {});
    }, [
        shortcutsConfig,
        resolverResult,
        createShortcutRef,
        shortcutRefs,
        excludeLastFromRefs
    ]);
    (0, $42omo.useEffect)(()=>{
        const currentUnbindFunctions = unbindFunctionsRef.current;
        const currentShortcutRefs = shortcutRefs;
        return ()=>{
            // Clean up all event listeners using the stored unbind functions
            Object.values(currentShortcutRefs).forEach((ref)=>{
                const unbind = currentUnbindFunctions.get(ref);
                if (unbind) {
                    unbind();
                    currentUnbindFunctions.delete(ref);
                }
            });
            clearClosePopupTimer();
        };
    }, [
        clearClosePopupTimer,
        shortcutRefs
    ]);
    const currentApsKey = (0, $42omo.useMemo)(()=>Object.keys(shortcutRefs).find((apsKey)=>currentShortcutRef?.current === shortcutRefs[apsKey]?.current), [
        shortcutRefs,
        currentShortcutRef
    ]);
    const currentAppKey = currentApsKey && (0, $511e8e2f0dc221c0$export$b8c071b2cc567f75)(currentApsKey);
    const currentAppResolved = currentAppKey && resolverResult?.invitedApps?.[currentAppKey];
    const currentAppCollaborators = (0, $42omo.useMemo)(()=>currentAppResolved?.collaborators?.map((collab)=>({
                name: '',
                src: collab?.avatar
            })) ?? [], [
        currentAppResolved?.collaborators
    ]);
    const currentShortcutLink = (0, $42omo.useMemo)(()=>currentShortcutRef?.current?.href, [
        currentShortcutRef
    ]);
    (0, $42omo.useEffect)(()=>{
        // These are the app keys for which we'll be displaying our treatment
        const invitedAppShortcutKeys = Object.values(referrableShortcuts).reduce((acc, shortcut)=>{
            if (shortcut.type === 'link' && (0, $511e8e2f0dc221c0$export$f45e7800f1f61594)(shortcut.apsKey) && !!shortcut.ref) acc.push((0, $511e8e2f0dc221c0$export$b8c071b2cc567f75)(shortcut.apsKey));
            return acc;
        }, []);
        resolverResult?.registerImpression({
            products: invitedAppShortcutKeys
        }); // Fire an analytics event when the user views the invited app shortcuts
        if (invitedAppShortcutKeys.length > 0) fireViewedInvitedAppShortcuts(invitedAppShortcutKeys);
    }, [
        referrableShortcuts,
        resolverResult,
        fireViewedInvitedAppShortcuts
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $65ddfdee4001ff48$export$a5c3144306783a42).Provider, {
        value: {
            impressedProducts: {
                JIRA_SOFTWARE: $eb94a7a15b9af3a3$var$isAppImpressed(resolverResult?.invitedApps?.jira),
                CONFLUENCE: $eb94a7a15b9af3a3$var$isAppImpressed(resolverResult?.invitedApps?.confluence)
            }
        },
        children: [
            children({
                referrableShortcuts: referrableShortcuts
            }),
            isPopupShown && currentShortcutRef && currentShortcutLink && currentApsKey && /*#__PURE__*/ (0, $l998X.jsx)((0, $5acee1e1684ee9fc$export$872e174e62e92fd), {
                trigger: currentShortcutRef,
                onMouseEnterPopup: handleOnMouseEnterPopup,
                onMouseLeavePopup: handleOnMouseLeavePopup,
                currentApsKey: currentApsKey,
                currentAppCollaborators: currentAppCollaborators,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                            grow: "fill",
                            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                                alignBlock: "start",
                                alignInline: "start",
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        children: currentAppCollaborators.length > 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                            ...(0, $8640c6d7c63a6659$export$defe85febe8b728c).popupMainTextWithCollaborators
                                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                            ...(0, $8640c6d7c63a6659$export$defe85febe8b728c).popupMainTextWithoutCollaborators
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                        href: currentShortcutLink,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        onClick: ()=>fireLinkClickedAcceptInvite({
                                                app: (0, $511e8e2f0dc221c0$export$b8c071b2cc567f75)(currentApsKey)
                                            }),
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                            ...(0, $8640c6d7c63a6659$export$defe85febe8b728c).popupAcceptInviteButton
                                        })
                                    })
                                ]
                            })
                        }),
                        currentAppCollaborators.length > 0 && currentApsKey && /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                            grow: "hug",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Pg7f.default), {
                                data: currentAppCollaborators.map((collaborator)=>({
                                        ...collaborator,
                                        appearance: 'circle',
                                        size: 'medium'
                                    })),
                                maxCount: 2,
                                overrides: {
                                    MoreIndicator: {
                                        render: (Component, props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $a9b6255e0132bb39$export$cb6b49c74b6579bc), {
                                                currentApsKey: currentApsKey,
                                                currentAppCollaborators: currentAppCollaborators,
                                                children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                                                    ...props,
                                                    isActive: false,
                                                    onClick: ()=>{}
                                                })
                                            })
                                    }
                                }
                            })
                        }, currentApsKey)
                    ]
                })
            })
        ]
    });
};
const $eb94a7a15b9af3a3$var$isAppImpressed = (appDetails)=>!!appDetails?.firstImpressionAt;














var $5hYae = parcelRequire("5hYae");

const $167cc3f1dc82a812$export$4519a9392cf3004e = ({ shortcutItems: shortcutItems = [], forceStatic: forceStatic, product: product, openInSameTab: openInSameTab, invitedAppProductLinks: invitedAppProductLinks })=>{
    const mappedShortcutItems = (0, $42omo.useMemo)(()=>{
        return shortcutItems.map((item)=>{
            if (item.type === 'link' && item.apsKey && invitedAppProductLinks[item.apsKey]) {
                const key = item.apsKey;
                const filteredProductLinks = invitedAppProductLinks[item.apsKey];
                // we only want to take single link items as we are not supporting expand menus
                if (filteredProductLinks.length === 1 && !item.url) return {
                    ...item,
                    key: key,
                    url: filteredProductLinks[0].url
                };
            }
            return null;
        }).filter(Boolean);
    }, [
        shortcutItems,
        invitedAppProductLinks
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
        testId: "shortcuts-menu",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9kbAI.MenuList), {
            children: mappedShortcutItems.map((shortcut)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $5hYae.ShortcutMenuItem), {
                    shortcut: shortcut,
                    forceStatic: forceStatic,
                    product: product,
                    openInSameTab: openInSameTab
                }, shortcut.key))
        })
    });
};




const $87dae69a81f59d82$export$f96c96985b06f150 = ({ enabled: enabled, shortcutItemsConfig: shortcutItemsConfig })=>{
    // store the invited app product links by apsKey in a state
    const [invitedAppProductLinks, setInvitedAppProductLinks] = (0, $42omo.useState)({});
    /**
	 * Handle updating the invited app product links by apsKey when the getFilteredProductLinks function is updated.
	 */ const handleUpdateInvitedAppProductLinks = (0, $42omo.useCallback)((getFilteredProductLinks)=>{
        if (enabled && getFilteredProductLinks && typeof getFilteredProductLinks === 'function') setInvitedAppProductLinks(Object.entries(shortcutItemsConfig).reduce((acc, [, config])=>{
            if (config.type === 'link' && config.apsKey && getFilteredProductLinks) {
                const { links: links } = getFilteredProductLinks(config.apsKey);
                acc[config.apsKey] = links;
            }
            return acc;
        }, {}));
    }, [
        enabled,
        shortcutItemsConfig
    ]);
    return {
        invitedAppProductLinks: invitedAppProductLinks,
        handleUpdateInvitedAppProductLinks: handleUpdateInvitedAppProductLinks
    };
};



var $b3j2Y = parcelRequire("b3j2Y");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $dPJCf = parcelRequire("dPJCf");


var $epLE5 = parcelRequire("epLE5");


var $jmjWc = parcelRequire("jmjWc");


var $gKr8t = parcelRequire("gKr8t");


var $9wGTI = parcelRequire("9wGTI");


var $b8XTE = parcelRequire("b8XTE");


var $6adZX = parcelRequire("6adZX");


var $5XsiK = parcelRequire("5XsiK");


var $9iEMr = parcelRequire("9iEMr");


var $6mKj3 = parcelRequire("6mKj3");


var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");





var $i4dNk = parcelRequire("i4dNk");

const $12338c25dd8aaf48$export$2471979fb08e1cdf = (0, $3u0dr.isReactCompilerActiveV1)() ? (platformCustomizations)=>{
    const $ = (0, $frIzR.c)(14);
    const { navCustomization: navCustomization } = (0, $i4dNk.useCfind4473CreationFocusedNav)(true);
    let customizedForExperiment;
    if (navCustomization === (0, $i4dNk.loading)) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = [
                {
                    menuId: "recent",
                    visible: false
                },
                {
                    menuId: "starred",
                    visible: false
                },
                {
                    menuId: "companyHubShortcut",
                    visible: false
                },
                {
                    menuId: "teamsShortcut",
                    visible: false
                },
                {
                    menuId: "templates",
                    visible: false
                }
            ];
            $[0] = t0;
        } else t0 = $[0];
        customizedForExperiment = t0;
    } else {
        if (navCustomization === (0, $i4dNk.d0)) {
            let t0;
            if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
                t0 = [
                    {
                        menuId: "recent",
                        visible: false
                    },
                    {
                        menuId: "starred",
                        visible: false
                    },
                    {
                        menuId: "companyHubShortcut",
                        visible: false
                    },
                    {
                        menuId: "teamsShortcut",
                        visible: false
                    },
                    {
                        menuId: "templates",
                        visible: true
                    }
                ];
                $[1] = t0;
            } else t0 = $[1];
            customizedForExperiment = t0;
        } else if (navCustomization === (0, $i4dNk.d1)) {
            let t0;
            if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
                t0 = [
                    {
                        menuId: "templates",
                        visible: true
                    }
                ];
                $[2] = t0;
            } else t0 = $[2];
            customizedForExperiment = t0;
        } else {
            let t0;
            if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
                t0 = [];
                $[3] = t0;
            } else t0 = $[3];
            customizedForExperiment = t0;
        }
    }
    let t0;
    if ($[4] !== platformCustomizations) {
        t0 = new Set(platformCustomizations.map($12338c25dd8aaf48$var$_temp));
        $[4] = platformCustomizations;
        $[5] = t0;
    } else t0 = $[5];
    const customizedMenuIds = t0;
    let t1;
    if ($[6] !== customizedForExperiment || $[7] !== customizedMenuIds) {
        t1 = customizedForExperiment.filter((item_0)=>!customizedMenuIds.has(item_0.menuId));
        $[6] = customizedForExperiment;
        $[7] = customizedMenuIds;
        $[8] = t1;
    } else t1 = $[8];
    const itemsToCustomize = t1;
    let t2;
    if ($[9] !== itemsToCustomize || $[10] !== platformCustomizations) {
        t2 = [
            ...platformCustomizations,
            ...itemsToCustomize
        ];
        $[9] = itemsToCustomize;
        $[10] = platformCustomizations;
        $[11] = t2;
    } else t2 = $[11];
    const platformCustomizationsWithSimplifyNav = t2;
    let t3;
    if ($[12] !== platformCustomizationsWithSimplifyNav) {
        t3 = {
            platformCustomizationsWithSimplifyNav: platformCustomizationsWithSimplifyNav
        };
        $[12] = platformCustomizationsWithSimplifyNav;
        $[13] = t3;
    } else t3 = $[13];
    return t3;
} : (platformCustomizations)=>{
    const { navCustomization: navCustomization } = (0, $i4dNk.useCfind4473CreationFocusedNav)(true);
    const platformCustomizationsWithSimplifyNav = (0, $42omo.useMemo)(()=>{
        let customizedForExperiment;
        if (navCustomization === (0, $i4dNk.loading)) customizedForExperiment = [
            {
                menuId: 'recent',
                visible: false
            },
            {
                menuId: 'starred',
                visible: false
            },
            {
                menuId: 'companyHubShortcut',
                visible: false
            },
            {
                menuId: 'teamsShortcut',
                visible: false
            },
            {
                menuId: 'templates',
                visible: false
            }
        ];
        else if (navCustomization === (0, $i4dNk.d0)) customizedForExperiment = [
            {
                menuId: 'recent',
                visible: false
            },
            {
                menuId: 'starred',
                visible: false
            },
            {
                menuId: 'companyHubShortcut',
                visible: false
            },
            {
                menuId: 'teamsShortcut',
                visible: false
            },
            {
                menuId: 'templates',
                visible: true
            }
        ];
        else if (navCustomization === (0, $i4dNk.d1)) customizedForExperiment = [
            {
                menuId: 'templates',
                visible: true
            }
        ];
        else customizedForExperiment = [];
        // IDs of menu items whose visibility has been customized by the user
        const customizedMenuIds = new Set(platformCustomizations.map((item)=>item.menuId));
        const itemsToCustomize = customizedForExperiment.filter((item_0)=>!customizedMenuIds.has(item_0.menuId));
        // For users in simplify nav, hide items that the user has not explicitly chosen to show
        return [
            ...platformCustomizations,
            ...itemsToCustomize
        ];
    }, [
        platformCustomizations,
        navCustomization
    ]);
    return {
        platformCustomizationsWithSimplifyNav: platformCustomizationsWithSimplifyNav
    };
};
function $12338c25dd8aaf48$var$_temp(item) {
    return item.menuId;
}



var $1uFsv = parcelRequire("1uFsv");











var $5d9b4 = parcelRequire("5d9b4");


var $T9xHm = parcelRequire("T9xHm");





var $1NBp8 = parcelRequire("1NBp8");


var $1ytiN = parcelRequire("1ytiN");


var $cEgMD = parcelRequire("cEgMD");


var $eSLr0 = parcelRequire("eSLr0");


var $6ld6a = parcelRequire("6ld6a");











var $5spQU = parcelRequire("5spQU");

















var $7CeAz = parcelRequire("7CeAz");





var $jyPfN = parcelRequire("jyPfN");


const $87ca580d0450c799$export$4873f44d198fe46c = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(8);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            location: (0, $eSLr0.SYSTEM_HEADER_LEFT),
            allowedWebItems: [
                (0, $5cb9965cd3125e0a$export$8fa81f0104234d32),
                (0, $5cb9965cd3125e0a$export$78f3e9dc1aa1d31d)
            ]
        };
        $[0] = t0;
    } else t0 = $[0];
    const { loading: webItemsLoading, webItems: webItems } = (0, $6ld6a.useWebItemLocation)(t0);
    const { isCompanyHubEntryPointEnabled: isCompanyHubEntryPointEnabled } = (0, $7CeAz.useIsCompanyHubEnabled)();
    const { frontCoverState: frontCoverState, loading: loading } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    let t1;
    if ($[1] !== hasViewUserProfilePermission || $[2] !== webItems || $[3] !== webItemsLoading) {
        t1 = !webItemsLoading && (hasViewUserProfilePermission || !!webItems.find($87ca580d0450c799$var$_temp));
        $[1] = hasViewUserProfilePermission;
        $[2] = webItems;
        $[3] = webItemsLoading;
        $[4] = t1;
    } else t1 = $[4];
    const isPeopleVisible = t1;
    const isCompanyHubVisible = !loading && isCompanyHubEntryPointEnabled && !!frontCoverState;
    let t2;
    if ($[5] !== isCompanyHubVisible || $[6] !== isPeopleVisible) {
        t2 = {
            isPeopleVisible: isPeopleVisible,
            isCompanyHubVisible: isCompanyHubVisible
        };
        $[5] = isCompanyHubVisible;
        $[6] = isPeopleVisible;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ()=>{
    const { loading: webItemsLoading, webItems: webItems } = (0, $6ld6a.useWebItemLocation)({
        location: (0, $eSLr0.SYSTEM_HEADER_LEFT),
        allowedWebItems: [
            (0, $5cb9965cd3125e0a$export$8fa81f0104234d32),
            (0, $5cb9965cd3125e0a$export$78f3e9dc1aa1d31d)
        ]
    });
    const { isCompanyHubEntryPointEnabled: isCompanyHubEntryPointEnabled } = (0, $7CeAz.useIsCompanyHubEnabled)();
    const { frontCoverState: frontCoverState, loading: loading } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const isPeopleVisible = !webItemsLoading && (hasViewUserProfilePermission || !!webItems.find((item)=>item.completeKey === (0, $5cb9965cd3125e0a$export$78f3e9dc1aa1d31d)));
    const isCompanyHubVisible = !loading && isCompanyHubEntryPointEnabled && !!frontCoverState;
    return (0, $42omo.useMemo)(()=>({
            isPeopleVisible: isPeopleVisible,
            isCompanyHubVisible: isCompanyHubVisible
        }), [
        isCompanyHubVisible,
        isPeopleVisible
    ]);
};
function $87ca580d0450c799$var$_temp(item) {
    return item.completeKey === (0, $5cb9965cd3125e0a$export$78f3e9dc1aa1d31d);
}









var $ay6Zz = parcelRequire("ay6Zz");










const $00a8e5a05a96c57e$export$597036aedc68c98f = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(8);
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== cloudId || $[1] !== orgId) {
        t0 = (0, $ay6Zz.navigateToTeamsApp)({
            type: "LANDING",
            cloudId: cloudId,
            orgId: orgId,
            userHasNav4Enabled: true
        });
        $[0] = cloudId;
        $[1] = orgId;
        $[2] = t0;
    } else t0 = $[2];
    const { href: href } = t0;
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $1NBp8.COMPANY_HUB).toUrl();
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== href) {
        t2 = (0, $5XsiK.isTeamsAppEnabled)() ? href : "";
        $[4] = href;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = {
            companyHubShortcut: t1,
            teamsShortcut: t2
        };
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ()=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { href: href } = (0, $ay6Zz.navigateToTeamsApp)({
        type: 'LANDING',
        cloudId: cloudId,
        orgId: orgId,
        userHasNav4Enabled: true
    });
    return {
        companyHubShortcut: (0, $1NBp8.COMPANY_HUB).toUrl(),
        teamsShortcut: (0, $5XsiK.isTeamsAppEnabled)() ? href : ''
    };
};












var $xQxzY = parcelRequire("xQxzY");


var $he3NE = parcelRequire("he3NE");

const $8d8811eb68255c1e$export$54d534cc91e54850 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(2);
    const { data: data } = (0, $xQxzY.useQuery)((0, $he3NE.GetLicensedProductsQuery));
    let t0;
    if ($[0] !== data?.confluence_tenantContext?.licensedProducts) {
        const licensedProducts = data?.confluence_tenantContext?.licensedProducts || [];
        t0 = licensedProducts.reduce($8d8811eb68255c1e$var$_temp, {
            hasJira: false,
            hasLoom: false
        });
        $[0] = data?.confluence_tenantContext?.licensedProducts;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    // eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations
    const { data: data } = (0, $xQxzY.useQuery)((0, $he3NE.GetLicensedProductsQuery));
    return (0, $42omo.useMemo)(()=>{
        const licensedProducts = data?.confluence_tenantContext?.licensedProducts || [];
        return licensedProducts.reduce((acc, product)=>{
            if (product.licenseStatus !== 'ACTIVE') return acc;
            switch(product.productKey){
                case 'jira-software':
                    acc.hasJira = true;
                    break;
                case 'loom':
                    acc.hasLoom = true;
                    break;
                default:
                    break;
            }
            return acc;
        }, {
            hasJira: false,
            hasLoom: false
        });
    }, [
        data
    ]);
};
function $8d8811eb68255c1e$var$_temp(acc, product) {
    if (product.licenseStatus !== "ACTIVE") return acc;
    bb17: switch(product.productKey){
        case "jira-software":
            acc.hasJira = true;
            break bb17;
        case "loom":
            acc.hasLoom = true;
            break bb17;
        default:
    }
    return acc;
}


const $5cb9965cd3125e0a$var$AuthenticationEnumMap = {
    //0 least privileged, 3 most privileged
    [(0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS]: 0,
    [(0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS]: 1,
    [(0, $d9tcB.AccessStatus).EXTERNAL_SHARE_ACCESS]: 0,
    [(0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS]: 3,
    [(0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS]: 2,
    [(0, $d9tcB.AccessStatus).NOT_PERMITTED]: 0,
    [(0, $d9tcB.AccessStatus).UNLICENSED_AUTHENTICATED_ACCESS]: 1
};
// Default configuration for all possible top-level items in Confluence Global Nav
const $5cb9965cd3125e0a$var$defaultMenuConfiguration = {
    customHome: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS,
        isCustomizable: false
    },
    yourWork: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: false
    },
    notes: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: true
    },
    companyHub: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: false
    },
    recent: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).UNLICENSED_AUTHENTICATED_ACCESS,
        isCustomizable: true
    },
    starred: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).UNLICENSED_AUTHENTICATED_ACCESS,
        isCustomizable: true
    },
    spaces: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS,
        isCustomizable: true
    },
    apps: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS,
        isCustomizable: true
    },
    goals: {
        //todo: where does this go?
        defaultVisibility: false,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: true,
        href: '#',
        apsKey: 'GOALS'
    },
    topics: {
        //todo: where does this go?
        defaultVisibility: false,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS,
        isCustomizable: true,
        href: '#'
    },
    teams: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: true,
        href: (0, $1NBp8.CONFLUENCE_PEOPLE_DIRECTORY_SEARCH).toUrl()
    },
    drafts: {
        defaultVisibility: false,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: true,
        href: (0, $1NBp8.HOME).toUrl({
            view: 'drafts'
        })
    },
    tasks: {
        defaultVisibility: false,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: true,
        href: (0, $1NBp8.HOME).toUrl({
            view: 'tasks'
        })
    },
    templates: {
        defaultVisibility: false,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS,
        isCustomizable: true,
        href: (0, $1NBp8.TEMPLATE_GALLERY).toUrl()
    },
    companyHubShortcut: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: true,
        isAppShortcut: true,
        href: (0, $1NBp8.COMPANY_HUB).toUrl()
    },
    jiraShortcut: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: true,
        isAppShortcut: true,
        apsKey: 'JIRA_SOFTWARE'
    },
    loomShortcut: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: true,
        isAppShortcut: true,
        apsKey: 'LOOM'
    },
    teamsShortcut: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: true,
        isAppShortcut: true,
        apsKey: 'TEAMS'
    },
    customize: {
        defaultVisibility: false,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: false
    }
};
const $5cb9965cd3125e0a$var$defaultPlatformCustomizationList = Object.entries($5cb9965cd3125e0a$var$defaultMenuConfiguration).filter(([, { isCustomizable: isCustomizable }])=>isCustomizable).map(([menuId, { defaultVisibility: defaultVisibility, isAppShortcut: isAppShortcut }])=>({
        menuId: menuId,
        visible: defaultVisibility,
        isAppShortcut: isAppShortcut || false
    }));
const $5cb9965cd3125e0a$var$mergeCustomizationsWithDefaults = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((platformCustomizations)=>{
    const validatedCustomizations = [];
    const customizedMenuIds = new Set();
    platformCustomizations?.forEach((item)=>{
        if ($5cb9965cd3125e0a$var$defaultMenuConfiguration[item.menuId]) {
            validatedCustomizations.push(item);
            customizedMenuIds.add(item.menuId);
        }
    });
    // These items always appear first
    const finalMenuItems = [
        {
            menuId: 'customHome',
            visible: true
        },
        {
            menuId: 'yourWork',
            visible: true
        }
    ];
    // Add any customized menu items
    validatedCustomizations.forEach((item)=>{
        finalMenuItems.push(item);
    });
    // Add any default items that were not customized
    $5cb9965cd3125e0a$var$defaultPlatformCustomizationList.forEach((item)=>{
        if (!customizedMenuIds.has(item.menuId)) finalMenuItems.push(item);
    });
    // Company Hub is an app shortcut.
    finalMenuItems.push({
        menuId: 'companyHub',
        visible: true
    });
    // Customize always appears last
    finalMenuItems.push({
        menuId: 'customize',
        visible: true
    });
    return finalMenuItems;
});
const $5cb9965cd3125e0a$var$createMenuItem = (menuId, config)=>({
        menuId: menuId,
        isCustomizable: config.isCustomizable,
        ...config.href && {
            href: config.href
        },
        ...config.isAppShortcut && {
            isAppShortcut: config.isAppShortcut
        }
    });
const $5cb9965cd3125e0a$var$createMenuItemNext = (menuId, config, visible)=>({
        menuId: menuId,
        visible: visible,
        isNotCustomizable: !config.isCustomizable,
        isNotToggleable: !config.isCustomizable,
        ...config.href && {
            href: config.href
        },
        ...config.isAppShortcut && {
            isAppShortcut: config.isAppShortcut
        }
    });
const $5cb9965cd3125e0a$export$9ef0020da7b7dcc4 = (showCustomization, accessStatus, platformCustomizations, visibilityOverrides, getFilteredProductLinks, fallbackUrls)=>{
    const globalMenuItems = [];
    const moreMenuItems = [];
    const appShortcutMenuItems = [];
    const allMenuItems = [];
    const orderedItems = $5cb9965cd3125e0a$var$mergeCustomizationsWithDefaults(platformCustomizations);
    const customizeItemId = 'customize';
    orderedItems.forEach((item)=>{
        const menuId = item.menuId;
        const defaultConfig = $5cb9965cd3125e0a$var$defaultMenuConfiguration[menuId];
        const accessStatusLevel = accessStatus && $5cb9965cd3125e0a$var$AuthenticationEnumMap[accessStatus] || 0; //if accessStatus is null, we default to anon level access
        if (//check if auth level is equal to or greater than what's required for each menu item
        $5cb9965cd3125e0a$var$AuthenticationEnumMap[defaultConfig.authenticationLevelRequired] <= accessStatusLevel && visibilityOverrides?.[menuId] !== false && menuId !== customizeItemId && !defaultConfig.isAppShortcut) {
            const menuItem = $5cb9965cd3125e0a$var$createMenuItem(menuId, defaultConfig);
            (item.visible ? globalMenuItems : moreMenuItems).push(menuItem);
            allMenuItems.push($5cb9965cd3125e0a$var$createMenuItemNext(menuId, defaultConfig, item.visible));
        }
        // APP SHORTCUTS
        if (visibilityOverrides?.[menuId] && defaultConfig.isAppShortcut) {
            const pushConfig = {
                ...defaultConfig
            };
            if (getFilteredProductLinks && defaultConfig.apsKey) pushConfig.href = getFilteredProductLinks(defaultConfig.apsKey)?.promotedLink?.url ?? fallbackUrls?.[menuId];
            if (pushConfig.apsKey && pushConfig.href || !pushConfig.apsKey) {
                appShortcutMenuItems.push($5cb9965cd3125e0a$var$createMenuItemNext(item.menuId, pushConfig, item.visible));
                if (!item.visible) moreMenuItems.push($5cb9965cd3125e0a$var$createMenuItem(item.menuId, pushConfig));
            }
        }
    });
    // customize sidebar item should be the last item of the more items menu
    // unless there are no items, then it should be in the global menu items
    if (showCustomization && visibilityOverrides?.[customizeItemId] !== false) {
        const customizeItem = $5cb9965cd3125e0a$var$createMenuItem(customizeItemId, $5cb9965cd3125e0a$var$defaultMenuConfiguration[customizeItemId]);
        (moreMenuItems.length === 0 ? globalMenuItems : moreMenuItems).push(customizeItem);
    }
    return {
        globalMenuItems: globalMenuItems,
        moreMenuItems: moreMenuItems,
        allMenuItems: allMenuItems,
        appShortcutMenuItems: appShortcutMenuItems
    };
};
const $5cb9965cd3125e0a$export$aad046bd9909db8f = (0, $3u0dr.isReactCompilerActiveV1)() ? (showCustomization, accessStatus, platformCustomizations, getFilteredProductLinks)=>{
    const $ = (0, $frIzR.c)(28);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            location: (0, $eSLr0.SYSTEM_HEADER_LEFT),
            allowedWebItems: [
                $5cb9965cd3125e0a$export$8fa81f0104234d32,
                $5cb9965cd3125e0a$export$78f3e9dc1aa1d31d
            ]
        };
        $[0] = t0;
    } else t0 = $[0];
    const { loading: webItemsLoading, webItems: webItems } = (0, $6ld6a.useWebItemLocation)(t0);
    const fallbackUrls = (0, $00a8e5a05a96c57e$export$597036aedc68c98f)();
    const { hasJira: hasJira, hasLoom: hasLoom } = (0, $8d8811eb68255c1e$export$54d534cc91e54850)();
    const { homepageUri: homepageUri } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { isPeopleVisible: isPeopleVisible, isCompanyHubVisible: isCompanyHubVisible } = (0, $87ca580d0450c799$export$4873f44d198fe46c)();
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $5XsiK.isTeamsAppEnabled)();
        $[1] = t1;
    } else t1 = $[1];
    const teamsAppEnabled = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $9wGTI.fg)("use_frontend_feature_encoding_sdk") ? !(0, $5spQU.isFeatureEnabled)("confluence", "confluence-forge-apps-sidebar") && !(0, $9wGTI.fg)("forge-apps-sidebar-enabled-in-isolated-cloud") : (0, $T9xHm.isIsolatedCloud)() && !(0, $9wGTI.fg)("forge-apps-sidebar-enabled-in-isolated-cloud");
        $[2] = t2;
    } else t2 = $[2];
    const shouldHideAppsSideBarInIsolatedCloud = t2;
    let t3;
    if ($[3] !== webItems || $[4] !== webItemsLoading) {
        t3 = !webItemsLoading && !!webItems.find($5cb9965cd3125e0a$var$_temp);
        $[3] = webItems;
        $[4] = webItemsLoading;
        $[5] = t3;
    } else t3 = $[5];
    const isSpacesVisible = t3;
    let t4;
    if ($[6] !== homepageUri || $[7] !== isCompanyHubVisible) {
        t4 = isCompanyHubVisible && homepageUri.includes((0, $cEgMD.getCompanyHubSpaceKey)());
        $[6] = homepageUri;
        $[7] = isCompanyHubVisible;
        $[8] = t4;
    } else t4 = $[8];
    const isCompanyHubSetAsCustomHome = t4;
    let t5;
    if ($[9] !== homepageUri || $[10] !== isCompanyHubSetAsCustomHome) {
        t5 = !isCompanyHubSetAsCustomHome && ![
            "/spa.action",
            "",
            "homepageUri"
        ].includes(homepageUri);
        $[9] = homepageUri;
        $[10] = isCompanyHubSetAsCustomHome;
        $[11] = t5;
    } else t5 = $[11];
    const isCustomHomeVisible = t5;
    let t6;
    if ($[12] !== isCompanyHubVisible) {
        t6 = isCompanyHubVisible && !(0, $9wGTI.fg)("nav4_global_links_confluence");
        $[12] = isCompanyHubVisible;
        $[13] = t6;
    } else t6 = $[13];
    const t7 = isPeopleVisible && !teamsAppEnabled;
    let t8;
    if ($[14] !== accessStatus || $[15] !== fallbackUrls || $[16] !== getFilteredProductLinks || $[17] !== hasJira || $[18] !== hasLoom || $[19] !== isCompanyHubVisible || $[20] !== isCustomHomeVisible || $[21] !== isPeopleVisible || $[22] !== isSpacesVisible || $[23] !== platformCustomizations || $[24] !== showCustomization || $[25] !== t6 || $[26] !== t7) {
        const visibilityOverrides = {
            customHome: isCustomHomeVisible,
            companyHub: t6,
            spaces: isSpacesVisible,
            teams: t7,
            topics: false,
            goals: false,
            templates: true,
            drafts: true,
            apps: !shouldHideAppsSideBarInIsolatedCloud,
            tasks: true,
            notes: (0, $6mKj3.expVal)("cc_notes", "isEnabled", false),
            customize: true,
            companyHubShortcut: isCompanyHubVisible && (0, $9wGTI.fg)("nav4_global_links_confluence"),
            jiraShortcut: hasJira && (0, $9wGTI.fg)("nav4_global_links_confluence"),
            loomShortcut: hasLoom && (0, $9wGTI.fg)("nav4_global_links_confluence"),
            teamsShortcut: isPeopleVisible && teamsAppEnabled
        };
        t8 = $5cb9965cd3125e0a$export$9ef0020da7b7dcc4(showCustomization, accessStatus, platformCustomizations, visibilityOverrides, getFilteredProductLinks, fallbackUrls);
        $[14] = accessStatus;
        $[15] = fallbackUrls;
        $[16] = getFilteredProductLinks;
        $[17] = hasJira;
        $[18] = hasLoom;
        $[19] = isCompanyHubVisible;
        $[20] = isCustomHomeVisible;
        $[21] = isPeopleVisible;
        $[22] = isSpacesVisible;
        $[23] = platformCustomizations;
        $[24] = showCustomization;
        $[25] = t6;
        $[26] = t7;
        $[27] = t8;
    } else t8 = $[27];
    return t8;
} : (showCustomization, accessStatus, platformCustomizations, getFilteredProductLinks)=>{
    const { loading: webItemsLoading, webItems: webItems } = (0, $6ld6a.useWebItemLocation)({
        location: (0, $eSLr0.SYSTEM_HEADER_LEFT),
        allowedWebItems: [
            $5cb9965cd3125e0a$export$8fa81f0104234d32,
            $5cb9965cd3125e0a$export$78f3e9dc1aa1d31d
        ]
    });
    const fallbackUrls = (0, $00a8e5a05a96c57e$export$597036aedc68c98f)();
    const { hasJira: hasJira, hasLoom: hasLoom } = (0, $8d8811eb68255c1e$export$54d534cc91e54850)();
    const { homepageUri: homepageUri } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { isPeopleVisible: isPeopleVisible, isCompanyHubVisible: isCompanyHubVisible } = (0, $87ca580d0450c799$export$4873f44d198fe46c)();
    const teamsAppEnabled = (0, $5XsiK.isTeamsAppEnabled)();
    // Gate ON: environment-aware enablement for Forge Apps sidebar; Gate OFF: legacy isolated cloud fallback
    const shouldHideAppsSideBarInIsolatedCloud = (0, $9wGTI.fg)('use_frontend_feature_encoding_sdk') ? !(0, $5spQU.isFeatureEnabled)('confluence', 'confluence-forge-apps-sidebar') && !(0, $9wGTI.fg)('forge-apps-sidebar-enabled-in-isolated-cloud') : (0, $T9xHm.isIsolatedCloud)() && !(0, $9wGTI.fg)('forge-apps-sidebar-enabled-in-isolated-cloud');
    const isSpacesVisible = !webItemsLoading && !!webItems.find((item)=>item.completeKey === $5cb9965cd3125e0a$export$8fa81f0104234d32);
    const isCompanyHubSetAsCustomHome = isCompanyHubVisible && homepageUri.includes((0, $cEgMD.getCompanyHubSpaceKey)());
    const isCustomHomeVisible = !isCompanyHubSetAsCustomHome && ![
        '/spa.action',
        '',
        'homepageUri'
    ].includes(homepageUri);
    return (0, $42omo.useMemo)(()=>{
        // remove elements from the returned data structures based on application state and override defaults and customization store
        // eslint-disable-next-line confluence-feature-gating/inline-usage
        const visibilityOverrides = {
            customHome: isCustomHomeVisible,
            companyHub: isCompanyHubVisible && !(0, $9wGTI.fg)('nav4_global_links_confluence'),
            spaces: isSpacesVisible,
            teams: isPeopleVisible && !teamsAppEnabled,
            topics: false,
            // todo: remove when platform tells us what topics does / goes
            goals: false,
            // todo: remove when platform tells us what goals does / goes
            templates: true,
            drafts: true,
            apps: !shouldHideAppsSideBarInIsolatedCloud,
            tasks: true,
            notes: (0, $6mKj3.expVal)('cc_notes', 'isEnabled', false),
            customize: true,
            companyHubShortcut: isCompanyHubVisible && (0, $9wGTI.fg)('nav4_global_links_confluence'),
            jiraShortcut: hasJira && (0, $9wGTI.fg)('nav4_global_links_confluence'),
            loomShortcut: hasLoom && (0, $9wGTI.fg)('nav4_global_links_confluence'),
            teamsShortcut: isPeopleVisible && teamsAppEnabled
        };
        return $5cb9965cd3125e0a$export$9ef0020da7b7dcc4(showCustomization, accessStatus, platformCustomizations, visibilityOverrides, getFilteredProductLinks, fallbackUrls);
    }, [
        isCustomHomeVisible,
        isCompanyHubVisible,
        isSpacesVisible,
        isPeopleVisible,
        accessStatus,
        shouldHideAppsSideBarInIsolatedCloud,
        showCustomization,
        platformCustomizations,
        getFilteredProductLinks,
        teamsAppEnabled,
        fallbackUrls,
        hasJira,
        hasLoom
    ]);
};
const $5cb9965cd3125e0a$export$8fa81f0104234d32 = 'com.atlassian.confluence.plugins.confluence-space-ia:header-spaces-link';
const $5cb9965cd3125e0a$export$78f3e9dc1aa1d31d = 'com.atlassian.confluence.plugins.confluence-space-ia:header-people-link';
function $5cb9965cd3125e0a$var$_temp(item) {
    return item.completeKey === $5cb9965cd3125e0a$export$8fa81f0104234d32;
}















var $gasvu = parcelRequire("gasvu");

var $k3207 = parcelRequire("k3207");



const $87d6e462347f520d$export$4bb4a114d280c175 = (globalShortcutsItemMap, customizationMenuConfig)=>{
    return (0, $42omo.useMemo)(()=>{
        // return the original config if no customizationMenuConfig is provided
        if (!customizationMenuConfig || customizationMenuConfig.length === 0) return Object.values(globalShortcutsItemMap);
        // Create a map for low complexity lookups
        const configMap = new Map(customizationMenuConfig.map((config)=>[
                config.menuId,
                config
            ]));
        const result = [];
        const addedKeys = new Set();
        // First pass: add items in the order specified by customizationMenuConfig
        customizationMenuConfig.forEach(({ menuId: menuId, visible: visible })=>{
            if (visible && globalShortcutsItemMap[menuId]) {
                result.push(globalShortcutsItemMap[menuId]);
                addedKeys.add(menuId);
            }
        });
        // Second pass: add remaining items that aren't in customizationMenuConfig or aren't visible
        Object.entries(globalShortcutsItemMap).forEach(([key, value])=>{
            if (!addedKeys.has(key)) {
                const config = configMap.get(key);
                // Add if not in config (assume visible) or if in config but not visible
                if (!config) result.push(value);
            }
        });
        return result;
    }, [
        globalShortcutsItemMap,
        customizationMenuConfig
    ]);
};




















parcelRequire("42omo");











const $82db327e56ac3de4$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    label: {
        id: "navigation.global-shortcuts.apps.company-hub",
        defaultMessage: "Company Hub"
    }
});


const $5a42c6aaec7538b2$var$icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.HubIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true,
    label: ""
});
const $5a42c6aaec7538b2$export$50e5fd99bfef1a4a = (fallbackUrl, options = {})=>(0, $b3ea6dd191ed3e50$export$7613f0bd7ffe380c)($5a42c6aaec7538b2$var$icon, (0, $82db327e56ac3de4$export$defe85febe8b728c).label, fallbackUrl, {
        analyticsName: (0, $culkJ.Products).ATLAS_HUB,
        ...options
    });






parcelRequire("42omo");











const $e96a79584135f443$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    label: {
        id: "navigation.global-shortcuts.apps.loom",
        defaultMessage: "Loom"
    }
});


const $4898362ef69c915e$var$icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.LoomIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true,
    label: ""
});
const $4898362ef69c915e$export$ef6b4021b8157342 = (fallbackUrl, options = {})=>(0, $b3ea6dd191ed3e50$export$7613f0bd7ffe380c)($4898362ef69c915e$var$icon, (0, $e96a79584135f443$export$defe85febe8b728c).label, fallbackUrl, {
        apsKey: (0, $culkJ.Products).LOOM,
        analyticsName: (0, $culkJ.Products).LOOM,
        ...options
    });





parcelRequire("42omo");











const $6e45175315a8a66e$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    label: {
        id: "navigation.global-shortcuts.apps.teams",
        defaultMessage: "Teams"
    }
});


const $3dab1474f6c2c995$var$icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.TeamsIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true,
    label: ""
});
const $3dab1474f6c2c995$export$6fe02dcc2001dcb0 = (fallbackUrl, options = {})=>(0, $b3ea6dd191ed3e50$export$7613f0bd7ffe380c)($3dab1474f6c2c995$var$icon, (0, $6e45175315a8a66e$export$defe85febe8b728c).label, fallbackUrl, {
        apsKey: (0, $culkJ.Products).ATLAS_TEAMS,
        analyticsName: (0, $culkJ.Products).ATLAS_TEAMS,
        ...options
    });
























var $8tdj3 = parcelRequire("8tdj3");





var $lujnM = parcelRequire("lujnM");


var $7O4kd = parcelRequire("7O4kd");

const $67a256fbfa808886$var$DEFAULT_COMPANY_HUB_NAME = 'Company Hub';
const $67a256fbfa808886$var$i18n = (0, $cgtv4.defineMessages)({
    CompanyHubName: {
        id: "side-navigation.custom.company-hub.shortcut-name",
        defaultMessage: "Company Hub"
    }
});
const $67a256fbfa808886$export$7d5e579a7612f1c2 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { isHidden: isHidden, onClick: onClick } = t0;
    if (isHidden) return null;
    let t1;
    if ($[0] !== onClick) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7O4kd.AbstractCompanyHubItem), {
            navVersion: "4"
        }, (t2)=>{
            const { companyHubName: companyHubName, isSelected: isSelected, namedRoute: namedRoute, onClick: onAbstractCompanyHubItemClick } = t2;
            const elemBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.HubIcon), {
                size: "xsmall"
            });
            const elemAfter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
                label: "",
                spacing: "spacious",
                size: "small"
            });
            const onMenuLinkItemClick = ()=>{
                onClick?.();
                onAbstractCompanyHubItemClick();
            };
            const isDefaultCompanyHubName = companyHubName === $67a256fbfa808886$var$DEFAULT_COMPANY_HUB_NAME;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
                elemAfter: elemAfter,
                elemBefore: elemBefore,
                href: namedRoute?.toUrl() || "#",
                isSelected: isSelected,
                onClick: onMenuLinkItemClick,
                target: "_blank"
            }, isDefaultCompanyHubName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $67a256fbfa808886$var$i18n.CompanyHubName) : companyHubName);
        });
        $[0] = onClick;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ isHidden: isHidden, onClick: onClick })=>{
    // This item can only be hidden if it's an app shortcut, but then it doesn't peek because it opens in a new tab.
    if (isHidden) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7O4kd.AbstractCompanyHubItem), {
        navVersion: "4"
    }, ({ companyHubName: companyHubName, isSelected: isSelected, namedRoute: namedRoute, onClick: onAbstractCompanyHubItemClick })=>{
        const target = '_blank';
        // https://hello.atlassian.net/wiki/spaces/DST/pages/4992197568/Company+Hub+Team+25+App+Tile+update+worksheet and
        // https://www.figma.com/design/MrViCsb93b2UqRjYrGQgaD/Confluence-Griffin-nav?node-id=9932-52111&t=B9QrCfJUvgDZwy64-0
        // say the icon should be 20px.
        const elemBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.HubIcon), {
            size: "xsmall"
        });
        const elemAfter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
            label: "",
            spacing: "spacious",
            size: "small"
        });
        const onMenuLinkItemClick = ()=>{
            onClick?.();
            onAbstractCompanyHubItemClick();
        };
        const isDefaultCompanyHubName = companyHubName === $67a256fbfa808886$var$DEFAULT_COMPANY_HUB_NAME;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
            elemAfter: elemAfter,
            elemBefore: elemBefore,
            href: namedRoute?.toUrl() || '#',
            isSelected: isSelected,
            onClick: onMenuLinkItemClick,
            target: target
        }, isDefaultCompanyHubName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $67a256fbfa808886$var$i18n.CompanyHubName) : companyHubName);
    });
};




const $1bf1672000eb6ee8$export$ed2673425deb0c2f = (0, $3u0dr.isReactCompilerActiveV1)() ? (props)=>{
    const $ = (0, $frIzR.c)(21);
    const fallbackUrls = (0, $00a8e5a05a96c57e$export$597036aedc68c98f)();
    const { hasLoom: hasLoom, hasJira: hasJira } = (0, $8d8811eb68255c1e$export$54d534cc91e54850)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $5XsiK.isTeamsAppEnabled)();
        $[0] = t0;
    } else t0 = $[0];
    const teamsAppEnabled = t0;
    const { isPeopleVisible: isPeopleVisible, isCompanyHubVisible: isCompanyHubVisible } = (0, $87ca580d0450c799$export$4873f44d198fe46c)();
    const companyHubShortcutWithoutComponent = (0, $5a42c6aaec7538b2$export$50e5fd99bfef1a4a)(fallbackUrls.companyHubShortcut);
    const jiraShortcut = (0, $e306a0f1948559b4$export$b34e755010aed2b2)("");
    const loomShortcut = (0, $4898362ef69c915e$export$ef6b4021b8157342)("");
    const teamsShortcut = (0, $3dab1474f6c2c995$export$6fe02dcc2001dcb0)(fallbackUrls.teamsShortcut);
    props?.teamsShortcutConfig;
    let t1;
    if ($[1] !== companyHubShortcutWithoutComponent) {
        t1 = {
            ...companyHubShortcutWithoutComponent,
            type: "component",
            component: (0, $67a256fbfa808886$export$7d5e579a7612f1c2)
        };
        $[1] = companyHubShortcutWithoutComponent;
        $[2] = t1;
    } else t1 = $[2];
    const companyHubShortcut = t1;
    let t2;
    if ($[3] !== companyHubShortcut || $[4] !== isCompanyHubVisible) {
        t2 = isCompanyHubVisible ? {
            companyHubShortcut: companyHubShortcut
        } : {};
        $[3] = companyHubShortcut;
        $[4] = isCompanyHubVisible;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== hasJira || $[7] !== jiraShortcut) {
        t3 = hasJira ? {
            jiraShortcut: jiraShortcut
        } : {};
        $[6] = hasJira;
        $[7] = jiraShortcut;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== hasLoom || $[10] !== loomShortcut) {
        t4 = hasLoom ? {
            loomShortcut: loomShortcut
        } : {};
        $[9] = hasLoom;
        $[10] = loomShortcut;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== isPeopleVisible || $[13] !== props?.teamsShortcutConfig || $[14] !== teamsShortcut) {
        t5 = isPeopleVisible && teamsAppEnabled ? {
            teamsShortcut: props?.teamsShortcutConfig && (0, $9wGTI.fg)("teams-shortcut-next-confluence") ? props?.teamsShortcutConfig : teamsShortcut
        } : {};
        $[12] = isPeopleVisible;
        $[13] = props?.teamsShortcutConfig;
        $[14] = teamsShortcut;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== t2 || $[17] !== t3 || $[18] !== t4 || $[19] !== t5) {
        t6 = {
            ...t2,
            ...t3,
            ...t4,
            ...t5
        };
        $[16] = t2;
        $[17] = t3;
        $[18] = t4;
        $[19] = t5;
        $[20] = t6;
    } else t6 = $[20];
    return t6;
} : (props)=>{
    const fallbackUrls = (0, $00a8e5a05a96c57e$export$597036aedc68c98f)();
    const { hasLoom: hasLoom, hasJira: hasJira } = (0, $8d8811eb68255c1e$export$54d534cc91e54850)();
    const teamsAppEnabled = (0, $5XsiK.isTeamsAppEnabled)();
    const { isPeopleVisible: isPeopleVisible, isCompanyHubVisible: isCompanyHubVisible } = (0, $87ca580d0450c799$export$4873f44d198fe46c)();
    const companyHubShortcutWithoutComponent = (0, $5a42c6aaec7538b2$export$50e5fd99bfef1a4a)(fallbackUrls['companyHubShortcut']);
    const jiraShortcut = (0, $e306a0f1948559b4$export$b34e755010aed2b2)('');
    const loomShortcut = (0, $4898362ef69c915e$export$ef6b4021b8157342)('');
    const teamsShortcut = (0, $3dab1474f6c2c995$export$6fe02dcc2001dcb0)(fallbackUrls['teamsShortcut']);
    return (0, $42omo.useMemo)(()=>{
        const companyHubShortcut = {
            ...companyHubShortcutWithoutComponent,
            type: 'component',
            component: (0, $67a256fbfa808886$export$7d5e579a7612f1c2)
        };
        return {
            ...isCompanyHubVisible ? {
                companyHubShortcut: companyHubShortcut
            } : {},
            ...hasJira ? {
                jiraShortcut: jiraShortcut
            } : {},
            ...hasLoom ? {
                loomShortcut: loomShortcut
            } : {},
            ...isPeopleVisible && teamsAppEnabled ? {
                teamsShortcut: props?.teamsShortcutConfig && (0, $9wGTI.fg)('teams-shortcut-next-confluence') ? props?.teamsShortcutConfig : teamsShortcut
            } : {}
        };
    }, [
        companyHubShortcutWithoutComponent,
        hasJira,
        jiraShortcut,
        hasLoom,
        loomShortcut,
        teamsShortcut,
        props?.teamsShortcutConfig,
        teamsAppEnabled,
        isCompanyHubVisible,
        isPeopleVisible
    ]);
};

















var $T1bCI = parcelRequire("T1bCI");















var $hSHWm = parcelRequire("hSHWm");


var $gqqjz = parcelRequire("gqqjz");


var $koZ31 = parcelRequire("koZ31");








var $g6zY9 = parcelRequire("g6zY9");





var $6xdDU = parcelRequire("6xdDU");








const $33adfcc827e1f5d8$var$LazyTeamCreateDialog = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Y2j5Z",
    name: "LazyTeamCreateDialog",
    loader: ()=>(parcelRequire("eiYCj")).then(({ TeamCreateDialog: TeamCreateDialog })=>TeamCreateDialog),
    loading: ()=>null
});
const $33adfcc827e1f5d8$export$9169fd4d2562e042 = (0, $3u0dr.isReactCompilerActiveV1)() ? function CreateTeamModal(t0) {
    const $ = (0, $frIzR.c)(10);
    const { isOpen: isOpen, onClose: onClose, addFlag: addFlag } = t0;
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    let t1;
    if ($[0] !== addFlag) {
        t1 = (flag)=>{
            const { title: title, description: description, appearance: appearance, actions: actions } = flag;
            addFlag({
                type: appearance === "success" || appearance === "normal" ? "success-circle" : appearance,
                title: title,
                description: description,
                close: "auto",
                actions: actions,
                id: flag.id
            });
        };
        $[0] = addFlag;
        $[1] = t1;
    } else t1 = $[1];
    const addFlagFn = t1;
    let t2;
    if ($[2] !== addFlagFn || $[3] !== cloudId || $[4] !== isOpen || $[5] !== onClose || $[6] !== orgId) {
        t2 = isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g6zY9.PeopleAndTeamsConfigurationProvider), {
            product: "confluence"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($33adfcc827e1f5d8$var$LazyTeamCreateDialog, {
            cloudId: cloudId,
            product: "confluence",
            orgId: orgId,
            onClose: onClose,
            enableMembershipSettingsChoice: true,
            enableTeamPermissionCheck: true,
            onCreateTeamSuccess: onClose,
            onCreateTeamFailed: onClose,
            addFlag: addFlagFn
        }))) : null;
        $[2] = addFlagFn;
        $[3] = cloudId;
        $[4] = isOpen;
        $[5] = onClose;
        $[6] = orgId;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, t2);
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : function CreateTeamModal({ isOpen: isOpen, onClose: onClose, addFlag: addFlag }) {
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const addFlagFn = (0, $42omo.useCallback)((flag)=>{
        const { title: title, description: description, appearance: appearance, actions: actions } = flag;
        addFlag({
            type: appearance === 'success' || appearance === 'normal' ? 'success-circle' : appearance,
            title: title,
            description: description,
            close: 'auto',
            actions: actions,
            id: flag.id
        });
    }, [
        addFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g6zY9.PeopleAndTeamsConfigurationProvider), {
        product: "confluence"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($33adfcc827e1f5d8$var$LazyTeamCreateDialog, {
        cloudId: cloudId,
        product: "confluence",
        orgId: orgId,
        onClose: onClose,
        enableMembershipSettingsChoice: true,
        enableTeamPermissionCheck: true,
        onCreateTeamSuccess: onClose,
        onCreateTeamFailed: onClose,
        addFlag: addFlagFn
    }))) : null);
};



const $2f5cc3338e9d2ca7$var$ACTION_SUBJECT_ID = 'teamsAppShortcut';
const $2f5cc3338e9d2ca7$var$CREATE_A_TEAM = 'createATeam';
const $2f5cc3338e9d2ca7$var$INVITE_PEOPLE = 'invitePeople';
const $2f5cc3338e9d2ca7$export$68b2e4594fafcb97 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(21);
    const hasFiredExposure = (0, $42omo.useRef)(false);
    const fallbackUrls = (0, $00a8e5a05a96c57e$export$597036aedc68c98f)();
    const shortcutUrl = fallbackUrls.teamsShortcut;
    const teamsShortcut = (0, $3dab1474f6c2c995$export$6fe02dcc2001dcb0)(shortcutUrl);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { openCoreInvites: openCoreInvites } = (0, $42omo.useContext)((0, $hSHWm.CoreInvitesContext));
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $6mKj3.UNSAFE_noExposureExp)("confluence_global_nav_teams_app_with_actions");
        $[0] = t0;
    } else t0 = $[0];
    const [experimentConfig, fireExposure] = t0;
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = experimentConfig.get("cohort", "not-enrolled");
        $[1] = t1;
    } else t1 = $[1];
    const cohort = t1;
    const [isCreateTeamModalOpen, setCreateTeamModalOpen] = (0, $42omo.useState)(false);
    let t2;
    if ($[2] !== createAnalyticsEvent) {
        t2 = ()=>{
            if (!hasFiredExposure.current) {
                hasFiredExposure.current = true;
                fireExposure();
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        source: "globalNavigation",
                        action: "mouseEnter",
                        actionSubject: "navigationItem",
                        actionSubjectId: $2f5cc3338e9d2ca7$var$ACTION_SUBJECT_ID,
                        attributes: {
                            inviteFromTeamsAppCohort: cohort
                        }
                    }
                }).fire();
            }
        };
        $[2] = createAnalyticsEvent;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== cloudId || $[5] !== createAnalyticsEvent || $[6] !== formatMessage || $[7] !== openCoreInvites) {
        t3 = cohort === "variation" ? {
            actions: [
                {
                    onClick: ()=>{
                        createAnalyticsEvent({
                            type: "sendUIEvent",
                            data: {
                                source: "globalNavigation",
                                action: "clicked",
                                actionSubject: "dropdownItem",
                                actionSubjectId: $2f5cc3338e9d2ca7$var$ACTION_SUBJECT_ID,
                                attributes: {
                                    itemId: $2f5cc3338e9d2ca7$var$INVITE_PEOPLE
                                }
                            }
                        }).fire();
                        openCoreInvites?.((0, $koZ31.CoreInvitesSource).PEOPLE_MENU, {
                            onModalClosed: $2f5cc3338e9d2ca7$var$_temp,
                            onInviteCompleted: $2f5cc3338e9d2ca7$var$_temp2
                        }, undefined, {
                            resourceAri: `ari:cloud:confluence::site/${cloudId}`,
                            source: $2f5cc3338e9d2ca7$var$ACTION_SUBJECT_ID
                        });
                    },
                    component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage($2f5cc3338e9d2ca7$var$messages.invitePeople))
                },
                {
                    onClick: ()=>{
                        createAnalyticsEvent({
                            type: "sendUIEvent",
                            data: {
                                source: "globalNavigation",
                                action: "clicked",
                                actionSubject: "dropdownItem",
                                actionSubjectId: $2f5cc3338e9d2ca7$var$ACTION_SUBJECT_ID,
                                attributes: {
                                    itemId: $2f5cc3338e9d2ca7$var$CREATE_A_TEAM
                                }
                            }
                        }).fire();
                        setCreateTeamModalOpen(true);
                    },
                    component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage($2f5cc3338e9d2ca7$var$messages.createTeam))
                }
            ]
        } : {};
        $[4] = cloudId;
        $[5] = createAnalyticsEvent;
        $[6] = formatMessage;
        $[7] = openCoreInvites;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== t2 || $[10] !== t3 || $[11] !== teamsShortcut) {
        t4 = {
            ...teamsShortcut,
            onMouseEnter: t2,
            ...t3
        };
        $[9] = t2;
        $[10] = t3;
        $[11] = teamsShortcut;
        $[12] = t4;
    } else t4 = $[12];
    const config = t4;
    let t5;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = [
            (0, $gqqjz.FlagsStateContainer)
        ];
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== isCreateTeamModalOpen) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t5
        }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $33adfcc827e1f5d8$export$9169fd4d2562e042), {
                isOpen: isCreateTeamModalOpen,
                onClose: ()=>setCreateTeamModalOpen(false),
                addFlag: flags.showFlag
            }));
        $[14] = isCreateTeamModalOpen;
        $[15] = t6;
    } else t6 = $[15];
    const createTeamModalComponent = t6;
    if (cohort !== "variation") {
        let t7;
        if ($[16] !== config) {
            t7 = {
                config: config,
                component: null
            };
            $[16] = config;
            $[17] = t7;
        } else t7 = $[17];
        return t7;
    }
    let t7;
    if ($[18] !== config || $[19] !== createTeamModalComponent) {
        t7 = {
            config: config,
            component: createTeamModalComponent
        };
        $[18] = config;
        $[19] = createTeamModalComponent;
        $[20] = t7;
    } else t7 = $[20];
    return t7;
} : ()=>{
    const hasFiredExposure = (0, $42omo.useRef)(false);
    const fallbackUrls = (0, $00a8e5a05a96c57e$export$597036aedc68c98f)();
    const shortcutUrl = fallbackUrls['teamsShortcut'];
    const teamsShortcut = (0, $3dab1474f6c2c995$export$6fe02dcc2001dcb0)(shortcutUrl);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { openCoreInvites: openCoreInvites } = (0, $42omo.useContext)((0, $hSHWm.CoreInvitesContext));
    const [experimentConfig, fireExposure] = (0, $42omo.useMemo)(()=>(0, $6mKj3.UNSAFE_noExposureExp)('confluence_global_nav_teams_app_with_actions'), []);
    const cohort = (0, $42omo.useMemo)(()=>experimentConfig.get('cohort', 'not-enrolled'), [
        experimentConfig
    ]);
    const [isCreateTeamModalOpen, setCreateTeamModalOpen] = (0, $42omo.useState)(false);
    const config = (0, $42omo.useMemo)(()=>({
            ...teamsShortcut,
            onMouseEnter: ()=>{
                if (!hasFiredExposure.current) {
                    hasFiredExposure.current = true;
                    // Actions can't be dynamically shown so unsafe exposure used here on hover as the point where the actions are shown / not shown
                    fireExposure();
                    createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            source: 'globalNavigation',
                            action: 'mouseEnter',
                            actionSubject: 'navigationItem',
                            actionSubjectId: $2f5cc3338e9d2ca7$var$ACTION_SUBJECT_ID,
                            attributes: {
                                inviteFromTeamsAppCohort: cohort
                            }
                        }
                    }).fire();
                }
            },
            ...cohort === 'variation' ? {
                actions: [
                    {
                        onClick: ()=>{
                            createAnalyticsEvent({
                                type: 'sendUIEvent',
                                data: {
                                    source: 'globalNavigation',
                                    action: 'clicked',
                                    actionSubject: 'dropdownItem',
                                    actionSubjectId: $2f5cc3338e9d2ca7$var$ACTION_SUBJECT_ID,
                                    attributes: {
                                        itemId: $2f5cc3338e9d2ca7$var$INVITE_PEOPLE
                                    }
                                }
                            }).fire();
                            openCoreInvites?.((0, $koZ31.CoreInvitesSource).PEOPLE_MENU, {
                                onModalClosed: ()=>null,
                                onInviteCompleted: ()=>null
                            }, undefined, {
                                resourceAri: `ari:cloud:confluence::site/${cloudId}`,
                                source: $2f5cc3338e9d2ca7$var$ACTION_SUBJECT_ID
                            });
                        },
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage($2f5cc3338e9d2ca7$var$messages.invitePeople))
                    },
                    {
                        onClick: ()=>{
                            createAnalyticsEvent({
                                type: 'sendUIEvent',
                                data: {
                                    source: 'globalNavigation',
                                    action: 'clicked',
                                    actionSubject: 'dropdownItem',
                                    actionSubjectId: $2f5cc3338e9d2ca7$var$ACTION_SUBJECT_ID,
                                    attributes: {
                                        itemId: $2f5cc3338e9d2ca7$var$CREATE_A_TEAM
                                    }
                                }
                            }).fire();
                            setCreateTeamModalOpen(true);
                        },
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage($2f5cc3338e9d2ca7$var$messages.createTeam))
                    }
                ]
            } : {}
        }), [
        createAnalyticsEvent,
        formatMessage,
        setCreateTeamModalOpen,
        openCoreInvites,
        cloudId,
        teamsShortcut,
        fireExposure,
        cohort
    ]);
    const createTeamModalComponent = (0, $42omo.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: [
                (0, $gqqjz.FlagsStateContainer)
            ]
        }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $33adfcc827e1f5d8$export$9169fd4d2562e042), {
                isOpen: isCreateTeamModalOpen,
                onClose: ()=>setCreateTeamModalOpen(false),
                addFlag: flags.showFlag
            }));
    }, [
        isCreateTeamModalOpen,
        setCreateTeamModalOpen
    ]);
    if (cohort !== 'variation') return {
        config: config,
        component: null
    };
    return {
        config: config,
        component: createTeamModalComponent
    };
};
const $2f5cc3338e9d2ca7$var$messages = (0, $cgtv4.defineMessages)({
    invitePeople: {
        id: "side-navigation.custom.teams-app-shortcut.invite-people",
        defaultMessage: "Invite people"
    },
    createTeam: {
        id: "side-navigation.custom.teams-app-shortcut.create-team",
        defaultMessage: "Create team"
    }
});
function $2f5cc3338e9d2ca7$var$_temp() {
    return null;
}
function $2f5cc3338e9d2ca7$var$_temp2() {
    return null;
}


const $7d243d65a15d9065$export$69209b4d7b9e00bc = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(24);
    const { orderedMenuConfig: t1, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks, isInvitedAppShortcutsEnabled: t2 } = t0;
    let t3;
    if ($[0] !== t1) {
        t3 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t3;
    } else t3 = $[1];
    const orderedMenuConfig = t3;
    const isInvitedAppShortcutsEnabled = t2 === undefined ? false : t2;
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { config: teamsShortcutConfig, component: teamsShortcutComponent } = (0, $2f5cc3338e9d2ca7$export$68b2e4594fafcb97)();
    let t4;
    if ($[2] !== onUpdateGetFilteredProductLinks) {
        t4 = (getFilteredProductLinks)=>{
            if (onUpdateGetFilteredProductLinks) onUpdateGetFilteredProductLinks(getFilteredProductLinks);
        };
        $[2] = onUpdateGetFilteredProductLinks;
        $[3] = t4;
    } else t4 = $[3];
    const updateGetFilteredProductLinks = t4;
    let t5;
    if ($[4] !== teamsShortcutConfig) {
        t5 = {
            teamsShortcutConfig: teamsShortcutConfig
        };
        $[4] = teamsShortcutConfig;
        $[5] = t5;
    } else t5 = $[5];
    const shortcutItemsConfig = (0, $1bf1672000eb6ee8$export$ed2673425deb0c2f)(t5);
    let t6;
    bb0: {
        if (!isInvitedAppShortcutsEnabled) {
            t6 = shortcutItemsConfig;
            break bb0;
        }
        let rest;
        if ($[6] !== shortcutItemsConfig) {
            const { jiraShortcut: _jiraShortcut, ...t7 } = shortcutItemsConfig;
            rest = t7;
            $[6] = shortcutItemsConfig;
            $[7] = rest;
        } else rest = $[7];
        t6 = rest;
    }
    const shortcutItemsConfigReduced = t6;
    const orderedShortcuts = (0, $87d6e462347f520d$export$4bb4a114d280c175)(shortcutItemsConfigReduced, orderedMenuConfig);
    let t7;
    if ($[8] !== cloudId) {
        t7 = cloudId ? (0, $k3207.productLinksWorkspaceCloudIdFilter)(cloudId) : undefined;
        $[8] = cloudId;
        $[9] = t7;
    } else t7 = $[9];
    const productLinksFilter = t7;
    let t8;
    if ($[10] !== cloudId || $[11] !== orderedShortcuts || $[12] !== orgId || $[13] !== productLinksFilter || $[14] !== updateGetFilteredProductLinks) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gasvu.GlobalShortcuts), {
            testId: "global-app-shortcuts",
            cloudId: cloudId,
            orgId: orgId,
            shortcutItems: orderedShortcuts,
            promoteSite: true,
            product: "confluence",
            productLinksFilter: productLinksFilter,
            onUpdateGetFilteredProductLinks: updateGetFilteredProductLinks
        });
        $[10] = cloudId;
        $[11] = orderedShortcuts;
        $[12] = orgId;
        $[13] = productLinksFilter;
        $[14] = updateGetFilteredProductLinks;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== orderedShortcuts.length) {
        t9 = orderedShortcuts.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eYEH3.TopLevelSpacer), null);
        $[16] = orderedShortcuts.length;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== teamsShortcutComponent) {
        t10 = (0, $9wGTI.fg)("teams-shortcut-next-confluence") && teamsShortcutComponent;
        $[18] = teamsShortcutComponent;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== t10 || $[21] !== t8 || $[22] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t8, t9, t10);
        $[20] = t10;
        $[21] = t8;
        $[22] = t9;
        $[23] = t11;
    } else t11 = $[23];
    return t11;
} : ({ orderedMenuConfig: orderedMenuConfig = [], onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks, isInvitedAppShortcutsEnabled: isInvitedAppShortcutsEnabled = false })=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { config: teamsShortcutConfig, component: teamsShortcutComponent } = (0, $2f5cc3338e9d2ca7$export$68b2e4594fafcb97)();
    const updateGetFilteredProductLinks = (0, $42omo.useCallback)((getFilteredProductLinks)=>{
        if (onUpdateGetFilteredProductLinks) onUpdateGetFilteredProductLinks(getFilteredProductLinks);
    }, [
        onUpdateGetFilteredProductLinks
    ]);
    const shortcutItemsConfig = (0, $1bf1672000eb6ee8$export$ed2673425deb0c2f)({
        teamsShortcutConfig: teamsShortcutConfig
    });
    const shortcutItemsConfigReduced = (0, $42omo.useMemo)(()=>{
        if (!isInvitedAppShortcutsEnabled) return shortcutItemsConfig;
        const { jiraShortcut: _jiraShortcut, ...rest } = shortcutItemsConfig;
        return rest;
    }, [
        shortcutItemsConfig,
        isInvitedAppShortcutsEnabled
    ]);
    // Sort shortcut items based on the ordered menu config
    const orderedShortcuts = (0, $87d6e462347f520d$export$4bb4a114d280c175)(shortcutItemsConfigReduced, orderedMenuConfig);
    const productLinksFilter = cloudId ? (0, $k3207.productLinksWorkspaceCloudIdFilter)(cloudId) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gasvu.GlobalShortcuts), {
        testId: "global-app-shortcuts",
        cloudId: cloudId,
        orgId: orgId,
        shortcutItems: orderedShortcuts,
        promoteSite: true,
        product: "confluence",
        productLinksFilter: productLinksFilter,
        onUpdateGetFilteredProductLinks: updateGetFilteredProductLinks
    }), orderedShortcuts.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eYEH3.TopLevelSpacer), null), (0, $9wGTI.fg)('teams-shortcut-next-confluence') && teamsShortcutComponent);
};









var $l5LHO = parcelRequire("l5LHO");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $iI2ST = parcelRequire("iI2ST");





var $iZRoG = parcelRequire("iZRoG");


var $63PsI = parcelRequire("63PsI");














var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fNcP1 = parcelRequire("fNcP1");

var $8tIbq = parcelRequire("8tIbq");


var $lsxnT = parcelRequire("lsxnT");

/* eslint-disable check-i18n-id-prefix/i18n-id-prefix-with-package-name-defineMessages */ // Not a good idea to use experiment prefix in potentially long-lasting i18n strings



const $3b8a0fc692cee1ba$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    weAddedFeatures: {
        id: "creation-focused-nav.we-added-features",
        defaultMessage: "We added features to your sidebar"
    },
    toChangeYourView: {
        id: "creation-focused-nav.toChangeYourView",
        defaultMessage: "To change your view, customize your sidebar in the {menuName} menu"
    },
    more: {
        id: "creation-focused-nav.more",
        defaultMessage: "More"
    },
    customizeSidebar: {
        id: "creation-focused-nav.customizeSidebar",
        defaultMessage: "Customize sidebar"
    },
    gotIt: {
        id: "creation-focused-nav.gotIt",
        defaultMessage: "Got it"
    }
});





const $f373027e4dce4138$export$ea3b4f1126b4c509 = ({ isCollapsed: isCollapsed, children: children })=>{
    const { isSpotlightVisible: isSpotlightVisible, onSpotlightShown: onSpotlightShown } = (0, $i4dNk.useCfind4473CreationFocusedNav)();
    const { PopoverContent: PopoverContent } = (0, $lsxnT.useChoreographerAssets)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [hasDismissed, setHasDismissed] = (0, $42omo.useState)(false);
    const [shouldShowSpotlight, setShouldShowSpotlight] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (isSpotlightVisible) setShouldShowSpotlight(true);
    }, [
        isSpotlightVisible
    ]);
    const onDismiss = (reason)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismissedCreationFocusedNavSpotlight',
                source: 'creation-focused-nav-button-spotlight',
                attributes: {
                    reason: reason
                }
            }
        }).fire();
        setHasDismissed(true);
    };
    const onShown = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'shown',
                actionSubject: 'spotlight',
                actionSubjectId: 'creationFocusedNavSpotlight',
                source: 'creation-focused-nav-button-spotlight'
            }
        }).fire();
        onSpotlightShown?.();
    };
    const isVisible = !isCollapsed && !hasDismissed && shouldShowSpotlight;
    if (!isVisible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8tIbq.UNSAFE_UpdateOnChange), {
        selectors: [
            'nav#side-navigation'
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PopoverContent, {
        messageId: "creation-focused-nav-more-features-spotlight",
        messageType: "engagement",
        placement: "right-end",
        dismiss: ()=>onDismiss('auto'),
        isVisible: isVisible,
        onMessageDisposition: (status)=>{
            if (status === 'started') onShown();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), {
        testId: "spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUJpY.SpotlightHeadline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $3b8a0fc692cee1ba$export$a7357cdd1f0b0168).weAddedFeatures)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), {
        onClick: ()=>onDismiss('dismiss-control')
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...(0, $3b8a0fc692cee1ba$export$a7357cdd1f0b0168).toChangeYourView,
        values: {
            menuName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                as: "strong"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $3b8a0fc692cee1ba$export$a7357cdd1f0b0168).more))
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), {
        onClick: ()=>onDismiss('primary-action')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $3b8a0fc692cee1ba$export$a7357cdd1f0b0168).gotIt)))))));
};




var $1LksZ = parcelRequire("1LksZ");


var $cxU8R = parcelRequire("cxU8R");

const $6bf303f52478ae0b$export$e967513bbeba0537 = ({ moreMenuItems: moreMenuItems, isOpen: isOpen, toggleMenu: toggleMenu, onClick: onClick, peekingId: peekingId, isCollapsed: isCollapsed })=>{
    const companyHubName = (0, $63PsI.useCompanyHubName)();
    const iconByMenuId = (0, $cxU8R.useIconByMenuId)();
    if (!moreMenuItems || moreMenuItems?.length <= 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l5LHO.Popup), {
        isOpen: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f373027e4dce4138$export$ea3b4f1126b4c509), {
        isCollapsed: isCollapsed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l5LHO.PopupTrigger), null, (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iI2ST.ButtonMenuItem), {
            ...triggerProps,
            elemBefore: (0, $cxU8R.MoreIconComponent),
            onClick: toggleMenu
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $1LksZ.i18n).more)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $6bf303f52478ae0b$var$popupContentContainerStyles,
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l5LHO.PopupContent), {
        placement: "bottom-start",
        // Offset the top margin of the menu section.
        // This will keep an even spacing of menu items between those inside the dropdown and those above,
        // and keep the icons aligned
        offset: [
            -4,
            4
        ],
        onClose: toggleMenu,
        shouldRenderToParent: true,
        strategy: "absolute",
        shouldFitContainer: true
    }, ()=>{
        // The number of visible / non-null menu items so that proper dividers can be added.
        let nonNullMenuItemCount = 0;
        const menuItems = moreMenuItems.map(({ menuId: menuId, href: href, isAppShortcut: isAppShortcut })=>{
            if (peekingId && menuId === peekingId) return null; //if an item is peeking, do not render it in this menu
            ++nonNullMenuItemCount;
            if (menuId === 'companyHub') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, nonNullMenuItemCount !== 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iZRoG.Divider), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67a256fbfa808886$export$7d5e579a7612f1c2), {
                key: menuId,
                onClick: ()=>onClick(menuId),
                setIsCustomizeSidebarDialogVisible: ()=>{}
            }));
            let node;
            if (href) node = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
                href: href,
                onClick: ()=>onClick(menuId),
                elemBefore: iconByMenuId[menuId],
                key: menuId,
                target: isAppShortcut ? '_blank' : undefined
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                ...(0, $1LksZ.i18n)[menuId],
                values: menuId === 'companyHubShortcut' ? {
                    companyHubName: companyHubName
                } : {}
            }));
            else node = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iI2ST.ButtonMenuItem), {
                onClick: ()=>onClick(menuId),
                elemBefore: iconByMenuId[menuId],
                key: menuId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                ...(0, $1LksZ.i18n)[menuId],
                values: menuId === 'companyHubShortcut' ? {
                    companyHubName: companyHubName
                } : {}
            }));
            // The item "Customize sidebar" is visually divided from the preceeding global items and/or app shortcuts:
            if (node && nonNullMenuItemCount !== 1 && menuId === 'customize') node = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iZRoG.Divider), null), node);
            return node;
        });
        // PopupContent has an `xcss` prop, but it casts its value to `string` and thus isn't suitable.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $6bf303f52478ae0b$var$popupContentStyles,
            role: "list"
        }, menuItems);
    })));
};
const $6bf303f52478ae0b$var$popupContentContainerStyles = (0, $ecnYn.xcss)({
    position: 'relative',
    marginInline: 'space.negative.050',
    height: '0'
});
const $6bf303f52478ae0b$var$popupContentStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    paddingLeft: 'space.050',
    paddingRight: 'space.050'
});























var $jlIaF = parcelRequire("jlIaF");





var $7zgzO = parcelRequire("7zgzO");







const $15140e42b692bfde$var$i18n = (0, $cgtv4.defineMessages)({
    CustomHomeLink: {
        id: "side-navigation.custom.home.link",
        defaultMessage: "Custom Home Page"
    }
});

const $15140e42b692bfde$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("bfhzz"))).fireCustomHomepageClickedAnalytics);
const $15140e42b692bfde$export$adaf351fc9d12cd2 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(10);
    const { location: location, match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $15140e42b692bfde$var$useLazyClickAnalytics(createAnalyticsEvent, match?.name);
    const { homepageUri: homepageUri, homepageTitle: homepageTitle } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    let t0;
    if ($[0] !== homepageUri || $[1] !== location) {
        t0 = !!location && location.pathname === `${0, $jlIaF.CONTEXT_PATH}${homepageUri}` && location.search.includes("mode=global");
        $[0] = homepageUri;
        $[1] = location;
        $[2] = t0;
    } else t0 = $[2];
    const isSelected = t0;
    const t1 = `${(0, $jlIaF.CONTEXT_PATH)}${homepageUri}?mode=global`;
    let t2;
    if ($[3] !== homepageTitle) {
        t2 = homepageTitle || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $15140e42b692bfde$var$i18n.CustomHomeLink);
        $[3] = homepageTitle;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== fireClickAnalytics || $[6] !== isSelected || $[7] !== t1 || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
            href: t1,
            elemBefore: (0, $cxU8R.HomeIconComponent),
            isSelected: isSelected,
            onClick: fireClickAnalytics
        }, t2);
        $[5] = fireClickAnalytics;
        $[6] = isSelected;
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ()=>{
    //takes globalItemProps but is not customizable so doesn't use them
    const { location: location, match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $15140e42b692bfde$var$useLazyClickAnalytics(createAnalyticsEvent, match?.name);
    const { homepageUri: homepageUri, homepageTitle: homepageTitle } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const isSelected = !!location && location.pathname === `${0, $jlIaF.CONTEXT_PATH}${homepageUri}` && location.search.includes('mode=global');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
        href: `${(0, $jlIaF.CONTEXT_PATH)}${homepageUri}?mode=global`,
        elemBefore: (0, $cxU8R.HomeIconComponent),
        isSelected: isSelected,
        onClick: fireClickAnalytics
    }, homepageTitle || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $15140e42b692bfde$var$i18n.CustomHomeLink));
};






























var $gnkil = parcelRequire("gnkil");


var $efvKr = parcelRequire("efvKr");


var $9vJRo = parcelRequire("9vJRo");


var $de2j9 = parcelRequire("de2j9");








var $jrref = parcelRequire("jrref");
























var $fdtRy = parcelRequire("fdtRy");



var $19Jj3 = parcelRequire("19Jj3");

var $aG6kF = parcelRequire("aG6kF");


var $gj7hi = parcelRequire("gj7hi");


var $fT2ta = parcelRequire("fT2ta");




var $2ff731f9901765b7$exports = {};
$2ff731f9901765b7$exports = new URL("Home.eb3dbfc7.gif", import.meta.url).toString();


var $aaa2d9cdc909fccc$exports = {};
$aaa2d9cdc909fccc$exports = new URL("Home-dark.b4541437.gif", import.meta.url).toString();



var $3Awqk = parcelRequire("3Awqk");


var $3SChL = parcelRequire("3SChL");


var $2AgON = parcelRequire("2AgON");

const $3472cc1e48bf28c2$var$STEP_ID = 'nth-user-orientation-editor-for-you-spotlight';
const $3472cc1e48bf28c2$export$9cb1114290a9ed04 = ({ children: children })=>{
    const { reset: reset, next: next, back: back, currentStep: currentStep, progress: progress, hasInteracted: hasInteracted } = (0, $3SChL.useTour)($3472cc1e48bf28c2$var$STEP_ID);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const isVisible = currentStep === $3472cc1e48bf28c2$var$STEP_ID;
    const { PopoverContent: PopoverContent } = (0, $lsxnT.useChoreographerAssets)();
    const { handleNext: handleNext, handleBack: handleBack, handleDismiss: handleDismiss } = (0, $2AgON.useSpotlightAnalytics)({
        spotlightId: $3472cc1e48bf28c2$var$STEP_ID,
        isVisible: isVisible,
        onNext: next,
        onBack: back,
        onDismiss: reset
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jrref.Hide), {
        below: "md"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PopoverContent, {
        shouldDismissOnClickOutside: false,
        next: handleNext,
        back: handleBack,
        dismiss: handleDismiss,
        placement: "right-end",
        offset: [
            0,
            24
        ],
        isVisible: isVisible,
        messageId: $3472cc1e48bf28c2$var$STEP_ID,
        messageType: hasInteracted ? 'transactional' : 'engagement'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
        entranceDirection: "left"
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), {
            testId: $3472cc1e48bf28c2$var$STEP_ID
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUJpY.SpotlightHeadline), null, formatMessage((0, $3Awqk.editorForYouSpotlight).headline)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fdtRy.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($2ff731f9901765b7$exports))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($aaa2d9cdc909fccc$exports))),
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage((0, $3Awqk.editorForYouSpotlight).body))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aG6kF.SpotlightStepCount), null, formatMessage((0, $3Awqk.spotlight).progress, progress)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $19Jj3.SpotlightSecondaryAction), null, formatMessage((0, $3Awqk.spotlight).back)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), null, formatMessage((0, $3Awqk.spotlight).next))))))))));
};












var $6GD8y = parcelRequire("6GD8y");




const $7f5a9a3cdf96d75c$export$65c30f73882c92dc = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { href: href, keyboardShortcut: keyboardShortcut, deprecatedKeyboardShortcut: deprecatedKeyboardShortcut, isAppNavigationShortcut: isAppNavigationShortcut, children: children, onShortcutTriggered: onShortcutTriggered } = t0;
    const { push: push } = (0, $dPJCf.useRouteActions)();
    let t1;
    if ($[0] !== href || $[1] !== onShortcutTriggered || $[2] !== push) {
        t1 = ()=>{
            onShortcutTriggered();
            href && push(href);
        };
        $[0] = href;
        $[1] = onShortcutTriggered;
        $[2] = push;
        $[3] = t1;
    } else t1 = $[3];
    const listenerCallback = t1;
    let t2;
    if ($[4] !== deprecatedKeyboardShortcut || $[5] !== isAppNavigationShortcut || $[6] !== keyboardShortcut || $[7] !== listenerCallback) {
        t2 = keyboardShortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            deprecatedAccelerator: deprecatedKeyboardShortcut,
            accelerator: keyboardShortcut,
            listener: listenerCallback,
            isAppNavigationShortcut: isAppNavigationShortcut || false
        });
        $[4] = deprecatedKeyboardShortcut;
        $[5] = isAppNavigationShortcut;
        $[6] = keyboardShortcut;
        $[7] = listenerCallback;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== children || $[10] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children, t2);
        $[9] = children;
        $[10] = t2;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
} : ({ href: href, keyboardShortcut: keyboardShortcut, deprecatedKeyboardShortcut: deprecatedKeyboardShortcut, isAppNavigationShortcut: isAppNavigationShortcut, children: children, onShortcutTriggered: onShortcutTriggered })=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const listenerCallback = ()=>{
        onShortcutTriggered();
        href && push(href);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children, keyboardShortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: deprecatedKeyboardShortcut,
        accelerator: keyboardShortcut,
        listener: listenerCallback,
        isAppNavigationShortcut: isAppNavigationShortcut || false
    }));
});









const $b9c6e796d679cd96$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("bfhzz"))).fireHomeClickedAnalytics);
const $b9c6e796d679cd96$var$isOnHomeSelector = {
    selector: (routeUrl)=>{
        if (!routeUrl) return false;
        return routeUrl === (0, $1NBp8.HOME).toUrl() || routeUrl === (0, $1NBp8.WIKI).toUrl();
    }
};
const $b9c6e796d679cd96$export$d16f83425c70386f = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(9);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $b9c6e796d679cd96$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const isSelected = (0, $dPJCf.useRouteUrl)($b9c6e796d679cd96$var$isOnHomeSelector);
    const [t0] = (0, $efvKr.useLivePageMode)();
    const { isEditMode: isLiveEditMode } = t0;
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $1NBp8.HOME).toUrl();
        $[0] = t1;
    } else t1 = $[0];
    const homeUrl = t1;
    const t2 = !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.GO_HOME_SHORTCUT) : undefined;
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $1LksZ.i18n).forYou);
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== fireClickAnalytics || $[3] !== isSelected) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9vJRo.HomeOnboardingTakeoverV2HomeNudge), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3472cc1e48bf28c2$export$9cb1114290a9ed04), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
            href: homeUrl,
            elemBefore: (0, $cxU8R.ForYouIconComponent),
            isSelected: isSelected,
            onClick: fireClickAnalytics
        }, t3)));
        $[2] = fireClickAnalytics;
        $[3] = isSelected;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== fireClickAnalytics || $[6] !== t2 || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7f5a9a3cdf96d75c$export$65c30f73882c92dc), {
            href: homeUrl,
            deprecatedKeyboardShortcut: t2,
            keyboardShortcut: (0, $gnkil.UNIVERSAL_GO_HOME_SHORTCUT),
            isAppNavigationShortcut: true,
            onShortcutTriggered: fireClickAnalytics
        }, t4);
        $[5] = fireClickAnalytics;
        $[6] = t2;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ()=>{
    //takes globalItemProps but is not customizable so doesn't use them
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $b9c6e796d679cd96$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const isSelected = (0, $dPJCf.useRouteUrl)($b9c6e796d679cd96$var$isOnHomeSelector);
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const homeUrl = (0, $1NBp8.HOME).toUrl();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7f5a9a3cdf96d75c$export$65c30f73882c92dc), {
        href: homeUrl,
        deprecatedKeyboardShortcut: !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.GO_HOME_SHORTCUT) : undefined,
        keyboardShortcut: (0, $gnkil.UNIVERSAL_GO_HOME_SHORTCUT),
        isAppNavigationShortcut: true,
        onShortcutTriggered: fireClickAnalytics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9vJRo.HomeOnboardingTakeoverV2HomeNudge), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3472cc1e48bf28c2$export$9cb1114290a9ed04), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
        href: homeUrl,
        elemBefore: (0, $cxU8R.ForYouIconComponent),
        isSelected: isSelected,
        onClick: fireClickAnalytics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $1LksZ.i18n).forYou)))));
};



















var $h0OZ6 = parcelRequire("h0OZ6");

var $580cg = parcelRequire("580cg");

var $f4c6t = parcelRequire("f4c6t");














var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");
























var $d4Pk4 = parcelRequire("d4Pk4");


var $dYU3e = parcelRequire("dYU3e");


var $2fgSf = parcelRequire("2fgSf");


var $WG1VM = parcelRequire("WG1VM");


var $8BHAT = parcelRequire("8BHAT");

function $f64f22d885b98eec$export$603721ee0464e7fd(cloudId) {
    return ((0, $2fgSf.shouldUseAGGActivityV3)() ? (0, $dYU3e.queryAgg) : (0, $dYU3e.query))({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $8BHAT.RecentContentMenuQuery),
        variables: {
            cloudId: (0, $d4Pk4.PlatformSiteAri).create({
                siteId: cloudId
            }).toString(),
            after: '',
            first: (0, $WG1VM.PAGE_SIZE),
            eventTypes: [],
            objectTypes: (0, $WG1VM.OBJECT_TYPES)
        },
        fetchPolicy: 'network-only'
    });
}



var $lg4wi = parcelRequire("lg4wi");













const $3bf409fa34ce0763$export$27f33b8cbd60853b = (0, $3u0dr.isReactCompilerActiveV1)() ? (menuId, isSelected, isHidden, peekingId, setPeekingId)=>{
    const $ = (0, $frIzR.c)(14);
    const isPeeking = isSelected && isHidden;
    const [isAnyFlyoutPeeking] = (0, $6adZX.useIsFlyoutOpen)(peekingId);
    let t0;
    if ($[0] !== isAnyFlyoutPeeking || $[1] !== isPeeking || $[2] !== menuId || $[3] !== peekingId || $[4] !== setPeekingId) {
        t0 = ()=>{
            const peekingInState = peekingId === menuId;
            if (setPeekingId) {
                if (isPeeking && !peekingInState && !isAnyFlyoutPeeking) setPeekingId(menuId);
                if (!isPeeking && peekingInState) setPeekingId(undefined);
            }
        };
        $[0] = isAnyFlyoutPeeking;
        $[1] = isPeeking;
        $[2] = menuId;
        $[3] = peekingId;
        $[4] = setPeekingId;
        $[5] = t0;
    } else t0 = $[5];
    let t1;
    if ($[6] !== isAnyFlyoutPeeking || $[7] !== isHidden || $[8] !== isPeeking || $[9] !== isSelected || $[10] !== menuId || $[11] !== peekingId || $[12] !== setPeekingId) {
        t1 = [
            isHidden,
            peekingId,
            setPeekingId,
            menuId,
            isSelected,
            isPeeking,
            isAnyFlyoutPeeking
        ];
        $[6] = isAnyFlyoutPeeking;
        $[7] = isHidden;
        $[8] = isPeeking;
        $[9] = isSelected;
        $[10] = menuId;
        $[11] = peekingId;
        $[12] = setPeekingId;
        $[13] = t1;
    } else t1 = $[13];
    (0, $42omo.useEffect)(t0, t1);
    return !!(isHidden && !isPeeking);
} : (menuId, isSelected, isHidden, peekingId, setPeekingId)=>{
    const isPeeking = isSelected && isHidden;
    const [isAnyFlyoutPeeking] = (0, $6adZX.useIsFlyoutOpen)(peekingId);
    (0, $42omo.useEffect)(()=>{
        const peekingInState = peekingId === menuId;
        if (setPeekingId) {
            if (isPeeking && !peekingInState && !isAnyFlyoutPeeking) setPeekingId(menuId);
            if (!isPeeking && peekingInState) setPeekingId(undefined);
        }
    }, [
        isHidden,
        peekingId,
        setPeekingId,
        menuId,
        isSelected,
        isPeeking,
        isAnyFlyoutPeeking
    ]);
    return !!(isHidden && !isPeeking);
};



const $43bbe423a7434a33$export$af1f39df90a1145e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "r-0zb",
    name: "RecentContentMenuLoader",
    loader: async ()=>(await (parcelRequire("1NFFE"))).RecentContentMenu,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lg4wi.ContentMenuLoadingState), null)
});

const $43bbe423a7434a33$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("bfhzz"))).fireRecentsClickedAnalytics);
const $43bbe423a7434a33$var$MENU_ID = 'recent';
const $43bbe423a7434a33$export$f1cccf52bb5faf3f = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(37);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId } = t0;
    const { isFlyoutOpen: isFlyoutOpen, openFlyout: openFlyout, closeFlyout: closeFlyout } = (0, $6adZX.useFlyout)($43bbe423a7434a33$var$MENU_ID);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const hasBeenOpenedBefore = (0, $42omo.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $43bbe423a7434a33$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $efvKr.useLivePageMode)();
    const { isEditMode: isLiveEditMode } = t1;
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    let t2;
    if ($[0] !== experienceTracker) {
        t2 = ()=>{
            experienceTracker.abort({
                name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
                reason: "Primary dropdown menu: closed by user",
                attributes: {
                    navVersion: "4",
                    dropdownType: "recent"
                }
            });
        };
        $[0] = experienceTracker;
        $[1] = t2;
    } else t2 = $[1];
    const abortExperienceTracker = t2;
    let t3;
    if ($[2] !== experienceTracker) {
        t3 = ()=>{
            experienceTracker.start({
                name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).NAVIGATION_LOAD,
                attributes: {
                    navVersion: "4",
                    dropdownType: "recent"
                }
            });
        };
        $[2] = experienceTracker;
        $[3] = t3;
    } else t3 = $[3];
    const startExperienceTracker = t3;
    let t4;
    if ($[4] !== abortExperienceTracker || $[5] !== closeFlyout || $[6] !== fireClickAnalytics || $[7] !== isFlyoutOpen || $[8] !== openFlyout) {
        t4 = (newIsOpen)=>{
            if (!newIsOpen) {
                abortExperienceTracker();
                isFlyoutOpen && closeFlyout();
                if (hasBeenOpenedBefore.current) fireClickAnalytics(false);
            } else {
                openFlyout();
                hasBeenOpenedBefore.current = true;
            }
        };
        $[4] = abortExperienceTracker;
        $[5] = closeFlyout;
        $[6] = fireClickAnalytics;
        $[7] = isFlyoutOpen;
        $[8] = openFlyout;
        $[9] = t4;
    } else t4 = $[9];
    const onOpenChange = t4;
    let t5;
    if ($[10] !== fireClickAnalytics || $[11] !== isFlyoutOpen || $[12] !== isHidden || $[13] !== openFlyout || $[14] !== startExperienceTracker) {
        t5 = ()=>{
            if (!isFlyoutOpen) {
                fireClickAnalytics(true, true, isHidden);
                startExperienceTracker();
                openFlyout();
            }
        };
        $[10] = fireClickAnalytics;
        $[11] = isFlyoutOpen;
        $[12] = isHidden;
        $[13] = openFlyout;
        $[14] = startExperienceTracker;
        $[15] = t5;
    } else t5 = $[15];
    const onShortcutTriggered = t5;
    let t6;
    if ($[16] !== closeFlyout || $[17] !== fireClickAnalytics || $[18] !== isFlyoutOpen || $[19] !== openFlyout || $[20] !== startExperienceTracker) {
        t6 = ()=>{
            if (!isFlyoutOpen) {
                openFlyout();
                startExperienceTracker();
                fireClickAnalytics(true);
            } else closeFlyout();
        };
        $[16] = closeFlyout;
        $[17] = fireClickAnalytics;
        $[18] = isFlyoutOpen;
        $[19] = openFlyout;
        $[20] = startExperienceTracker;
        $[21] = t6;
    } else t6 = $[21];
    const onClick = t6;
    let t7;
    if ($[22] !== cloudId || $[23] !== isFlyoutOpen) {
        t7 = ()=>{
            if (!isFlyoutOpen) {
                $43bbe423a7434a33$export$af1f39df90a1145e.preload();
                (0, $f64f22d885b98eec$export$603721ee0464e7fd)(cloudId);
            }
        };
        $[22] = cloudId;
        $[23] = isFlyoutOpen;
        $[24] = t7;
    } else t7 = $[24];
    const onHover = t7;
    const isSelected = (0, $dPJCf.useRouteUrl)($43bbe423a7434a33$var$isOnRecentRoute);
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)($43bbe423a7434a33$var$MENU_ID, isSelected || isFlyoutOpen, isHidden, peekingId, setPeekingId);
    const t8 = !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.GO_TO_RECENT_SHORTCUT) : undefined;
    let t9;
    if ($[25] !== closeFlyout || $[26] !== isFlyoutOpen || $[27] !== isSelected || $[28] !== onClick || $[29] !== onHover || $[30] !== onOpenChange || $[31] !== shouldHide) {
        t9 = !shouldHide && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            onMouseEnter: onHover,
            onFocus: onHover
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h0OZ6.FlyoutMenuItem), {
            onOpenChange: onOpenChange,
            isOpen: isFlyoutOpen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f4c6t.FlyoutMenuItemTrigger), {
            elemBefore: (0, $cxU8R.ClockIconComponent),
            onClick: onClick,
            isSelected: isSelected
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $1LksZ.i18n).recent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $580cg.FlyoutMenuItemContent), {
            onClose: ()=>isFlyoutOpen && closeFlyout(),
            autoFocus: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($43bbe423a7434a33$export$af1f39df90a1145e, null))));
        $[25] = closeFlyout;
        $[26] = isFlyoutOpen;
        $[27] = isSelected;
        $[28] = onClick;
        $[29] = onHover;
        $[30] = onOpenChange;
        $[31] = shouldHide;
        $[32] = t9;
    } else t9 = $[32];
    let t10;
    if ($[33] !== onShortcutTriggered || $[34] !== t8 || $[35] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7f5a9a3cdf96d75c$export$65c30f73882c92dc), {
            deprecatedKeyboardShortcut: t8,
            keyboardShortcut: (0, $gnkil.UNIVERSAL_GO_TO_RECENT_SHORTCUT),
            isAppNavigationShortcut: true,
            onShortcutTriggered: onShortcutTriggered
        }, t9);
        $[33] = onShortcutTriggered;
        $[34] = t8;
        $[35] = t9;
        $[36] = t10;
    } else t10 = $[36];
    return t10;
} : ({ isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId })=>{
    const { isFlyoutOpen: isFlyoutOpen, openFlyout: openFlyout, closeFlyout: closeFlyout } = (0, $6adZX.useFlyout)($43bbe423a7434a33$var$MENU_ID);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const hasBeenOpenedBefore = (0, $42omo.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $43bbe423a7434a33$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const abortExperienceTracker = (0, $42omo.useCallback)(()=>{
        experienceTracker.abort({
            name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
            reason: 'Primary dropdown menu: closed by user',
            attributes: {
                navVersion: '4',
                dropdownType: 'recent'
            }
        });
    }, [
        experienceTracker
    ]);
    const startExperienceTracker = (0, $42omo.useCallback)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
            timeout: (0, $aJPUt.ExperienceTimeout).NAVIGATION_LOAD,
            attributes: {
                navVersion: '4',
                dropdownType: 'recent'
            }
        });
    }, [
        experienceTracker
    ]);
    const onOpenChange = (0, $42omo.useCallback)((newIsOpen)=>{
        if (!newIsOpen) {
            abortExperienceTracker();
            isFlyoutOpen && closeFlyout();
            // onOpenChange is called whenever FlyoutMenuItem component mounts, but we
            // only want to fire analytics event on user interaction. We check here if the
            // flyout has been opened before to ignore onOpenChange calls before user interaction
            if (hasBeenOpenedBefore.current) fireClickAnalytics(false);
        } else {
            openFlyout();
            hasBeenOpenedBefore.current = true;
        }
    }, [
        abortExperienceTracker,
        isFlyoutOpen,
        closeFlyout,
        fireClickAnalytics,
        openFlyout
    ]);
    const onShortcutTriggered = (0, $42omo.useCallback)(()=>{
        if (!isFlyoutOpen) {
            fireClickAnalytics(true, true, isHidden);
            startExperienceTracker();
            openFlyout();
        }
    }, [
        fireClickAnalytics,
        isFlyoutOpen,
        openFlyout,
        startExperienceTracker,
        isHidden
    ]);
    const onClick = (0, $42omo.useCallback)(()=>{
        if (!isFlyoutOpen) {
            openFlyout();
            startExperienceTracker();
            fireClickAnalytics(true); //if we clicked on it we know it's not hidden or fired via keyboard shortcut
        } else closeFlyout();
    }, [
        fireClickAnalytics,
        isFlyoutOpen,
        openFlyout,
        closeFlyout,
        startExperienceTracker
    ]);
    const onHover = (0, $42omo.useCallback)(()=>{
        if (!isFlyoutOpen) {
            $43bbe423a7434a33$export$af1f39df90a1145e.preload();
            (0, $f64f22d885b98eec$export$603721ee0464e7fd)(cloudId);
        }
    }, [
        isFlyoutOpen,
        cloudId
    ]);
    const isSelected = (0, $dPJCf.useRouteUrl)($43bbe423a7434a33$var$isOnRecentRoute);
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)($43bbe423a7434a33$var$MENU_ID, isSelected || isFlyoutOpen, isHidden, peekingId, setPeekingId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7f5a9a3cdf96d75c$export$65c30f73882c92dc), {
        deprecatedKeyboardShortcut: !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.GO_TO_RECENT_SHORTCUT) : undefined,
        keyboardShortcut: (0, $gnkil.UNIVERSAL_GO_TO_RECENT_SHORTCUT),
        isAppNavigationShortcut: true,
        onShortcutTriggered: onShortcutTriggered
    }, !shouldHide && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        onMouseEnter: onHover,
        onFocus: onHover
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h0OZ6.FlyoutMenuItem), {
        onOpenChange: onOpenChange,
        isOpen: isFlyoutOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f4c6t.FlyoutMenuItemTrigger), {
        elemBefore: (0, $cxU8R.ClockIconComponent),
        onClick: onClick,
        isSelected: isSelected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $1LksZ.i18n).recent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $580cg.FlyoutMenuItemContent), {
        onClose: ()=>isFlyoutOpen && closeFlyout(),
        autoFocus: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($43bbe423a7434a33$export$af1f39df90a1145e, null)))));
};
const $43bbe423a7434a33$var$isOnRecentRoute = {
    selector: (routeUrl)=>routeUrl === (0, $1NBp8.HOME).toUrl({
            view: 'recent'
        })
};




































































var $gSytF = parcelRequire("gSytF");


var $1IQhI = parcelRequire("1IQhI");

function $db09a4ff30df6c3f$export$4c74f8426e49d30c() {
    return (0, $dYU3e.query)({
        query: (0, $gSytF.default),
        variables: (0, $1IQhI.starredContentMenuQueryVars),
        fetchPolicy: 'network-only'
    });
}







const $d78d93494cd6b93d$export$17b89e6a36c6b530 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ayHpY",
    name: "StarredContentMenuLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("1IQhI")))).StarredContentMenu,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lg4wi.ContentMenuLoadingState), null)
});

const $d78d93494cd6b93d$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("bfhzz"))).fireStarredClickedAnalytics);
const $d78d93494cd6b93d$var$MENU_ID = 'starred';
const $d78d93494cd6b93d$export$d11aa717bebc8f86 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(46);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId } = t0;
    const { isFlyoutOpen: isFlyoutOpen, openFlyout: openFlyout, closeFlyout: closeFlyout } = (0, $6adZX.useFlyout)($d78d93494cd6b93d$var$MENU_ID);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const hasBeenOpenedBefore = (0, $42omo.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $d78d93494cd6b93d$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $efvKr.useLivePageMode)();
    const { isEditMode: isLiveEditMode } = t1;
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    let t2;
    if ($[0] !== experienceTracker) {
        t2 = ()=>{
            experienceTracker.abort({
                name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
                reason: "Primary dropdown menu: closed by user",
                attributes: {
                    navVersion: "4",
                    dropdownType: "starred"
                }
            });
        };
        $[0] = experienceTracker;
        $[1] = t2;
    } else t2 = $[1];
    const abortExperienceTracker = t2;
    let t3;
    if ($[2] !== experienceTracker) {
        t3 = ()=>{
            experienceTracker.start({
                name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).NAVIGATION_LOAD,
                attributes: {
                    navVersion: "4",
                    dropdownType: "starred"
                }
            });
        };
        $[2] = experienceTracker;
        $[3] = t3;
    } else t3 = $[3];
    const startExperienceTracker = t3;
    let t4;
    if ($[4] !== abortExperienceTracker || $[5] !== closeFlyout || $[6] !== fireClickAnalytics || $[7] !== isFlyoutOpen || $[8] !== openFlyout) {
        t4 = (newIsOpen)=>{
            if (!newIsOpen) {
                abortExperienceTracker();
                if (hasBeenOpenedBefore.current) fireClickAnalytics(false);
                isFlyoutOpen && closeFlyout();
            } else {
                openFlyout();
                hasBeenOpenedBefore.current = true;
            }
        };
        $[4] = abortExperienceTracker;
        $[5] = closeFlyout;
        $[6] = fireClickAnalytics;
        $[7] = isFlyoutOpen;
        $[8] = openFlyout;
        $[9] = t4;
    } else t4 = $[9];
    const onOpenChange = t4;
    let t5;
    if ($[10] !== fireClickAnalytics || $[11] !== isFlyoutOpen || $[12] !== isHidden || $[13] !== openFlyout || $[14] !== startExperienceTracker) {
        t5 = ()=>{
            if (!isFlyoutOpen) {
                fireClickAnalytics(true, true, isHidden);
                startExperienceTracker();
                openFlyout();
            }
        };
        $[10] = fireClickAnalytics;
        $[11] = isFlyoutOpen;
        $[12] = isHidden;
        $[13] = openFlyout;
        $[14] = startExperienceTracker;
        $[15] = t5;
    } else t5 = $[15];
    const onShortcutTriggered = t5;
    let t6;
    if ($[16] !== closeFlyout || $[17] !== fireClickAnalytics || $[18] !== isFlyoutOpen || $[19] !== openFlyout || $[20] !== startExperienceTracker) {
        t6 = ()=>{
            if (!isFlyoutOpen) {
                openFlyout();
                startExperienceTracker();
                fireClickAnalytics(true);
            } else closeFlyout();
        };
        $[16] = closeFlyout;
        $[17] = fireClickAnalytics;
        $[18] = isFlyoutOpen;
        $[19] = openFlyout;
        $[20] = startExperienceTracker;
        $[21] = t6;
    } else t6 = $[21];
    const onClick = t6;
    let t7;
    if ($[22] !== isFlyoutOpen) {
        t7 = ()=>{
            if (!isFlyoutOpen) {
                $d78d93494cd6b93d$export$17b89e6a36c6b530.preload();
                (0, $db09a4ff30df6c3f$export$4c74f8426e49d30c)();
            }
        };
        $[22] = isFlyoutOpen;
        $[23] = t7;
    } else t7 = $[23];
    const onHover = t7;
    const isSelected = (0, $dPJCf.useRouteUrl)($d78d93494cd6b93d$var$isOnStarredRoute);
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)($d78d93494cd6b93d$var$MENU_ID, isSelected || isFlyoutOpen, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    const t8 = !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.GO_TO_STARRED_SHORTCUT) : undefined;
    let t9;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $1LksZ.i18n).starred);
        $[24] = t9;
    } else t9 = $[24];
    let t10;
    if ($[25] !== isSelected || $[26] !== onClick) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f4c6t.FlyoutMenuItemTrigger), {
            elemBefore: (0, $cxU8R.StarIconComponent),
            onClick: onClick,
            isSelected: isSelected
        }, t9);
        $[25] = isSelected;
        $[26] = onClick;
        $[27] = t10;
    } else t10 = $[27];
    let t11;
    if ($[28] !== closeFlyout || $[29] !== isFlyoutOpen) {
        t11 = ()=>isFlyoutOpen && closeFlyout();
        $[28] = closeFlyout;
        $[29] = isFlyoutOpen;
        $[30] = t11;
    } else t11 = $[30];
    let t12;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d78d93494cd6b93d$export$17b89e6a36c6b530, null);
        $[31] = t12;
    } else t12 = $[31];
    let t13;
    if ($[32] !== t11) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $580cg.FlyoutMenuItemContent), {
            onClose: t11,
            autoFocus: false
        }, t12);
        $[32] = t11;
        $[33] = t13;
    } else t13 = $[33];
    let t14;
    if ($[34] !== isFlyoutOpen || $[35] !== onOpenChange || $[36] !== t10 || $[37] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h0OZ6.FlyoutMenuItem), {
            onOpenChange: onOpenChange,
            isOpen: isFlyoutOpen
        }, t10, t13);
        $[34] = isFlyoutOpen;
        $[35] = onOpenChange;
        $[36] = t10;
        $[37] = t13;
        $[38] = t14;
    } else t14 = $[38];
    let t15;
    if ($[39] !== onHover || $[40] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            onMouseEnter: onHover,
            onFocus: onHover
        }, t14);
        $[39] = onHover;
        $[40] = t14;
        $[41] = t15;
    } else t15 = $[41];
    let t16;
    if ($[42] !== onShortcutTriggered || $[43] !== t15 || $[44] !== t8) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7f5a9a3cdf96d75c$export$65c30f73882c92dc), {
            deprecatedKeyboardShortcut: t8,
            keyboardShortcut: (0, $gnkil.UNIVERSAL_GO_TO_STARRED_SHORTCUT),
            isAppNavigationShortcut: true,
            onShortcutTriggered: onShortcutTriggered
        }, t15);
        $[42] = onShortcutTriggered;
        $[43] = t15;
        $[44] = t8;
        $[45] = t16;
    } else t16 = $[45];
    return t16;
} : ({ isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId })=>{
    const { isFlyoutOpen: isFlyoutOpen, openFlyout: openFlyout, closeFlyout: closeFlyout } = (0, $6adZX.useFlyout)($d78d93494cd6b93d$var$MENU_ID);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const hasBeenOpenedBefore = (0, $42omo.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $d78d93494cd6b93d$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const abortExperienceTracker = (0, $42omo.useCallback)(()=>{
        experienceTracker.abort({
            name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
            reason: 'Primary dropdown menu: closed by user',
            attributes: {
                navVersion: '4',
                dropdownType: 'starred'
            }
        });
    }, [
        experienceTracker
    ]);
    const startExperienceTracker = (0, $42omo.useCallback)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
            timeout: (0, $aJPUt.ExperienceTimeout).NAVIGATION_LOAD,
            attributes: {
                navVersion: '4',
                dropdownType: 'starred'
            }
        });
    }, [
        experienceTracker
    ]);
    const onOpenChange = (0, $42omo.useCallback)((newIsOpen)=>{
        if (!newIsOpen) {
            abortExperienceTracker();
            // onOpenChange is called whenever FlyoutMenuItem component mounts, but we
            // only want to fire analytics event on user interaction. We check here if the
            // flyout has been opened before to ignore onOpenChange calls before user interaction
            if (hasBeenOpenedBefore.current) fireClickAnalytics(false);
            isFlyoutOpen && closeFlyout();
        } else {
            openFlyout();
            hasBeenOpenedBefore.current = true;
        }
    }, [
        abortExperienceTracker,
        fireClickAnalytics,
        isFlyoutOpen,
        closeFlyout,
        openFlyout
    ]);
    const onShortcutTriggered = (0, $42omo.useCallback)(()=>{
        if (!isFlyoutOpen) {
            fireClickAnalytics(true, true, isHidden);
            startExperienceTracker();
            openFlyout();
        }
    }, [
        fireClickAnalytics,
        isFlyoutOpen,
        startExperienceTracker,
        isHidden,
        openFlyout
    ]);
    const onClick = (0, $42omo.useCallback)(()=>{
        if (!isFlyoutOpen) {
            openFlyout();
            startExperienceTracker();
            fireClickAnalytics(true); //if we clicked on it we know it's not hidden or fired via keyboard shortcut
        } else closeFlyout();
    }, [
        fireClickAnalytics,
        isFlyoutOpen,
        startExperienceTracker,
        openFlyout,
        closeFlyout
    ]);
    const onHover = (0, $42omo.useCallback)(()=>{
        if (!isFlyoutOpen) {
            $d78d93494cd6b93d$export$17b89e6a36c6b530.preload();
            (0, $db09a4ff30df6c3f$export$4c74f8426e49d30c)();
        }
    }, [
        isFlyoutOpen
    ]);
    const isSelected = (0, $dPJCf.useRouteUrl)($d78d93494cd6b93d$var$isOnStarredRoute);
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)($d78d93494cd6b93d$var$MENU_ID, isSelected || isFlyoutOpen, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7f5a9a3cdf96d75c$export$65c30f73882c92dc), {
        deprecatedKeyboardShortcut: !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.GO_TO_STARRED_SHORTCUT) : undefined,
        keyboardShortcut: (0, $gnkil.UNIVERSAL_GO_TO_STARRED_SHORTCUT),
        isAppNavigationShortcut: true,
        onShortcutTriggered: onShortcutTriggered
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        onMouseEnter: onHover,
        onFocus: onHover
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h0OZ6.FlyoutMenuItem), {
        onOpenChange: onOpenChange,
        isOpen: isFlyoutOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f4c6t.FlyoutMenuItemTrigger), {
        elemBefore: (0, $cxU8R.StarIconComponent),
        onClick: onClick,
        isSelected: isSelected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $1LksZ.i18n).starred)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $580cg.FlyoutMenuItemContent), {
        onClose: ()=>isFlyoutOpen && closeFlyout(),
        autoFocus: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d78d93494cd6b93d$export$17b89e6a36c6b530, null)))));
};
const $d78d93494cd6b93d$var$isOnStarredRoute = {
    selector: (routeUrl)=>routeUrl === (0, $1NBp8.HOME).toUrl({
            view: 'starred'
        })
};

































var $5WLjq = parcelRequire("5WLjq");


var $ep3mz = parcelRequire("ep3mz");











var $a0CEX = parcelRequire("a0CEX");


























const $b163ca06b80c33e1$var$MENU_ID = 'spaces';

const $b163ca06b80c33e1$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("bfhzz"))).fireSpacesClickedAnalytics);
const $b163ca06b80c33e1$export$e60b35895fc7fef7 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(38);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId } = t0;
    const { isFlyoutOpen: isFlyoutOpen, openFlyout: openFlyout, closeFlyout: closeFlyout } = (0, $6adZX.useFlyout)($b163ca06b80c33e1$var$MENU_ID);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const selectedSpaceKey = spaceKey;
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const isMounted = (0, $42omo.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $b163ca06b80c33e1$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    if ($[0] !== experienceTracker) {
        t1 = ()=>{
            experienceTracker.abort({
                name: (0, $irVI7.APP_NAV_SPACES_DROPDOWN_EXPERIENCE),
                reason: "Primary dropdown menu: closed by user",
                attributes: {
                    navVersion: "4",
                    dropdownType: "spaces"
                }
            });
        };
        $[0] = experienceTracker;
        $[1] = t1;
    } else t1 = $[1];
    const abortExperienceTracker = t1;
    let t2;
    if ($[2] !== experienceTracker) {
        t2 = ()=>{
            experienceTracker.start({
                name: (0, $irVI7.APP_NAV_SPACES_DROPDOWN_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).NAVIGATION_LOAD,
                attributes: {
                    navVersion: "4",
                    dropdownType: "spaces"
                }
            });
        };
        $[2] = experienceTracker;
        $[3] = t2;
    } else t2 = $[3];
    const startExperienceTracker = t2;
    let t3;
    if ($[4] !== abortExperienceTracker || $[5] !== closeFlyout || $[6] !== fireClickAnalytics || $[7] !== isFlyoutOpen || $[8] !== openFlyout) {
        t3 = (newIsOpen)=>{
            if (!isMounted.current) {
                isMounted.current = true;
                return;
            }
            if (!newIsOpen) {
                abortExperienceTracker();
                fireClickAnalytics(false);
                isFlyoutOpen && closeFlyout();
            } else openFlyout();
        };
        $[4] = abortExperienceTracker;
        $[5] = closeFlyout;
        $[6] = fireClickAnalytics;
        $[7] = isFlyoutOpen;
        $[8] = openFlyout;
        $[9] = t3;
    } else t3 = $[9];
    const onOpenChange = t3;
    let t4;
    if ($[10] !== closeFlyout || $[11] !== fireClickAnalytics || $[12] !== isFlyoutOpen || $[13] !== openFlyout || $[14] !== startExperienceTracker) {
        t4 = ()=>{
            if (!isFlyoutOpen) {
                openFlyout();
                startExperienceTracker();
                fireClickAnalytics(true);
            } else closeFlyout();
        };
        $[10] = closeFlyout;
        $[11] = fireClickAnalytics;
        $[12] = isFlyoutOpen;
        $[13] = openFlyout;
        $[14] = startExperienceTracker;
        $[15] = t4;
    } else t4 = $[15];
    const onClick = t4;
    let t5;
    if ($[16] !== isFlyoutOpen || $[17] !== isLicensed || $[18] !== selectedSpaceKey) {
        t5 = ()=>{
            if (!isFlyoutOpen) {
                (0, $a0CEX.SpacesDropdownLoader).preload();
                if (selectedSpaceKey) (0, $5WLjq.preloadSpacesList)({
                    isLicensed: isLicensed,
                    selectedSpaceKey: selectedSpaceKey
                });
            }
        };
        $[16] = isFlyoutOpen;
        $[17] = isLicensed;
        $[18] = selectedSpaceKey;
        $[19] = t5;
    } else t5 = $[19];
    const onMouseEnter = t5;
    const isSelected = (0, $dPJCf.useRouteName)($b163ca06b80c33e1$var$isOnSpacesRoute);
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)($b163ca06b80c33e1$var$MENU_ID, isSelected || isFlyoutOpen, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    let t6;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $1LksZ.i18n).spaces);
        $[20] = t6;
    } else t6 = $[20];
    let t7;
    if ($[21] !== isSelected || $[22] !== onClick) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f4c6t.FlyoutMenuItemTrigger), {
            elemBefore: (0, $6mKj3.expVal)("confluence_space_icon_update", "isEnabled", false) ? (0, $cxU8R.SpacesIconComponent) : (0, $cxU8R.GlobeIconComponent),
            onClick: onClick,
            isSelected: isSelected
        }, t6);
        $[21] = isSelected;
        $[22] = onClick;
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== closeFlyout || $[25] !== isFlyoutOpen) {
        t8 = ()=>isFlyoutOpen && closeFlyout();
        $[24] = closeFlyout;
        $[25] = isFlyoutOpen;
        $[26] = t8;
    } else t8 = $[26];
    let t9;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $b163ca06b80c33e1$var$fixFocus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a0CEX.SpacesDropdownLoader), {
            isNav4Enabled: true
        }));
        $[27] = t9;
    } else t9 = $[27];
    let t10;
    if ($[28] !== t8) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $580cg.FlyoutMenuItemContent), {
            onClose: t8,
            autoFocus: false
        }, t9);
        $[28] = t8;
        $[29] = t10;
    } else t10 = $[29];
    let t11;
    if ($[30] !== isFlyoutOpen || $[31] !== onOpenChange || $[32] !== t10 || $[33] !== t7) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
            name: "spaces-item-spotlight"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h0OZ6.FlyoutMenuItem), {
            onOpenChange: onOpenChange,
            isOpen: isFlyoutOpen
        }, t7, t10));
        $[30] = isFlyoutOpen;
        $[31] = onOpenChange;
        $[32] = t10;
        $[33] = t7;
        $[34] = t11;
    } else t11 = $[34];
    let t12;
    if ($[35] !== onMouseEnter || $[36] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            onMouseEnter: onMouseEnter,
            onFocus: onMouseEnter
        }, t11));
        $[35] = onMouseEnter;
        $[36] = t11;
        $[37] = t12;
    } else t12 = $[37];
    return t12;
} : ({ isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId })=>{
    const { isFlyoutOpen: isFlyoutOpen, openFlyout: openFlyout, closeFlyout: closeFlyout } = (0, $6adZX.useFlyout)($b163ca06b80c33e1$var$MENU_ID);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const selectedSpaceKey = spaceKey;
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const isMounted = (0, $42omo.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $b163ca06b80c33e1$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const abortExperienceTracker = (0, $42omo.useCallback)(()=>{
        experienceTracker.abort({
            name: (0, $irVI7.APP_NAV_SPACES_DROPDOWN_EXPERIENCE),
            reason: 'Primary dropdown menu: closed by user',
            attributes: {
                navVersion: '4',
                dropdownType: 'spaces'
            }
        });
    }, [
        experienceTracker
    ]);
    const startExperienceTracker = (0, $42omo.useCallback)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.APP_NAV_SPACES_DROPDOWN_EXPERIENCE),
            timeout: (0, $aJPUt.ExperienceTimeout).NAVIGATION_LOAD,
            attributes: {
                navVersion: '4',
                dropdownType: 'spaces'
            }
        });
    }, [
        experienceTracker
    ]);
    const onOpenChange = (0, $42omo.useCallback)((newIsOpen)=>{
        if (!isMounted.current) {
            isMounted.current = true;
            return;
        }
        if (!newIsOpen) {
            abortExperienceTracker();
            fireClickAnalytics(false);
            isFlyoutOpen && closeFlyout();
        } else openFlyout();
    }, [
        abortExperienceTracker,
        fireClickAnalytics,
        isFlyoutOpen,
        openFlyout,
        closeFlyout
    ]);
    const onClick = (0, $42omo.useCallback)(()=>{
        if (!isFlyoutOpen) {
            openFlyout();
            startExperienceTracker();
            fireClickAnalytics(true);
        } else closeFlyout();
    }, [
        fireClickAnalytics,
        isFlyoutOpen,
        startExperienceTracker,
        openFlyout,
        closeFlyout
    ]);
    const onMouseEnter = (0, $42omo.useCallback)(()=>{
        if (!isFlyoutOpen) {
            (0, $a0CEX.SpacesDropdownLoader).preload();
            if (selectedSpaceKey) (0, $5WLjq.preloadSpacesList)({
                isLicensed: isLicensed,
                selectedSpaceKey: selectedSpaceKey
            });
        }
    }, [
        isFlyoutOpen,
        isLicensed,
        selectedSpaceKey
    ]);
    const isSelected = (0, $dPJCf.useRouteName)($b163ca06b80c33e1$var$isOnSpacesRoute);
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)($b163ca06b80c33e1$var$MENU_ID, isSelected || isFlyoutOpen, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        onMouseEnter: onMouseEnter,
        onFocus: onMouseEnter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: "spaces-item-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h0OZ6.FlyoutMenuItem), {
        onOpenChange: onOpenChange,
        isOpen: isFlyoutOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f4c6t.FlyoutMenuItemTrigger), {
        elemBefore: (0, $6mKj3.expVal)('confluence_space_icon_update', 'isEnabled', false) ? (0, $cxU8R.SpacesIconComponent) : (0, $cxU8R.GlobeIconComponent),
        onClick: onClick,
        isSelected: isSelected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $1LksZ.i18n).spaces)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $580cg.FlyoutMenuItemContent), {
        onClose: ()=>isFlyoutOpen && closeFlyout(),
        autoFocus: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b163ca06b80c33e1$var$fixFocus
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a0CEX.SpacesDropdownLoader), {
        isNav4Enabled: true
    })))))));
};
const $b163ca06b80c33e1$var$fixFocus = (0, $ecnYn.xcss)({
    //@ts-expect-error styling is applying but property does not exist for SafeCSSObject
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    a: {
        ':focus-visible': {
            outlineOffset: `${"var(--ds-space-negative-025, -2px)"}`
        }
    }
});
const $b163ca06b80c33e1$var$isOnSpacesRoute = {
    selector: (routeName)=>routeName === (0, $1NBp8.SPACE_DIRECTORY).name
};

















var $QU6QS = parcelRequire("QU6QS");





var $c1ydB = parcelRequire("c1ydB");

var $dXXAF = parcelRequire("dXXAF");

var $cNRxA = parcelRequire("cNRxA");























var $3b6WO = parcelRequire("3b6WO");





var $7aRa9 = parcelRequire("7aRa9");


























var $kpYGL = parcelRequire("kpYGL");


var $aGrg7 = parcelRequire("aGrg7");


var $gdv5Z = parcelRequire("gdv5Z");













var $2KDGn = parcelRequire("2KDGn");

var $2bhek = parcelRequire("2bhek");


var $lzcvT = parcelRequire("lzcvT");








var $9fBoq = parcelRequire("9fBoq");











var $5tgcI = parcelRequire("5tgcI");


var $g0ob9 = parcelRequire("g0ob9");











var $g9Ghb = parcelRequire("g9Ghb");




const $0f8b49aa1915d320$var$supportedItems = {
    'com.atlassian.confluence.plugins.confluence-space-ia:header-automation-link': 'confluence_space_settings_automation_list_item',
    'com.atlassian.confluence.extra.team-calendars:header-mycalendar-link': 'confluence_space_settings_calendars_list_item'
};
const $0f8b49aa1915d320$export$43d465b7d4e0318d = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { completeKey: completeKey, href: href } = t0;
    if (!completeKey || !$0f8b49aa1915d320$var$supportedItems[completeKey]) return null;
    const t1 = $0f8b49aa1915d320$var$supportedItems[completeKey];
    let t2;
    if ($[0] !== href || $[1] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g9Ghb.ReverseTrialLozengeListItemExperiment), {
            touchpointId: t1,
            edition: (0, $d9tcB.ConfluenceEdition).PREMIUM,
            href: href
        });
        $[0] = href;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ completeKey: completeKey, href: href })=>{
    if (!completeKey || !$0f8b49aa1915d320$var$supportedItems[completeKey]) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g9Ghb.ReverseTrialLozengeListItemExperiment), {
        touchpointId: $0f8b49aa1915d320$var$supportedItems[completeKey],
        edition: (0, $d9tcB.ConfluenceEdition).PREMIUM,
        href: href
    });
};



const $f16994fe41446773$var$AsyncDiscoverSection = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ABCqb",
    name: "AsyncDiscoverSection",
    loader: async ()=>(await (parcelRequire("2yoLO"))).DiscoverSection
});
const $f16994fe41446773$var$DISCOVER_URL = `${(0, $jlIaF.CONTEXT_PATH)}/marketplace`;
const $f16994fe41446773$export$a8ebc8242442c256 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(27);
    const { loading: loading, webItems: webItems, extensions: extensions } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent) {
        t1 = (itemId)=>()=>{
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "navigationItem",
                        actionSubjectId: "appsNavigationMenuItem",
                        source: "globalNavigation",
                        attributes: {
                            navigationLayer: "global",
                            navigationContainer: "sidebar",
                            navVersion: "4",
                            componentType: "customItem",
                            itemType: "app",
                            itemId: itemId,
                            section: "yourApps"
                        }
                    }
                }).fire();
            };
        $[0] = createAnalyticsEvent;
        $[1] = t1;
    } else t1 = $[1];
    const fireAppsNavigationItemClicked = t1;
    const location = (0, $QU6QS.useLocation)();
    const hasApps = webItems.length > 0 || extensions.length > 0;
    const displayApps = hasApps && !loading;
    let t2;
    if ($[2] !== displayApps) {
        t2 = displayApps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2bhek.MenuSectionHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f16994fe41446773$var$i18n.yourApps));
        $[2] = displayApps;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== displayApps || $[5] !== extensions || $[6] !== fireAppsNavigationItemClicked || $[7] !== location?.pathname || $[8] !== webItems) {
        t3 = displayApps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f16994fe41446773$var$AppItems, {
            webItems: webItems,
            extensions: extensions,
            pathname: location?.pathname || "",
            fireAppsNavigationItemClicked: fireAppsNavigationItemClicked
        });
        $[4] = displayApps;
        $[5] = extensions;
        $[6] = fireAppsNavigationItemClicked;
        $[7] = location?.pathname;
        $[8] = webItems;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== loading) {
        t4 = loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f16994fe41446773$var$LoadingSkeletons, null);
        $[10] = loading;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== t3 || $[13] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9kbAI.MenuList), null, t3, t4);
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    let t6;
    if ($[15] !== t2 || $[16] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2KDGn.MenuSection), null, t2, t5);
        $[15] = t2;
        $[16] = t5;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $9wGTI.fg)("confluence_nav_4_apps_menu_recommend") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f16994fe41446773$var$AsyncDiscoverSection, null);
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== fireAppsNavigationItemClicked || $[20] !== hasApps || $[21] !== loading || $[22] !== location?.pathname) {
        t8 = ((0, $9wGTI.fg)("use_frontend_feature_encoding_sdk") ? (0, $5spQU.isFeatureEnabled)("adminhub", "adminhub-apps-discovery") : !(0, $lzcvT.isFedRamp)()) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2KDGn.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9kbAI.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
            isSelected: location?.pathname?.includes($f16994fe41446773$var$DISCOVER_URL),
            href: $f16994fe41446773$var$DISCOVER_URL,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aGrg7))), {
                label: "",
                color: "currentColor"
            }),
            onClick: fireAppsNavigationItemClicked("exploreApps")
        }, loading || hasApps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f16994fe41446773$var$i18n.exploreMoreApps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f16994fe41446773$var$i18n.exploreApps))));
        $[19] = fireAppsNavigationItemClicked;
        $[20] = hasApps;
        $[21] = loading;
        $[22] = location?.pathname;
        $[23] = t8;
    } else t8 = $[23];
    let t9;
    if ($[24] !== t6 || $[25] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t6, t7, t8);
        $[24] = t6;
        $[25] = t8;
        $[26] = t9;
    } else t9 = $[26];
    return t9;
} : ({ loading: loading, webItems: webItems, extensions: extensions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireAppsNavigationItemClicked = (itemId)=>()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'navigationItem',
                    actionSubjectId: 'appsNavigationMenuItem',
                    source: 'globalNavigation',
                    attributes: {
                        navigationLayer: 'global',
                        navigationContainer: 'sidebar',
                        navVersion: '4',
                        componentType: 'customItem',
                        itemType: 'app',
                        itemId: itemId,
                        section: 'yourApps'
                    }
                }
            }).fire();
        };
    const location = (0, $QU6QS.useLocation)();
    const hasApps = webItems.length > 0 || extensions.length > 0;
    const displayApps = hasApps && !loading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2KDGn.MenuSection), null, displayApps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2bhek.MenuSectionHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f16994fe41446773$var$i18n.yourApps)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9kbAI.MenuList), null, displayApps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f16994fe41446773$var$AppItems, {
        webItems: webItems,
        extensions: extensions,
        pathname: location?.pathname || '',
        fireAppsNavigationItemClicked: fireAppsNavigationItemClicked
    }), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f16994fe41446773$var$LoadingSkeletons, null))), (0, $9wGTI.fg)('confluence_nav_4_apps_menu_recommend') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f16994fe41446773$var$AsyncDiscoverSection, null), ((0, $9wGTI.fg)('use_frontend_feature_encoding_sdk') ? (0, $5spQU.isFeatureEnabled)('adminhub', 'adminhub-apps-discovery') : !(0, $lzcvT.isFedRamp)()) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2KDGn.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9kbAI.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
        isSelected: location?.pathname?.includes($f16994fe41446773$var$DISCOVER_URL),
        href: $f16994fe41446773$var$DISCOVER_URL,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aGrg7))), {
            label: "",
            color: "currentColor"
        }),
        onClick: fireAppsNavigationItemClicked('exploreApps')
    }, loading || hasApps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f16994fe41446773$var$i18n.exploreMoreApps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f16994fe41446773$var$i18n.exploreApps)))));
};
const $f16994fe41446773$var$AppItems = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(15);
    const { webItems: webItems, extensions: extensions, pathname: pathname, fireAppsNavigationItemClicked: fireAppsNavigationItemClicked } = t0;
    let t1;
    if ($[0] !== fireAppsNavigationItemClicked || $[1] !== pathname || $[2] !== webItems) {
        let t2;
        if ($[4] !== fireAppsNavigationItemClicked || $[5] !== pathname) {
            t2 = (t3)=>{
                const { id: id, url: url, label: label, icon: icon, completeKey: completeKey, styleClass: styleClass } = t3;
                const href = $f16994fe41446773$var$fixWebItemUrl(url, completeKey);
                const injectStyleClass = (element)=>{
                    if (element === null) return;
                    if (typeof styleClass !== "string" || styleClass.length === 0) return;
                    const classList = styleClass.split(" ");
                    element.classList.add(...classList);
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
                    key: id,
                    ref: injectStyleClass,
                    href: href,
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g0ob9.AppIcon), {
                        url: icon?.path,
                        completeKey: completeKey
                    }),
                    elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0f8b49aa1915d320$export$43d465b7d4e0318d), {
                        completeKey: completeKey,
                        href: href
                    }),
                    isSelected: $f16994fe41446773$var$getIsSelected(pathname, href),
                    onClick: fireAppsNavigationItemClicked(completeKey)
                }, label);
            };
            $[4] = fireAppsNavigationItemClicked;
            $[5] = pathname;
            $[6] = t2;
        } else t2 = $[6];
        t1 = webItems.map(t2);
        $[0] = fireAppsNavigationItemClicked;
        $[1] = pathname;
        $[2] = webItems;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[7] !== extensions || $[8] !== pathname) {
        let t3;
        if ($[10] !== pathname) {
            t3 = (extension)=>{
                const href_0 = (0, $1NBp8.GLOBAL_PAGE_FORGE).toUrl({
                    appId: extension.appId,
                    envId: extension.environmentId,
                    forgeManifestRoute: extension.properties.route
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
                    key: extension.key,
                    href: href_0,
                    isSelected: $f16994fe41446773$var$getIsSelected(pathname, href_0),
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g0ob9.AppIcon), {
                        url: extension.properties.icon
                    })
                }, (0, $9fBoq.extensionTitle)(extension));
            };
            $[10] = pathname;
            $[11] = t3;
        } else t3 = $[11];
        t2 = extensions.map(t3);
        $[7] = extensions;
        $[8] = pathname;
        $[9] = t2;
    } else t2 = $[9];
    let t3;
    if ($[12] !== t1 || $[13] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1, t2);
        $[12] = t1;
        $[13] = t2;
        $[14] = t3;
    } else t3 = $[14];
    return t3;
} : ({ webItems: webItems, extensions: extensions, pathname: pathname, fireAppsNavigationItemClicked: fireAppsNavigationItemClicked })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, webItems.map(({ id: id, url: url, label: label, icon: icon, completeKey: completeKey, styleClass: styleClass })=>{
        const href = $f16994fe41446773$var$fixWebItemUrl(url, completeKey);
        /**
     * Injecting the `styleClass` using a callback ref.
     *
     * This could be a `useLayoutEffect` too, but we'd need to refactor this
     * render prop function to be a component.
     *
     * A `useLayoutEffect` might be desirable if we need to worry about
     * removing the styles, such as if `styleClass` can change.
     *
     * From what I can tell `styleClass` cannot change so this doesn't matter.
     *
     * Also, a callback ref should be called before any effects (better for TTVC?)
     */ const injectStyleClass = (element)=>{
            if (element === null) return;
            if (typeof styleClass !== 'string' || styleClass.length === 0) return;
            const classList = styleClass.split(' ');
            element.classList.add(...classList);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
            key: id,
            ref: injectStyleClass,
            href: href,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g0ob9.AppIcon), {
                url: icon?.path,
                completeKey: completeKey
            }),
            elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0f8b49aa1915d320$export$43d465b7d4e0318d), {
                completeKey: completeKey,
                href: href
            }),
            isSelected: $f16994fe41446773$var$getIsSelected(pathname, href),
            onClick: fireAppsNavigationItemClicked(completeKey)
        }, label);
    }), extensions.map((extension)=>{
        const href_0 = (0, $1NBp8.GLOBAL_PAGE_FORGE).toUrl({
            appId: extension.appId,
            envId: extension.environmentId,
            forgeManifestRoute: extension.properties.route
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
            key: extension.key,
            href: href_0,
            isSelected: $f16994fe41446773$var$getIsSelected(pathname, href_0),
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g0ob9.AppIcon), {
                url: extension.properties.icon
            })
        }, (0, $9fBoq.extensionTitle)(extension));
    }));
const $f16994fe41446773$var$LoadingSkeletons = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingBlockStart: "space.100",
            testId: "loading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "100%",
            height: "20px",
            borderRadius: "3px"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "100%",
            height: "20px",
            borderRadius: "3px"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "100%",
            height: "20px",
            borderRadius: "3px"
        })));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        paddingBlockStart: "space.100",
        testId: "loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "100%",
        height: "20px",
        borderRadius: "3px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "100%",
        height: "20px",
        borderRadius: "3px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "100%",
        height: "20px",
        borderRadius: "3px"
    })));
const $f16994fe41446773$var$absoluteUrlCheck = new RegExp('^(?:[a-z]+:)?//', 'i');
const $f16994fe41446773$var$fixWebItemUrl = (url, completeKey)=>{
    if (!url) return '#';
    if (completeKey === (0, $5tgcI.ANALYTICS_KEY) || completeKey === (0, $5tgcI.ANALYTICS_KEY_MODERATE)) return (0, $1NBp8.SITE_ANALYTICS).toUrl();
    if ($f16994fe41446773$var$absoluteUrlCheck.test(url)) return url;
    if (url.startsWith((0, $jlIaF.CONTEXT_PATH))) return url;
    return `${0, $jlIaF.CONTEXT_PATH}${url}`;
};
const $f16994fe41446773$var$getIsSelected = (pathname, href)=>{
    const hrefWithoutQuery = href.split('?')[0];
    return pathname === hrefWithoutQuery;
};
const $f16994fe41446773$var$i18n = (0, $cgtv4.defineMessages)({
    yourApps: {
        id: "side-navigation.global.apps.your-apps",
        defaultMessage: "Your apps"
    },
    exploreApps: {
        id: "side-navigation.global.apps.explore-apps",
        defaultMessage: "Explore apps"
    },
    exploreMoreApps: {
        id: "side-navigation.global.apps.explore-more-apps",
        defaultMessage: "Explore more apps"
    }
});

















var $9VJDA = parcelRequire("9VJDA");





var $1qfLF = parcelRequire("1qfLF");


var $lGgRw = parcelRequire("lGgRw");


var $cGtPE = parcelRequire("cGtPE");

var $2SlZp = parcelRequire("2SlZp");














const $b1f880ba7abf8fa5$var$useLazyClickMoreActionsAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("h8IEo"))).fireAppsMoreActionsButtonClicked);

const $b1f880ba7abf8fa5$var$useLazyClickMoreActionsItemAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("h8IEo"))).fireAppsMoreActionsDropdownItemClicked);
const $b1f880ba7abf8fa5$export$a70b62f9ab9df290 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(8);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickMoreActionsAnalytics = $b1f880ba7abf8fa5$var$useLazyClickMoreActionsAnalytics(createAnalyticsEvent);
    let t0;
    if ($[0] !== fireClickMoreActionsAnalytics) {
        t0 = ()=>{
            setIsOpen($b1f880ba7abf8fa5$var$_temp);
            fireClickMoreActionsAnalytics();
        };
        $[0] = fireClickMoreActionsAnalytics;
        $[1] = t0;
    } else t0 = $[1];
    const onClick = t0;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>setIsOpen(false);
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== onClick) {
        t2 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                icon: $b1f880ba7abf8fa5$var$_temp3,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $b1f880ba7abf8fa5$var$i18n.moreActions),
                onClick: onClick,
                spacing: "compact",
                appearance: "subtle",
                ...triggerProps
            });
        $[3] = onClick;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== isOpen || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            isOpen: isOpen,
            onClose: t1,
            content: $b1f880ba7abf8fa5$var$_temp2,
            trigger: t2,
            placement: "bottom-start",
            shouldRenderToParent: true
        });
        $[5] = isOpen;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ()=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickMoreActionsAnalytics = $b1f880ba7abf8fa5$var$useLazyClickMoreActionsAnalytics(createAnalyticsEvent);
    const onClick = ()=>{
        setIsOpen((v)=>!v);
        fireClickMoreActionsAnalytics();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1f880ba7abf8fa5$var$AppsMoreActionsMenuContent, null),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                        ...iconProps,
                        size: "small"
                    }),
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $b1f880ba7abf8fa5$var$i18n.moreActions),
                onClick: onClick,
                spacing: "compact",
                appearance: "subtle",
                ...triggerProps
            }),
        placement: "bottom-start",
        shouldRenderToParent: true
    });
};
const $b1f880ba7abf8fa5$var$AppsMoreActionsMenuContent = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(13);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { environment: environment, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const fireClickMoreActionsItemManageAppsAnalytics = $b1f880ba7abf8fa5$var$useLazyClickMoreActionsItemAnalytics(createAnalyticsEvent, "manageApps");
    const fireClickMoreActionsItemAppAuditLogsAnalytics = $b1f880ba7abf8fa5$var$useLazyClickMoreActionsItemAnalytics(createAnalyticsEvent, "appAuditLogs");
    const fireClickMoreActionsItemViewAppRequestsAnalytics = $b1f880ba7abf8fa5$var$useLazyClickMoreActionsItemAnalytics(createAnalyticsEvent, "viewAppRequests");
    const adminHubBaseUrl = environment == "PRODUCTION" ? "https://admin.atlassian.com" : "https://admin.stg.atlassian.com";
    const adminHubAppRequestsUrl = `${adminHubBaseUrl}/s/${cloudId}/user-connected-apps/tab/requested`;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $1NBp8.DEFAULT_ADMIN_MANAGE_APPS).toUrl();
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $b1f880ba7abf8fa5$var$i18n.manageApps);
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== fireClickMoreActionsItemManageAppsAnalytics) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cGtPE.default), {
            href: t0,
            target: "_blank",
            onClick: fireClickMoreActionsItemManageAppsAnalytics
        }, t1);
        $[2] = fireClickMoreActionsItemManageAppsAnalytics;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== fireClickMoreActionsItemAppAuditLogsAnalytics) {
        t3 = (0, $9wGTI.fg)("show_app_audit_logs_upm_dep") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cGtPE.default), {
            href: (0, $1NBp8.ADMIN_APP_AUDIT_LOGS).toUrl(),
            target: "_blank",
            onClick: fireClickMoreActionsItemAppAuditLogsAnalytics
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $b1f880ba7abf8fa5$var$i18n.appAuditLogs));
        $[4] = fireClickMoreActionsItemAppAuditLogsAnalytics;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== adminHubAppRequestsUrl || $[7] !== fireClickMoreActionsItemViewAppRequestsAnalytics) {
        t4 = (0, $9wGTI.fg)("confluence_frontend_enduser-emcee-discover") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cGtPE.default), {
            href: (0, $9wGTI.fg)("should_redirect_to_admin-hub_for_app_requests") ? adminHubAppRequestsUrl : (0, $1NBp8.MARKETPLACE_APP_REQUESTS).toUrl(),
            target: "_blank",
            onClick: fireClickMoreActionsItemViewAppRequestsAnalytics
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $b1f880ba7abf8fa5$var$i18n.viewAppRequests));
        $[6] = adminHubAppRequestsUrl;
        $[7] = fireClickMoreActionsItemViewAppRequestsAnalytics;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2SlZp.default), null, t2, t3, t4);
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { environment: environment, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const fireClickMoreActionsItemManageAppsAnalytics = $b1f880ba7abf8fa5$var$useLazyClickMoreActionsItemAnalytics(createAnalyticsEvent, 'manageApps');
    const fireClickMoreActionsItemAppAuditLogsAnalytics = $b1f880ba7abf8fa5$var$useLazyClickMoreActionsItemAnalytics(createAnalyticsEvent, 'appAuditLogs');
    const fireClickMoreActionsItemViewAppRequestsAnalytics = $b1f880ba7abf8fa5$var$useLazyClickMoreActionsItemAnalytics(createAnalyticsEvent, 'viewAppRequests');
    const adminHubBaseUrl = environment == 'PRODUCTION' ? 'https://admin.atlassian.com' : 'https://admin.stg.atlassian.com';
    const adminHubAppRequestsUrl = `${adminHubBaseUrl}/s/${cloudId}/user-connected-apps/tab/requested`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2SlZp.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cGtPE.default), {
        href: (0, $1NBp8.DEFAULT_ADMIN_MANAGE_APPS).toUrl(),
        target: "_blank",
        onClick: fireClickMoreActionsItemManageAppsAnalytics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $b1f880ba7abf8fa5$var$i18n.manageApps)), (0, $9wGTI.fg)('show_app_audit_logs_upm_dep') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cGtPE.default), {
        href: (0, $1NBp8.ADMIN_APP_AUDIT_LOGS).toUrl(),
        target: "_blank",
        onClick: fireClickMoreActionsItemAppAuditLogsAnalytics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $b1f880ba7abf8fa5$var$i18n.appAuditLogs)), (0, $9wGTI.fg)('confluence_frontend_enduser-emcee-discover') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cGtPE.default), {
        href: (0, $9wGTI.fg)('should_redirect_to_admin-hub_for_app_requests') ? adminHubAppRequestsUrl : (0, $1NBp8.MARKETPLACE_APP_REQUESTS).toUrl(),
        target: "_blank",
        onClick: fireClickMoreActionsItemViewAppRequestsAnalytics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $b1f880ba7abf8fa5$var$i18n.viewAppRequests)));
};
const $b1f880ba7abf8fa5$var$i18n = (0, $cgtv4.defineMessages)({
    moreActions: {
        id: "side-navigation.global.apps.more-actions",
        defaultMessage: "More actions"
    },
    manageApps: {
        id: "side-navigation.global.apps.manage-apps",
        defaultMessage: "Manage apps"
    },
    appAuditLogs: {
        id: "side-navigation.global.apps.app-audit-log",
        defaultMessage: "App audit logs"
    },
    viewAppRequests: {
        id: "side-navigation.global.apps.view-app-requests",
        defaultMessage: "View app requests"
    }
});
function $b1f880ba7abf8fa5$var$_temp(v) {
    return !v;
}
function $b1f880ba7abf8fa5$var$_temp2() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1f880ba7abf8fa5$var$AppsMoreActionsMenuContent, null);
}
function $b1f880ba7abf8fa5$var$_temp3(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
        ...iconProps,
        size: "small"
    });
}



var $8dUjs = parcelRequire("8dUjs");


const $9b893ee6ed889345$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("bfhzz"))).fireAppsClickedAnalytics);
const $9b893ee6ed889345$export$4c83861e794746b0 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(33);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId } = t0;
    const { edition: edition, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isAdmin = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $9b893ee6ed889345$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    let t1;
    if ($[0] !== accessStatus || $[1] !== edition) {
        t1 = (0, $8dUjs.getGlobalAppsParams)({
            edition: edition,
            accessStatus: accessStatus
        });
        $[0] = accessStatus;
        $[1] = edition;
        $[2] = t1;
    } else t1 = $[2];
    const { webItemParams: webItemParams, forgeExtensionParams: forgeExtensionParams } = t1;
    const { webItems: webItems, loading: webItemsLoading, error: webItemsError } = (0, $6ld6a.useWebItemLocation)(webItemParams);
    const { extensions: extensions, loading: extensionsLoading, error: extensionsError } = (0, $3b6WO.useExtensionList)(forgeExtensionParams);
    let t2;
    if ($[3] !== webItems) {
        t2 = webItems.map($9b893ee6ed889345$var$_temp);
        $[3] = webItems;
        $[4] = t2;
    } else t2 = $[4];
    const webItemUrls = t2;
    let t3;
    if ($[5] !== extensions) {
        t3 = extensions.map($9b893ee6ed889345$var$_temp2);
        $[5] = extensions;
        $[6] = t3;
    } else t3 = $[6];
    const extensionsUrls = t3;
    const location = (0, $QU6QS.useLocation)();
    let t4;
    if ($[7] !== extensionsUrls || $[8] !== location?.pathname || $[9] !== webItemUrls) {
        t4 = {
            selector: (routeUrl)=>{
                const path = routeUrl || location?.pathname;
                return webItemUrls.some((appUrl_0)=>path.includes(appUrl_0)) || extensionsUrls.some((appUrl)=>path.includes(appUrl)) || path.includes(`${(0, $jlIaF.CONTEXT_PATH)}/marketplace`);
            }
        };
        $[7] = extensionsUrls;
        $[8] = location?.pathname;
        $[9] = webItemUrls;
        $[10] = t4;
    } else t4 = $[10];
    const isOnAppsRoute = (0, $dPJCf.useRouteUrl)(t4);
    const loading = webItemsLoading || extensionsLoading;
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)("apps", isOnAppsRoute, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    let t5;
    if ($[11] !== fireClickAnalytics) {
        t5 = (_, __, analyticsAttributes)=>{
            const { isExpanded: isExpanded } = analyticsAttributes;
            fireClickAnalytics(isExpanded);
        };
        $[11] = fireClickAnalytics;
        $[12] = t5;
    } else t5 = $[12];
    const onClick = t5;
    let t6;
    if ($[13] !== isAdmin) {
        t6 = isAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1f880ba7abf8fa5$export$a70b62f9ab9df290), null);
        $[13] = isAdmin;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $1LksZ.i18n).apps);
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== onClick || $[17] !== t6) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cNRxA.ExpandableMenuItemTrigger), {
            elemBefore: (0, $cxU8R.AppsIconComponent),
            actionsOnHover: t6,
            onClick: onClick
        }, t7);
        $[16] = onClick;
        $[17] = t6;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== extensions || $[20] !== loading || $[21] !== webItems) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dXXAF.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f16994fe41446773$export$a8ebc8242442c256), {
            loading: loading,
            webItems: webItems,
            extensions: extensions
        }));
        $[19] = extensions;
        $[20] = loading;
        $[21] = webItems;
        $[22] = t9;
    } else t9 = $[22];
    let t10;
    if ($[23] !== isOnAppsRoute || $[24] !== t8 || $[25] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c1ydB.ExpandableMenuItem), {
            isDefaultExpanded: isOnAppsRoute
        }, t8, t9);
        $[23] = isOnAppsRoute;
        $[24] = t8;
        $[25] = t9;
        $[26] = t10;
    } else t10 = $[26];
    let t11;
    if ($[27] !== extensionsError || $[28] !== webItemsError) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9b893ee6ed889345$var$ErrorFlag, {
            webItemsError: webItemsError,
            extensionsError: extensionsError
        });
        $[27] = extensionsError;
        $[28] = webItemsError;
        $[29] = t11;
    } else t11 = $[29];
    let t12;
    if ($[30] !== t10 || $[31] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t10, t11);
        $[30] = t10;
        $[31] = t11;
        $[32] = t12;
    } else t12 = $[32];
    return t12;
} : ({ isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId })=>{
    const { edition: edition, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isAdmin = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $9b893ee6ed889345$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const { webItemParams: webItemParams, forgeExtensionParams: forgeExtensionParams } = (0, $8dUjs.getGlobalAppsParams)({
        edition: edition,
        accessStatus: accessStatus
    });
    const { webItems: webItems, loading: webItemsLoading, error: webItemsError } = (0, $6ld6a.useWebItemLocation)(webItemParams);
    const { extensions: extensions, loading: extensionsLoading, error: extensionsError } = (0, $3b6WO.useExtensionList)(forgeExtensionParams);
    const webItemUrls = webItems.map((webItem)=>(webItem.url || '').split('?')[0]);
    const extensionsUrls = extensions.map((extension)=>(0, $1NBp8.GLOBAL_PAGE_FORGE).toUrl({
            appId: extension.appId,
            envId: extension.environmentId,
            forgeManifestRoute: extension.properties.route
        }));
    const location = (0, $QU6QS.useLocation)();
    const isOnAppsRoute = (0, $dPJCf.useRouteUrl)({
        selector: (routeUrl)=>{
            const path = routeUrl || location?.pathname;
            return webItemUrls.some((appUrl_0)=>path.includes(appUrl_0)) || extensionsUrls.some((appUrl)=>path.includes(appUrl)) || path.includes(`${(0, $jlIaF.CONTEXT_PATH)}/marketplace`);
        }
    });
    const loading = webItemsLoading || extensionsLoading;
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)('apps', isOnAppsRoute, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    const onClick = (_, __, analyticsAttributes)=>{
        const { isExpanded: isExpanded } = analyticsAttributes;
        fireClickAnalytics(isExpanded);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c1ydB.ExpandableMenuItem), {
        isDefaultExpanded: isOnAppsRoute
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cNRxA.ExpandableMenuItemTrigger), {
        elemBefore: (0, $cxU8R.AppsIconComponent),
        actionsOnHover: isAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1f880ba7abf8fa5$export$a70b62f9ab9df290), null),
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $1LksZ.i18n).apps)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dXXAF.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f16994fe41446773$export$a8ebc8242442c256), {
        loading: loading,
        webItems: webItems,
        extensions: extensions
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9b893ee6ed889345$var$ErrorFlag, {
        webItemsError: webItemsError,
        extensionsError: extensionsError
    }));
};
const $9b893ee6ed889345$var$ErrorFlag = (0, $7aRa9.withFlags)(({ webItemsError: webItemsError, extensionsError: extensionsError, flags: flags })=>{
    (0, $42omo.useEffect)(()=>{
        if (webItemsError || extensionsError) flags.showFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $9b893ee6ed889345$var$errorI18n.errorTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $9b893ee6ed889345$var$errorI18n.errorDescription),
            type: 'error',
            close: 'auto'
        });
    }, [
        webItemsError,
        extensionsError,
        flags
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, webItemsError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: webItemsError
    }), extensionsError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: extensionsError
    }));
});
const $9b893ee6ed889345$var$errorI18n = (0, $cgtv4.defineMessages)({
    errorTitle: {
        id: "side-navigation.global.apps.error-title",
        defaultMessage: "We couldn\u2019t load apps"
    },
    errorDescription: {
        id: "side-navigation.global.apps.error-description",
        defaultMessage: "Refresh and try again."
    }
});
function $9b893ee6ed889345$var$_temp(webItem) {
    return (webItem.url || "").split("?")[0];
}
function $9b893ee6ed889345$var$_temp2(extension) {
    return (0, $1NBp8.GLOBAL_PAGE_FORGE).toUrl({
        appId: extension.appId,
        envId: extension.environmentId,
        forgeManifestRoute: extension.properties.route
    });
}
























const $7313825a48cf91f9$export$67e928cbe0262396 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(1);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId } = t0;
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)("topics", false, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
            href: "#",
            elemBefore: (0, $cxU8R.HashIconComponent)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $1LksZ.i18n).topics));
        $[0] = t1;
    } else t1 = $[0];
    return t1;
} : ({ isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId })=>{
    const isSelected = false; //toDo: this will be the all Spaces URL once flyouts support selected state
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)('topics', isSelected, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
        href: "#",
        elemBefore: (0, $cxU8R.HashIconComponent)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $1LksZ.i18n).topics));
};
























const $d18e4b06ef32e11b$export$cb6e506fa0abf530 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(1);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId } = t0;
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)("goals", false, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
            href: "#",
            elemBefore: (0, $cxU8R.GoalIconComponent)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $1LksZ.i18n).goals));
        $[0] = t1;
    } else t1 = $[0];
    return t1;
} : ({ isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId })=>{
    const isSelected = false;
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)('goals', isSelected, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
        href: "#",
        elemBefore: (0, $cxU8R.GoalIconComponent)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $1LksZ.i18n).goals));
};





































const $12bdfaacd20fcb4d$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("bfhzz"))).fireTeamsClickedAnalytics);
const $12bdfaacd20fcb4d$var$isOnPeopleRouteArgs = {
    selector: (routeName)=>{
        if (!routeName) return false;
        return routeName === (0, $1NBp8.PEOPLE_DIRECTORY).name;
    }
};
const $12bdfaacd20fcb4d$export$31c02f8c1cc69561 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId } = t0;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const isSelected = (0, $dPJCf.useRouteName)($12bdfaacd20fcb4d$var$isOnPeopleRouteArgs);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickedAnalytics = $12bdfaacd20fcb4d$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)("teams", isSelected, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $1NBp8.CONFLUENCE_PEOPLE_DIRECTORY_SEARCH).toUrl();
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $1LksZ.i18n).teams);
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== fireClickedAnalytics || $[3] !== isSelected) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
            href: t1,
            isSelected: isSelected,
            elemBefore: (0, $cxU8R.TeamsIconComponent),
            onClick: fireClickedAnalytics
        }, t2);
        $[2] = fireClickedAnalytics;
        $[3] = isSelected;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId })=>{
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const isSelected = (0, $dPJCf.useRouteName)($12bdfaacd20fcb4d$var$isOnPeopleRouteArgs);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickedAnalytics = $12bdfaacd20fcb4d$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)('teams', isSelected, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
        href: (0, $1NBp8.CONFLUENCE_PEOPLE_DIRECTORY_SEARCH).toUrl(),
        isSelected: isSelected,
        elemBefore: (0, $cxU8R.TeamsIconComponent),
        onClick: fireClickedAnalytics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $1LksZ.i18n).teams));
};





































const $b246fff4221da373$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("bfhzz"))).fireDraftsClickedAnalytics);
const $b246fff4221da373$var$onDraftSelector = {
    selector: (routeUrl)=>{
        if (!routeUrl) return false;
        return routeUrl === (0, $1NBp8.HOME).toUrl({
            view: 'drafts'
        });
    }
};
const $b246fff4221da373$export$cf67e987117d08e0 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId } = t0;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $b246fff4221da373$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const isSelected = (0, $dPJCf.useRouteUrl)($b246fff4221da373$var$onDraftSelector);
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)("drafts", isSelected, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $1NBp8.HOME).toUrl({
            view: "drafts"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $1LksZ.i18n).drafts);
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== fireClickAnalytics || $[3] !== isSelected || $[4] !== t1) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
            href: t1,
            elemBefore: (0, $cxU8R.EditIconComponent),
            isSelected: isSelected,
            onClick: fireClickAnalytics
        }, t2);
        $[2] = fireClickAnalytics;
        $[3] = isSelected;
        $[4] = t1;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId })=>{
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $b246fff4221da373$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const isSelected = (0, $dPJCf.useRouteUrl)($b246fff4221da373$var$onDraftSelector);
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)('drafts', isSelected, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
        href: (0, $1NBp8.HOME).toUrl({
            view: 'drafts'
        }),
        elemBefore: (0, $cxU8R.EditIconComponent),
        isSelected: isSelected,
        onClick: fireClickAnalytics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $1LksZ.i18n).drafts));
};





































const $708853e8a76c69ca$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("bfhzz"))).fireTasksClickedAnalytics);
const $708853e8a76c69ca$var$onTasksSelector = {
    selector: (routeUrl)=>{
        if (!routeUrl) return false;
        return routeUrl === (0, $1NBp8.HOME).toUrl({
            view: 'tasks'
        });
    }
};
const $708853e8a76c69ca$export$a0a057c2941dc0bc = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId } = t0;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $708853e8a76c69ca$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const isSelected = (0, $dPJCf.useRouteUrl)($708853e8a76c69ca$var$onTasksSelector);
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)("tasks", isSelected, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $1NBp8.HOME).toUrl({
            view: "tasks"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $1LksZ.i18n).tasks);
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== fireClickAnalytics || $[3] !== isSelected || $[4] !== t1) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
            href: t1,
            elemBefore: (0, $cxU8R.TaskIconComponent),
            isSelected: isSelected,
            onClick: fireClickAnalytics
        }, t2);
        $[2] = fireClickAnalytics;
        $[3] = isSelected;
        $[4] = t1;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId })=>{
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $708853e8a76c69ca$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const isSelected = (0, $dPJCf.useRouteUrl)($708853e8a76c69ca$var$onTasksSelector);
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)('tasks', isSelected, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
        href: (0, $1NBp8.HOME).toUrl({
            view: 'tasks'
        }),
        elemBefore: (0, $cxU8R.TaskIconComponent),
        isSelected: isSelected,
        onClick: fireClickAnalytics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $1LksZ.i18n).tasks));
};





































const $6f20c917496dda1e$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("bfhzz"))).fireTemplatesClickedAnalytics);
const $6f20c917496dda1e$var$isOnTemplatesSelector = {
    selector: (routeUrl)=>{
        if (!routeUrl) return false;
        return routeUrl.includes((0, $1NBp8.TEMPLATE_GALLERY).toUrl()); //templates adds a bunch of query components
    }
};
const $6f20c917496dda1e$export$9e7802a7d1db8cfc = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId } = t0;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $6f20c917496dda1e$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const isSelected = (0, $dPJCf.useRouteUrl)($6f20c917496dda1e$var$isOnTemplatesSelector);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $1NBp8.TEMPLATE_GALLERY).toUrl();
        $[0] = t1;
    } else t1 = $[0];
    const templateUrl = t1;
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)("templates", isSelected, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $1LksZ.i18n).templates);
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== fireClickAnalytics || $[3] !== isSelected) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
            href: templateUrl,
            elemBefore: (0, $cxU8R.TemplatesIconComponent),
            isSelected: isSelected,
            onClick: fireClickAnalytics
        }, t2);
        $[2] = fireClickAnalytics;
        $[3] = isSelected;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId })=>{
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $6f20c917496dda1e$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const isSelected = (0, $dPJCf.useRouteUrl)($6f20c917496dda1e$var$isOnTemplatesSelector);
    const templateUrl = (0, $1NBp8.TEMPLATE_GALLERY).toUrl();
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)('templates', isSelected, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
        href: templateUrl,
        elemBefore: (0, $cxU8R.TemplatesIconComponent),
        isSelected: isSelected,
        onClick: fireClickAnalytics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $1LksZ.i18n).templates));
};



























var $6JI2k = parcelRequire("6JI2k");


var $56QzY = parcelRequire("56QzY");

















var $lKMTm = parcelRequire("lKMTm");


var $fyVkL = parcelRequire("fyVkL");















var $fpGTa = parcelRequire("fpGTa");




var $bxB0V = parcelRequire("bxB0V");


var $eAuT4 = parcelRequire("eAuT4");


var $ivb8S = parcelRequire("ivb8S");

const $7d661c853a7c7be3$export$14b76ab4aeca40fb = ({ shouldShow: shouldShow = false, onOkAction: onOkAction, onTryItAction: onTryItAction, onOutsideClick: onOutsideClick, children: children })=>{
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        onOkAction?.();
        setOnboardingState({
            key: (0, $eAuT4.NOTES_ONBOARDING_SPOTLIGHT).SPOTLIGHT_DISMISSED,
            value: 'true'
        });
    }, [
        onOkAction,
        setOnboardingState
    ]);
    const handleTryItClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'tryIt',
                source: 'notesOnboardingSpotlight'
            }
        }).fire();
        onTryItAction?.();
        handleDismiss();
    }, [
        onTryItAction,
        createAnalyticsEvent,
        handleDismiss
    ]);
    const handleOkClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismiss',
                source: 'notesOnboardingSpotlight'
            }
        }).fire();
        handleDismiss();
    }, [
        createAnalyticsEvent,
        handleDismiss
    ]);
    const handleLearnMoreClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'learnMore',
                source: 'notesOnboardingSpotlight'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const handleOutsideClick = (0, $42omo.useCallback)(()=>{
        handleDismiss();
        onOutsideClick?.();
    }, [
        handleDismiss,
        onOutsideClick
    ]);
    (0, $42omo.useEffect)(()=>{
        if (shouldShow) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'shown',
                actionSubject: 'nudgeTooltip',
                actionSubjectId: 'notesOnboarding',
                source: 'notesOnboardingSpotlight'
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        shouldShow
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bxB0V.OnboardingNudge), {
        hidden: !shouldShow,
        setHidden: ()=>{},
        heading: formatMessage($7d661c853a7c7be3$var$i18n.heading),
        actions: [
            {
                onClick: handleTryItClick,
                text: formatMessage($7d661c853a7c7be3$var$i18n.tryItButton)
            },
            {
                onClick: handleOkClick,
                text: formatMessage($7d661c853a7c7be3$var$i18n.okButton)
            }
        ],
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...$7d661c853a7c7be3$var$i18n.body,
            values: {
                a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fpGTa.default), {
                        href: "https://support.atlassian.com/confluence-cloud/docs/create-and-edit-pages/",
                        target: "_blank",
                        onClick: handleLearnMoreClick,
                        xcss: $7d661c853a7c7be3$var$linkStyles,
                        tabIndex: -1
                    }, chunks)
            }
        }),
        actionSubjectId: "notesOnboarding",
        source: "notesOnboardingSpotlight",
        width: 275,
        position: "right-start",
        hideNudgeOnClick: false,
        hideSpotlightCardOnOutsideClick: false,
        onOutsideClick: handleOutsideClick
    }, children);
};
const $7d661c853a7c7be3$var$linkStyles = (0, $ecnYn.xcss)({
    textDecoration: 'underline',
    cursor: 'pointer',
    color: 'color.text.inverse',
    ':hover': {
        color: 'color.text.inverse'
    }
});
const $7d661c853a7c7be3$var$i18n = (0, $cgtv4.defineMessages)({
    heading: {
        id: "onboarding-notes.introSpotlight.heading",
        defaultMessage: "Take notes in private"
    },
    body: {
        id: "onboarding-notes.introSpotlight.body",
        defaultMessage: "<a>Jot down ideas</a> or create to-dos that no one can see but you."
    },
    okButton: {
        id: "onboarding-notes.introSpotlight.okButton",
        defaultMessage: "Ok"
    },
    tryItButton: {
        id: "onboarding-notes.introSpotlight.tryItButton",
        defaultMessage: "Try it"
    }
});



















const $b6615b59aab94fd3$var$NotesMenuLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "KFEHX",
    name: "NotesMenuLoader",
    loader: async ()=>(await (parcelRequire("ljgqo"))).NotesMenu,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lg4wi.ContentMenuLoadingState), null)
});
const $b6615b59aab94fd3$var$i18n = (0, $cgtv4.defineMessages)({
    notes: {
        id: "side-navigation.global.notes",
        defaultMessage: "Notes"
    }
});
const $b6615b59aab94fd3$var$MENU_ID = 'notes';
const $b6615b59aab94fd3$export$9eb8b2e7dc4d6ce3 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(52);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { isFlyoutOpen: isFlyoutOpen, openFlyout: openFlyout, closeFlyout: closeFlyout } = (0, $6adZX.useFlyout)($b6615b59aab94fd3$var$MENU_ID);
    const { setActiveNoteId: setActiveNoteId } = (0, $6JI2k.useNotesActions)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const [hasHovered, setHasHovered] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $9wGTI.fg)("cc_notes_onboarding_spotlight");
        $[0] = t1;
    } else t1 = $[0];
    const { data: onboardingStateData, loading: isOnboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)((0, $eAuT4.NOTES_ONBOARDING_SPOTLIGHT).SPOTLIGHT_DISMISSED, !t1);
    let t2;
    if ($[1] !== onboardingStateData) {
        t2 = (0, $ivb8S.deserializeState)(onboardingStateData);
        $[1] = onboardingStateData;
        $[2] = t2;
    } else t2 = $[2];
    const { hasSpotlightDismissed: hasSpotlightDismissed } = t2;
    let t3;
    if ($[3] !== closeFlyout || $[4] !== setActiveNoteId) {
        t3 = (noteId)=>{
            setActiveNoteId(noteId);
            closeFlyout();
        };
        $[3] = closeFlyout;
        $[4] = setActiveNoteId;
        $[5] = t3;
    } else t3 = $[5];
    const onNoteClick = t3;
    let t4;
    if ($[6] !== closeFlyout || $[7] !== createAnalyticsEvent || $[8] !== hasSpotlightDismissed || $[9] !== isFlyoutOpen || $[10] !== openFlyout || $[11] !== routeDataRef || $[12] !== setOnboardingState) {
        t4 = ()=>{
            if (!isFlyoutOpen) openFlyout();
            else closeFlyout();
            if (!hasSpotlightDismissed) setOnboardingState({
                key: (0, $eAuT4.NOTES_ONBOARDING_SPOTLIGHT).SPOTLIGHT_DISMISSED,
                value: "true"
            });
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "globalNavigation",
                    action: "clicked",
                    actionSubject: "navigationItem",
                    actionSubjectId: "notes",
                    attributes: {
                        selectedItemPageContext: routeDataRef.current?.routeName,
                        navigationLayer: "global",
                        navVersion: "4",
                        navdexPointType: (0, $56QzY.START_TOUCH)
                    }
                }
            }).fire();
        };
        $[6] = closeFlyout;
        $[7] = createAnalyticsEvent;
        $[8] = hasSpotlightDismissed;
        $[9] = isFlyoutOpen;
        $[10] = openFlyout;
        $[11] = routeDataRef;
        $[12] = setOnboardingState;
        $[13] = t4;
    } else t4 = $[13];
    const onClickNavItem = t4;
    let t5;
    if ($[14] !== closeFlyout || $[15] !== isFlyoutOpen) {
        t5 = ()=>{
            if (isFlyoutOpen) closeFlyout();
        };
        $[14] = closeFlyout;
        $[15] = isFlyoutOpen;
        $[16] = t5;
    } else t5 = $[16];
    const onNoteCreate = t5;
    const { createNote: createNote } = (0, $lKMTm.useNotesData)();
    let t6;
    if ($[17] !== createAnalyticsEvent || $[18] !== createNote || $[19] !== onNoteCreate || $[20] !== setActiveNoteId) {
        t6 = async ()=>{
            const { data: data } = await createNote({
                variables: {
                    body: "{\"version\":1,\"type\":\"doc\",\"content\":[]}"
                }
            });
            setActiveNoteId(data?.createNote?.note?.ari);
            if (data?.createNote?.success && data?.createNote?.note?.ari) (0, $fyVkL.triggerCreationTrackEvent)({
                createAnalyticsEvent: createAnalyticsEvent,
                noteId: data.createNote.note.ari,
                entryPoint: "createNoteShortcut"
            });
            onNoteCreate?.();
        };
        $[17] = createAnalyticsEvent;
        $[18] = createNote;
        $[19] = onNoteCreate;
        $[20] = setActiveNoteId;
        $[21] = t6;
    } else t6 = $[21];
    const handleNoteCreation = t6;
    let t7;
    if ($[22] !== closeFlyout || $[23] !== isFlyoutOpen || $[24] !== openFlyout) {
        t7 = (newIsOpen)=>{
            if (!newIsOpen) isFlyoutOpen && closeFlyout();
            else openFlyout();
        };
        $[22] = closeFlyout;
        $[23] = isFlyoutOpen;
        $[24] = openFlyout;
        $[25] = t7;
    } else t7 = $[25];
    const onOpenChange = t7;
    let t8;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = ()=>{
            if ((0, $9wGTI.fg)("cc_notes_onboarding_spotlight")) setHasHovered(true);
        };
        $[26] = t8;
    } else t8 = $[26];
    const handleMouseEnter = t8;
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)($b6615b59aab94fd3$var$MENU_ID, isFlyoutOpen, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    let t9;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $b6615b59aab94fd3$var$i18n.notes);
        $[27] = t9;
    } else t9 = $[27];
    let t10;
    if ($[28] !== onClickNavItem) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f4c6t.FlyoutMenuItemTrigger), {
            elemBefore: (0, $cxU8R.NotesIconComponent),
            onClick: onClickNavItem
        }, t9);
        $[28] = onClickNavItem;
        $[29] = t10;
    } else t10 = $[29];
    let t11;
    if ($[30] !== closeFlyout || $[31] !== isFlyoutOpen) {
        t11 = ()=>isFlyoutOpen && closeFlyout();
        $[30] = closeFlyout;
        $[31] = isFlyoutOpen;
        $[32] = t11;
    } else t11 = $[32];
    let t12;
    if ($[33] !== onNoteClick || $[34] !== onNoteCreate) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b6615b59aab94fd3$var$NotesMenuLoader, {
            onNoteClick: onNoteClick,
            onNoteCreate: onNoteCreate
        });
        $[33] = onNoteClick;
        $[34] = onNoteCreate;
        $[35] = t12;
    } else t12 = $[35];
    let t13;
    if ($[36] !== t11 || $[37] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $580cg.FlyoutMenuItemContent), {
            onClose: t11,
            autoFocus: false
        }, t12);
        $[36] = t11;
        $[37] = t12;
        $[38] = t13;
    } else t13 = $[38];
    let t14;
    if ($[39] !== handleNoteCreation) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            accelerator: (0, $gnkil.UNIVERSAL_CREATE_NOTE_SHORTCUT),
            listener: handleNoteCreation,
            isAppNavigationShortcut: true
        });
        $[39] = handleNoteCreation;
        $[40] = t14;
    } else t14 = $[40];
    let t15;
    if ($[41] !== isFlyoutOpen || $[42] !== onOpenChange || $[43] !== t10 || $[44] !== t13 || $[45] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h0OZ6.FlyoutMenuItem), {
            onOpenChange: onOpenChange,
            isOpen: isFlyoutOpen
        }, t10, t13, t14);
        $[41] = isFlyoutOpen;
        $[42] = onOpenChange;
        $[43] = t10;
        $[44] = t13;
        $[45] = t14;
        $[46] = t15;
    } else t15 = $[46];
    const notesMenuItem = t15;
    const shouldShowSpotlight = !isOnboardingStateLoading && !!onboardingStateData && !hasSpotlightDismissed && hasHovered;
    let t16;
    if ($[47] !== shouldShowSpotlight) {
        t16 = shouldShowSpotlight && (0, $9wGTI.fg)("cc_notes_onboarding_spotlight");
        $[47] = shouldShowSpotlight;
        $[48] = t16;
    } else t16 = $[48];
    let t17;
    if ($[49] !== notesMenuItem || $[50] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            onMouseEnter: handleMouseEnter,
            onFocus: handleMouseEnter,
            "data-testid": "notes-item-wrapper",
            role: "button",
            tabIndex: 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d661c853a7c7be3$export$14b76ab4aeca40fb), {
            shouldShow: t16
        }, notesMenuItem));
        $[49] = notesMenuItem;
        $[50] = t16;
        $[51] = t17;
    } else t17 = $[51];
    return t17;
} : ({ isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { isFlyoutOpen: isFlyoutOpen, openFlyout: openFlyout, closeFlyout: closeFlyout } = (0, $6adZX.useFlyout)($b6615b59aab94fd3$var$MENU_ID);
    const { setActiveNoteId: setActiveNoteId } = (0, $6JI2k.useNotesActions)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const [hasHovered, setHasHovered] = (0, $42omo.useState)(false);
    const { data: onboardingStateData, loading: isOnboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)((0, $eAuT4.NOTES_ONBOARDING_SPOTLIGHT).SPOTLIGHT_DISMISSED, !(0, $9wGTI.fg)('cc_notes_onboarding_spotlight'));
    const { hasSpotlightDismissed: hasSpotlightDismissed } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const onNoteClick = (0, $42omo.useCallback)((noteId)=>{
        setActiveNoteId(noteId);
        closeFlyout();
    }, [
        closeFlyout,
        setActiveNoteId
    ]);
    const onClickNavItem = (0, $42omo.useCallback)(()=>{
        if (!isFlyoutOpen) openFlyout();
        else closeFlyout();
        if (!hasSpotlightDismissed) setOnboardingState({
            key: (0, $eAuT4.NOTES_ONBOARDING_SPOTLIGHT).SPOTLIGHT_DISMISSED,
            value: 'true'
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'notes',
                attributes: {
                    selectedItemPageContext: routeDataRef.current?.routeName,
                    navigationLayer: 'global',
                    navVersion: '4',
                    navdexPointType: (0, $56QzY.START_TOUCH)
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isFlyoutOpen,
        openFlyout,
        closeFlyout,
        hasSpotlightDismissed,
        setOnboardingState,
        routeDataRef
    ]);
    const onNoteCreate = (0, $42omo.useCallback)(()=>{
        if (isFlyoutOpen) closeFlyout();
    }, [
        isFlyoutOpen,
        closeFlyout
    ]);
    const { createNote: createNote } = (0, $lKMTm.useNotesData)();
    const handleNoteCreation = (0, $42omo.useCallback)(async ()=>{
        // Currently, we are sending in an empty adf body for note creation, but may need to replace this
        // when the BE is capable of handling a null body
        const { data: data } = await createNote({
            variables: {
                body: '{"version":1,"type":"doc","content":[]}'
            }
        });
        setActiveNoteId(data?.createNote?.note?.ari);
        if (data?.createNote?.success && data?.createNote?.note?.ari) (0, $fyVkL.triggerCreationTrackEvent)({
            createAnalyticsEvent: createAnalyticsEvent,
            noteId: data.createNote.note.ari,
            entryPoint: 'createNoteShortcut'
        });
        onNoteCreate?.();
    }, [
        createNote,
        setActiveNoteId,
        onNoteCreate,
        createAnalyticsEvent
    ]);
    const onOpenChange = (0, $42omo.useCallback)((newIsOpen)=>{
        if (!newIsOpen) isFlyoutOpen && closeFlyout();
        else openFlyout();
    }, [
        isFlyoutOpen,
        closeFlyout,
        openFlyout
    ]);
    const handleMouseEnter = (0, $42omo.useCallback)(()=>{
        if ((0, $9wGTI.fg)('cc_notes_onboarding_spotlight')) setHasHovered(true);
    }, []);
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)($b6615b59aab94fd3$var$MENU_ID, isFlyoutOpen, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    const notesMenuItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h0OZ6.FlyoutMenuItem), {
        onOpenChange: onOpenChange,
        isOpen: isFlyoutOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f4c6t.FlyoutMenuItemTrigger), {
        elemBefore: (0, $cxU8R.NotesIconComponent),
        onClick: onClickNavItem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $b6615b59aab94fd3$var$i18n.notes)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $580cg.FlyoutMenuItemContent), {
        onClose: ()=>isFlyoutOpen && closeFlyout(),
        autoFocus: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b6615b59aab94fd3$var$NotesMenuLoader, {
        onNoteClick: onNoteClick,
        onNoteCreate: onNoteCreate
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_CREATE_NOTE_SHORTCUT),
        listener: handleNoteCreation,
        isAppNavigationShortcut: true
    }));
    const shouldShowSpotlight = !isOnboardingStateLoading && !!onboardingStateData && !hasSpotlightDismissed && hasHovered;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        onMouseEnter: handleMouseEnter,
        onFocus: handleMouseEnter,
        "data-testid": "notes-item-wrapper",
        role: "button",
        tabIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d661c853a7c7be3$export$14b76ab4aeca40fb), {
        shouldShow: shouldShowSpotlight && (0, $9wGTI.fg)('cc_notes_onboarding_spotlight')
    }, notesMenuItem));
};


































const $95245a9bd03c7ad9$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("bfhzz"))).fireCustomizeSidebarClickedAnalytics);
const $95245a9bd03c7ad9$export$249a65f26e2bc7f5 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId, setIsCustomizeSidebarDialogVisible: setIsCustomizeSidebarDialogVisible } = t0;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $95245a9bd03c7ad9$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    let t1;
    if ($[0] !== fireClickAnalytics || $[1] !== setIsCustomizeSidebarDialogVisible) {
        t1 = ()=>{
            setIsCustomizeSidebarDialogVisible(true);
            fireClickAnalytics();
        };
        $[0] = fireClickAnalytics;
        $[1] = setIsCustomizeSidebarDialogVisible;
        $[2] = t1;
    } else t1 = $[2];
    const onClick = t1;
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)("customize", false, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $1LksZ.i18n).customize);
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== onClick) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iI2ST.ButtonMenuItem), {
            elemBefore: (0, $cxU8R.CustomizeIconComponent),
            onClick: onClick
        }, t2);
        $[4] = onClick;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId, setIsCustomizeSidebarDialogVisible: setIsCustomizeSidebarDialogVisible })=>{
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $95245a9bd03c7ad9$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const onClick = (0, $42omo.useCallback)(()=>{
        setIsCustomizeSidebarDialogVisible(true);
        fireClickAnalytics();
    }, [
        fireClickAnalytics,
        setIsCustomizeSidebarDialogVisible
    ]);
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)('customize', false, // will never be "selected" if in the more menu
    isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iI2ST.ButtonMenuItem), {
        elemBefore: (0, $cxU8R.CustomizeIconComponent),
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $1LksZ.i18n).customize));
};






const $19a89177b077740c$export$d6688983e7eca068 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "SqNIQ",
    name: "TeamsAppShortcutLoader",
    loader: async ()=>(await (parcelRequire("iydiV"))).TeamsAppShortcutItem
});









const $ddfb598ef229bd1a$export$7bd12ce5959bde45 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { shortcutsConfig: shortcutsConfig, customizationMenuConfig: customizationMenuConfig, children: children } = t0;
    const orderedShortcuts = (0, $87d6e462347f520d$export$4bb4a114d280c175)(shortcutsConfig, customizationMenuConfig);
    let t1;
    if ($[0] !== children || $[1] !== orderedShortcuts) {
        t1 = children({
            shortcuts: orderedShortcuts
        });
        $[0] = children;
        $[1] = orderedShortcuts;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ shortcutsConfig: shortcutsConfig, customizationMenuConfig: customizationMenuConfig, children: children })=>{
    // sort filtered products based on order of customizationMenuConfig
    const orderedShortcuts = (0, $87d6e462347f520d$export$4bb4a114d280c175)(shortcutsConfig, customizationMenuConfig);
    return children({
        shortcuts: orderedShortcuts
    });
};



const $7b79f828379224e7$var$CustomizationModalLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Vj9xc",
    name: "CustomizationModalLoader",
    loader: async ()=>{
        const { CustomizationModalComponent: CustomizationModalComponent } = await (parcelRequire("335sG"));
        return CustomizationModalComponent;
    }
});
const $7b79f828379224e7$export$311d3c02bd72bcc0 = 'confluence.sidebar.';

const $7b79f828379224e7$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("bfhzz"))).fireMoreMenuClickedAnalytics);
const $7b79f828379224e7$var$hasAccess = (accessStatus)=>![
        (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS,
        (0, $d9tcB.AccessStatus).UNLICENSED_AUTHENTICATED_ACCESS,
        null
    ].includes(accessStatus);
const $7b79f828379224e7$var$hasGlobalAppShortcutsAccess = (accessStatus)=>![
        (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS,
        (0, $d9tcB.AccessStatus).EXTERNAL_SHARE_ACCESS,
        (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS,
        (0, $d9tcB.AccessStatus).NOT_PERMITTED,
        null
    ].includes(accessStatus);
const $7b79f828379224e7$var$GlobalItemComponents = {
    customHome: (0, $15140e42b692bfde$export$adaf351fc9d12cd2),
    yourWork: (0, $b9c6e796d679cd96$export$d16f83425c70386f),
    companyHub: (0, $67a256fbfa808886$export$7d5e579a7612f1c2),
    recent: (0, $43bbe423a7434a33$export$f1cccf52bb5faf3f),
    starred: (0, $d78d93494cd6b93d$export$d11aa717bebc8f86),
    spaces: (0, $b163ca06b80c33e1$export$e60b35895fc7fef7),
    apps: (0, $9b893ee6ed889345$export$4c83861e794746b0),
    goals: (0, $d18e4b06ef32e11b$export$cb6e506fa0abf530),
    topics: (0, $7313825a48cf91f9$export$67e928cbe0262396),
    teams: (0, $12bdfaacd20fcb4d$export$31c02f8c1cc69561),
    drafts: (0, $b246fff4221da373$export$cf67e987117d08e0),
    tasks: (0, $708853e8a76c69ca$export$a0a057c2941dc0bc),
    templates: (0, $6f20c917496dda1e$export$9e7802a7d1db8cfc),
    notes: (0, $b6615b59aab94fd3$export$9eb8b2e7dc4d6ce3),
    customize: (0, $95245a9bd03c7ad9$export$249a65f26e2bc7f5)
};
const $7b79f828379224e7$export$f83d6aa785dd4970 = ({ productSideNavigation: productSideNavigation, isOnAnySettingsScreen: isOnAnySettingsScreen, isCollapsed: isCollapsed })=>{
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const [peekingId, setPeekingId] = (0, $42omo.useState)(undefined);
    const [isMoreMenuOpen, setIsMoreMenuOpen] = (0, $42omo.useState)(false);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $7b79f828379224e7$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const { openFlyout: openFlyout, closeFlyout: closeFlyout } = (0, $6adZX.useFlyoutActions)();
    const transitionId = (0, $dPJCf.useTransitionId)();
    const teamsAppEnabled = (0, $5XsiK.isTeamsAppEnabled)();
    const [getFilteredProductLinks, setGetFilteredProductLinks] = (0, $42omo.useState)(undefined);
    const [isCustomizeSidebarDialogVisible, setIsCustomizeSidebarDialogVisible] = (0, $42omo.useState)(false);
    const jiraShortcut = (0, $e306a0f1948559b4$export$b34e755010aed2b2)('');
    const isInvitedAppShortcutsEnabled = (0, $42omo.useMemo)(()=>// we split the kill-switch gate and targeting gate to avoid the overrides precedence issue
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('twcg-460-personalised-invite-notifications-m2-gate') && // TODO: add eligibility check hook later
        (0, $6mKj3.expVal)('twcg-460-personalised-invite-notifications-m2', 'isEnabled', false), []);
    const invitedAppShortcutsConfig = (0, $42omo.useMemo)(()=>{
        if (!isInvitedAppShortcutsEnabled) return {};
        return {
            jira: jiraShortcut
        };
    }, [
        isInvitedAppShortcutsEnabled,
        jiraShortcut
    ]);
    const { invitedAppProductLinks: invitedAppProductLinks, handleUpdateInvitedAppProductLinks: handleUpdateInvitedAppProductLinks } = (0, $87dae69a81f59d82$export$f96c96985b06f150)({
        enabled: isInvitedAppShortcutsEnabled,
        shortcutItemsConfig: invitedAppShortcutsConfig
    });
    (0, $42omo.useEffect)(()=>{
        if (transitionId && transitionId > 0) //on any transition close open flyout. On initial Load transitionId = 0
        closeFlyout();
    }, [
        closeFlyout,
        transitionId
    ]);
    const moreMenuOnClickCallback = (0, $42omo.useCallback)((menuId)=>{
        setIsMoreMenuOpen(!isMoreMenuOpen);
        // TODO: it would be great if we could refactor the following menu-specific logic into the respective menu components
        if (menuId === 'customize') {
            setIsCustomizeSidebarDialogVisible(true);
            fireClickAnalytics('customiseSidebar');
        } else fireClickAnalytics(menuId);
        if (menuId === 'recent' || menuId === 'starred' || menuId === 'spaces') {
            openFlyout(menuId);
            setPeekingId(menuId);
        }
        if (menuId === 'apps') push('/wiki/marketplace/discover');
    }, [
        fireClickAnalytics,
        isMoreMenuOpen,
        openFlyout,
        push
    ]);
    const { data: data, error: error } = (0, $j1Ss3.useQuery)($7b79f828379224e7$var$GlobalNavigationComponentQuery, {
        client: (0, $gKr8t.getAGGClient)(),
        variables: {
            entityAri: (0, $hHhbz.ConfluenceWorkspaceAri).create({
                siteId: cloudId,
                activationId: activationId
            }).toString(),
            ownerAri: userId ? (0, $gHaxX.IdentityUserAri).create({
                userId: userId
            }).toString() : ''
        },
        skip: !userId || !activationId
    });
    const platformCustomizations = (0, $42omo.useMemo)(()=>{
        if (data?.settings_navigationCustomisation?.sidebar?.nodes) return data.settings_navigationCustomisation.sidebar.nodes.map((node)=>({
                menuId: node.menuId?.replace($7b79f828379224e7$export$311d3c02bd72bcc0, ''),
                visible: Boolean(node.visible)
            }));
        return [];
    }, [
        data
    ]);
    const { platformCustomizationsWithSimplifyNav: platformCustomizationsWithSimplifyNav } = (0, $12338c25dd8aaf48$export$2471979fb08e1cdf)(platformCustomizations);
    //only show customization and fetch data if we meet these conditions
    const showCustomization = !!activationId && $7b79f828379224e7$var$hasAccess(accessStatus);
    // only render global app shortcuts if we meet these conditions, defaults to true if the FG is off
    const showGlobalAppShortcuts = (0, $9wGTI.fg)('navx-2420-conf-only-show-gas-to-non-anon-users') ? $7b79f828379224e7$var$hasGlobalAppShortcutsAccess(accessStatus) : true;
    const { globalMenuItems: globalMenuItems, moreMenuItems: moreMenuItems, appShortcutMenuItems: appShortcutMenuItems, allMenuItems: allMenuItems } = (0, $5cb9965cd3125e0a$export$aad046bd9909db8f)(showCustomization, accessStatus, platformCustomizationsWithSimplifyNav, getFilteredProductLinks);
    // The visible app shortcuts:
    // "Company Hub" is the first and only app shortcut at the time of this writing so the naming and abstraction here are as simple as possible.
    let companyHubAppShortcut = null;
    // The item "Customize sidebar" when it's one of the visible global items and app shortcuts:
    let globalCustomizeMenuItem = null;
    const moreMenuItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6bf303f52478ae0b$export$e967513bbeba0537), {
        moreMenuItems: moreMenuItems,
        isOpen: isMoreMenuOpen,
        onClick: moreMenuOnClickCallback,
        toggleMenu: ()=>setIsMoreMenuOpen(!isMoreMenuOpen),
        peekingId: peekingId,
        isCollapsed: isCollapsed
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: "nav4-spotlight-0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9kbAI.MenuList), null, !isOnAnySettingsScreen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: "enhance-orientation-spotlight-tour-target-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": "nav4-globalItems"
    }, globalMenuItems.map(({ menuId: menuId_0 })=>{
        const Component = $7b79f828379224e7$var$GlobalItemComponents[menuId_0];
        let node_0 = null;
        if (Component) {
            node_0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
                key: menuId_0,
                setIsCustomizeSidebarDialogVisible: setIsCustomizeSidebarDialogVisible
            });
            // All global items stay together and all app shortcuts stay together, they are separate groups.
            // I.e. the app shortcuts should be after a peeking global item (if any).
            // This is the render of the global items section so skip the app shortcuts (of which there is only Company Hub at Team '25 US) here and render them later.
            if (menuId_0 === 'companyHub') {
                companyHubAppShortcut = node_0;
                return null;
            } else if (menuId_0 === 'customize') {
                // The item "Customize sidebar" should be:
                // - after the app shortcuts if any;
                // - visually divided from the preceeding global items or app shortcuts.
                globalCustomizeMenuItem = node_0;
                return null;
            }
        }
        return node_0;
    }), // we split the kill-switch gate and targeting gate to avoid the overrides precedence issue
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    isInvitedAppShortcutsEnabled && showGlobalAppShortcuts && (0, $9wGTI.fg)('nav4_global_links_confluence') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eb94a7a15b9af3a3$export$a06354f64c80dd3d), {
        shortcutsConfig: invitedAppShortcutsConfig
    }, ({ referrableShortcuts: referrableShortcuts })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ddfb598ef229bd1a$export$7bd12ce5959bde45), {
            shortcutsConfig: referrableShortcuts,
            customizationMenuConfig: platformCustomizationsWithSimplifyNav
        }, ({ shortcuts: shortcuts })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $167cc3f1dc82a812$export$4519a9392cf3004e), {
                forceStatic: true,
                shortcutItems: shortcuts,
                product: "confluence",
                invitedAppProductLinks: invitedAppProductLinks
            }))), moreMenuItems.map((result)=>{
        const Component_0 = $7b79f828379224e7$var$GlobalItemComponents[result.menuId];
        return Component_0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component_0, {
            key: result.menuId,
            isHidden: true,
            peekingId: peekingId,
            setPeekingId: setPeekingId,
            setIsCustomizeSidebarDialogVisible: setIsCustomizeSidebarDialogVisible
        });
    }), companyHubAppShortcut && !(0, $9wGTI.fg)('nav4_global_links_confluence') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eYEH3.TopLevelSpacer), null), companyHubAppShortcut), teamsAppEnabled && !(0, $9wGTI.fg)('nav4_global_links_confluence') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, !companyHubAppShortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eYEH3.TopLevelSpacer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $19a89177b077740c$export$d6688983e7eca068), null)), globalCustomizeMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eYEH3.TopLevelSpacer), null), globalCustomizeMenuItem), showCustomization && !(0, $9wGTI.fg)('nav4_global_links_confluence') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, (companyHubAppShortcut || teamsAppEnabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eYEH3.TopLevelSpacer), null), moreMenuItem, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eYEH3.TopLevelSpacer), null)), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }), isCustomizeSidebarDialogVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b79f828379224e7$var$CustomizationModalLoader, {
        onClose: ()=>setIsCustomizeSidebarDialogVisible(false),
        productItemsData: allMenuItems,
        appItemsData: (0, $9wGTI.fg)('nav4_global_links_confluence') ? appShortcutMenuItems : []
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b8XTE.PageSegmentLoadEnd), {
        metric: (0, $1uFsv.GLOBAL_NAVIGATION_METRIC)
    }))), (0, $9wGTI.fg)('nav4_global_links_confluence') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eYEH3.TopLevelSpacer), null)), productSideNavigation, !isOnAnySettingsScreen && showGlobalAppShortcuts && (0, $9wGTI.fg)('nav4_global_links_confluence') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9kbAI.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eYEH3.TopLevelSpacer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d243d65a15d9065$export$69209b4d7b9e00bc), {
        orderedMenuConfig: platformCustomizationsWithSimplifyNav,
        onUpdateGetFilteredProductLinks: (fn)=>{
            setGetFilteredProductLinks(()=>fn);
            handleUpdateInvitedAppProductLinks(fn);
        },
        isInvitedAppShortcutsEnabled: isInvitedAppShortcutsEnabled
    }), moreMenuItem), !(0, $9wGTI.fg)('confluence_nav4_global-invite') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9kbAI.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9iEMr.PersistentInvitePeopleButton), {
        source: "pageTree"
    })) : null);
};
const $7b79f828379224e7$export$94a5e0cf2e657dff = (cache, variables, nodes)=>{
    cache.writeQuery({
        query: $7b79f828379224e7$var$GlobalNavigationComponentQuery,
        variables: variables,
        data: {
            settings_navigationCustomisation: {
                __typename: 'NavigationCustomisation',
                sidebar: {
                    __typename: 'SidebarCustomisation',
                    nodes: nodes
                }
            }
        }
    });
};
const $7b79f828379224e7$var$GlobalNavigationComponentQuery = (0, $eSUdr.default)`query GlobalNavigationComponentQuery($entityAri:ID!$ownerAri:ID!){settings_navigationCustomisation(entityAri:$entityAri ownerAri:$ownerAri){sidebar{nodes{menuId visible}}}}`;
module.exports["PLATFORM_MENU_ID_PREFIX"] = $7b79f828379224e7$export$311d3c02bd72bcc0;
module.exports["GlobalNavigationComponent"] = $7b79f828379224e7$export$f83d6aa785dd4970;
module.exports["updateNavigationCustomization"] = $7b79f828379224e7$export$94a5e0cf2e657dff;

});

parcelRegister("9kbAI", function(module, exports) {

var $dM2NO = parcelRequire("dM2NO");

const $e769d84ead345f3c$export$d4c4e98c5044dc8 = (0, $dM2NO.List);
module.exports["MenuList"] = $e769d84ead345f3c$export$d4c4e98c5044dc8;

});

parcelRegister("hHhbz", function(module, exports) {

var $5O1YC = parcelRequire("5O1YC");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/workspace/manifest.ts
var $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $5O1YC.ConfluenceWorkspaceAriResourceOwner),
    resourceType: (0, $5O1YC.ConfluenceWorkspaceAriResourceType),
    resourceIdSlug: "{activationId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/
    }
};
// src/confluence/workspace/index.ts
var $ce23c8815c812c15$export$d47d8a7e69df1865 = class _ConfluenceWorkspaceAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts.qualifier,
            platformQualifier: $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts.resourceOwner,
            resourceType: $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts);
        return new _ConfluenceWorkspaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts);
        return new _ConfluenceWorkspaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId;
    }
};
module.exports["ConfluenceWorkspaceAri"] = $ce23c8815c812c15$export$d47d8a7e69df1865;

});

parcelRegister("5O1YC", function(module, exports) {
// src/confluence/workspace/types.ts
var $43a327cfc847ac6c$export$19f1a63686ec0369 = "confluence", $43a327cfc847ac6c$export$f1c423a93fbc71 = "workspace";
module.exports["ConfluenceWorkspaceAriResourceOwner"] = $43a327cfc847ac6c$export$19f1a63686ec0369;
module.exports["ConfluenceWorkspaceAriResourceType"] = $43a327cfc847ac6c$export$f1c423a93fbc71;

});

parcelRegister("6adZX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $059c9f3c8066ba5d$var$initialState = {
    openFlyoutId: null
};
const $059c9f3c8066ba5d$export$3d79379112bcd772 = (0, $1P1Tu.createStore)({
    name: 'FlyoutStore',
    initialState: $059c9f3c8066ba5d$var$initialState,
    actions: {
        openFlyout: (menuId)=>({ setState: setState })=>{
                setState({
                    openFlyoutId: menuId
                });
            },
        closeFlyout: (menuId = null)=>({ setState: setState, getState: getState })=>{
                if (!menuId || menuId === getState().openFlyoutId) setState({
                    openFlyoutId: null
                });
            }
    }
});
const $059c9f3c8066ba5d$export$377168f986312a4 = (0, $9zUhf.createHook)($059c9f3c8066ba5d$export$3d79379112bcd772, {
    selector: (state, menuId)=>state.openFlyoutId === menuId
});
const $059c9f3c8066ba5d$export$3f64b5809402b3ff = (menuId)=>{
    const [isFlyoutOpen, flyoutActions] = $059c9f3c8066ba5d$export$377168f986312a4(menuId);
    const openFlyout = (0, $42omo.useCallback)(()=>flyoutActions.openFlyout(menuId), [
        flyoutActions,
        menuId
    ]);
    const closeFlyout = (0, $42omo.useCallback)(()=>flyoutActions.closeFlyout(menuId), [
        flyoutActions,
        menuId
    ]);
    return {
        isFlyoutOpen: isFlyoutOpen,
        openFlyout: openFlyout,
        closeFlyout: closeFlyout
    };
};
const $059c9f3c8066ba5d$export$285f2f1642666795 = (0, $9zUhf.createActionsHook)($059c9f3c8066ba5d$export$3d79379112bcd772);
module.exports["useIsFlyoutOpen"] = $059c9f3c8066ba5d$export$377168f986312a4;
module.exports["useFlyout"] = $059c9f3c8066ba5d$export$3f64b5809402b3ff;
module.exports["useFlyoutActions"] = $059c9f3c8066ba5d$export$285f2f1642666795;

});

parcelRegister("9iEMr", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2048a90ab37af5eb$export$443aeffdf2d81fe6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "AoEt_",
    name: "PersistentInvitePeopleButton",
    loader: async ()=>(await (parcelRequire("eEVy9"))).PersistentInvitePeopleButton
});
module.exports["PersistentInvitePeopleButton"] = $2048a90ab37af5eb$export$443aeffdf2d81fe6;

});

parcelRegister("eEVy9", function(module, exports) {

let $aac1714a2b42106a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aac1714a2b42106a$var$load("6wr18"),
    $aac1714a2b42106a$var$load("ffEVr"),
    $aac1714a2b42106a$var$load("h2810")
]).then(()=>parcelRequire('ctZ6E'));

});

parcelRegister("i4dNk", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $dBcar = parcelRequire("dBcar");


var $ivb8S = parcelRequire("ivb8S");

const $0451aea256d3610a$export$5ff0b879ab65d0b0 = 'd1';
const $0451aea256d3610a$export$46c1c92549715335 = 'loading';
const $0451aea256d3610a$export$61c0af74ec47d243 = 'd0';
const $0451aea256d3610a$export$f883a24d5edde77c = 'none';
const $0451aea256d3610a$export$a226a5c24cc00b77 = (updateState = false)=>{
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { cohort: cohort, delayInMinutes: delayInMinutes } = $0451aea256d3610a$var$getExperimentData();
    const hasUpdatedState = (0, $42omo.useRef)(false);
    const isInExperimentControl = cohort !== 'treatment';
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT),
        (0, $dBcar.CREATION_FOCUSED_NAV_START_TIME)
    ], isInExperimentControl);
    const spotlightShown = ()=>{
        setOnboardingState({
            key: (0, $dBcar.CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT),
            value: 'false'
        });
    };
    if (isInExperimentControl) return {
        isSpotlightVisible: false,
        areBannersHidden: false,
        navCustomization: $0451aea256d3610a$export$f883a24d5edde77c
    };
    if (onboardingStateLoading) // Simplify nav and hide banners while loading, to minimize flashing
    return {
        isSpotlightVisible: false,
        areBannersHidden: true,
        navCustomization: $0451aea256d3610a$export$46c1c92549715335
    };
    if (onboardingStateError) // Control behavior if there are any errors
    return {
        isSpotlightVisible: false,
        areBannersHidden: false,
        navCustomization: $0451aea256d3610a$export$f883a24d5edde77c
    };
    const { shouldShowSpotlight: shouldShowSpotlight, startTime: startTime } = (0, $ivb8S.deserializeState)(onboardingStateData);
    if ($0451aea256d3610a$var$isSiteOlderThanDelay(delayInMinutes, startTime)) {
        if (shouldShowSpotlight) // Spotlight ready to show --> Show spotlight, bring nav features back, but don't bring banners back
        return {
            isSpotlightVisible: true,
            areBannersHidden: true,
            navCustomization: $0451aea256d3610a$export$5ff0b879ab65d0b0,
            onSpotlightShown: spotlightShown
        };
        else if (shouldShowSpotlight === false) // Spotlight has already shown --> Don't show spotlight, bring nav features back, but don't bring banners back
        return {
            isSpotlightVisible: false,
            areBannersHidden: true,
            navCustomization: $0451aea256d3610a$export$5ff0b879ab65d0b0
        };
        // This account was created before the experiment started, so we won't change anything even though statsig returned "treatment"
        return {
            isSpotlightVisible: false,
            areBannersHidden: false,
            navCustomization: $0451aea256d3610a$export$f883a24d5edde77c
        };
    } else if (shouldShowSpotlight === undefined && updateState && !hasUpdatedState.current) {
        hasUpdatedState.current = true;
        setOnboardingState({
            key: (0, $dBcar.CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT),
            value: 'true'
        });
    }
    return {
        isSpotlightVisible: false,
        areBannersHidden: true,
        navCustomization: $0451aea256d3610a$export$61c0af74ec47d243
    };
};
const $0451aea256d3610a$var$getExperimentData = ()=>{
    // eslint-disable-next-line confluence-feature-gating/unsafe-no-exposure
    const [expConfig] = (0, $6mKj3.UNSAFE_noExposureExp)('cfind-4473-creation-focused-nav'); // Experiment exposure is fired in the backend
    const cohort = expConfig.get('cohort', 'control');
    const minutesPerHour = 60;
    const hoursPerDay = 24;
    const defaultDelayInMinutes = minutesPerHour * hoursPerDay;
    const delayInMinutes = expConfig.get('delayInMinutes', defaultDelayInMinutes.toString());
    return {
        cohort: cohort,
        delayInMinutes: parseInt(delayInMinutes)
    };
};
const $0451aea256d3610a$var$isSiteOlderThanDelay = (delayInMinutes, siteActivationDateString)=>{
    if (!siteActivationDateString) return true; // If site has no activation date, assume it is old
    const siteActivationDateNumber = Number(siteActivationDateString);
    const siteActivationDate = new Date(siteActivationDateNumber ?? '');
    if (isNaN(siteActivationDate.getTime())) return true; // If site has no activation date, assume it is old
    const createdAtTimestamp = siteActivationDate.getTime();
    const millisecondsSinceCreation = Date.now() - createdAtTimestamp;
    const secondsPerMinute = 60;
    const millisecondsPerSecond = 1000;
    const millisecondsInDelayTime = delayInMinutes * secondsPerMinute * millisecondsPerSecond;
    return millisecondsSinceCreation > millisecondsInDelayTime;
};
module.exports["d1"] = $0451aea256d3610a$export$5ff0b879ab65d0b0;
module.exports["loading"] = $0451aea256d3610a$export$46c1c92549715335;
module.exports["d0"] = $0451aea256d3610a$export$61c0af74ec47d243;
module.exports["useCfind4473CreationFocusedNav"] = $0451aea256d3610a$export$a226a5c24cc00b77;

});

parcelRegister("7CeAz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cEgMD = parcelRequire("cEgMD");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $1ytiN = parcelRequire("1ytiN");


var $8NC5Z = parcelRequire("8NC5Z");

const $16ea73778f65e8da$export$1d4394ae12760637 = ()=>{
    const { frontCoverState: frontCoverState, isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
    const canPublish = isSiteAdmin || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const isAdminDiscoverable = // 1. If entitled (e.g. Premium), both site admin and product admin have the
    //    entry point in the top nav, because it leads to COMPANY_HUB.
    // 2. If not entitled (e.g. Free or Standard):
    //   a. only site admin has the entry point in the top nav, because it
    //      renders an upsell;
    //   b. product admin doesn't have the entry point in the top nav, because
    //      it automatically redirects to HOME.
    shouldShowPremiumUpsell ? isSiteAdmin : canPublish;
    const isCompanyHubFeatureAvailable = !shouldShowPremiumUpsell;
    const isCompanyHubPublished = Boolean(isCompanyHubFeatureAvailable && frontCoverState === (0, $cEgMD.FrontCoverStateEnum).SHOWN);
    const isCompanyHubShownToEditors = Boolean(isCompanyHubFeatureAvailable && frontCoverState === (0, $cEgMD.FrontCoverStateEnum).EDITORS_ONLY || isCompanyHubPublished);
    const isCompanyHubEntryPointEnabled = Boolean(isCompanyHubFeatureAvailable && (isCompanyHubPublished || isCompanyHubShownToEditors) || isAdminDiscoverable);
    return {
        canPublish: isCompanyHubFeatureAvailable && canPublish,
        isCompanyHubPublished: isCompanyHubPublished,
        isCompanyHubShownToEditors: isCompanyHubShownToEditors,
        isCompanyHubEntryPointEnabled: isCompanyHubEntryPointEnabled
    };
};
module.exports["useIsCompanyHubEnabled"] = $16ea73778f65e8da$export$1d4394ae12760637;

});

parcelRegister("8NC5Z", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $j1Ss3 = parcelRequire("j1Ss3");


var $7Sm4c = parcelRequire("7Sm4c");


var $euL71 = parcelRequire("euL71");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $5ZqQS = parcelRequire("5ZqQS");


var $bQm3c = parcelRequire("bQm3c");

const $1de3a5511529eed3$export$f032b5e8b485da1d = ({ skip: skip = false } = {})=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const shouldSkip = skip || edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const { data: data, error: error } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query useCompanyHubPremiumGateCompanyHubPremiumGateQuery{entitlements{companyHub{isEntitled}}}`, {
        skip: shouldSkip
    });
    if (error) {
        if (!((0, $1uFM6.isUnauthorizedError)(error) || (0, $f9jv7.isNotFoundError)(error))) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).COMPANY_HUB
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    return !shouldSkip && !data?.entitlements.companyHub.isEntitled;
};
module.exports["useCompanyHubPremiumGate"] = $1de3a5511529eed3$export$f032b5e8b485da1d;

});

parcelRegister("f9jv7", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $b29e4bf652226e80$export$6ccdb59d3479f4f1 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '404');
module.exports["isNotFoundError"] = $b29e4bf652226e80$export$6ccdb59d3479f4f1;

});

parcelRegister("he3NE", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $2383d17835531100$export$e367407479ee8cd8 = (0, $eSUdr.default)`query GetLicensedProductsQuery{confluence_tenantContext{licensedProducts{licenseStatus productKey}}}`;
module.exports["GetLicensedProductsQuery"] = $2383d17835531100$export$e367407479ee8cd8;

});

parcelRegister("hSHWm", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $d1e7679282bf3961$export$8b4809eaf655f286 = /*#__PURE__*/ (0, $42omo.createContext)({});
module.exports["CoreInvitesContext"] = $d1e7679282bf3961$export$8b4809eaf655f286;

});

parcelRegister("koZ31", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ var $6a2b9fa9e63188b2$export$1ba03842b7d3a654 = /*#__PURE__*/ function(CoreInvitesSource) {
    CoreInvitesSource["UNKNOWN"] = "unknown";
    CoreInvitesSource["MENTION"] = "mention";
    CoreInvitesSource["PEOPLE_MENU"] = "peopleMenu";
    CoreInvitesSource["ONBOARDING_INVITE_FLAG"] = "onboarding-invite-flag";
    CoreInvitesSource["PERSISTENT_INVITE_PAGETREE"] = "pageTree";
    CoreInvitesSource["PERSISTENT_INVITE_HOMESCREEN"] = "homeScreen";
    CoreInvitesSource["CONTEXTUAL_INVITE_NUDGE"] = "onboarding-contextual-invite-nudge";
    CoreInvitesSource["LIVE_PAGES_NUDGE"] = "onboarding-contextual-invite-live-pages-nudge";
    CoreInvitesSource["SHARE_DIALOG"] = "share-dialog";
    CoreInvitesSource["SHARE_AND_RESTRICT_DIALOG"] = "share-and-restrict-dialog";
    CoreInvitesSource["IBO_TAKEOVER_INVITE"] = "onboarding-takeover-invite-people";
    CoreInvitesSource["EA_DROPDOWN"] = "ea-dropdown";
    CoreInvitesSource["HOME_ONBOARDING_TAKEOVER_V2"] = "home-onboarding-takeover-v2";
    CoreInvitesSource["CROSS_JOIN"] = "virality-cross-join";
    CoreInvitesSource["OPEN_MODAL_QUERY_PARAM"] = "open-modal-query-param";
    return CoreInvitesSource;
}({});
module.exports["CoreInvitesSource"] = $6a2b9fa9e63188b2$export$1ba03842b7d3a654;

});

parcelRegister("g6zY9", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $jYxBx = parcelRequire("jYxBx");


var $4iF3c = parcelRequire("4iF3c");


var $ay82t = parcelRequire("ay82t");


var $bGdnm = parcelRequire("bGdnm");

const $388a803502193d4e$export$8a37839ac1e08b25 = /*#__PURE__*/ (0, $42omo.createContext)((0, $ay82t.DEFAULT_CONTEXT));
const $388a803502193d4e$export$3bf19eb896b777b8 = ({ children: children, locale: locale, product: product, teamPermissions: teamPermissions, orgId: orgId, teamPermissionCheckEnabled: teamPermissionCheckEnabled = false })=>{
    const overrides = (0, $bGdnm.usePeopleAndTeamsConfigurationOverrides)(teamPermissionCheckEnabled, orgId, teamPermissions);
    const artifact = (0, $4iF3c.usePeopleAndTeamsRemoteArtifact)(product, locale, overrides);
    return /*#__PURE__*/ (0, $l998X.jsx)($388a803502193d4e$export$8a37839ac1e08b25.Provider, {
        value: artifact || (0, $ay82t.DEFAULT_CONTEXT),
        children: children
    });
};
const $388a803502193d4e$export$d3f5bd36d1c6597e = ({ children: children, locale: locale, product: product, teamPermissions: teamPermissions, teamPermissionCheckEnabled: teamPermissionCheckEnabled, orgId: orgId, ...flightDeckProps })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jYxBx.FlightDeckProvider), {
        product: product,
        ...flightDeckProps,
        children: /*#__PURE__*/ (0, $l998X.jsx)($388a803502193d4e$export$3bf19eb896b777b8, {
            locale: locale,
            product: product,
            teamPermissions: teamPermissions,
            teamPermissionCheckEnabled: teamPermissionCheckEnabled,
            orgId: orgId,
            children: children
        })
    });
};
const $388a803502193d4e$export$130340d16a670190 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($388a803502193d4e$export$8a37839ac1e08b25);
module.exports["PeopleAndTeamsConfigurationProvider"] = $388a803502193d4e$export$d3f5bd36d1c6597e;
module.exports["usePeopleAndTeamsConfigurationContext"] = $388a803502193d4e$export$130340d16a670190;

});

parcelRegister("4iF3c", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jYxBx = parcelRequire("jYxBx");


var $dJyK1 = parcelRequire("dJyK1");

const $db3d1eeeab1c870c$var$transformArtifactsWithOverrides = (artifact, overrideKeys)=>{
    if (!artifact?.overrides?.length || overrideKeys.length === 0) return artifact;
    return overrideKeys.reduce((acc, overrideKey)=>{
        return {
            ...acc,
            ...artifact.overrides && artifact.overrides.find((override)=>override.key === overrideKey)?.item || null
        };
    }, artifact);
};
const $db3d1eeeab1c870c$export$233293b7afb7b362 = (product, locale, overridesKeys)=>{
    const dimensions = (0, $42omo.useMemo)(()=>({
            ...(0, $dJyK1.FD_CLIENT_FETCH_PROPS).dimensions,
            locale: locale
        }), [
        locale
    ]);
    const artifact = (0, $jYxBx.useFlightDeckArtifact)((0, $dJyK1.FD_CLIENT_FETCH_PROPS).name, dimensions);
    /**
	 * FlightDeck doesn't allow custom, a 'product', dimension so we must handle this ourselves.
	 * We can probably remove this memo once that functionality is available
	 */ return (0, $42omo.useMemo)(()=>{
        const productArtifact = artifact ? product in artifact['people-menu'] ? artifact['people-menu'][product] : artifact['people-menu'].default : null;
        return {
            ['people-menu']: $db3d1eeeab1c870c$var$transformArtifactsWithOverrides(productArtifact, overridesKeys ? overridesKeys['people-menu'] : [])
        };
    }, [
        artifact,
        product,
        overridesKeys
    ]);
};
module.exports["usePeopleAndTeamsRemoteArtifact"] = $db3d1eeeab1c870c$export$233293b7afb7b362;

});

parcelRegister("dJyK1", function(module, exports) {

var $lzcvT = parcelRequire("lzcvT");

const $323cb1b03fbc7278$export$953923d576277fd6 = 'people-and-teams-configuration-service';
const $323cb1b03fbc7278$export$71f196808ce40e60 = 'prod';
const $323cb1b03fbc7278$export$6392ca3738ed1e9 = 'fedramp-moderate';
const $323cb1b03fbc7278$export$e836203c1e95eac3 = 'commercial';
const $323cb1b03fbc7278$export$c270c412a04ff3e6 = {
    name: $323cb1b03fbc7278$export$953923d576277fd6,
    dimensions: {
        environmentType: $323cb1b03fbc7278$export$71f196808ce40e60,
        perimeter: (0, $lzcvT.isFedRamp)() ? $323cb1b03fbc7278$export$6392ca3738ed1e9 : $323cb1b03fbc7278$export$e836203c1e95eac3
    }
};
module.exports["FD_CLIENT_FETCH_PROPS"] = $323cb1b03fbc7278$export$c270c412a04ff3e6;

});

parcelRegister("ay82t", function(module, exports) {
const $1b2ab48db02b5584$export$9c542858adf7dcd0 = {
    ['people-menu']: null
};
module.exports["DEFAULT_CONTEXT"] = $1b2ab48db02b5584$export$9c542858adf7dcd0;

});

parcelRegister("bGdnm", function(module, exports) {

var $3jKGE = parcelRequire("3jKGE");


var $2LwsB = parcelRequire("2LwsB");

const $0bdd48c7faa20aa6$export$66d7d96ce076bcd6 = (teamPermissionCheckEnabled, orgId, teamPermissionsProps)=>{
    const { permissions: teamPermissionsFromHook } = (0, $3jKGE.useTeamsPermissionsService)(orgId, {
        enabled: teamPermissionCheckEnabled && !teamPermissionsProps
    });
    const teamPermissions = teamPermissionsProps || teamPermissionsFromHook;
    return {
        'people-menu': [
            ...!teamPermissions?.canCreateTeams ? [
                (0, $2LwsB.PeopleMenuOverrides).createTeamsDisabled
            ] : [],
            ...!teamPermissions?.canViewTeams ? [
                (0, $2LwsB.PeopleMenuOverrides).viewTeamsDisabled
            ] : []
        ]
    };
};
module.exports["usePeopleAndTeamsConfigurationOverrides"] = $0bdd48c7faa20aa6$export$66d7d96ce076bcd6;

});

parcelRegister("3jKGE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $dh538 = parcelRequire("dh538");


var $fDXXi = parcelRequire("fDXXi");


var $cpl2G = parcelRequire("cpl2G");


var $5QWbm = parcelRequire("5QWbm");

const $9331aa7e61d4593d$export$b24dcbe1ec677a8 = (scope, { enabled: enabled, attributes: attributes } = {
    enabled: false,
    attributes: {}
})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    // backwards compatibility allow orgId to be passed as a string
    const { orgId: orgId, cloudId: cloudId } = typeof scope === 'string' || !scope ? {
        orgId: scope,
        cloudId: undefined
    } : scope;
    const [state, { getPermissions: getPermissions }] = (0, $5QWbm.useTeamsPermissionsStore)();
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const fetchData = (0, $42omo.useCallback)(async ()=>{
        getPermissions({
            orgId: orgId,
            cloudId: cloudId,
            enabled: enabled
        }, {
            onFetch: ()=>{
                if ((0, $dh538.fg)('ptc-enable-teams-common-analytics-refactor')) // @ts-expect-error - hyphenated event names are not supported in the analytics spec
                fireEvent('operational.use-team-permissions.fetched', {
                    userId: attributes?.userId,
                    orgId: orgId,
                    cloudId: cloudId
                });
                else (0, $cpl2G.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'fetched',
                    actionSubject: 'use-team-permissions',
                    attributes: {
                        userId: attributes?.userId,
                        orgId: orgId,
                        cloudId: cloudId
                    }
                });
            }
        });
    }, [
        orgId,
        cloudId,
        enabled,
        getPermissions,
        createAnalyticsEvent,
        attributes?.userId,
        fireEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    return {
        loading: state.isLoading,
        data: state.permissionsResponse,
        error: state.error,
        ...state
    };
};
module.exports["useTeamsPermissionsService"] = $9331aa7e61d4593d$export$b24dcbe1ec677a8;

});

parcelRegister("cpl2G", function(module, exports) {
const $a9507de806b2aaad$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $a9507de806b2aaad$var$runItLater = (cb)=>{
    if (window.requestIdleCallback === 'function') return window.requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $a9507de806b2aaad$var$fireEvent = (kind)=>(createAnalyticsEvent, body)=>{
        if (!createAnalyticsEvent) return;
        $a9507de806b2aaad$var$runItLater(()=>{
            createAnalyticsEvent({
                eventType: kind,
                ...body
            }).fire($a9507de806b2aaad$var$ANALYTICS_CHANNEL);
        });
    };
const $a9507de806b2aaad$export$a1fb57756f0de62b = $a9507de806b2aaad$var$fireEvent('operational');
const $a9507de806b2aaad$export$59608e0169622110 = $a9507de806b2aaad$var$fireEvent('screen');
const $a9507de806b2aaad$export$574d2f19a52d67ca = $a9507de806b2aaad$var$fireEvent('track');
const $a9507de806b2aaad$export$7eca133280843f9e = $a9507de806b2aaad$var$fireEvent('ui');
const $a9507de806b2aaad$export$91c413c8a5c77e19 = (error)=>{
    if (!error) return false;
    // Check for ' 403' with space beforehand to not count urls containing 403 in cloud or team id
    if ('status' in error && error['status'] === 403 || error?.message?.includes(' 403')) return false;
    if ('status' in error && error['status'] === 401 || error?.message?.includes(' 401')) return false;
    if ('status' in error && error['status'] === 429 || error?.message?.includes(' 429')) return false;
    if (error.message === 'Failed to fetch') return false;
    return true;
};
module.exports["fireOperationalEvent"] = $a9507de806b2aaad$export$a1fb57756f0de62b;
module.exports["fireScreenEvent"] = $a9507de806b2aaad$export$59608e0169622110;
module.exports["fireTrackEvent"] = $a9507de806b2aaad$export$574d2f19a52d67ca;
module.exports["fireUIEvent"] = $a9507de806b2aaad$export$7eca133280843f9e;
module.exports["isSeriousError"] = $a9507de806b2aaad$export$91c413c8a5c77e19;

});

parcelRegister("5QWbm", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $ftJwu = parcelRequire("ftJwu");

var $asH6r = parcelRequire("asH6r");


var $lu59R = parcelRequire("lu59R");

const $08e6b6a081f172d2$var$actions = {
    getPermissions: ({ orgId: orgId, cloudId: cloudId, enabled: enabled }, { onFetch: onFetch })=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { hasLoaded: hasLoaded, isLoading: isLoading } = getState();
            if (hasLoaded || isLoading || !enabled || !orgId || !cloudId) return;
            try {
                setState({
                    isLoading: true
                });
                (0, $asH6r.teamsClient).setContext({
                    orgId: orgId,
                    cloudId: cloudId
                });
                const response = await (0, $asH6r.teamsClient).getPermissions();
                dispatch($08e6b6a081f172d2$var$actions.setPermissions(response.permissions));
                onFetch?.();
            } catch (error) {
                dispatch($08e6b6a081f172d2$var$actions.setError(error instanceof (0, $ftJwu.HttpError) ? error : new Error('Failed to fetch permissions')));
            }
        },
    setError: (error)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                error: error
            });
        },
    setLoading: (isLoading)=>({ setState: setState })=>{
            setState({
                isLoading: isLoading
            });
        },
    setPermissions: (permissions)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                permissions: (0, $lu59R.transformPermissions)(permissions),
                permissionsResponse: {
                    permissions: permissions
                }
            });
        }
};
const $08e6b6a081f172d2$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        error: undefined,
        hasLoaded: false,
        isLoading: false,
        permissions: {
            canCreateTeams: true,
            canViewTeams: true,
            canAdminTeams: false
        }
    },
    actions: $08e6b6a081f172d2$var$actions,
    name: 'teams-permissions'
});
const $08e6b6a081f172d2$export$4e7a1c55cba5a168 = (0, $9zUhf.createHook)($08e6b6a081f172d2$var$Store);
module.exports["useTeamsPermissionsStore"] = $08e6b6a081f172d2$export$4e7a1c55cba5a168;

});

parcelRegister("lu59R", function(module, exports) {
const $d878918ac6235789$export$7fe0bfa353103198 = (permissions)=>{
    return permissions.reduce((acc, permission)=>{
        switch(permission){
            case 'CAN_CREATE_TEAMS':
                return {
                    ...acc,
                    canCreateTeams: true
                };
            case 'CAN_VIEW_TEAMS':
                return {
                    ...acc,
                    canViewTeams: true
                };
            case 'CAN_ADMIN_TEAMS':
                return {
                    ...acc,
                    canAdminTeams: true
                };
            default:
                return acc;
        }
    }, {
        canCreateTeams: false,
        canViewTeams: false,
        canAdminTeams: false
    });
};
module.exports["transformPermissions"] = $d878918ac6235789$export$7fe0bfa353103198;

});

parcelRegister("2LwsB", function(module, exports) {
var $f3d73af2348a66b1$export$c6e6fe52d34907dc = /*#__PURE__*/ function(PeopleMenuOverrides) {
    PeopleMenuOverrides["createTeamsDisabled"] = "create-teams-disabled";
    PeopleMenuOverrides["viewTeamsDisabled"] = "view-teams-disabled";
    return PeopleMenuOverrides;
}({});
module.exports["PeopleMenuOverrides"] = $f3d73af2348a66b1$export$c6e6fe52d34907dc;

});

parcelRegister("eiYCj", function(module, exports) {

let $a6a1c45d7a67d316$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a6a1c45d7a67d316$var$load("hRUX7"),
    $a6a1c45d7a67d316$var$load("g4oYs"),
    $a6a1c45d7a67d316$var$load("6wr18"),
    $a6a1c45d7a67d316$var$load("jGDMX"),
    $a6a1c45d7a67d316$var$load("7EorR"),
    $a6a1c45d7a67d316$var$load("ffEVr"),
    $a6a1c45d7a67d316$var$load("kHOMt"),
    $a6a1c45d7a67d316$var$load("hhss7"),
    $a6a1c45d7a67d316$var$load("k7TXX")
]).then(()=>parcelRequire('hS9vX'));

});

parcelRegister("iI2ST", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $5ujhR = parcelRequire("5ujhR");


var $jjpBv = parcelRequire("jjpBv");

const $d3e054ddee411308$export$6dc09b7c0ec1dfcd = /*#__PURE__*/ (0, $42omo.forwardRef)(({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, isDisabled: isDisabled, isSelected: isSelected, elemBefore: elemBefore, actionsOnHover: actionsOnHover, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jjpBv.MenuListItem), {
        ref: listItemRef,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5ujhR.MenuItemBase), {
            testId: testId,
            description: description,
            elemAfter: elemAfter,
            elemBefore: elemBefore,
            isDisabled: isDisabled,
            /**
					 * Not passing `actions` and `actionsOnHover` to MenuItemBase when `isDisabled`,
					 * so they aren't rendered in the disabled state.
					 */ actions: isDisabled ? undefined : actions,
            actionsOnHover: isDisabled ? undefined : actionsOnHover,
            onClick: onClick,
            ariaControls: (0, $dh538.fg)('platform-dst-buttonmenuitem-selected-state-support') ? ariaControls : undefined,
            ariaExpanded: (0, $dh538.fg)('platform-dst-buttonmenuitem-selected-state-support') ? ariaExpanded : undefined,
            ariaHasPopup: (0, $dh538.fg)('platform-dst-buttonmenuitem-selected-state-support') ? ariaHasPopup : undefined,
            isSelected: (0, $dh538.fg)('platform-dst-buttonmenuitem-selected-state-support') ? isSelected : undefined,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
});
module.exports["ButtonMenuItem"] = $d3e054ddee411308$export$6dc09b7c0ec1dfcd;

});

parcelRegister("iZRoG", function(module, exports) {
/* divider.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $afccce05c0d0956c$var$styles = null; /**
                      * __Divider__
                      *
                      * A divider for use between menu sections.
                      */ 
const $afccce05c0d0956c$export$2e0a83ec2e27ecbb = ()=>/*#__PURE__*/ (0, $l998X.jsx)("hr", {
        /**
                                  * The existing usage of these dividers is presentational,
                                  * so we are removing the separator semantics by default.
                                  *
                                  * In the future we may consider allowing opt-in separator semantics,
                                  * but it probably isn't necessary.
                                  */ role: "none",
        className: (0, $gMc0m.default)([
            "_h7alglyw _179rglyw _mqm2ia51 _1bsb1osq"
        ])
    });
module.exports["Divider"] = $afccce05c0d0956c$export$2e0a83ec2e27ecbb;

});

parcelRegister("63PsI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $1ytiN = parcelRequire("1ytiN");

function $acec4613ff860ea3$export$e7c489d818076f3d() {
    let { companyHubName: companyHubName } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const intl = (0, $8C5kA.default)();
    if (!companyHubName) companyHubName = intl.formatMessage($acec4613ff860ea3$var$messages.defaultCompanyHubName);
    return companyHubName;
}
// eslint-disable-next-line check-i18n-id-prefix/i18n-id-prefix-with-package-name-defineMessages -- Moved from confluence/next/packages/app-navigation/src/Nav3/PrimaryItems/CompanyHubItem.tsx
const $acec4613ff860ea3$var$messages = (0, $cgtv4.defineMessages)({
    defaultCompanyHubName: {
        id: "app-navigation.company-hub.link",
        defaultMessage: "Company hub"
    }
});
module.exports["useCompanyHubName"] = $acec4613ff860ea3$export$e7c489d818076f3d;

});

parcelRegister("1LksZ", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $135393dc762a6338$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    customHome: {
        id: "side-navigation.global.home",
        defaultMessage: "Home"
    },
    forYou: {
        id: "side-navigation.global.for.you",
        defaultMessage: "For you"
    },
    yourWork: {
        id: "side-navigation.global.your.work",
        defaultMessage: "For you"
    },
    companyHub: {
        id: "side-navigation.global.company.hub",
        defaultMessage: "Company Hub"
    },
    recent: {
        id: "side-navigation.global.recent",
        defaultMessage: "Recent"
    },
    starred: {
        id: "side-navigation.global.starred",
        defaultMessage: "Starred"
    },
    spaces: {
        id: "side-navigation.global.spaces",
        defaultMessage: "Spaces"
    },
    apps: {
        id: "side-navigation.global.apps",
        defaultMessage: "Apps"
    },
    goals: {
        id: "side-navigation.global.goals",
        defaultMessage: "Goals"
    },
    topics: {
        id: "side-navigation.global.topics",
        defaultMessage: "Topics"
    },
    teams: {
        id: "side-navigation.global.teams",
        defaultMessage: "Teams"
    },
    drafts: {
        id: "side-navigation.global.drafts",
        defaultMessage: "Drafts"
    },
    tasks: {
        id: "side-navigation.global.tasks",
        defaultMessage: "Tasks"
    },
    more: {
        id: "side-navigation.global.more",
        defaultMessage: "More"
    },
    customize: {
        id: "side-navigation.global.customize.sidebar",
        defaultMessage: "Customize sidebar"
    },
    templates: {
        id: "side-navigation.global.customize.templates",
        defaultMessage: "Templates"
    },
    workflows: {
        id: "side-navigation.global.customize.workflows",
        defaultMessage: "Workflows"
    },
    separator: {
        id: "side-navigation.global.customize.separator",
        defaultMessage: "HIDE FROM SIDEBAR"
    },
    jiraShortcut: {
        id: "side-navigation.global.customize.jiraShortcut",
        defaultMessage: "Jira"
    },
    loomShortcut: {
        id: "side-navigation.global.customize.loomShortcut",
        defaultMessage: "Loom"
    },
    teamsShortcut: {
        id: "side-navigation.global.customize.teamsShortcut",
        defaultMessage: "Teams"
    },
    companyHubShortcut: {
        id: "side-navigation.global.customize.companyHubShortcut",
        // eslint-disable-next-line @atlassian/i18n/no-useless-message
        defaultMessage: "{companyHubName}"
    },
    notes: {
        id: "side-navigation.global.customize.notesShortcut",
        defaultMessage: "Notes"
    }
});
module.exports["i18n"] = $135393dc762a6338$export$a7357cdd1f0b0168;

});

parcelRegister("cxU8R", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4wwVl = parcelRequire("4wwVl");


var $fJM5Q = parcelRequire("fJM5Q");


var $ctmPb = parcelRequire("ctmPb");


var $kevJM = parcelRequire("kevJM");


var $kfYj7 = parcelRequire("kfYj7");


var $buthI = parcelRequire("buthI");


var $tvI67 = parcelRequire("tvI67");


var $gJsgh = parcelRequire("gJsgh");


var $la4Nn = parcelRequire("la4Nn");


var $1dKyn = parcelRequire("1dKyn");


var $1Zr9M = parcelRequire("1Zr9M");


var $dmbve = parcelRequire("dmbve");


var $9VJDA = parcelRequire("9VJDA");


var $gXn1S = parcelRequire("gXn1S");


var $isYda = parcelRequire("isYda");


var $jRsqV = parcelRequire("jRsqV");


var $hbYDZ = parcelRequire("hbYDZ");


var $lAFHW = parcelRequire("lAFHW");


var $6mKj3 = parcelRequire("6mKj3");

const $b1654aa018846a1e$var$StyledIconComponent = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { icon: icon } = t0;
    const IconComponent = icon;
    let t1;
    if ($[0] !== IconComponent) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(IconComponent, {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        });
        $[0] = IconComponent;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ icon: icon })=>{
    const IconComponent = icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(IconComponent, {
        label: "",
        color: "currentColor",
        spacing: "spacious"
    });
});
const $b1654aa018846a1e$var$StyledLogoComponent = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { logo: logo, testId: testId } = t0;
    const LogoComponent = logo;
    let t1;
    if ($[0] !== LogoComponent || $[1] !== testId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LogoComponent, {
            label: "",
            size: "xsmall",
            shouldUseNewLogoDesign: true,
            testId: testId
        });
        $[0] = LogoComponent;
        $[1] = testId;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ logo: logo, testId: testId })=>{
    const LogoComponent = logo;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LogoComponent, {
        label: "",
        size: "xsmall",
        shouldUseNewLogoDesign: true,
        testId: testId
    });
});
const $b1654aa018846a1e$export$4370213f5e13a087 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($4wwVl)))
});
const $b1654aa018846a1e$export$fcf3ce494c961537 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($fJM5Q)))
});
const $b1654aa018846a1e$export$e25b0b35bcc6a6f4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($ctmPb)))
});
const $b1654aa018846a1e$export$22eb82a2d06386cd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kevJM)))
});
const $b1654aa018846a1e$export$e354edba2d87a80b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kfYj7)))
});
const $b1654aa018846a1e$export$815068847a2940cc = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($buthI)))
});
const $b1654aa018846a1e$export$1820ff183b9ac996 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($hbYDZ)))
});
const $b1654aa018846a1e$export$2ad8d00357381dab = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($tvI67)))
});
const $b1654aa018846a1e$export$b8743c92b35ba3d2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($gJsgh)))
});
const $b1654aa018846a1e$export$ea1e8de44637bcc8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($la4Nn)))
});
const $b1654aa018846a1e$export$85b08d1fd6c3c91e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($1dKyn)))
});
const $b1654aa018846a1e$export$3ac9d636aeac90b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M)))
});
const $b1654aa018846a1e$export$44d9bde334d7e007 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($dmbve)))
});
const $b1654aa018846a1e$export$296eedab7746f8f0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($gXn1S)))
});
const $b1654aa018846a1e$export$1f926db0b8c551ab = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA)))
});
const $b1654aa018846a1e$export$553a8f8e72a63c41 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($isYda)))
});
const $b1654aa018846a1e$export$a56e3a05fa146b0b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($jRsqV)))
});
const $b1654aa018846a1e$export$7ef71e75b22027b6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledLogoComponent, {
    logo: (0, $lAFHW.HubIcon)
});
const $b1654aa018846a1e$export$b98c953fd1e726cc = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledLogoComponent, {
    logo: (0, $lAFHW.TeamsIcon)
});
const $b1654aa018846a1e$export$7ac757a6aec752f4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledLogoComponent, {
    logo: (0, $lAFHW.JiraIcon)
});
const $b1654aa018846a1e$export$6e55f825f45b7145 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledLogoComponent, {
    logo: (0, $lAFHW.LoomIcon)
});
const $b1654aa018846a1e$export$803815ff2adecad4 = {
    customHome: $b1654aa018846a1e$export$fcf3ce494c961537,
    yourWork: $b1654aa018846a1e$export$4370213f5e13a087,
    // Component has been updated to 'For you', key remains the same.
    companyHub: $b1654aa018846a1e$export$e25b0b35bcc6a6f4,
    recent: $b1654aa018846a1e$export$22eb82a2d06386cd,
    starred: $b1654aa018846a1e$export$e354edba2d87a80b,
    spaces: $b1654aa018846a1e$export$815068847a2940cc,
    apps: $b1654aa018846a1e$export$2ad8d00357381dab,
    goals: $b1654aa018846a1e$export$b8743c92b35ba3d2,
    topics: $b1654aa018846a1e$export$ea1e8de44637bcc8,
    teams: $b1654aa018846a1e$export$85b08d1fd6c3c91e,
    drafts: $b1654aa018846a1e$export$3ac9d636aeac90b,
    tasks: $b1654aa018846a1e$export$44d9bde334d7e007,
    templates: $b1654aa018846a1e$export$296eedab7746f8f0,
    customize: $b1654aa018846a1e$export$553a8f8e72a63c41,
    notes: $b1654aa018846a1e$export$a56e3a05fa146b0b,
    companyHubShortcut: $b1654aa018846a1e$export$7ef71e75b22027b6,
    teamsShortcut: $b1654aa018846a1e$export$b98c953fd1e726cc,
    jiraShortcut: $b1654aa018846a1e$export$7ac757a6aec752f4,
    loomShortcut: $b1654aa018846a1e$export$6e55f825f45b7145
};
const $b1654aa018846a1e$export$d7b6490d01f6dc6 = ()=>{
    if ((0, $6mKj3.expVal)('confluence_space_icon_update', 'isEnabled', false)) return {
        ...$b1654aa018846a1e$export$803815ff2adecad4,
        spaces: $b1654aa018846a1e$export$1820ff183b9ac996
    };
    return $b1654aa018846a1e$export$803815ff2adecad4;
};
module.exports["ForYouIconComponent"] = $b1654aa018846a1e$export$4370213f5e13a087;
module.exports["HomeIconComponent"] = $b1654aa018846a1e$export$fcf3ce494c961537;
module.exports["ClockIconComponent"] = $b1654aa018846a1e$export$22eb82a2d06386cd;
module.exports["StarIconComponent"] = $b1654aa018846a1e$export$e354edba2d87a80b;
module.exports["GlobeIconComponent"] = $b1654aa018846a1e$export$815068847a2940cc;
module.exports["SpacesIconComponent"] = $b1654aa018846a1e$export$1820ff183b9ac996;
module.exports["AppsIconComponent"] = $b1654aa018846a1e$export$2ad8d00357381dab;
module.exports["GoalIconComponent"] = $b1654aa018846a1e$export$b8743c92b35ba3d2;
module.exports["HashIconComponent"] = $b1654aa018846a1e$export$ea1e8de44637bcc8;
module.exports["TeamsIconComponent"] = $b1654aa018846a1e$export$85b08d1fd6c3c91e;
module.exports["EditIconComponent"] = $b1654aa018846a1e$export$3ac9d636aeac90b;
module.exports["TaskIconComponent"] = $b1654aa018846a1e$export$44d9bde334d7e007;
module.exports["TemplatesIconComponent"] = $b1654aa018846a1e$export$296eedab7746f8f0;
module.exports["MoreIconComponent"] = $b1654aa018846a1e$export$1f926db0b8c551ab;
module.exports["CustomizeIconComponent"] = $b1654aa018846a1e$export$553a8f8e72a63c41;
module.exports["NotesIconComponent"] = $b1654aa018846a1e$export$a56e3a05fa146b0b;
module.exports["useIconByMenuId"] = $b1654aa018846a1e$export$d7b6490d01f6dc6;

});

parcelRegister("fJM5Q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd36682bcf7d93c8d6a4f8218f4f4e2d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b7505d4a6629268d$var$_react = $b7505d4a6629268d$var$_interopRequireDefault((parcelRequire("42omo")));

var $b7505d4a6629268d$var$_baseNew = $b7505d4a6629268d$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b7505d4a6629268d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Home".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for home in navigation. When a user clicks on this, they should return to the homepage.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b7505d4a6629268d$var$HomeIcon = (props)=>/*#__PURE__*/ $b7505d4a6629268d$var$_react.default.createElement($b7505d4a6629268d$var$_baseNew.default, Object.assign({
        name: "HomeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.646.727a2 2 0 0 1 2.708 0l5 4.6A2 2 0 0 1 15 6.799V13a2 2 0 0 1-2 2H9.75a.75.75 0 0 1-.75-.75V9.5H7v4.75a.75.75 0 0 1-.75.75H3a2 2 0 0 1-2-2V6.799a2 2 0 0 1 .646-1.472zM8.339 1.83a.5.5 0 0 0-.678 0l-5 4.6a.5.5 0 0 0-.161.368V13a.5.5 0 0 0 .5.5h2.5V8.75A.75.75 0 0 1 6.25 8h3.5a.75.75 0 0 1 .75.75v4.75H13a.5.5 0 0 0 .5-.5V6.799a.5.5 0 0 0-.162-.368z" clip-rule="evenodd"/>`
    }, props));
$b7505d4a6629268d$var$HomeIcon.displayName = 'HomeIcon';
var $b7505d4a6629268d$var$_default = module.exports.default = $b7505d4a6629268d$var$HomeIcon;

});

parcelRegister("bfhzz", function(module, exports) {

let $82feba03f45a47c6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $82feba03f45a47c6$var$load("SepNY").then(()=>parcelRequire('3QuUN'));

});

parcelRegister("jrref", function(module, exports) {
/* hide.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $7ca6755ada461d2d$var$styles = {
    'above.xs': "_114bglyw",
    'above.sm': "_181nglyw",
    'above.md': "_dm25glyw",
    'above.lg': "_je3oglyw",
    'above.xl': "_1uxvglyw",
    'below.xs': "_1m0aglyw",
    'below.sm': "_sugaglyw",
    'below.md': "_1mjbglyw",
    'below.lg': "_liwcglyw",
    'below.xl': "_14wzglyw"
};
const $7ca6755ada461d2d$export$bed28288a051538 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(AsElement, {
        className: (0, $gMc0m.default)([
            above && $7ca6755ada461d2d$var$styles[`above.${above}`],
            below && $7ca6755ada461d2d$var$styles[`below.${below}`],
            xcss
        ]),
        children: children
    });
};
module.exports["Hide"] = $7ca6755ada461d2d$export$bed28288a051538;

});

parcelRegister("19Jj3", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fVUfS = parcelRequire("fVUfS");

var $iXCQx = parcelRequire("iXCQx");


var $2MPqq = parcelRequire("2MPqq");

const $b6d455d4ca0de162$var$styles = {
    root: "_2rko12b0 _syaz15cr _bfhk1aqn _irr31ibz _1di6of27"
};
const $b6d455d4ca0de162$export$869dfff69399fe87 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ 'aria-label': ariaLabel, onClick: onClick, children: children, testId: testId }, ref)=>{
    const { secondaryAction: secondaryAction } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    const back = (event)=>{
        secondaryAction.action.current(event);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        "aria-label": ariaLabel,
        ref: ref,
        testId: testId,
        xcss: $b6d455d4ca0de162$var$styles.root,
        onClick: onClick || back,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            as: "span",
            children: children
        })
    });
});
module.exports["SpotlightSecondaryAction"] = $b6d455d4ca0de162$export$869dfff69399fe87;

});

parcelRegister("aG6kF", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1s5hv = parcelRequire("1s5hv");

var $iXCQx = parcelRequire("iXCQx");


var $6F6hl = parcelRequire("6F6hl");

const $2d58ceeae1d26536$var$styles = {
    root: "_1ul91ris"
};
const $2d58ceeae1d26536$export$f4d9def8bfebca = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        xcss: $2d58ceeae1d26536$var$styles.root,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
            ref: ref,
            testId: testId,
            children: [
                children,
                " ",
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                    children: "steps"
                })
            ]
        })
    });
});
module.exports["SpotlightStepCount"] = $2d58ceeae1d26536$export$f4d9def8bfebca;

});

parcelRegister("3Awqk", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $90247d71b6534bef$export$ce22f6f6b0034afd = (0, $cgtv4.defineMessages)({
    next: {
        id: "experiment-nth-user-orientation.spotlight.next",
        defaultMessage: "Next"
    },
    back: {
        id: "experiment-nth-user-orientation.spotlight.back",
        defaultMessage: "Back"
    },
    done: {
        id: "experiment-nth-user-orientation.spotlight.done",
        defaultMessage: "Done"
    },
    dismiss: {
        id: "experiment-nth-user-orientation.spotlight.dismiss",
        defaultMessage: "Dismiss Tour"
    },
    progress: {
        id: "experiment-nth-user-orientation.spotlight.progress",
        defaultMessage: "{step} of {steps}"
    }
});
const $90247d71b6534bef$export$9a4454cd199ce080 = (0, $cgtv4.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.editorSpaceSpotlight.headline",
        defaultMessage: "Your space, your start"
    },
    body: {
        id: "experiment-nth-user-orientation.editorSpaceSpotlight.body",
        defaultMessage: "This is your personal space. Create more to organize your team\u2019s work."
    }
});
const $90247d71b6534bef$export$252e22890fb2efa6 = (0, $cgtv4.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.editorForYouSpotlight.headline",
        defaultMessage: "Catch up on team activity here"
    },
    body: {
        id: "experiment-nth-user-orientation.editorForYouSpotlight.body",
        defaultMessage: "See recent pages, team updates, and quick links tailored for you."
    }
});
const $90247d71b6534bef$export$6794fada8079fe55 = (0, $cgtv4.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.editorBpqaSpotlight.headline",
        defaultMessage: "Now let\u2019s create your first page!"
    },
    body: {
        id: "experiment-nth-user-orientation.editorBpqaSpotlight.body",
        defaultMessage: "With a template, a page is a click away. Hover on one for a preview."
    }
});
const $90247d71b6534bef$export$5e40e80091fe8d93 = (0, $cgtv4.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.homeForYouSpotlight.headline",
        defaultMessage: "Welcome to For You"
    },
    body: {
        id: "experiment-nth-user-orientation.homeForYouSpotlight.body",
        defaultMessage: "See your team\u2019s latest updates, all in one place. No detective work required."
    }
});
const $90247d71b6534bef$export$7825440c9499d8f5 = (0, $cgtv4.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.homeSpaceSpotlight.headline",
        defaultMessage: "Find your content in spaces"
    },
    body: {
        id: "experiment-nth-user-orientation.homeSpaceSpotlight.body",
        defaultMessage: "Keep one for yourself and make many more for every project, team, or idea."
    }
});
const $90247d71b6534bef$export$2649c34524e05250 = (0, $cgtv4.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.homeTemplateSpotlight.headline",
        defaultMessage: "You\u2019re all set \uD83D\uDE80"
    },
    body: {
        id: "experiment-nth-user-orientation.homeTemplateSpotlight.body",
        defaultMessage: "Kick things off with a template, or select Create to start from scratch."
    }
});
const $90247d71b6534bef$export$dd1a2e8e1bad6c6 = (0, $cgtv4.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.homeCreateSpotlight.headline",
        defaultMessage: "Ready to create your first page?"
    },
    body: {
        id: "experiment-nth-user-orientation.homeCreateSpotlight.body",
        defaultMessage: "Select Create to create your first page."
    }
});
module.exports["spotlight"] = $90247d71b6534bef$export$ce22f6f6b0034afd;
module.exports["editorSpaceSpotlight"] = $90247d71b6534bef$export$9a4454cd199ce080;
module.exports["editorForYouSpotlight"] = $90247d71b6534bef$export$252e22890fb2efa6;
module.exports["editorBpqaSpotlight"] = $90247d71b6534bef$export$6794fada8079fe55;

});

parcelRegister("3SChL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $751fcd22fac4dec6$export$7a357837346c6789 = {
    home: [
        'nth-user-orientation-home-for-you-spotlight',
        'nth-user-orientation-home-space-spotlight',
        'nth-user-orientation-home-template-spotlight'
    ],
    'home-fallback': [
        'nth-user-orientation-home-for-you-spotlight',
        'nth-user-orientation-home-space-spotlight',
        'nth-user-orientation-home-create-spotlight'
    ],
    editor: [
        'nth-user-orientation-editor-space-spotlight',
        'nth-user-orientation-editor-for-you-spotlight',
        'nth-user-orientation-editor-bpqa-spotlight'
    ]
};
const $751fcd22fac4dec6$var$detectTour = (renderedSpotlights)=>{
    // Find the first tour where all required spotlights are registered
    for (const [tour, spotlights] of Object.entries($751fcd22fac4dec6$export$7a357837346c6789)){
        if (spotlights.every((spotlight)=>renderedSpotlights.has(spotlight))) return tour;
    }
    return null;
};
const $751fcd22fac4dec6$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        active: false,
        step: 0,
        renderedSpotlights: new Set(),
        hasInteracted: false
    },
    actions: {
        activate: ()=>({ setState: setState })=>{
                setState({
                    active: true,
                    step: 0
                });
            },
        reset: ()=>({ setState: setState })=>{
                setState({
                    active: false,
                    step: 0,
                    hasInteracted: false
                });
            },
        next: ()=>({ setState: setState, getState: getState })=>{
                const nextStep = Math.min(getState().step + 1, 2);
                setState({
                    step: nextStep,
                    hasInteracted: true
                });
            },
        back: ()=>({ setState: setState, getState: getState })=>{
                const prevStep = Math.max(getState().step - 1, 0);
                setState({
                    step: prevStep,
                    hasInteracted: true
                });
            },
        registerSpotlight: ({ spotlightId: spotlightId })=>({ setState: setState, getState: getState })=>{
                const newRegistered = new Set(getState().renderedSpotlights);
                newRegistered.add(spotlightId);
                setState({
                    renderedSpotlights: newRegistered
                });
            },
        deregisterSpotlight: ({ spotlightId: spotlightId })=>({ setState: setState, getState: getState })=>{
                const newRegistered = new Set(getState().renderedSpotlights);
                newRegistered.delete(spotlightId);
                setState({
                    renderedSpotlights: newRegistered
                });
            }
    },
    name: 'experiment-nth-user-orientation-store'
});
const $751fcd22fac4dec6$export$6d3060c9729a9bf7 = (0, $9zUhf.createStateHook)($751fcd22fac4dec6$var$Store);
const $751fcd22fac4dec6$export$31ec7099503725e8 = (0, $9zUhf.createActionsHook)($751fcd22fac4dec6$var$Store);
const $751fcd22fac4dec6$export$e9b94d8bc34db24 = (spotlightId)=>{
    const { next: next, back: back, reset: reset, registerSpotlight: registerSpotlight, deregisterSpotlight: deregisterSpotlight } = $751fcd22fac4dec6$export$31ec7099503725e8();
    const { step: step, active: active, renderedSpotlights: renderedSpotlights, hasInteracted: hasInteracted } = $751fcd22fac4dec6$export$6d3060c9729a9bf7();
    // Auto-register/deregister the spotlight when spotlights use this hook. This way
    // we can keep track of which spotlights are currently rendered, and use that list
    // to figure out if the user is eligible for a tour.
    (0, $42omo.useEffect)(()=>{
        registerSpotlight({
            spotlightId: spotlightId
        });
        return ()=>{
            deregisterSpotlight({
                spotlightId: spotlightId
            });
        };
    }, [
        spotlightId,
        registerSpotlight,
        deregisterSpotlight
    ]);
    const detectedTour = (0, $42omo.useMemo)(()=>$751fcd22fac4dec6$var$detectTour(renderedSpotlights), [
        renderedSpotlights
    ]);
    if (!active || !detectedTour) return {
        reset: reset,
        back: back,
        next: next,
        currentStep: null,
        progress: {
            step: 0,
            steps: 0
        },
        hasInteracted: hasInteracted
    };
    return {
        reset: reset,
        back: back,
        next: next,
        currentStep: $751fcd22fac4dec6$export$7a357837346c6789[detectedTour][step],
        progress: {
            step: step + 1,
            steps: detectedTour ? $751fcd22fac4dec6$export$7a357837346c6789[detectedTour].length : 0
        },
        hasInteracted: hasInteracted
    };
};
module.exports["useNthUserOrientationState"] = $751fcd22fac4dec6$export$6d3060c9729a9bf7;
module.exports["useNthUserOrientationActions"] = $751fcd22fac4dec6$export$31ec7099503725e8;
module.exports["useTour"] = $751fcd22fac4dec6$export$e9b94d8bc34db24;

});

parcelRegister("2AgON", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");

const $3c36b21fe0d55bcd$var$SPOTLIGHT_ACTION_SUBJECT_IDS = {
    'nth-user-orientation-home-for-you-spotlight': 'nthUserOrientationHomeForYouSpotlight',
    'nth-user-orientation-home-space-spotlight': 'nthUserOrientationHomeSpaceSpotlight',
    'nth-user-orientation-home-template-spotlight': 'nthUserOrientationHomeTemplateSpotlight',
    'nth-user-orientation-home-create-spotlight': 'nthUserOrientationHomeCreateSpotlight',
    'nth-user-orientation-editor-space-spotlight': 'nthUserOrientationEditorSpaceSpotlight',
    'nth-user-orientation-editor-for-you-spotlight': 'nthUserOrientationEditorForYouSpotlight',
    'nth-user-orientation-editor-bpqa-spotlight': 'nthUserOrientationEditorBpqaSpotlight'
};
function $3c36b21fe0d55bcd$export$b54fada573f13a91({ spotlightId: spotlightId, isVisible: isVisible, onNext: onNext, onBack: onBack, onDismiss: onDismiss }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    // Fire render event when spotlight becomes visible
    (0, $42omo.useEffect)(()=>{
        if (isVisible) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'rendered',
                actionSubject: 'spotlight',
                actionSubjectId: $3c36b21fe0d55bcd$var$SPOTLIGHT_ACTION_SUBJECT_IDS[spotlightId],
                source: 'nth-user-orientation'
            }
        }).fire();
    }, [
        isVisible,
        createAnalyticsEvent,
        spotlightId
    ]);
    const handleNext = (0, $42omo.useCallback)(()=>{
        if (onNext) {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'next',
                    source: spotlightId
                }
            }).fire();
            onNext();
        }
    }, [
        onNext,
        createAnalyticsEvent,
        spotlightId
    ]);
    const handleBack = (0, $42omo.useCallback)(()=>{
        if (onBack) {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'back',
                    source: spotlightId
                }
            }).fire();
            onBack();
        }
    }, [
        onBack,
        createAnalyticsEvent,
        spotlightId
    ]);
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismissTour',
                source: spotlightId
            }
        }).fire();
        onDismiss();
    }, [
        onDismiss,
        createAnalyticsEvent,
        spotlightId
    ]);
    return {
        handleNext: onNext ? handleNext : undefined,
        handleBack: onBack ? handleBack : undefined,
        handleDismiss: handleDismiss
    };
}
module.exports["useSpotlightAnalytics"] = $3c36b21fe0d55bcd$export$b54fada573f13a91;

});

parcelRegister("d4Pk4", function(module, exports) {

var $94jtO = parcelRequire("94jtO");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/platform/site/manifest.ts
var $985375b928439e07$var$platformSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $94jtO.PlatformSiteAriResourceOwner),
    resourceType: (0, $94jtO.PlatformSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/platform/site/index.ts
var $985375b928439e07$export$62388e9e87e2e1c9 = class _PlatformSiteAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $985375b928439e07$var$platformSiteAriStaticOpts.qualifier,
            platformQualifier: $985375b928439e07$var$platformSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $985375b928439e07$var$platformSiteAriStaticOpts.resourceOwner,
            resourceType: $985375b928439e07$var$platformSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $985375b928439e07$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $985375b928439e07$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["PlatformSiteAri"] = $985375b928439e07$export$62388e9e87e2e1c9;

});

parcelRegister("94jtO", function(module, exports) {
// src/platform/site/types.ts
var $69a39916eb9c41be$export$2866935ccba4694c = "platform", $69a39916eb9c41be$export$c9ae8b227ea4b550 = "site";
module.exports["PlatformSiteAriResourceOwner"] = $69a39916eb9c41be$export$2866935ccba4694c;
module.exports["PlatformSiteAriResourceType"] = $69a39916eb9c41be$export$c9ae8b227ea4b550;

});

parcelRegister("2fgSf", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $e7508444bbfb347b$export$69ed422375389c7 = ()=>{
    const isDefaultDomain = window.location.hostname.endsWith('.atlassian.net') || window.location.hostname.endsWith('.jira-dev.com');
    return !isDefaultDomain && (0, $9wGTI.fg)('cc-activity-v3-use-agg-endpoint-for-custom-domain');
};
module.exports["shouldUseAGGActivityV3"] = $e7508444bbfb347b$export$69ed422375389c7;

});

parcelRegister("WG1VM", function(module, exports) {

var $abN8T = parcelRequire("abN8T");


var $d4Pk4 = parcelRequire("d4Pk4");


var $jlIaF = parcelRequire("jlIaF");


var $c7GB4 = parcelRequire("c7GB4");


var $8BHAT = parcelRequire("8BHAT");

const $c69e7b592fedb17e$export$8ec3d08588d2eeda = 30;
var $c69e7b592fedb17e$var$ActivityEventType = /*#__PURE__*/ function(ActivityEventType) {
    ActivityEventType["ASSIGNED"] = "ASSIGNED";
    ActivityEventType["COMMENTED"] = "COMMENTED";
    ActivityEventType["CREATED"] = "CREATED";
    ActivityEventType["EDITED"] = "EDITED";
    ActivityEventType["LIKED"] = "LIKED";
    ActivityEventType["PUBLISHED"] = "PUBLISHED";
    ActivityEventType["SNAPSHOTTED"] = "SNAPSHOTTED";
    ActivityEventType["STARTED"] = "STARTED";
    ActivityEventType["TRANSITIONED"] = "TRANSITIONED";
    ActivityEventType["UNASSIGNED"] = "UNASSIGNED";
    ActivityEventType["UPDATED"] = "UPDATED";
    ActivityEventType["VIEWED"] = "VIEWED";
    return ActivityEventType;
}($c69e7b592fedb17e$var$ActivityEventType || {});
var $c69e7b592fedb17e$var$ActivityObjectType = /*#__PURE__*/ function(ActivityObjectType) {
    ActivityObjectType["PAGE"] = "PAGE";
    ActivityObjectType["BLOGPOST"] = "BLOGPOST";
    ActivityObjectType["WHITEBOARD"] = "WHITEBOARD";
    ActivityObjectType["DATABASE"] = "DATABASE";
    ActivityObjectType["EMBED"] = "EMBED";
    ActivityObjectType["CONTENT"] = "CONTENT";
    ActivityObjectType["COMMENT"] = "COMMENT";
    return ActivityObjectType;
}($c69e7b592fedb17e$var$ActivityObjectType || {});
const $c69e7b592fedb17e$export$c49cfb2681596b20 = [
    "PAGE",
    "BLOGPOST",
    "WHITEBOARD",
    "DATABASE",
    "EMBED",
    "CONTENT"
];
const $c69e7b592fedb17e$var$WORKED_ON_EVENT_TYPES = [
    "EDITED",
    "PUBLISHED",
    "UPDATED",
    "CREATED",
    "STARTED",
    "SNAPSHOTTED"
];
const $c69e7b592fedb17e$var$transformActivityNodeLegacyUrl = (activitiesNode)=>{
    const transformedNode = $c69e7b592fedb17e$var$transformActivityData(activitiesNode?.node);
    if (!transformedNode?.object?.content?.links?.webui) return transformedNode;
    return {
        ...transformedNode,
        object: {
            ...transformedNode.object,
            url: `${0, $jlIaF.CONTEXT_PATH}${transformedNode.object.content.links.webui}`,
            content: {
                ...transformedNode.object.content
            }
        }
    };
};
const $c69e7b592fedb17e$var$transformActivityData = (recent)=>{
    if (recent?.object?.data?.commentId) {
        recent.event.eventType = 'commented';
        recent.object.data = recent?.object?.data?.container;
    }
    const content = recent?.object?.data;
    if (content) {
        content.type = content.type?.toLowerCase() === 'blog_post' ? 'blogpost' : content.type?.toLowerCase();
        content.subtype = content.subtype?.toLowerCase();
        // The "status" field is ConfluencePage/ConfluenceBlogPost type for pages/blogs but is
        // ConfluenceContentStatus type for all other content types. To prevent the GraphQL
        // "returns different types" error, we are using the aliases "pageStatus" and "blogStatus"
        content.status = [
            content.status,
            content.pageStatus,
            content.blogStatus
        ].find((status)=>status)?.toLowerCase();
        // FE workaround for activity query returning "status: DRAFT" for published content with unpublished changes
        if (content.status === 'draft' && content.createdAt) content.status = 'current';
    }
    if (recent?.event) recent.event.eventType = recent.event.eventType?.toUpperCase();
    const transformedId = content?.id && (0, $c7GB4.getIdFromConfluenceContentAri)({
        ari: recent?.object?.data?.id,
        resourceType: recent?.object?.data?.type
    });
    const recentData = recent?.object?.data;
    // TODO: This is currently transforming activity V3 data into activity V2 format. This
    // tranformation will be simplified in DISCO-4281
    const transformedContent = {
        ...recentData,
        id: transformedId,
        metadata: {
            ...recentData?.metadata,
            currentuser: {
                favourited: {
                    isFavourite: recentData?.viewer?.favoritedSummary?.isFavorite
                }
            }
        },
        links: {
            webui: recentData?.links?.webUi,
            editui: recentData?.links?.editUi
        },
        subType: recentData?.subtype,
        emoji: {
            nodes: [
                {
                    key: 'emoji-title-published',
                    value: recentData?.metadata?.titleEmojiPublished?.value
                },
                {
                    key: 'emoji-title-draft',
                    value: recentData?.metadata?.titleEmojiDraft?.value
                }
            ]
        }
    };
    return {
        ...recent,
        id: transformedId,
        timestamp: recent?.event?.timestamp,
        object: {
            ...recent?.object,
            content: transformedContent
        }
    };
};
const $c69e7b592fedb17e$var$getAllRecentQueryOptions = (cloudId)=>({
        query: (0, $8BHAT.RecentContentMenuQuery),
        initialVars: {
            cloudId: (0, $d4Pk4.PlatformSiteAri).create({
                siteId: cloudId
            }).toString(),
            after: '',
            first: $c69e7b592fedb17e$export$8ec3d08588d2eeda,
            eventTypes: [],
            objectTypes: $c69e7b592fedb17e$export$c49cfb2681596b20
        },
        fetchMoreVars: (endCursor)=>({
                cloudId: (0, $d4Pk4.PlatformSiteAri).create({
                    siteId: cloudId
                }).toString(),
                after: endCursor
            }),
        transformNodes: (data)=>(data?.activity?.myActivity?.all?.edges || []).map($c69e7b592fedb17e$var$transformActivityNodeLegacyUrl),
        getPaginationParams: (data)=>{
            const allActivity = data?.activity?.myActivity?.all;
            return {
                endCursor: allActivity?.pageInfo?.endCursor || '',
                hasNextPage: allActivity?.pageInfo?.hasNextPage || false
            };
        },
        updatePaginationResults: (prev, fetchMoreResult)=>{
            const prevNodes = prev.activity?.myActivity?.all?.edges || [];
            const fetchMoreNodes = fetchMoreResult.activity?.myActivity?.all?.edges || [];
            const mergedNodes = [
                ...prevNodes,
                ...fetchMoreNodes
            ];
            const result = {
                ...fetchMoreResult
            };
            (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(result, 'activity.myActivity.all.edges', mergedNodes);
            return result;
        }
    });
const $c69e7b592fedb17e$var$getCollaboratedOnQueryOptions = (cloudId)=>({
        query: (0, $8BHAT.RecentContentMenuQuery),
        initialVars: {
            cloudId: (0, $d4Pk4.PlatformSiteAri).create({
                siteId: cloudId
            }).toString(),
            after: '',
            first: $c69e7b592fedb17e$export$8ec3d08588d2eeda,
            eventTypes: $c69e7b592fedb17e$var$WORKED_ON_EVENT_TYPES,
            objectTypes: [
                ...$c69e7b592fedb17e$export$c49cfb2681596b20,
                "COMMENT"
            ]
        },
        fetchMoreVars: (endCursor)=>({
                cloudId: (0, $d4Pk4.PlatformSiteAri).create({
                    siteId: cloudId
                }).toString(),
                after: endCursor
            }),
        transformNodes: (data)=>(data?.activity?.myActivity?.all?.edges || []).map($c69e7b592fedb17e$var$transformActivityNodeLegacyUrl),
        getPaginationParams: (data)=>{
            const allActivity = data?.activity?.myActivity?.all;
            return {
                endCursor: allActivity?.pageInfo?.endCursor || '',
                hasNextPage: allActivity?.pageInfo?.hasNextPage || false
            };
        },
        updatePaginationResults: (prev, fetchMoreResult)=>{
            const prevNodes = prev.activity?.myActivity?.all?.edges || [];
            const fetchMoreNodes = fetchMoreResult.activity?.myActivity?.all?.edges || [];
            const mergedNodes = [
                ...prevNodes,
                ...fetchMoreNodes
            ];
            const result = {
                ...fetchMoreResult
            };
            (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(result, 'activity.myActivity.all.edges', mergedNodes);
            return result;
        }
    });
const $c69e7b592fedb17e$var$getWorkedOnQueryOptions = (cloudId)=>({
        query: (0, $8BHAT.RecentContentMenuQuery),
        initialVars: {
            cloudId: (0, $d4Pk4.PlatformSiteAri).create({
                siteId: cloudId
            }).toString(),
            after: '',
            first: $c69e7b592fedb17e$export$8ec3d08588d2eeda,
            eventTypes: $c69e7b592fedb17e$var$WORKED_ON_EVENT_TYPES,
            objectTypes: $c69e7b592fedb17e$export$c49cfb2681596b20
        },
        fetchMoreVars: (endCursor)=>({
                cloudId: (0, $d4Pk4.PlatformSiteAri).create({
                    siteId: cloudId
                }).toString(),
                after: endCursor
            }),
        transformNodes: (data)=>(data?.activity?.myActivity?.all?.edges || []).map($c69e7b592fedb17e$var$transformActivityNodeLegacyUrl),
        getPaginationParams: (data)=>{
            const allActivity = data?.activity?.myActivity?.all;
            return {
                endCursor: allActivity?.pageInfo?.endCursor || '',
                hasNextPage: allActivity?.pageInfo?.hasNextPage || false
            };
        },
        updatePaginationResults: (prev, fetchMoreResult)=>{
            const prevNodes = prev.activity?.myActivity?.all?.edges || [];
            const fetchMoreNodes = fetchMoreResult.activity?.myActivity?.all?.edges || [];
            const mergedNodes = [
                ...prevNodes,
                ...fetchMoreNodes
            ];
            const result = {
                ...fetchMoreResult
            };
            (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(result, 'activity.myActivity.all.edges', mergedNodes);
            return result;
        }
    });
const $c69e7b592fedb17e$var$mapCreatedByMeTabNodes = (node)=>{
    return {
        ...node,
        timestamp: node?.content?.metadata?.currentuser?.lastcontributed?.when,
        object: {
            url: `${0, $jlIaF.CONTEXT_PATH}${node.url}`,
            content: node.content
        }
    };
};
const $c69e7b592fedb17e$var$getCreatedByMeQueryOptions = ()=>{
    return {
        query: (0, $8BHAT.RecentlyCreatedByMeQuery),
        initialVars: {
            cql: `type in (page, blogpost, embed, whiteboard, database) and owner=currentUser() and created >= startOfDay("-90d") order by created desc`,
            cqlcontext: `{"contentStatuses":["draft", "current"]}`,
            after: '',
            first: $c69e7b592fedb17e$export$8ec3d08588d2eeda
        },
        fetchMoreVars: (endCursor)=>({
                after: endCursor
            }),
        transformNodes: (data)=>(data?.search?.nodes || []).map($c69e7b592fedb17e$var$mapCreatedByMeTabNodes),
        getPaginationParams: (data)=>({
                endCursor: data?.search?.pageInfo?.endCursor || '',
                hasNextPage: data?.search?.pageInfo?.hasNextPage || false
            }),
        updatePaginationResults: (prev, fetchMoreResult)=>{
            const prevNodes = prev.search?.nodes || [];
            const fetchMoreNodes = fetchMoreResult.search?.nodes || [];
            const mergedNodes = [
                ...prevNodes,
                ...fetchMoreNodes
            ];
            const result = {
                ...fetchMoreResult
            };
            (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(result, 'search.nodes', mergedNodes);
            return result;
        }
    };
};
const $c69e7b592fedb17e$export$175d7f1f999191e6 = (cloudId)=>{
    const queryOptions = {
        ALL: $c69e7b592fedb17e$var$getAllRecentQueryOptions(cloudId),
        COLLABORATED_ON: $c69e7b592fedb17e$var$getCollaboratedOnQueryOptions(cloudId),
        WORKED_ON: $c69e7b592fedb17e$var$getWorkedOnQueryOptions(cloudId),
        CREATED_BY_ME: $c69e7b592fedb17e$var$getCreatedByMeQueryOptions()
    };
    return queryOptions;
};
module.exports["PAGE_SIZE"] = $c69e7b592fedb17e$export$8ec3d08588d2eeda;
module.exports["OBJECT_TYPES"] = $c69e7b592fedb17e$export$c49cfb2681596b20;
module.exports["getQueryOptions"] = $c69e7b592fedb17e$export$175d7f1f999191e6;

});

parcelRegister("c7GB4", function(module, exports) {

var $eB56w = parcelRequire("eB56w");

var $iH7AG = parcelRequire("iH7AG");

var $dM0Qh = parcelRequire("dM0Qh");

var $lb1Mg = parcelRequire("lb1Mg");

var $a2xFu = parcelRequire("a2xFu");

var $a5Dk4 = parcelRequire("a5Dk4");


var $1ggpj = parcelRequire("1ggpj");

const $c96e0d62cf176fc6$export$84dfa7fadd8a006b = ({ ari: ari, resourceType: resourceType })=>{
    if (!ari) return null;
    switch(resourceType){
        case (0, $1ggpj.ContentType).PAGE:
            return (0, $a2xFu.ConfluencePageAri).parse(ari).pageId;
        case (0, $1ggpj.ContentType).BLOGPOST:
            return (0, $eB56w.ConfluenceBlogpostAri).parse(ari).blogpostId;
        case (0, $1ggpj.ContentType).WHITEBOARD:
            return (0, $a5Dk4.ConfluenceWhiteboardAri).parse(ari).whiteboardId;
        case (0, $1ggpj.ContentType).DATABASE:
            return (0, $iH7AG.ConfluenceDatabaseAri).parse(ari).databaseId;
        case (0, $1ggpj.ContentType).EMBED:
            return (0, $dM0Qh.ConfluenceEmbedAri).parse(ari).embedId;
        case (0, $1ggpj.ContentType).FOLDER:
            return (0, $lb1Mg.ConfluenceFolderAri).parse(ari).folderId;
    }
};
module.exports["getIdFromConfluenceContentAri"] = $c96e0d62cf176fc6$export$84dfa7fadd8a006b;

});

parcelRegister("eB56w", function(module, exports) {

var $fOAkx = parcelRequire("fOAkx");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/blogpost/manifest.ts
var $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $fOAkx.ConfluenceBlogpostAriResourceOwner),
    resourceType: (0, $fOAkx.ConfluenceBlogpostAriResourceType),
    resourceIdSlug: "{blogpostId}",
    resourceIdSegmentFormats: {
        blogpostId: /[0-9]+/
    }
};
// src/confluence/blogpost/index.ts
var $aa087af90d1c8aca$export$8602a2c2f6ac09bc = class _ConfluenceBlogpostAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get blogpostId() {
        return this._blogpostId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.qualifier,
            platformQualifier: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.resourceOwner,
            resourceType: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.resourceType,
            resourceId: `${opts.blogpostId}`,
            resourceIdSegmentValues: {
                blogpostId: opts.blogpostId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            blogpostId: this.blogpostId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._blogpostId = opts.resourceIdSegmentValues.blogpostId;
    }
};
module.exports["ConfluenceBlogpostAri"] = $aa087af90d1c8aca$export$8602a2c2f6ac09bc;

});

parcelRegister("fOAkx", function(module, exports) {
// src/confluence/blogpost/types.ts
var $b837b4f269c93ee4$export$9389f06bd1d0765c = "confluence", $b837b4f269c93ee4$export$fb777a2d645a4129 = "blogpost";
module.exports["ConfluenceBlogpostAriResourceOwner"] = $b837b4f269c93ee4$export$9389f06bd1d0765c;
module.exports["ConfluenceBlogpostAriResourceType"] = $b837b4f269c93ee4$export$fb777a2d645a4129;

});

parcelRegister("iH7AG", function(module, exports) {

var $hIjpx = parcelRequire("hIjpx");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/database/manifest.ts
var $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $hIjpx.ConfluenceDatabaseAriResourceOwner),
    resourceType: (0, $hIjpx.ConfluenceDatabaseAriResourceType),
    resourceIdSlug: "activation/{activationId}/{databaseId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        databaseId: /[0-9]+/
    }
};
// src/confluence/database/index.ts
var $d9c22183dba005c8$export$317cd32472deea7e = class _ConfluenceDatabaseAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get databaseId() {
        return this._databaseId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.qualifier,
            platformQualifier: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.resourceOwner,
            resourceType: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.databaseId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                databaseId: opts.databaseId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            databaseId: this.databaseId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._databaseId = opts.resourceIdSegmentValues.databaseId;
    }
};
module.exports["ConfluenceDatabaseAri"] = $d9c22183dba005c8$export$317cd32472deea7e;

});

parcelRegister("hIjpx", function(module, exports) {
// src/confluence/database/types.ts
var $ce559a57d4ba003b$export$e83bc7b627335f1d = "confluence", $ce559a57d4ba003b$export$d26db9a1a0b750aa = "database";
module.exports["ConfluenceDatabaseAriResourceOwner"] = $ce559a57d4ba003b$export$e83bc7b627335f1d;
module.exports["ConfluenceDatabaseAriResourceType"] = $ce559a57d4ba003b$export$d26db9a1a0b750aa;

});

parcelRegister("dM0Qh", function(module, exports) {

var $dPsPU = parcelRequire("dPsPU");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/embed/manifest.ts
var $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $dPsPU.ConfluenceEmbedAriResourceOwner),
    resourceType: (0, $dPsPU.ConfluenceEmbedAriResourceType),
    resourceIdSlug: "activation/{activationId}/{embedId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        embedId: /[0-9]+/
    }
};
// src/confluence/embed/index.ts
var $a070694ffdc5cb3b$export$47d4b4205d0ac61a = class _ConfluenceEmbedAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get embedId() {
        return this._embedId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.qualifier,
            platformQualifier: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.resourceOwner,
            resourceType: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.embedId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                embedId: opts.embedId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            embedId: this.embedId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._embedId = opts.resourceIdSegmentValues.embedId;
    }
};
module.exports["ConfluenceEmbedAri"] = $a070694ffdc5cb3b$export$47d4b4205d0ac61a;

});

parcelRegister("dPsPU", function(module, exports) {
// src/confluence/embed/types.ts
var $a116681263506e39$export$7a02af293cacddd2 = "confluence", $a116681263506e39$export$f817d48842ea0d4a = "embed";
module.exports["ConfluenceEmbedAriResourceOwner"] = $a116681263506e39$export$7a02af293cacddd2;
module.exports["ConfluenceEmbedAriResourceType"] = $a116681263506e39$export$f817d48842ea0d4a;

});

parcelRegister("lb1Mg", function(module, exports) {

var $bYbE5 = parcelRequire("bYbE5");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/folder/manifest.ts
var $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $bYbE5.ConfluenceFolderAriResourceOwner),
    resourceType: (0, $bYbE5.ConfluenceFolderAriResourceType),
    resourceIdSlug: "activation/{activationId}/{folderId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        folderId: /[0-9]+/
    }
};
// src/confluence/folder/index.ts
var $f6ac010730fe9d5d$export$501a782385a3f485 = class _ConfluenceFolderAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get folderId() {
        return this._folderId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.qualifier,
            platformQualifier: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.resourceOwner,
            resourceType: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.folderId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                folderId: opts.folderId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            folderId: this.folderId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._folderId = opts.resourceIdSegmentValues.folderId;
    }
};
module.exports["ConfluenceFolderAri"] = $f6ac010730fe9d5d$export$501a782385a3f485;

});

parcelRegister("bYbE5", function(module, exports) {
// src/confluence/folder/types.ts
var $8b6e54dbbb0b2632$export$77cf4e1b17902bfa = "confluence", $8b6e54dbbb0b2632$export$6256ff329bc25a9c = "folder";
module.exports["ConfluenceFolderAriResourceOwner"] = $8b6e54dbbb0b2632$export$77cf4e1b17902bfa;
module.exports["ConfluenceFolderAriResourceType"] = $8b6e54dbbb0b2632$export$6256ff329bc25a9c;

});

parcelRegister("a2xFu", function(module, exports) {

var $5KmYv = parcelRequire("5KmYv");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/page/manifest.ts
var $74f4351b9cae92fc$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $5KmYv.ConfluencePageAriResourceOwner),
    resourceType: (0, $5KmYv.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $74f4351b9cae92fc$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $74f4351b9cae92fc$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $74f4351b9cae92fc$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};
module.exports["ConfluencePageAri"] = $74f4351b9cae92fc$export$3f931dd15d96caff;

});

parcelRegister("5KmYv", function(module, exports) {
// src/confluence/page/types.ts
var $42f311f8b7b6730c$export$da53e4f7db4c6a71 = "confluence", $42f311f8b7b6730c$export$636fc622562a2c5b = "page";
module.exports["ConfluencePageAriResourceOwner"] = $42f311f8b7b6730c$export$da53e4f7db4c6a71;
module.exports["ConfluencePageAriResourceType"] = $42f311f8b7b6730c$export$636fc622562a2c5b;

});

parcelRegister("a5Dk4", function(module, exports) {

var $aOBEU = parcelRequire("aOBEU");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/whiteboard/manifest.ts
var $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $aOBEU.ConfluenceWhiteboardAriResourceOwner),
    resourceType: (0, $aOBEU.ConfluenceWhiteboardAriResourceType),
    resourceIdSlug: "{whiteboardId}",
    resourceIdSegmentFormats: {
        whiteboardId: /[0-9]+/
    }
};
// src/confluence/whiteboard/index.ts
var $7588dfadc8876fc5$export$ba3d25b6768ddb10 = class _ConfluenceWhiteboardAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get whiteboardId() {
        return this._whiteboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.qualifier,
            platformQualifier: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.resourceOwner,
            resourceType: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.resourceType,
            resourceId: `${opts.whiteboardId}`,
            resourceIdSegmentValues: {
                whiteboardId: opts.whiteboardId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            whiteboardId: this.whiteboardId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._whiteboardId = opts.resourceIdSegmentValues.whiteboardId;
    }
};
module.exports["ConfluenceWhiteboardAri"] = $7588dfadc8876fc5$export$ba3d25b6768ddb10;

});

parcelRegister("aOBEU", function(module, exports) {
// src/confluence/whiteboard/types.ts
var $7dfbc92767b8c664$export$6130ea1abbb885ef = "confluence", $7dfbc92767b8c664$export$d3070d1568a10e2d = "whiteboard";
module.exports["ConfluenceWhiteboardAriResourceOwner"] = $7dfbc92767b8c664$export$6130ea1abbb885ef;
module.exports["ConfluenceWhiteboardAriResourceType"] = $7dfbc92767b8c664$export$d3070d1568a10e2d;

});

parcelRegister("1ggpj", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $lx6jn = parcelRequire("lx6jn");

var $2aa2bdb281c6889a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["PAGE"] = "page";
    ContentType["BLOGPOST"] = "blogpost";
    ContentType["DATABASE"] = "database";
    ContentType["EMBED"] = "embed";
    ContentType["FOLDER"] = "folder";
    return ContentType;
}({});
const $2aa2bdb281c6889a$export$31930b8b7828306b = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$e8b4d9d0d681efa4 = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$142530096b49b828 = [
    "whiteboard",
    "database",
    "embed",
    "page",
    "folder",
    "blogpost"
];
const $2aa2bdb281c6889a$export$de22146d402d9bdd = {
    ["whiteboard"]: (0, $lx6jn.FeedbackSource).WHITEBOARD,
    ["embed"]: (0, $lx6jn.FeedbackSource).EMBED,
    ["database"]: (0, $lx6jn.FeedbackSource).DATABASE
};
const $2aa2bdb281c6889a$export$10c6f1bef31d587c = [
    'database',
    'embed',
    'folder'
];
const $2aa2bdb281c6889a$export$544bad8872c0b7ed = 400;
module.exports["ContentType"] = $2aa2bdb281c6889a$export$e2e108cbe2e4f865;
module.exports["ARCHIVE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$31930b8b7828306b;
module.exports["DELETE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$e8b4d9d0d681efa4;
module.exports["VALID_OPERATION_TARGETS"] = $2aa2bdb281c6889a$export$142530096b49b828;
module.exports["CONTENT_TYPE_FEEDBACK_SOURCE"] = $2aa2bdb281c6889a$export$de22146d402d9bdd;
module.exports["TYPES_WITH_ACTIVATIONID"] = $2aa2bdb281c6889a$export$10c6f1bef31d587c;
module.exports["onChangeTitleDebounceTime"] = $2aa2bdb281c6889a$export$544bad8872c0b7ed;

});

parcelRegister("lx6jn", function(module, exports) {
var $4d57d476a3596595$export$1953473fc535c5c1 = /*#__PURE__*/ function(FeedbackSource) {
    FeedbackSource["EDITOR"] = "Editor";
    FeedbackSource["HELP_PANEL"] = "Help Panel";
    FeedbackSource["THEME_SELECTOR"] = "Theme Selector";
    FeedbackSource["WHITEBOARD"] = "Whiteboard";
    FeedbackSource["EMBED"] = "Embed";
    FeedbackSource["DATABASE"] = "Database";
    FeedbackSource["NAV_4"] = "Nav4";
    FeedbackSource["SHARE_DIALOG"] = "Share Dialog";
    FeedbackSource["CONTENT_WRAPPER"] = "Content Wrapper";
    FeedbackSource["LIVE_DOCS"] = "Live Docs";
    FeedbackSource["EDITOR_CONTROLS"] = "Editor Controls";
    FeedbackSource["NOTES"] = "Notes";
    FeedbackSource["CREATE_WITH_ROVO"] = "Create with Rovo";
    return FeedbackSource;
}({});
module.exports["FeedbackSource"] = $4d57d476a3596595$export$1953473fc535c5c1;

});

parcelRegister("lg4wi", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $gj7hi = parcelRequire("gj7hi");


var $kpYGL = parcelRequire("kpYGL");

var $5a97534dd007005d$exports = {};
$5a97534dd007005d$exports = new URL("errorWarning.3a015e54.svg", import.meta.url).toString();


var $df12eff91c81157e$exports = {};
$df12eff91c81157e$exports = new URL("noResultsDark.90199792.svg", import.meta.url).toString();


var $bc2576083d9a2d49$exports = {};
$bc2576083d9a2d49$exports = new URL("noResultsLight.5ffcf568.svg", import.meta.url).toString();


const $4fca70a5a203ab8a$var$ImageWithText = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { image: image, message: message, title: title, darkImage: darkImage, linkElement: linkElement } = t0;
    const t1 = darkImage || "";
    let t2;
    if ($[0] !== image || $[1] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: image,
            srcDark: t1,
            alt: "",
            width: "160px",
            height: "160px"
        });
        $[0] = image;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== title) {
        t3 = title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "bold",
            color: "color.text.subtle"
        }, title);
        $[3] = title;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== message) {
        t4 = message && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtle",
            align: "center",
            css: {
                textWrap: "balance"
            }
        }, message);
        $[5] = message;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== linkElement) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small"
        }, linkElement);
        $[7] = linkElement;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            alignInline: "center",
            space: "space.100"
        }, t3, t4, t5);
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== t2 || $[14] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            alignInline: "center",
            space: "space.100",
            grow: "fill"
        }, t2, t6);
        $[13] = t2;
        $[14] = t6;
        $[15] = t7;
    } else t7 = $[15];
    return t7;
} : ({ image: image, message: message, title: title, darkImage: darkImage, linkElement: linkElement })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        alignInline: "center",
        space: "space.100",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: image,
        srcDark: darkImage || '',
        alt: "",
        width: "160px",
        height: "160px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        alignInline: "center",
        space: "space.100"
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        weight: "bold",
        color: "color.text.subtle"
    }, title), message && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text.subtle",
        align: "center",
        css: {
            textWrap: 'balance'
        }
    }, message), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small"
    }, linkElement)));
};
const $4fca70a5a203ab8a$export$ee5f7ba6ec666d35 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { errorTitle: errorTitle } = t0;
    const intl = (0, $8C5kA.default)();
    let t1;
    if ($[0] !== intl) {
        t1 = intl.formatMessage($4fca70a5a203ab8a$var$i18n.errorMessageSubtitle);
        $[0] = intl;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== errorTitle || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4fca70a5a203ab8a$var$ImageWithText, {
            image: (0, (/*@__PURE__*/$parcel$interopDefault($5a97534dd007005d$exports))),
            title: errorTitle,
            message: t1
        });
        $[2] = errorTitle;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ errorTitle: errorTitle })=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4fca70a5a203ab8a$var$ImageWithText, {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($5a97534dd007005d$exports))),
        title: errorTitle,
        message: intl.formatMessage($4fca70a5a203ab8a$var$i18n.errorMessageSubtitle)
    });
};
const $4fca70a5a203ab8a$export$5967fd5ff661574a = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { message: message, advancedSearchLink: advancedSearchLink } = t0;
    const intl = (0, $8C5kA.default)();
    let t1;
    if ($[0] !== intl || $[1] !== message) {
        t1 = message || intl.formatMessage($4fca70a5a203ab8a$var$i18n.noResultsMessageSubtitle);
        $[0] = intl;
        $[1] = message;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== advancedSearchLink || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingBlockStart: "space.800",
            paddingBlockEnd: "space.300",
            paddingInline: "space.800"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4fca70a5a203ab8a$var$ImageWithText, {
            image: (0, (/*@__PURE__*/$parcel$interopDefault($bc2576083d9a2d49$exports))),
            message: t1,
            darkImage: (0, (/*@__PURE__*/$parcel$interopDefault($df12eff91c81157e$exports))),
            linkElement: advancedSearchLink
        }));
        $[3] = advancedSearchLink;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ message: message, advancedSearchLink: advancedSearchLink })=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        paddingBlockStart: "space.800",
        paddingBlockEnd: "space.300",
        paddingInline: "space.800"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4fca70a5a203ab8a$var$ImageWithText, {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($bc2576083d9a2d49$exports))),
        message: message || intl.formatMessage($4fca70a5a203ab8a$var$i18n.noResultsMessageSubtitle),
        darkImage: (0, (/*@__PURE__*/$parcel$interopDefault($df12eff91c81157e$exports))),
        linkElement: advancedSearchLink
    }));
};
const $4fca70a5a203ab8a$export$f6bcb1c900d8bf76 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { image: image, title: title, message: message, linkElement: linkElement } = t0;
    let t1;
    if ($[0] !== image || $[1] !== linkElement || $[2] !== message || $[3] !== title) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            padding: "space.800"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4fca70a5a203ab8a$var$ImageWithText, {
            image: image,
            title: title,
            message: message,
            linkElement: linkElement
        }));
        $[0] = image;
        $[1] = linkElement;
        $[2] = message;
        $[3] = title;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ image: image, title: title, message: message, linkElement: linkElement })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        padding: "space.800"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4fca70a5a203ab8a$var$ImageWithText, {
        image: image,
        title: title,
        message: message,
        linkElement: linkElement
    }));
};
const $4fca70a5a203ab8a$var$skeletonProps = {
    height: '9px',
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
    borderRadius: "var(--ds-radius-small, 3px)",
    isShimmering: true,
    color: "var(--ds-skeleton, #0515240F)",
    ShimmeringEndColor: "var(--ds-skeleton-subtle, #17171708)"
};
const $4fca70a5a203ab8a$export$a2ec9fdcdf0bd301 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingBlock: "space.300"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.300",
            alignBlock: "center",
            alignInline: "center",
            grow: "fill",
            testId: "content-menu-loading"
        }, [
            ...Array(10)
        ].map($4fca70a5a203ab8a$var$_temp)));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        paddingBlock: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.300",
        alignBlock: "center",
        alignInline: "center",
        grow: "fill",
        testId: "content-menu-loading"
    }, [
        ...Array(10)
    ].map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            key: index,
            width: "250px",
            ...$4fca70a5a203ab8a$var$skeletonProps
        }))));
};
const $4fca70a5a203ab8a$export$feed0f481420fd40 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            padding: "space.300"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.300",
            grow: "fill",
            testId: "content-menu-load-more"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "180px",
            ...$4fca70a5a203ab8a$var$skeletonProps
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "140px",
            ...$4fca70a5a203ab8a$var$skeletonProps
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "180px",
            ...$4fca70a5a203ab8a$var$skeletonProps
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "140px",
            ...$4fca70a5a203ab8a$var$skeletonProps
        })));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        padding: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.300",
        grow: "fill",
        testId: "content-menu-load-more"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "180px",
        ...$4fca70a5a203ab8a$var$skeletonProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "140px",
        ...$4fca70a5a203ab8a$var$skeletonProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "180px",
        ...$4fca70a5a203ab8a$var$skeletonProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "140px",
        ...$4fca70a5a203ab8a$var$skeletonProps
    })));
};
const $4fca70a5a203ab8a$var$i18n = (0, $cgtv4.defineMessages)({
    errorMessageSubtitle: {
        id: "side-navigation.content-menu.error-message.subtitle",
        defaultMessage: "Refresh and try again."
    },
    noResultsMessageSubtitle: {
        id: "side-navigation.content-menu.no-results-message.subtitle",
        defaultMessage: "We couldn\u2019t find what you\u2019re looking for."
    }
});
function $4fca70a5a203ab8a$var$_temp(_, index) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        key: index,
        width: "250px",
        ...$4fca70a5a203ab8a$var$skeletonProps
    });
}
module.exports["ContentMenuErrorState"] = $4fca70a5a203ab8a$export$ee5f7ba6ec666d35;
module.exports["ContentMenuNoResultsState"] = $4fca70a5a203ab8a$export$5967fd5ff661574a;
module.exports["ContentMenuEmptyState"] = $4fca70a5a203ab8a$export$f6bcb1c900d8bf76;
module.exports["ContentMenuLoadingState"] = $4fca70a5a203ab8a$export$a2ec9fdcdf0bd301;
module.exports["ContentMenuLoadMoreState"] = $4fca70a5a203ab8a$export$feed0f481420fd40;

});

parcelRegister("1NFFE", function(module, exports) {

let $14fab102d8335da7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $14fab102d8335da7$var$load("Wowvf"),
    $14fab102d8335da7$var$load("2yM8Y")
]).then(()=>parcelRequire('kIWbA'));

});

parcelRegister("1IQhI", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gSytF = parcelRequire("gSytF");


var $abN8T = parcelRequire("abN8T");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $jMyy4 = parcelRequire("jMyy4");


var $6a9Hv = parcelRequire("6a9Hv");


var $9wEpK = parcelRequire("9wEpK");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $6bJyJ = parcelRequire("6bJyJ");


var $inPa6 = parcelRequire("inPa6");


var $ccHMk = parcelRequire("ccHMk");


var $6F6hl = parcelRequire("6F6hl");


var $iZRoG = parcelRequire("iZRoG");


var $lujnM = parcelRequire("lujnM");


var $1NBp8 = parcelRequire("1NBp8");


var $1YXTQ = parcelRequire("1YXTQ");


var $irVI7 = parcelRequire("irVI7");


var $hjygH = parcelRequire("hjygH");


var $epLE5 = parcelRequire("epLE5");


var $fLinG = parcelRequire("fLinG");


var $6adZX = parcelRequire("6adZX");


var $jFJ1w = parcelRequire("jFJ1w");


var $6qyh6 = parcelRequire("6qyh6");

var $ad49408d40b2cab3$exports = {};
$ad49408d40b2cab3$exports = new URL("emptyStarBox.3b01bf42.svg", import.meta.url).toString();



var $lg4wi = parcelRequire("lg4wi");


var $1NAW6 = parcelRequire("1NAW6");


var $asFJu = parcelRequire("asFJu");


const $7e963e12da3cafa7$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("umYnl"))).fireContentMenuItemClickedAnalytics);
const $7e963e12da3cafa7$var$StarredContentMenuQuery = (0, $gSytF.default);
const $7e963e12da3cafa7$export$776b5788fd07993d = {
    start: 0
};
const $7e963e12da3cafa7$export$451cf4cf29a89606 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(54);
    const intl = (0, $8C5kA.default)();
    const [filterText, setFilterText] = (0, $42omo.useState)("");
    const scrollableRef = (0, $42omo.useRef)(null);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            variables: $7e963e12da3cafa7$export$776b5788fd07993d,
            fetchPolicy: "cache-and-network"
        };
        $[0] = t0;
    } else t0 = $[0];
    const { data: data, loading: loading, error: error, fetchMore: fetchMore, networkStatus: networkStatus } = (0, $jMyy4.useQueryInterop)($7e963e12da3cafa7$var$StarredContentMenuQuery, t0);
    const hasNextPage = data?.favoriteContent?.pageInfo?.hasNextPage || false;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { closeFlyout: closeFlyout } = (0, $6adZX.useFlyoutActions)();
    let t1;
    if ($[1] !== data?.favoriteContent?.nodes || $[2] !== filterText) {
        const lowerFilterText = filterText.toLowerCase();
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(data?.favoriteContent?.nodes?.filter((content)=>content !== null && content !== undefined && (!filterText || (content.title?.toLowerCase() || "").includes(lowerFilterText))), $7e963e12da3cafa7$var$_temp);
        $[1] = data?.favoriteContent?.nodes;
        $[2] = filterText;
        $[3] = t1;
    } else t1 = $[3];
    const filteredContent = t1;
    let t2;
    if ($[4] !== data?.favoriteContent?.nodes?.length || $[5] !== fetchMore || $[6] !== networkStatus) {
        t2 = ()=>{
            if (networkStatus === (0, $9wEpK.NetworkStatus).ready) fetchMore({
                variables: {
                    start: data?.favoriteContent?.nodes?.length || 0
                },
                updateQuery: $7e963e12da3cafa7$var$_temp2
            });
        };
        $[4] = data?.favoriteContent?.nodes?.length;
        $[5] = fetchMore;
        $[6] = networkStatus;
        $[7] = t2;
    } else t2 = $[7];
    data?.favoriteContent?.nodes;
    const loadMore = t2;
    const isEmptyState = !filterText && !filteredContent?.length;
    let t3;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            componentType: "fixedItem",
            itemId: "viewAllStarredItems"
        };
        $[8] = t3;
    } else t3 = $[8];
    const fireClickAnalytics = $7e963e12da3cafa7$var$useLazyClickAnalytics(createAnalyticsEvent, "starredNavigationMenuItem", t3);
    let t4;
    if ($[9] !== closeFlyout || $[10] !== fireClickAnalytics) {
        t4 = ()=>{
            closeFlyout();
            fireClickAnalytics();
        };
        $[9] = closeFlyout;
        $[10] = fireClickAnalytics;
        $[11] = t4;
    } else t4 = $[11];
    const onClick = t4;
    let t5;
    if ($[12] !== hasNextPage || $[13] !== loadMore) {
        t5 = {
            hasNextPage: hasNextPage,
            scrollableRef: scrollableRef,
            loadMore: loadMore
        };
        $[12] = hasNextPage;
        $[13] = loadMore;
        $[14] = t5;
    } else t5 = $[14];
    const { showLoadMoreButton: showLoadMoreButton, setShowLoadMoreButton: setShowLoadMoreButton, loadMoreButtonRef: loadMoreButtonRef, handleKeyDown: handleKeyDown, handleBlurCapture: handleBlurCapture, handleLoadMoreButtonClick: handleLoadMoreButtonClick } = (0, $asFJu.useInfiniteScroll)(t5);
    let t6;
    if ($[15] !== setShowLoadMoreButton) {
        t6 = (text)=>{
            setFilterText(text);
            setShowLoadMoreButton(false);
        };
        $[15] = setShowLoadMoreButton;
        $[16] = t6;
    } else t6 = $[16];
    const onFilterTextChange = t6;
    let t7;
    if ($[17] !== intl) {
        t7 = intl.formatMessage($7e963e12da3cafa7$var$i18n.title);
        $[17] = intl;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== data || $[20] !== filterText || $[21] !== intl || $[22] !== isEmptyState || $[23] !== loading || $[24] !== onFilterTextChange) {
        t8 = !isEmptyState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            paddingBlock: "space.075",
            paddingInlineStart: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1NAW6.ContentMenuTextFilter), {
            filterText: filterText,
            setFilterText: onFilterTextChange,
            placeholder: intl.formatMessage($7e963e12da3cafa7$var$i18n.filterPlaceholder),
            isDisabled: loading && !data,
            actionSubjectId: "starredNavigationMenuItem",
            itemId: "filterStarredItems"
        }));
        $[19] = data;
        $[20] = filterText;
        $[21] = intl;
        $[22] = isEmptyState;
        $[23] = loading;
        $[24] = onFilterTextChange;
        $[25] = t8;
    } else t8 = $[25];
    let t9;
    if ($[26] !== data || $[27] !== error || $[28] !== filterText || $[29] !== filteredContent || $[30] !== loading) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7e963e12da3cafa7$var$StarredContentMenuInner, {
            error: error,
            loading: loading,
            data: data,
            filteredContent: filteredContent,
            filterText: filterText
        });
        $[26] = data;
        $[27] = error;
        $[28] = filterText;
        $[29] = filteredContent;
        $[30] = loading;
        $[31] = t9;
    } else t9 = $[31];
    let t10;
    if ($[32] !== data?.favoriteContent?.nodes?.length || $[33] !== handleLoadMoreButtonClick || $[34] !== hasNextPage || $[35] !== isEmptyState || $[36] !== loadMore || $[37] !== loadMoreButtonRef || $[38] !== showLoadMoreButton) {
        t10 = !isEmptyState && hasNextPage && data?.favoriteContent?.nodes?.length !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "starred-content-menu-load-more"
        }, showLoadMoreButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            ref: loadMoreButtonRef,
            shouldFitContainer: true,
            onClick: handleLoadMoreButtonClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $7e963e12da3cafa7$var$i18n.loadMore)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fLinG.ViewportObserver), {
            onViewportEnter: loadMore
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lg4wi.ContentMenuLoadMoreState), null)));
        $[32] = data?.favoriteContent?.nodes?.length;
        $[33] = handleLoadMoreButtonClick;
        $[34] = hasNextPage;
        $[35] = isEmptyState;
        $[36] = loadMore;
        $[37] = loadMoreButtonRef;
        $[38] = showLoadMoreButton;
        $[39] = t10;
    } else t10 = $[39];
    let t11;
    if ($[40] !== handleBlurCapture || $[41] !== handleKeyDown || $[42] !== t10 || $[43] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $7e963e12da3cafa7$var$overflowStyles,
            ref: scrollableRef,
            onKeyDown: handleKeyDown,
            onBlurCapture: handleBlurCapture
        }, t9, t10);
        $[40] = handleBlurCapture;
        $[41] = handleKeyDown;
        $[42] = t10;
        $[43] = t9;
        $[44] = t11;
    } else t11 = $[44];
    let t12;
    if ($[45] !== intl || $[46] !== isEmptyState || $[47] !== onClick) {
        t12 = !isEmptyState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iZRoG.Divider), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
            href: (0, $1NBp8.HOME).toUrl({
                view: "starred"
            }),
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6bJyJ))), {
                label: "",
                color: "currentColor"
            }),
            onClick: onClick
        }, intl.formatMessage($7e963e12da3cafa7$var$i18n.viewAll)));
        $[45] = intl;
        $[46] = isEmptyState;
        $[47] = onClick;
        $[48] = t12;
    } else t12 = $[48];
    let t13;
    if ($[49] !== t11 || $[50] !== t12 || $[51] !== t7 || $[52] !== t8) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jFJ1w.ContentMenu), {
            title: t7
        }, t8, t11, t12);
        $[49] = t11;
        $[50] = t12;
        $[51] = t7;
        $[52] = t8;
        $[53] = t13;
    } else t13 = $[53];
    return t13;
} : ()=>{
    const intl = (0, $8C5kA.default)();
    const [filterText, setFilterText] = (0, $42omo.useState)('');
    const scrollableRef = (0, $42omo.useRef)(null);
    const { data: data, loading: loading, error: error, fetchMore: fetchMore, networkStatus: networkStatus } = (0, $jMyy4.useQueryInterop)($7e963e12da3cafa7$var$StarredContentMenuQuery, {
        variables: $7e963e12da3cafa7$export$776b5788fd07993d,
        fetchPolicy: 'cache-and-network'
    });
    const hasNextPage = data?.favoriteContent?.pageInfo?.hasNextPage || false;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { closeFlyout: closeFlyout } = (0, $6adZX.useFlyoutActions)();
    const lowerFilterText = filterText.toLowerCase();
    const filteredContent = (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(data?.favoriteContent?.nodes?.filter((content)=>content !== null && content !== undefined && (!filterText || (content.title?.toLowerCase() || '').includes(lowerFilterText))), (content_0)=>content_0?.id);
    const loadMore = (0, $42omo.useCallback)(()=>{
        if (networkStatus === (0, $9wEpK.NetworkStatus).ready) fetchMore({
            variables: {
                start: data?.favoriteContent?.nodes?.length || 0
            },
            updateQuery: (prev, { fetchMoreResult: fetchMoreResult })=>{
                if (!fetchMoreResult) return prev;
                const prevEdges = prev.favoriteContent?.nodes || [];
                const fetchMoreEdges = fetchMoreResult.favoriteContent?.nodes || [];
                const mergedEdges = [
                    ...prevEdges,
                    ...fetchMoreEdges
                ];
                const result = {
                    ...fetchMoreResult
                };
                (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(result, 'favoriteContent.nodes', mergedEdges);
                return result;
            }
        });
    }, [
        networkStatus,
        fetchMore,
        data?.favoriteContent?.nodes
    ]);
    const isEmptyState = !filterText && !filteredContent?.length;
    const fireClickAnalytics = $7e963e12da3cafa7$var$useLazyClickAnalytics(createAnalyticsEvent, 'starredNavigationMenuItem', {
        componentType: 'fixedItem',
        itemId: 'viewAllStarredItems'
    });
    const onClick = ()=>{
        closeFlyout();
        fireClickAnalytics();
    };
    const { showLoadMoreButton: showLoadMoreButton, setShowLoadMoreButton: setShowLoadMoreButton, loadMoreButtonRef: loadMoreButtonRef, handleKeyDown: handleKeyDown, handleBlurCapture: handleBlurCapture, handleLoadMoreButtonClick: handleLoadMoreButtonClick } = (0, $asFJu.useInfiniteScroll)({
        hasNextPage: hasNextPage,
        scrollableRef: scrollableRef,
        loadMore: loadMore
    });
    const onFilterTextChange = (0, $42omo.useCallback)((text)=>{
        setFilterText(text);
        setShowLoadMoreButton(false);
    }, [
        setShowLoadMoreButton
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jFJ1w.ContentMenu), {
        title: intl.formatMessage($7e963e12da3cafa7$var$i18n.title)
    }, !isEmptyState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        paddingBlock: "space.075",
        paddingInlineStart: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1NAW6.ContentMenuTextFilter), {
        filterText: filterText,
        setFilterText: onFilterTextChange,
        placeholder: intl.formatMessage($7e963e12da3cafa7$var$i18n.filterPlaceholder),
        isDisabled: loading && !data,
        actionSubjectId: "starredNavigationMenuItem",
        itemId: "filterStarredItems"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $7e963e12da3cafa7$var$overflowStyles,
        ref: scrollableRef,
        onKeyDown: handleKeyDown,
        onBlurCapture: handleBlurCapture
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7e963e12da3cafa7$var$StarredContentMenuInner, {
        error: error,
        loading: loading,
        data: data,
        filteredContent: filteredContent,
        filterText: filterText
    }), !isEmptyState && hasNextPage && data?.favoriteContent?.nodes?.length !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "starred-content-menu-load-more"
    }, showLoadMoreButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        ref: loadMoreButtonRef,
        shouldFitContainer: true,
        onClick: handleLoadMoreButtonClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $7e963e12da3cafa7$var$i18n.loadMore)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fLinG.ViewportObserver), {
        onViewportEnter: loadMore
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lg4wi.ContentMenuLoadMoreState), null)))), !isEmptyState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iZRoG.Divider), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
        href: (0, $1NBp8.HOME).toUrl({
            view: 'starred'
        }),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6bJyJ))), {
            label: "",
            color: "currentColor"
        }),
        onClick: onClick
    }, intl.formatMessage($7e963e12da3cafa7$var$i18n.viewAll))));
};
const $7e963e12da3cafa7$var$StarredContentMenuInner = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(29);
    const { error: error, loading: loading, data: data, filteredContent: filteredContent, filterText: filterText } = t0;
    const intl = (0, $8C5kA.default)();
    if (error) {
        let t1;
        if ($[0] !== intl) {
            t1 = intl.formatMessage($7e963e12da3cafa7$var$i18n.errorMessageTitle);
            $[0] = intl;
            $[1] = t1;
        } else t1 = $[1];
        let t2;
        if ($[2] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lg4wi.ContentMenuErrorState), {
                errorTitle: t1
            });
            $[2] = t1;
            $[3] = t2;
        } else t2 = $[3];
        let t3;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                navVersion: "4",
                dropdownType: "starred"
            };
            $[4] = t3;
        } else t3 = $[4];
        let t4;
        if ($[5] !== error) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hjygH.ExperienceStop), {
                name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
                error: error,
                attributes: t3
            });
            $[5] = error;
            $[6] = t4;
        } else t4 = $[6];
        let t5;
        if ($[7] !== t2 || $[8] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t2, t4);
            $[7] = t2;
            $[8] = t4;
            $[9] = t5;
        } else t5 = $[9];
        return t5;
    }
    if (loading && !data) {
        let t1;
        if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lg4wi.ContentMenuLoadingState), null);
            $[10] = t1;
        } else t1 = $[10];
        return t1;
    }
    if (!filteredContent || filteredContent?.length === 0) {
        let t1;
        if ($[11] !== filterText || $[12] !== intl) {
            t1 = filterText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lg4wi.ContentMenuNoResultsState), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lg4wi.ContentMenuEmptyState), {
                image: (0, (/*@__PURE__*/$parcel$interopDefault($ad49408d40b2cab3$exports))),
                title: intl.formatMessage($7e963e12da3cafa7$var$i18n.emptyStateTitle),
                message: intl.formatMessage($7e963e12da3cafa7$var$i18n.emptyStateMessage)
            });
            $[11] = filterText;
            $[12] = intl;
            $[13] = t1;
        } else t1 = $[13];
        return t1;
    }
    let t1;
    if ($[14] !== filterText || $[15] !== filteredContent.length || $[16] !== intl) {
        t1 = filterText !== "" ? intl.formatMessage($7e963e12da3cafa7$var$i18n.filteredResultsCount, {
            count: filteredContent.length
        }) : intl.formatMessage($7e963e12da3cafa7$var$i18n.showingAllResults);
        $[14] = filterText;
        $[15] = filteredContent.length;
        $[16] = intl;
        $[17] = t1;
    } else t1 = $[17];
    let t2;
    if ($[18] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), {
            role: "status"
        }, t1);
        $[18] = t1;
        $[19] = t2;
    } else t2 = $[19];
    let t3;
    if ($[20] !== filteredContent || $[21] !== intl) {
        let t4;
        if ($[23] !== intl) {
            t4 = (content)=>content ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6qyh6.ContentMenuItem), {
                    key: content.id,
                    content: content,
                    actionSubjectId: "starredNavigationMenuItem",
                    timestamp: content.metadata.currentuser?.favourited?.favouritedDate ? (0, $1YXTQ.formatTimeAgo)(intl, content.metadata.currentuser?.favourited?.favouritedDate) : undefined
                }) : null;
            $[23] = intl;
            $[24] = t4;
        } else t4 = $[24];
        t3 = filteredContent.map(t4);
        $[20] = filteredContent;
        $[21] = intl;
        $[22] = t3;
    } else t3 = $[22];
    let t4;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hjygH.ExperienceStop), {
            name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
            attributes: {
                navVersion: "4",
                dropdownType: "starred"
            }
        });
        $[25] = t4;
    } else t4 = $[25];
    let t5;
    if ($[26] !== t2 || $[27] !== t3) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t2, t3, t4);
        $[26] = t2;
        $[27] = t3;
        $[28] = t5;
    } else t5 = $[28];
    return t5;
} : ({ error: error, loading: loading, data: data, filteredContent: filteredContent, filterText: filterText })=>{
    const intl = (0, $8C5kA.default)();
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lg4wi.ContentMenuErrorState), {
        errorTitle: intl.formatMessage($7e963e12da3cafa7$var$i18n.errorMessageTitle)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hjygH.ExperienceStop), {
        name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
        error: error,
        attributes: {
            navVersion: '4',
            dropdownType: 'starred'
        }
    }));
    if (loading && !data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lg4wi.ContentMenuLoadingState), null);
    if (!filteredContent || filteredContent?.length === 0) return filterText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lg4wi.ContentMenuNoResultsState), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lg4wi.ContentMenuEmptyState), {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($ad49408d40b2cab3$exports))),
        title: intl.formatMessage($7e963e12da3cafa7$var$i18n.emptyStateTitle),
        message: intl.formatMessage($7e963e12da3cafa7$var$i18n.emptyStateMessage)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), {
        role: "status"
    }, filterText !== '' ? intl.formatMessage($7e963e12da3cafa7$var$i18n.filteredResultsCount, {
        count: filteredContent.length
    }) : intl.formatMessage($7e963e12da3cafa7$var$i18n.showingAllResults)), filteredContent.map((content)=>content ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6qyh6.ContentMenuItem), {
            key: content.id,
            content: content,
            actionSubjectId: "starredNavigationMenuItem",
            timestamp: content.metadata.currentuser?.favourited?.favouritedDate ? (0, $1YXTQ.formatTimeAgo)(intl, content.metadata.currentuser?.favourited?.favouritedDate) : undefined
        }) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hjygH.ExperienceStop), {
        name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
        attributes: {
            navVersion: '4',
            dropdownType: 'starred'
        }
    }));
};
const $7e963e12da3cafa7$var$overflowStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    height: '100%',
    justifyContent: 'start',
    marginInline: 'space.negative.100',
    paddingInline: 'space.100',
    paddingBlockEnd: 'space.050',
    //@ts-expect-error styling is applying but property does not exist for SafeCSSObject
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    a: {
        ':focus-visible': {
            outlineOffset: `${"var(--ds-space-negative-025, -2px)"}`
        }
    }
});
const $7e963e12da3cafa7$var$i18n = (0, $cgtv4.defineMessages)({
    title: {
        id: "side-navigation.starred-content-menu.title",
        defaultMessage: "Starred"
    },
    filterPlaceholder: {
        id: "side-navigation.starred-content-menu.filter-placeholder",
        defaultMessage: "Filter starred items"
    },
    viewAll: {
        id: "side-navigation.starred-content-menu.view-all",
        defaultMessage: "View all starred items"
    },
    emptyStateTitle: {
        id: "side-navigation.starred-content-menu.empty-state-title",
        defaultMessage: "You haven\u2019t starred anything yet"
    },
    emptyStateMessage: {
        id: "side-navigation.starred-content-menu.empty-state-message",
        defaultMessage: "Mark items that are important to you with a star to quickly access them. You\u2019ll see those items here."
    },
    errorMessageTitle: {
        id: "side-navigation.starred-content-menu.error-message.title",
        defaultMessage: "We couldn\u2019t load your starred items"
    },
    loadMore: {
        id: "side-navigation.starred-content-menu.load-more",
        defaultMessage: "Load more"
    },
    filteredResultsCount: {
        id: "side-navigation.star-content-menu.filtered-results-announcement",
        defaultMessage: "{count, plural, one {# result} other {# results}} found"
    },
    showingAllResults: {
        id: "side-navigation.star-content-menu.all-results-announcement",
        defaultMessage: "Showing all starred pages"
    }
});
function $7e963e12da3cafa7$var$_temp(content_0) {
    return content_0?.id;
}
function $7e963e12da3cafa7$var$_temp2(prev, t0) {
    const { fetchMoreResult: fetchMoreResult } = t0;
    if (!fetchMoreResult) return prev;
    const prevEdges = prev.favoriteContent?.nodes || [];
    const fetchMoreEdges = fetchMoreResult.favoriteContent?.nodes || [];
    const mergedEdges = [
        ...prevEdges,
        ...fetchMoreEdges
    ];
    const result = {
        ...fetchMoreResult
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(result, "favoriteContent.nodes", mergedEdges);
    return result;
}
module.exports["starredContentMenuQueryVars"] = $7e963e12da3cafa7$export$776b5788fd07993d;
module.exports["StarredContentMenu"] = $7e963e12da3cafa7$export$451cf4cf29a89606;

});

parcelRegister("hjygH", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

const $1aeb691895c5954d$export$85823f26dca064c3 = (0, $3u0dr.isReactCompilerActiveV1)() ? function ExperienceStop(t0) {
    const $ = (0, $frIzR.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>{
            if (error) experienceTracker.stopOnError({
                name: name,
                error: error,
                attributes: attributes
            });
            else experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        };
        t2 = [
            experienceTracker,
            name,
            attributes,
            error
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
} : function ExperienceStop({ name: name, error: error, attributes: attributes }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $42omo.useEffect)(()=>{
        if (error) experienceTracker.stopOnError({
            name: name,
            error: error,
            attributes: attributes
        });
        else experienceTracker.succeed({
            name: name,
            attributes: attributes
        });
    }, [
        experienceTracker,
        name,
        attributes,
        error
    ]);
    return null;
};
module.exports["ExperienceStop"] = $1aeb691895c5954d$export$85823f26dca064c3;

});

parcelRegister("fLinG", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $6e03a7b548499c40$export$da1a095605e6aa3c = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { onViewportEnter: onViewportEnter, children: children } = t0;
    const observerRef = (0, $42omo.useRef)(null);
    const targetRef = (0, $42omo.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== onViewportEnter) {
        t1 = ()=>{
            observerRef.current = new IntersectionObserver((entries)=>{
                if (entries[0].isIntersecting) onViewportEnter();
            });
            if (targetRef.current) observerRef.current.observe(targetRef.current);
            return ()=>{
                if (observerRef.current) {
                    observerRef.current.disconnect();
                    observerRef.current = null;
                }
            };
        };
        t2 = [
            onViewportEnter
        ];
        $[0] = onViewportEnter;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: targetRef
        }, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ onViewportEnter: onViewportEnter, children: children })=>{
    const observerRef = (0, $42omo.useRef)(null);
    const targetRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        // eslint-disable-next-line
        observerRef.current = new IntersectionObserver((entries)=>{
            if (entries[0].isIntersecting) onViewportEnter();
        });
        if (targetRef.current) observerRef.current.observe(targetRef.current);
        return ()=>{
            if (observerRef.current) {
                observerRef.current.disconnect();
                observerRef.current = null;
            }
        };
    }, [
        onViewportEnter
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: targetRef
    }, children);
};
module.exports["ViewportObserver"] = $6e03a7b548499c40$export$da1a095605e6aa3c;

});

parcelRegister("jFJ1w", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $7hXDW = parcelRequire("7hXDW");

const $74a973700eebe7fc$export$a7eb5ad3a73e575f = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { title: title, children: children } = t0;
    let t1;
    if ($[0] !== title) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $74a973700eebe7fc$var$headingStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
            as: "h2",
            size: "xsmall"
        }, title));
        $[0] = title;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $74a973700eebe7fc$var$containerStyles
        }, t1, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ title: title, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $74a973700eebe7fc$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $74a973700eebe7fc$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
        as: "h2",
        size: "xsmall"
    }, title)), children);
};
const $74a973700eebe7fc$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    maxHeight: 'min(calc(100vh - 26px), 760px)'
});
const $74a973700eebe7fc$var$headingStyles = (0, $ecnYn.xcss)({
    height: 'size.300',
    paddingBlock: 'space.075',
    paddingLeft: 'space.075',
    color: 'color.text.subtle',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    display: 'flex',
    alignItems: 'center'
});
module.exports["ContentMenu"] = $74a973700eebe7fc$export$a7eb5ad3a73e575f;

});

parcelRegister("6qyh6", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $inPa6 = parcelRequire("inPa6");


var $5nBzc = parcelRequire("5nBzc");


var $lujnM = parcelRequire("lujnM");


var $eFm27 = parcelRequire("eFm27");


var $jlIaF = parcelRequire("jlIaF");


var $8rneB = parcelRequire("8rneB");


var $brn6e = parcelRequire("brn6e");


var $bCECL = parcelRequire("bCECL");


var $epLE5 = parcelRequire("epLE5");


var $9wGTI = parcelRequire("9wGTI");


var $6adZX = parcelRequire("6adZX");


const $9de18fa36277a442$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("umYnl"))).fireContentMenuItemClickedAnalytics);
const $9de18fa36277a442$export$b44c5cc9e992fdfc = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(43);
    const { content: content, actionSubjectId: actionSubjectId, url: url, section: section, selectedFilter: selectedFilter, timestamp: timestamp, hideStarButton: hideStarButton } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { id: id, type: type, links: links, space: space, metadata: metadata } = content;
    const { closeFlyout: closeFlyout } = (0, $6adZX.useFlyoutActions)();
    const t1 = content?.status;
    let t2;
    if ($[0] !== id || $[1] !== section || $[2] !== selectedFilter || $[3] !== t1 || $[4] !== type) {
        t2 = {
            componentType: "customItem",
            contentType: type,
            contentId: id,
            contentStatus: t1,
            section: section,
            selectedFilter: selectedFilter
        };
        $[0] = id;
        $[1] = section;
        $[2] = selectedFilter;
        $[3] = t1;
        $[4] = type;
        $[5] = t2;
    } else t2 = $[5];
    const fireClickItemAnalytics = $9de18fa36277a442$var$useLazyClickAnalytics(createAnalyticsEvent, actionSubjectId, t2);
    let t3;
    if ($[6] !== id || $[7] !== type) {
        t3 = {
            componentType: "customItemAction",
            itemId: "star",
            parentContentType: type,
            parentContentId: id
        };
        $[6] = id;
        $[7] = type;
        $[8] = t3;
    } else t3 = $[8];
    const fireStarClickAnalytics = $9de18fa36277a442$var$useLazyClickAnalytics(createAnalyticsEvent, actionSubjectId, t3);
    let t4;
    if ($[9] !== id || $[10] !== type) {
        t4 = {
            componentType: "customItemAction",
            itemId: "unstar",
            parentContentType: type,
            parentContentId: id
        };
        $[9] = id;
        $[10] = type;
        $[11] = t4;
    } else t4 = $[11];
    const fireUnstarClickAnalytics = $9de18fa36277a442$var$useLazyClickAnalytics(createAnalyticsEvent, actionSubjectId, t4);
    let t5;
    if ($[12] !== closeFlyout || $[13] !== fireClickItemAnalytics) {
        t5 = ()=>{
            closeFlyout();
            fireClickItemAnalytics();
        };
        $[12] = closeFlyout;
        $[13] = fireClickItemAnalytics;
        $[14] = t5;
    } else t5 = $[14];
    const onClick = t5;
    if (!id) return null;
    const isStarred = metadata?.currentuser?.favourited?.isFavourite || false;
    const description = timestamp ? `${space?.name} \xb7 ${timestamp}` : space?.name;
    const link = url || `${0, $jlIaF.CONTEXT_PATH}${links?.webui}`;
    let t6;
    if ($[15] !== content.type) {
        t6 = content?.type && (content?.type != "whiteboard" || (0, $9wGTI.fg)("confluence_frontend_whiteboard_emoji_titles"));
        $[15] = content.type;
        $[16] = t6;
    } else t6 = $[16];
    const isEmojiContentType = t6;
    let emoji;
    let t7;
    if ($[17] !== content || $[18] !== isEmojiContentType) {
        const { emoji: t8, hasEmojiProperty: t9 } = isEmojiContentType ? $9de18fa36277a442$var$getEmoji(content) : {};
        emoji = t8 === undefined ? undefined : t8;
        const hasEmojiProperty = t9 === undefined ? undefined : t9;
        t7 = isEmojiContentType ? $9de18fa36277a442$var$getTitle(content?.title, hasEmojiProperty) : content?.title;
        $[17] = content;
        $[18] = isEmojiContentType;
        $[19] = emoji;
        $[20] = t7;
    } else {
        emoji = $[19];
        t7 = $[20];
    }
    const title = t7;
    const isDraft = content?.status === "draft";
    let t8;
    if ($[21] !== fireStarClickAnalytics || $[22] !== fireUnstarClickAnalytics || $[23] !== id || $[24] !== isStarred) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eFm27.PageStarButton), {
            contentId: id,
            isStarred: isStarred,
            size: "small",
            tooltipPosition: "top",
            onStar: fireStarClickAnalytics,
            onUnstar: fireUnstarClickAnalytics,
            spacing: "none"
        });
        $[21] = fireStarClickAnalytics;
        $[22] = fireUnstarClickAnalytics;
        $[23] = id;
        $[24] = isStarred;
        $[25] = t8;
    } else t8 = $[25];
    const starButton = t8;
    let t9;
    if ($[26] !== content.subType || $[27] !== emoji || $[28] !== type) {
        t9 = type && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bCECL.ContentIcon), {
            type: type,
            emoji: emoji,
            subType: content?.subType
        });
        $[26] = content.subType;
        $[27] = emoji;
        $[28] = type;
        $[29] = t9;
    } else t9 = $[29];
    let t10;
    if ($[30] !== isDraft) {
        t10 = isDraft && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            appearance: "default"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $9de18fa36277a442$var$i18n.draftLozengeText));
        $[30] = isDraft;
        $[31] = t10;
    } else t10 = $[31];
    const t11 = !hideStarButton && isStarred ? starButton : undefined;
    const t12 = !hideStarButton && !isStarred ? starButton : undefined;
    const t13 = description || "";
    let t14;
    if ($[32] !== title) {
        t14 = title || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $9de18fa36277a442$var$i18n.untitled);
        $[32] = title;
        $[33] = t14;
    } else t14 = $[33];
    let t15;
    if ($[34] !== link || $[35] !== onClick || $[36] !== t10 || $[37] !== t11 || $[38] !== t12 || $[39] !== t13 || $[40] !== t14 || $[41] !== t9) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
            elemBefore: t9,
            elemAfter: t10,
            actions: t11,
            actionsOnHover: t12,
            href: link,
            description: t13,
            onClick: onClick
        }, t14);
        $[34] = link;
        $[35] = onClick;
        $[36] = t10;
        $[37] = t11;
        $[38] = t12;
        $[39] = t13;
        $[40] = t14;
        $[41] = t9;
        $[42] = t15;
    } else t15 = $[42];
    return t15;
} : ({ content: content, actionSubjectId: actionSubjectId, url: url, section: section, selectedFilter: selectedFilter, timestamp: timestamp, hideStarButton: hideStarButton })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { id: id, type: type, links: links, space: space, metadata: metadata } = content;
    const { closeFlyout: closeFlyout } = (0, $6adZX.useFlyoutActions)();
    const fireClickItemAnalytics = $9de18fa36277a442$var$useLazyClickAnalytics(createAnalyticsEvent, actionSubjectId, {
        componentType: 'customItem',
        contentType: type,
        contentId: id,
        contentStatus: content?.status,
        section: section,
        selectedFilter: selectedFilter
    });
    const fireStarClickAnalytics = $9de18fa36277a442$var$useLazyClickAnalytics(createAnalyticsEvent, actionSubjectId, {
        componentType: 'customItemAction',
        itemId: 'star',
        parentContentType: type,
        parentContentId: id
    });
    const fireUnstarClickAnalytics = $9de18fa36277a442$var$useLazyClickAnalytics(createAnalyticsEvent, actionSubjectId, {
        componentType: 'customItemAction',
        itemId: 'unstar',
        parentContentType: type,
        parentContentId: id
    });
    const onClick = ()=>{
        closeFlyout();
        fireClickItemAnalytics();
    };
    if (!id) return null;
    const isStarred = metadata?.currentuser?.favourited?.isFavourite || false;
    const description = timestamp ? `${space?.name} \xb7 ${timestamp}` : space?.name;
    const link = url || `${0, $jlIaF.CONTEXT_PATH}${links?.webui}`;
    const isEmojiContentType = content?.type && (content?.type != 'whiteboard' || (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles'));
    const { emoji: emoji, hasEmojiProperty: hasEmojiProperty } = isEmojiContentType ? $9de18fa36277a442$var$getEmoji(content) : {};
    const title = isEmojiContentType ? $9de18fa36277a442$var$getTitle(content?.title, hasEmojiProperty) : content?.title;
    const isDraft = content?.status === 'draft';
    const starButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eFm27.PageStarButton), {
        contentId: id,
        isStarred: isStarred,
        size: "small",
        tooltipPosition: "top",
        onStar: fireStarClickAnalytics,
        onUnstar: fireUnstarClickAnalytics,
        spacing: "none"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
        elemBefore: type && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bCECL.ContentIcon), {
            type: type,
            emoji: emoji,
            subType: content?.subType
        }),
        elemAfter: isDraft && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            appearance: "default"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $9de18fa36277a442$var$i18n.draftLozengeText)),
        actions: !hideStarButton && isStarred ? starButton : undefined,
        actionsOnHover: !hideStarButton && !isStarred ? starButton : undefined,
        href: link,
        description: description || '',
        onClick: onClick
    }, title || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $9de18fa36277a442$var$i18n.untitled));
};
const $9de18fa36277a442$var$getEmoji = (content)=>{
    const emojiPropertyPublished = (0, $8rneB.getEmojiPublishedFromProperties)(content);
    const emojiPropertyDraft = (0, $8rneB.getEmojiDraftFromProperties)(content);
    const emoji = emojiPropertyPublished || emojiPropertyDraft || (0, $brn6e.getEmojiFromTitle)(content.title);
    return {
        hasEmojiProperty: Boolean(emojiPropertyPublished || emojiPropertyDraft),
        emoji: emoji
    };
};
const $9de18fa36277a442$var$getTitle = (originalTitle, hasEmojiProperty)=>hasEmojiProperty ? originalTitle : (0, $brn6e.removeEmojiFromTitle)(originalTitle);
const $9de18fa36277a442$var$i18n = (0, $cgtv4.defineMessages)({
    untitled: {
        id: "side-navigation.content-menu.untitled",
        defaultMessage: "Untitled"
    },
    draftLozengeText: {
        id: "side-navigation.content-menu.lozenge.draft",
        defaultMessage: "DRAFT"
    }
});
module.exports["ContentMenuItem"] = $9de18fa36277a442$export$b44c5cc9e992fdfc;

});

parcelRegister("eFm27", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $3gadb = parcelRequire("3gadb");


var $inPa6 = parcelRequire("inPa6");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");


var $9wGTI = parcelRequire("9wGTI");


var $clKWq = parcelRequire("clKWq");


var $cf6nm = parcelRequire("cf6nm");


var $77a1U = parcelRequire("77a1U");

const $75a2d6647cc04503$export$369212709d95b58d = ({ size: size, outlineAppearance: outlineAppearance, tooltipPosition: tooltipPosition, shortcut: shortcut, label: label, labelledBy: labelledBy, id: id, ...props })=>{
    const intl = (0, $8C5kA.default)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const spacing = size === 'small' ? 'compact' : 'default';
    const tooltipLabel = props.isStarred ? intl.formatMessage($75a2d6647cc04503$var$i18n.unstarContent) : intl.formatMessage($75a2d6647cc04503$var$i18n.starContent);
    const shortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: shortcut
    });
    const tooltipContent = shortcut && !(0, $9wGTI.fg)('platform_tooltip_shortcuts_migration_1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
        shortcut: shortcut,
        contentBefore: tooltipLabel,
        isTooltip: true
    }) : tooltipLabel;
    const buttonLabel = props.isStarred ? intl.formatMessage($75a2d6647cc04503$var$i18n.unstarContent) : intl.formatMessage($75a2d6647cc04503$var$i18n.starContent);
    const handleClick = (0, $42omo.useCallback)((starHandler, triggeredByKeyboardShortcut)=>(e)=>{
            starHandler(e);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'pageStar',
                    attributes: {
                        triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
                        action: props.isStarred ? 'unstar' : 'star'
                    },
                    source: 'PageStarButton'
                }
            }).fire();
        }, [
        createAnalyticsEvent,
        props.isStarred
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $77a1U.PageStar), props, ({ toggle: toggleStar })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: tooltipContent,
            shortcut: (0, $9wGTI.fg)('platform_tooltip_shortcuts_migration_1') ? shortcutStrings : undefined,
            position: tooltipPosition || 'top',
            hideTooltipOnClick: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $clKWq.ConditionalHiddenAction), {
            isHidden: !props.isStarred
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $clKWq.ConditionalSubtleHoverButton), {
            id: id,
            isSubtle: outlineAppearance === 'subtle',
            "data-id": props.isStarred ? 'page-unstar-button' : 'page-star-button',
            testId: props.isStarred ? 'page-unstar-button' : 'page-star-button',
            spacing: spacing,
            appearance: "subtle",
            onClick: handleClick(toggleStar, false),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cf6nm.StarIcon), {
                isStarred: props.isStarred,
                spacing: props.spacing
            }),
            "aria-label": buttonLabel,
            "aria-labelledby": labelledBy,
            "aria-pressed": props.isStarred,
            isDisabled: props.isDisabled
        }))), shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.STAR_BUTTON_SHORTCUT) : undefined,
            accelerator: (0, $gnkil.UNIVERSAL_STAR_BUTTON_SHORTCUT),
            listener: handleClick(toggleStar, true)
        })));
};
const $75a2d6647cc04503$var$i18n = (0, $cgtv4.defineMessages)({
    starContent: {
        id: "action-buttons.content.starContent.label",
        defaultMessage: "Star this content"
    },
    unstarContent: {
        id: "action-buttons.content.unstarContent.label",
        defaultMessage: "Unstar this content"
    }
});
module.exports["PageStarButton"] = $75a2d6647cc04503$export$369212709d95b58d;

});

parcelRegister("77a1U", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gmMgo = parcelRequire("gmMgo");


var $1KmJq = parcelRequire("1KmJq");


var $inPa6 = parcelRequire("inPa6");


var $7aRa9 = parcelRequire("7aRa9");


var $9wGTI = parcelRequire("9wGTI");


var $cfidN = parcelRequire("cfidN");

const $280d5b858bf30a19$var$PageStarActionButtonPageStarMutation = (0, $eSUdr.default)`mutation PageStarActionButtonPageStarMutation($id:ID!){favouritePage(favouritePageInput:{pageId:$id}){content{id metadata{currentuser{favourited{isFavourite favouritedDate}}}}}}`;
const $280d5b858bf30a19$var$PageStarActionButtonPageUnstarMutation = (0, $eSUdr.default)`mutation PageStarActionButtonPageUnstarMutation($id:ID!){unfavouritePage(favouritePageInput:{pageId:$id}){content{id metadata{currentuser{favourited{isFavourite favouritedDate}}}}}}`;
const $280d5b858bf30a19$var$i18n = (0, $cgtv4.defineMessages)({
    starErrorTitle: {
        id: "action-buttons.content.star.error.title",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We're having trouble starring this"
    },
    unstarErrorTitle: {
        id: "action-buttons.content.unstar.error.title",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We're having trouble unstarring this"
    },
    starSuccessFlagTitle: {
        id: "action-buttons.content.star.success.title",
        defaultMessage: "{contentTitle} starred"
    },
    unstarSuccessFlagTitle: {
        id: "action-buttons.content.unstar.success.title",
        defaultMessage: "{contentTitle} unstarred"
    },
    errorDescription: {
        id: "action-buttons.error.description",
        defaultMessage: "Refresh the page and try again."
    }
});
const $280d5b858bf30a19$var$useStarAnalytics = (contentId, analytics)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const stringAttrs = JSON.stringify(analytics?.attributes);
    return (0, $42omo.useCallback)((action)=>{
        if (!analytics) return;
        const { source: source, containerId: containerId, attributes: attributes } = analytics;
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: action,
                actionSubject: 'favouritePage',
                source: source,
                attributes: attributes,
                objectId: contentId,
                ...containerId && {
                    containerId: containerId
                }
            }
        }).fire();
    }, // Using stringAttrs as dependency instead of analytics.attributes
    // https://github.com/facebook/react/issues/14476
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        createAnalyticsEvent,
        analytics?.source,
        stringAttrs
    ]);
};
const $280d5b858bf30a19$var$PageStarComponent = ({ contentId: contentId, isStarred: isStarred, onStar: onStar, onUnstar: onUnstar, analytics: analytics, intl: intl, children: children, flags: flags, contentTitle: contentTitle = '', shouldShowFlags: shouldShowFlags = false })=>{
    const sendAnalyticsEvent = $280d5b858bf30a19$var$useStarAnalytics(contentId, analytics);
    const [star, { error: starError }] = (0, $1KmJq.useMutation)($280d5b858bf30a19$var$PageStarActionButtonPageStarMutation, {
        variables: {
            id: contentId
        },
        onCompleted: ()=>{
            sendAnalyticsEvent('created');
        },
        optimisticResponse: {
            favouritePage: {
                __typename: 'FavouritePagePayload',
                content: {
                    __typename: 'Content',
                    id: contentId,
                    metadata: {
                        __typename: 'ContentMetadata',
                        currentuser: {
                            __typename: 'ContentMetadata_CurrentUserMetadataProvider_currentuser',
                            favourited: {
                                // @ts-ignore TS doesn't recognize __typename which is needed for mutation
                                __typename: 'FavouritedSummary',
                                isFavourite: true,
                                favouritedDate: new Date().toISOString()
                            }
                        }
                    }
                }
            }
        }
    });
    const [unstar, { error: unstarError }] = (0, $1KmJq.useMutation)($280d5b858bf30a19$var$PageStarActionButtonPageUnstarMutation, {
        variables: {
            id: contentId
        },
        onCompleted: ()=>{
            sendAnalyticsEvent('deleted');
        },
        optimisticResponse: {
            unfavouritePage: {
                __typename: 'FavouritePagePayload',
                content: {
                    __typename: 'Content',
                    id: contentId,
                    metadata: {
                        __typename: 'ContentMetadata',
                        currentuser: {
                            // @ts-ignore TS doesn't recognize __typename which is needed for mutation
                            __typename: 'ContentMetadata_CurrentUserMetadataProvider_currentuser',
                            favourited: null
                        }
                    }
                }
            }
        }
    });
    const toggleStar = (0, $42omo.useCallback)((e)=>{
        e.preventDefault();
        if (isStarred) {
            onUnstar && onUnstar(e);
            unstar().then(()=>{
                if (shouldShowFlags && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) flags.showSuccessFlag({
                    title: intl.formatMessage($280d5b858bf30a19$var$i18n.unstarSuccessFlagTitle, {
                        contentTitle: contentTitle
                    }),
                    isAutoDismiss: true
                });
            }).catch((_)=>{});
        } else {
            onStar && onStar(e);
            star().then(()=>{
                if (shouldShowFlags && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) flags.showSuccessFlag({
                    title: intl.formatMessage($280d5b858bf30a19$var$i18n.starSuccessFlagTitle, {
                        contentTitle: contentTitle
                    }),
                    isAutoDismiss: true
                });
            }).catch((_)=>{});
        }
    }, [
        isStarred,
        onStar,
        star,
        onUnstar,
        unstar,
        contentTitle,
        flags,
        intl,
        shouldShowFlags
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children({
        toggle: toggleStar
    }), starError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cfidN.ActionErrorFlag), {
        title: intl.formatMessage($280d5b858bf30a19$var$i18n.starErrorTitle),
        description: intl.formatMessage($280d5b858bf30a19$var$i18n.errorDescription),
        error: starError
    }), unstarError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cfidN.ActionErrorFlag), {
        title: intl.formatMessage($280d5b858bf30a19$var$i18n.unstarErrorTitle),
        description: intl.formatMessage($280d5b858bf30a19$var$i18n.errorDescription),
        error: unstarError
    }));
};
const $280d5b858bf30a19$export$110ac8adb8c8c03 = (0, $7aRa9.withFlags)((0, $gmMgo.default)($280d5b858bf30a19$var$PageStarComponent));
module.exports["PageStar"] = $280d5b858bf30a19$export$110ac8adb8c8c03;

});

parcelRegister("umYnl", function(module, exports) {

let $05b49f605510a640$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $05b49f605510a640$var$load("SepNY").then(()=>parcelRequire('6y3LW'));

});

parcelRegister("1NAW6", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $1qfLF = parcelRequire("1qfLF");


var $gdv5Z = parcelRequire("gdv5Z");


var $jluld = parcelRequire("jluld");


var $hmuev = parcelRequire("hmuev");


var $4noo5 = parcelRequire("4noo5");


var $inPa6 = parcelRequire("inPa6");


var $epLE5 = parcelRequire("epLE5");


const $ba4ff569986cbcbe$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("umYnl"))).fireContentMenuItemClickedAnalytics);
const $ba4ff569986cbcbe$var$textFieldStyles = null;
const $ba4ff569986cbcbe$export$efb95505bdfcf1ee = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { filterText: filterText, setFilterText: setFilterText, placeholder: placeholder, isDisabled: isDisabled, actionSubjectId: actionSubjectId, itemId: itemId } = t0;
    const intl = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== itemId) {
        t1 = {
            componentType: "fixedItem",
            itemId: itemId
        };
        $[0] = itemId;
        $[1] = t1;
    } else t1 = $[1];
    const fireClickAnalytics = $ba4ff569986cbcbe$var$useLazyClickAnalytics(createAnalyticsEvent, actionSubjectId, t1);
    const setFilterFieldRef = $ba4ff569986cbcbe$var$_temp;
    let t2;
    if ($[2] !== setFilterText) {
        t2 = (e)=>setFilterText(e.currentTarget.value);
        $[2] = setFilterText;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            paddingInlineStart: "space.100"
        }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
            label: "",
            color: "currentColor"
        }));
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== filterText || $[6] !== intl || $[7] !== setFilterText) {
        t4 = Boolean(filterText) && /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            paddingInlineEnd: "space.050"
        }, /*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
            appearance: "subtle",
            spacing: "compact",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
            label: intl.formatMessage($ba4ff569986cbcbe$var$i18n.clearFilter),
            onClick: ()=>setFilterText("")
        }));
        $[5] = filterText;
        $[6] = intl;
        $[7] = setFilterText;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $gMc0m.default)([
            "_1h6d1l7x"
        ]);
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== filterText || $[11] !== fireClickAnalytics || $[12] !== isDisabled || $[13] !== placeholder || $[14] !== t2 || $[15] !== t4) {
        t6 = /*#__PURE__*/ $42omo.createElement((0, $4noo5.default), {
            ref: setFilterFieldRef,
            value: filterText,
            onChange: t2,
            onMouseDown: fireClickAnalytics,
            elemBeforeInput: t3,
            elemAfterInput: t4,
            isCompact: true,
            placeholder: placeholder,
            isDisabled: isDisabled,
            "aria-label": placeholder,
            className: t5
        });
        $[10] = filterText;
        $[11] = fireClickAnalytics;
        $[12] = isDisabled;
        $[13] = placeholder;
        $[14] = t2;
        $[15] = t4;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
} : ({ filterText: filterText, setFilterText: setFilterText, placeholder: placeholder, isDisabled: isDisabled, actionSubjectId: actionSubjectId, itemId: itemId })=>{
    const intl = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $ba4ff569986cbcbe$var$useLazyClickAnalytics(createAnalyticsEvent, actionSubjectId, {
        componentType: 'fixedItem',
        itemId: itemId
    });
    const setFilterFieldRef = (0, $42omo.useCallback)((node)=>{
        if (node) node.focus();
    }, []);
    return /*#__PURE__*/ $42omo.createElement((0, $4noo5.default), {
        ref: setFilterFieldRef,
        value: filterText,
        onChange: (e)=>setFilterText(e.currentTarget.value),
        onMouseDown: fireClickAnalytics,
        elemBeforeInput: /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            paddingInlineStart: "space.100"
        }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
            label: "",
            color: "currentColor"
        })),
        elemAfterInput: Boolean(filterText) && /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            paddingInlineEnd: "space.050"
        }, /*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
            appearance: "subtle",
            spacing: "compact",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
            label: intl.formatMessage($ba4ff569986cbcbe$var$i18n.clearFilter),
            onClick: ()=>setFilterText('')
        })),
        isCompact: true,
        placeholder: placeholder,
        isDisabled: isDisabled,
        "aria-label": placeholder,
        className: (0, $gMc0m.default)([
            "_1h6d1l7x"
        ])
    });
};
const $ba4ff569986cbcbe$var$i18n = (0, $cgtv4.defineMessages)({
    clearFilter: {
        id: "side-navigation.content-menu.text-filter.clear-filter",
        defaultMessage: "Clear filter"
    }
});
function $ba4ff569986cbcbe$var$_temp(node) {
    if (node) node.focus();
}
module.exports["ContentMenuTextFilter"] = $ba4ff569986cbcbe$export$efb95505bdfcf1ee;

});

parcelRegister("asFJu", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $208062d54eade01a$export$a973cef5093a8d22 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { hasNextPage: hasNextPage, scrollableRef: scrollableRef, loadMore: loadMore } = t0;
    const [showLoadMoreButton, setShowLoadMoreButton] = (0, $42omo.useState)(false);
    const isTabbedRef = (0, $42omo.useRef)(false);
    const loadMoreButtonRef = (0, $42omo.useRef)(null);
    const lastItemRef = (0, $42omo.useRef)(null);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setShowLoadMoreButton(false);
        };
        $[0] = t1;
    } else t1 = $[0];
    const hideLoadMoreButton = t1;
    let t2;
    let t3;
    if ($[1] !== scrollableRef) {
        t2 = ()=>{
            const scrollableElement = scrollableRef.current;
            scrollableElement?.addEventListener("wheel", hideLoadMoreButton);
            return ()=>{
                scrollableElement?.removeEventListener("wheel", hideLoadMoreButton);
            };
        };
        t3 = [
            hideLoadMoreButton,
            scrollableRef
        ];
        $[1] = scrollableRef;
        $[2] = t2;
        $[3] = t3;
    } else {
        t2 = $[2];
        t3 = $[3];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[4] !== loadMore) {
        t4 = ()=>{
            lastItemRef.current?.focus();
            setShowLoadMoreButton(false);
            loadMore();
        };
        $[4] = loadMore;
        $[5] = t4;
    } else t4 = $[5];
    const handleLoadMoreButtonClick = t4;
    let t5;
    if ($[6] !== hasNextPage) {
        t5 = (event)=>{
            isTabbedRef.current = event.key === "Tab" && !event.shiftKey;
            if (isTabbedRef.current && hasNextPage) setShowLoadMoreButton(true);
        };
        $[6] = hasNextPage;
        $[7] = t5;
    } else t5 = $[7];
    const handleKeyDown = t5;
    let t6;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (event_0)=>{
            const { target: blurredElement, relatedTarget: nextFocusedElement } = event_0;
            if (nextFocusedElement === loadMoreButtonRef.current) lastItemRef.current = blurredElement;
        };
        $[8] = t6;
    } else t6 = $[8];
    const handleBlurCapture = t6;
    let t7;
    if ($[9] !== handleKeyDown || $[10] !== handleLoadMoreButtonClick || $[11] !== loadMore || $[12] !== showLoadMoreButton) {
        t7 = {
            showLoadMoreButton: showLoadMoreButton,
            setShowLoadMoreButton: setShowLoadMoreButton,
            loadMoreButtonRef: loadMoreButtonRef,
            handleKeyDown: handleKeyDown,
            handleBlurCapture: handleBlurCapture,
            handleLoadMoreButtonClick: handleLoadMoreButtonClick,
            loadMore: loadMore
        };
        $[9] = handleKeyDown;
        $[10] = handleLoadMoreButtonClick;
        $[11] = loadMore;
        $[12] = showLoadMoreButton;
        $[13] = t7;
    } else t7 = $[13];
    return t7;
} : ({ hasNextPage: hasNextPage, scrollableRef: scrollableRef, loadMore: loadMore })=>{
    const [showLoadMoreButton, setShowLoadMoreButton] = (0, $42omo.useState)(false);
    const isTabbedRef = (0, $42omo.useRef)(false);
    const loadMoreButtonRef = (0, $42omo.useRef)(null);
    const lastItemRef = (0, $42omo.useRef)(null);
    const hideLoadMoreButton = (0, $42omo.useCallback)(()=>{
        setShowLoadMoreButton(false);
    }, []);
    // Add event listener to hide the load more button when scrolling
    (0, $42omo.useEffect)(()=>{
        const scrollableElement = scrollableRef.current;
        scrollableElement?.addEventListener('wheel', hideLoadMoreButton);
        return ()=>{
            scrollableElement?.removeEventListener('wheel', hideLoadMoreButton);
        };
    }, [
        hideLoadMoreButton,
        scrollableRef
    ]);
    const handleLoadMoreButtonClick = (0, $42omo.useCallback)(()=>{
        // focus on the last item before loading more content
        lastItemRef.current?.focus();
        setShowLoadMoreButton(false);
        loadMore();
    }, [
        loadMore
    ]);
    // Handle keyboard navigation to show the load more button when tabbing
    const handleKeyDown = (0, $42omo.useCallback)((event)=>{
        isTabbedRef.current = event.key === 'Tab' && !event.shiftKey;
        if (isTabbedRef.current && hasNextPage) setShowLoadMoreButton(true);
    }, [
        hasNextPage
    ]);
    // Handle blur event to manage focus when tabbing away from the load more button
    const handleBlurCapture = (0, $42omo.useCallback)((event_0)=>{
        const { target: blurredElement, relatedTarget: nextFocusedElement } = event_0;
        if (nextFocusedElement === loadMoreButtonRef.current) lastItemRef.current = blurredElement;
    }, []);
    return {
        showLoadMoreButton: showLoadMoreButton,
        setShowLoadMoreButton: setShowLoadMoreButton,
        loadMoreButtonRef: loadMoreButtonRef,
        handleKeyDown: handleKeyDown,
        handleBlurCapture: handleBlurCapture,
        handleLoadMoreButtonClick: handleLoadMoreButtonClick,
        loadMore: loadMore
    };
};
module.exports["useInfiniteScroll"] = $208062d54eade01a$export$a973cef5093a8d22;

});

parcelRegister("5WLjq", function(module, exports) {

var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $5IsL6 = parcelRequire("5IsL6");


var $gW6rh = parcelRequire("gW6rh");


var $4H4Pj = parcelRequire("4H4Pj");


var $4eIcx = parcelRequire("4eIcx");


var $5t9S7 = parcelRequire("5t9S7");

const $0075b8fcac3e7fa4$export$19b525d696aff959 = ({ isLicensed: isLicensed, selectedSpaceKey: selectedSpaceKey })=>{
    const preloadQueries = [];
    if (isLicensed) {
        preloadQueries.push((0, $dYU3e.query)({
            query: (0, $gW6rh.default),
            variables: {}
        }));
        if (selectedSpaceKey) preloadQueries.push((0, $dYU3e.query)({
            query: (0, $4eIcx.default),
            variables: {
                selectedSpaceKey: selectedSpaceKey
            }
        }));
        else preloadQueries.push((0, $dYU3e.query)({
            query: (0, $4H4Pj.default),
            variables: {}
        }));
    } else preloadQueries.push((0, $dYU3e.query)({
        query: (0, $5t9S7.default),
        variables: {}
    }));
    preloadQueries.push((0, $5IsL6.preloadCreateSpace)({
        isLicensed: isLicensed
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(preloadQueries);
};
module.exports["preloadSpacesList"] = $0075b8fcac3e7fa4$export$19b525d696aff959;

});

parcelRegister("5IsL6", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $3TUla = parcelRequire("3TUla");

const $c4ac54148814de4b$export$25bcc47d8ed557d4 = ({ isLicensed: isLicensed })=>{
    if (!isLicensed) return Promise.resolve({
        data: null
    });
    /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ return (0, $dYU3e.query)({
        query: (0, $3TUla.CreateSpaceQuery)
    });
};
module.exports["preloadCreateSpace"] = $c4ac54148814de4b$export$25bcc47d8ed557d4;

});

parcelRegister("c1ydB", function(module, exports) {
/* expandable-menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6mkwk = parcelRequire("6mkwk");


var $jjpBv = parcelRequire("jjpBv");


var $dqobF = parcelRequire("dqobF");

const $92c006c36a67b185$var$relativeStyles = {
    root: "_kqswh2mm"
}; /**
    * __ExpandableMenuItem__
    *
    * A composable component for nested menu items that can be revealed and hidden by interacting witih the parent menu item.
    *
    * Follows the [disclosure pattern](https://www.w3.org/WAI/ARIA/apg/patterns/disclosure/).
    *
    * Should be used with `ExpandableMenuItemTrigger` as the parent menu item, and children menu items should be wrapped in a `ExpandableMenuItemContent`.
    *
    * Usage example:
    * ```jsx
    * <ExpandableMenuItem>
    *   <ExpandableMenuItemTrigger>Parent menu item</ExpandableMenuItemTrigger>
    *   <ExpandableMenuItemContent>
    *     <ButtonMenuItem>Item 1</ButtonMenuItem>
    *     <ButtonMenuItem>Item 2</ButtonMenuItem>
    *   </ExpandableMenuItemContent>
    * </ExpandableMenuItem>
    * ```
    */ 
const $92c006c36a67b185$export$341dea48c30b36ff = /*#__PURE__*/ (0, $42omo.forwardRef)(({ isExpanded: isExpandedControlled, isDefaultExpanded: isDefaultExpanded = false, onExpansionToggle: onExpansionToggle, children: children, dropIndicator: dropIndicator, testId: testId }, forwardedRef)=>{
    const [isExpanded, setIsExpanded] = (0, $6mkwk.default)(isExpandedControlled, ()=>isDefaultExpanded);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dqobF.IsExpandedContext).Provider, {
        value: isExpanded,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dqobF.SetIsExpandedContext).Provider, {
            value: setIsExpanded,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dqobF.OnExpansionToggleContext).Provider, {
                value: onExpansionToggle ?? null,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jjpBv.MenuListItem), {
                    ref: forwardedRef,
                    testId: testId,
                    children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                        className: (0, $gMc0m.default)([
                            dropIndicator && $92c006c36a67b185$var$relativeStyles.root
                        ]),
                        children: [
                            children,
                            dropIndicator
                        ]
                    })
                })
            })
        })
    });
});
module.exports["ExpandableMenuItem"] = $92c006c36a67b185$export$341dea48c30b36ff;

});

parcelRegister("dXXAF", function(module, exports) {
/* expandable-menu-item-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");


var $dM2NO = parcelRequire("dM2NO");


var $dqobF = parcelRequire("dqobF");

const $fec615cc81a1fda0$var$styles = {
    content: "_bozg1crf",
    collapsedContent: "_1e0cglyw"
};
const $fec615cc81a1fda0$export$bd680a81504a92e9 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children }, forwardedRef)=>{
    const isExpanded = (0, $dqobF.useIsExpanded)();
    const level = (0, $dqobF.useLevel)();
    const hasExpanded = (0, $42omo.useRef)(false);
    const areAllAncestorsExpanded = (0, $dqobF.useAreAllAncestorsExpanded)();
    if (!isExpanded && !hasExpanded.current) return null;
    hasExpanded.current = true;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dqobF.LevelContext).Provider, {
        value: level + 1,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dqobF.AreAllAncestorsExpandedContext).Provider, {
            value: /**
     * By combining the current ancestor and with the current menu item's state, all nested menu items will know if their
     * ancestor menu items are all expanded.
     */ areAllAncestorsExpanded && isExpanded,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dM2NO.List), {
                ref: forwardedRef,
                xcss: (0, $1bHXt.cx)($fec615cc81a1fda0$var$styles.content, !isExpanded && $fec615cc81a1fda0$var$styles.collapsedContent),
                children: children
            })
        })
    });
});
module.exports["ExpandableMenuItemContent"] = $fec615cc81a1fda0$export$bd680a81504a92e9;

});

parcelRegister("cNRxA", function(module, exports) {
/* expandable-menu-item-trigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $1qfLF = parcelRequire("1qfLF");


var $3hoG4 = parcelRequire("3hoG4");


var $ghftu = parcelRequire("ghftu");


var $6R5uz = parcelRequire("6R5uz");


var $5ujhR = parcelRequire("5ujhR");


var $ZrrWT = parcelRequire("ZrrWT");


var $dqobF = parcelRequire("dqobF");

const $6e81c6ccd458cf94$var$chevronDisplayCssVar = '--expandable-chevron-display';
const $6e81c6ccd458cf94$var$providedElemBeforeDisplayCssVar = '--expandable-provided-elembefore-display';
const $6e81c6ccd458cf94$var$wrapperStyles = {
    root: "_1mmi1txw _165nglyw",
    showProvidedElemBefore: "_1mmiglyw _165n1bgi _v9u71txw _1hl9glyw _b31z1txw _1vnl1txw _12xsglyw _p8btglyw"
};
const $6e81c6ccd458cf94$var$iconStyles = {
    chevron: "_1e0ciw0t _1tz3r0mg",
    providedElemBefore: "_1e0c1xb2",
    providedElemBeforeSelected: "_syazxl6c"
};
const $6e81c6ccd458cf94$var$ExpandableMenuItemIcon = ({ iconProps: iconProps, isExpanded: isExpanded, isSelected: isSelected, providedElemBefore: providedElemBefore })=>{
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($ghftu))) : (0, (/*@__PURE__*/$parcel$interopDefault($6R5uz)));
    const chevronElem = /*#__PURE__*/ (0, $l998X.jsx)(ChevronIcon, {
        ...iconProps,
        label: "",
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : undefined,
        size: "small"
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $6e81c6ccd458cf94$var$iconStyles.chevron
                ]),
                children: chevronElem
            }),
            providedElemBefore && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $6e81c6ccd458cf94$var$iconStyles.providedElemBefore,
                    isSelected && $6e81c6ccd458cf94$var$iconStyles.providedElemBeforeSelected
                ]),
                children: providedElemBefore
            })
        ]
    });
};
const $6e81c6ccd458cf94$export$fe6fe51056867f4d = (0, $3hoG4.default)(({ actions: actions, isSelected: isSelected, href: href, elemBefore: providedElemBefore, elemAfter: elemAfter, actionsOnHover: actionsOnHover, onClick: onClick, children: children, testId: testId, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const id = (0, $42omo.useId)();
    const onExpansionToggle = (0, $dqobF.useOnExpansionToggle)();
    const isExpanded = (0, $dqobF.useIsExpanded)();
    const setIsExpanded = (0, $dqobF.useSetIsExpanded)();
    const itemRef = (0, $42omo.useRef)(null);
    const handleIconClick = (0, $42omo.useCallback)(()=>{
        onExpansionToggle?.(!isExpanded);
        setIsExpanded(!isExpanded);
    }, [
        isExpanded,
        onExpansionToggle,
        setIsExpanded
    ]);
    const handleMenuContentClick = (0, $42omo.useCallback)((event, analyticsEvent)=>{
        const newValue = !isExpanded;
        onClick?.(event, analyticsEvent, {
            isExpanded: newValue
        });
        onExpansionToggle?.(newValue);
        setIsExpanded(newValue);
    }, [
        onClick,
        onExpansionToggle,
        isExpanded,
        setIsExpanded
    ]);
    const isSelectable = typeof href !== 'undefined';
    (0, $ZrrWT.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: Boolean(isSelectable && isSelected)
    }); // Wrapped in an IconButton if the expandable menu item trigger is selectable
    const elemBefore = isSelectable ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)($6e81c6ccd458cf94$var$ExpandableMenuItemIcon, {
                iconProps: iconProps,
                isExpanded: isExpanded,
                isSelected: isSelected,
                providedElemBefore: providedElemBefore
            }),
        "aria-expanded": isExpanded,
        // screen readers on what will actually be expanded or collapsed. Screen readers will also use the
        // `aria-expanded` attribute to indicate the expanded state of the menu item.
        // We are not using the `aria-label` attribute here as it is not supported by the `IconButton` component.
        "aria-labelledby": id,
        // `aria-labelledby`, which will be used instead.
        label: "",
        appearance: "subtle",
        spacing: "compact",
        onClick: handleIconClick,
        interactionName: interactionName,
        testId: testId ? `${testId}--elem-before-button` : undefined
    }) : /*#__PURE__*/ (0, $l998X.jsx)($6e81c6ccd458cf94$var$ExpandableMenuItemIcon, {
        isExpanded: isExpanded,
        isSelected: isSelected,
        providedElemBefore: providedElemBefore
    }); // For expandable menu items, we shouldn't wrap in a `li` here. The `li` is instead at a higher level (`ExpandableMenuItem`), grouping the expandable menu item trigger and its content
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: itemRef,
        className: (0, $gMc0m.default)([
            $6e81c6ccd458cf94$var$wrapperStyles.root,
            providedElemBefore && $6e81c6ccd458cf94$var$wrapperStyles.showProvidedElemBefore
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5ujhR.MenuItemBase), {
            id: id,
            actions: actions,
            actionsOnHover: actionsOnHover,
            elemBefore: elemBefore,
            ariaExpanded: isExpanded,
            elemAfter: elemAfter,
            href: href,
            isSelected: isSelected,
            onClick: handleMenuContentClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            testId: testId,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
});
module.exports["ExpandableMenuItemTrigger"] = $6e81c6ccd458cf94$export$fe6fe51056867f4d;

});

parcelRegister("3b6WO", function(module, exports) {

var $8C5kA = parcelRequire("8C5kA");


var $42omo = parcelRequire("42omo");


var $7zIsq = parcelRequire("7zIsq");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $kqIWy = parcelRequire("kqIWy");


var $bFDX4 = parcelRequire("bFDX4");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $6qkXi = parcelRequire("6qkXi");

const $8eb9026be26e0c85$export$cab421e039d23b2 = ({ moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: returnBlockedExtensions = false, spaceContextOnly: spaceContextOnly })=>{
    const { locale: locale } = (0, $8C5kA.default)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const options = (0, $42omo.useMemo)(()=>(0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: queryOptions,
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            spaceContextOnly: spaceContextOnly
        }), [
        cloudId,
        locale,
        moduleType,
        queryOptions,
        returnBlockedExtensions,
        spaceKey,
        contentId,
        spaceContextOnly
    ]);
    const { extensions: extsData, loading: extsLoading, error: extsError } = (0, $7zIsq.usePrefilteredExtensionList)(options);
    (0, $42omo.useEffect)(()=>{
        // suppress 403 errors as we can't do much with them
        if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        // suppress 429 errors for offending users
        if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
    }, [
        extsError,
        spaceError
    ]);
    return {
        extensions: extsData,
        loading: extsLoading,
        error: extsError
    };
};
module.exports["useExtensionList"] = $8eb9026be26e0c85$export$cab421e039d23b2;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("6qkXi", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $gKr8t = parcelRequire("gKr8t");


var $hp2SH = parcelRequire("hp2SH");

const $26379cee560cb131$export$4b3c44afb1a70b38 = ({ cloudId: cloudId, locale: locale, moduleType: moduleType, queryOptions: queryOptions, includeHidden: includeHidden, spaceKey: spaceKey, contentId: contentId, spaceContextOnly: spaceContextOnly = false })=>{
    const options = {
        client: (0, $6mKj3.expVal)('confluence_cgraphql_client_for_forge_extensions', 'isEnabled', false) ? (0, $hp2SH.getApolloClient)() : (0, $gKr8t.getAGGClient)(),
        cloudId: cloudId,
        types: [
            moduleType
        ],
        queryOptions: {
            ...queryOptions
        },
        locale: locale,
        context: spaceContextOnly ? {
            spaceKey: spaceKey
        } : {
            spaceKey: spaceKey,
            contentId: contentId
        },
        includeHidden: includeHidden
    };
    return options;
};
module.exports["getUsePrefilteredExtensionListOptions"] = $26379cee560cb131$export$4b3c44afb1a70b38;

});

parcelRegister("aGrg7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5ade2eda47f6475cda14c97092098b50>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7c72f8afe5d616f3$var$_react = $7c72f8afe5d616f3$var$_interopRequireDefault((parcelRequire("42omo")));

var $7c72f8afe5d616f3$var$_baseNew = $7c72f8afe5d616f3$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $7c72f8afe5d616f3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Marketplace".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Marketplace.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7c72f8afe5d616f3$var$MarketplaceIcon = (props)=>/*#__PURE__*/ $7c72f8afe5d616f3$var$_react.default.createElement($7c72f8afe5d616f3$var$_baseNew.default, Object.assign({
        name: "MarketplaceIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.789 1.513A.75.75 0 0 1 2.5 1h11a.75.75 0 0 1 .711.513l1.502 4.5a.8.8 0 0 1 .038.237A3.08 3.08 0 0 1 14 9.032V13a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.031A3.08 3.08 0 0 1 .25 6.25q0-.12.038-.237zM3.5 9.329V13a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9.33a3.08 3.08 0 0 1-2.166-1.064A3.08 3.08 0 0 1 8 9.334a3.08 3.08 0 0 1-2.334-1.068A3.08 3.08 0 0 1 3.5 9.329M4.916 6.25v.03a1.584 1.584 0 0 1-3.163.08l.037-.11zm1.5.038.005-.038h3.158l.004.038a1.584 1.584 0 0 1-3.166 0M9.413 4.75H6.588l.25-2.25h2.324zm1.672 1.5a1.584 1.584 0 0 0 3.164.11l-.037-.11zm2.626-1.5h-2.788l-.25-2.25h2.288zM5.33 2.5l-.25 2.25H2.29l.75-2.25z" clip-rule="evenodd"/>`
    }, props));
$7c72f8afe5d616f3$var$MarketplaceIcon.displayName = 'MarketplaceIcon';
var $7c72f8afe5d616f3$var$_default = module.exports.default = $7c72f8afe5d616f3$var$MarketplaceIcon;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];
module.exports["MarkupRecursiveList"] = $1ec3e8240f57817b$export$3b98ab6402702476;
module.exports["MarkupList"] = $1ec3e8240f57817b$export$3ee8c58bb87b9685;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("5tgcI", function(module, exports) {
const $696759caf06ef68c$export$af39e4edc5e74 = 'com.atlassian.confluence.plugins.confluence-space-ia:header-spaces-link';
const $696759caf06ef68c$export$97c436ccc42cbac9 = 'com.atlassian.confluence.plugins.confluence-space-ia:header-people-link';
const $696759caf06ef68c$export$3a7ae658938afc39 = 'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.confluence.emcee__enduser-discover';
const $696759caf06ef68c$export$ee99bc1ad01a63ae = 'com.atlassian.confluence.plugins.confluence-space-ia:header-automation-link';
const $696759caf06ef68c$export$8a23ae6ca6b0c9ee = 'com.atlassian.confluence.extra.team-calendars:header-mycalendar-link';
const $696759caf06ef68c$export$38788381122702f5 = 'com.atlassian.plugins.atlassian-connect-plugin:com.addonengine.analytics__analytics-instance-settings-menu-item-adg3';
const $696759caf06ef68c$export$6c3d789a4f56bea2 = 'com.atlassian.plugins.atlassian-connect-plugin:com.addonengine.analytics.moderate__analytics-instance-settings-menu-item-adg3';
module.exports["SPACES_KEY"] = $696759caf06ef68c$export$af39e4edc5e74;
module.exports["PEOPLE_KEY"] = $696759caf06ef68c$export$97c436ccc42cbac9;
module.exports["DISCOVER_KEY"] = $696759caf06ef68c$export$3a7ae658938afc39;
module.exports["AUTOMATION_KEY"] = $696759caf06ef68c$export$ee99bc1ad01a63ae;
module.exports["CALENDAR_KEY"] = $696759caf06ef68c$export$8a23ae6ca6b0c9ee;
module.exports["ANALYTICS_KEY"] = $696759caf06ef68c$export$38788381122702f5;
module.exports["ANALYTICS_KEY_MODERATE"] = $696759caf06ef68c$export$6c3d789a4f56bea2;

});

parcelRegister("g0ob9", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jdPfT = parcelRequire("jdPfT");


var $fxBfz = parcelRequire("fxBfz");


var $8DN9t = parcelRequire("8DN9t");


var $cyLm6 = parcelRequire("cyLm6");


var $5tgcI = parcelRequire("5tgcI");

const $e8563bcd391eebd4$var$iconOverrides = {
    [(0, $5tgcI.AUTOMATION_KEY)]: (0, (/*@__PURE__*/$parcel$interopDefault($fxBfz))),
    [(0, $5tgcI.CALENDAR_KEY)]: (0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))),
    [(0, $5tgcI.ANALYTICS_KEY)]: (0, (/*@__PURE__*/$parcel$interopDefault($cyLm6))),
    [(0, $5tgcI.ANALYTICS_KEY_MODERATE)]: (0, (/*@__PURE__*/$parcel$interopDefault($cyLm6)))
};
const $e8563bcd391eebd4$export$5153830bdfb71453 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { url: url, completeKey: completeKey } = t0;
    if (completeKey) {
        const IconOverride = $e8563bcd391eebd4$var$iconOverrides[completeKey];
        if (IconOverride) {
            let t1;
            if ($[0] !== IconOverride) {
                t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(IconOverride, null);
                $[0] = IconOverride;
                $[1] = t1;
            } else t1 = $[1];
            return t1;
        }
    }
    if (!url) {
        let t1;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
                label: "",
                color: "currentColor"
            });
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("filter", {
            id: "changeFillColor"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
            type: "matrix",
            values: "0.02, 0, 0, 0, 0, 0, 0.04, 0, 0, 0, 0, 0, 0.07, 0, 0, 0, 0, 0, 1, 0"
        })));
        $[3] = t1;
    } else t1 = $[3];
    const t2 = $e8563bcd391eebd4$var$isSvg(url) ? "url(#changeFillColor)" : "";
    let t3;
    if ($[4] !== t2 || $[5] !== url) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            viewBox: "0 0 16 16",
            width: "16",
            height: "16",
            "aria-hidden": "true",
            "data-testid": "app-icon"
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("image", {
            xmlnsXlink: "http://www.w3.org/1999/xlink",
            xlinkHref: url,
            width: "16",
            height: "16",
            x: "0",
            y: "0",
            filter: t2
        }));
        $[4] = t2;
        $[5] = url;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ url: url, completeKey: completeKey })=>{
    if (completeKey) {
        const IconOverride = $e8563bcd391eebd4$var$iconOverrides[completeKey];
        if (IconOverride) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(IconOverride, null);
    }
    if (!url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
        label: "",
        color: "currentColor"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        viewBox: "0 0 16 16",
        width: "16",
        height: "16",
        "aria-hidden": "true",
        "data-testid": "app-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("filter", {
        id: "changeFillColor"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0.02, 0, 0, 0, 0, 0, 0.04, 0, 0, 0, 0, 0, 0.07, 0, 0, 0, 0, 0, 1, 0"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("image", {
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        xlinkHref: url,
        width: "16",
        height: "16",
        x: "0",
        y: "0",
        filter: $e8563bcd391eebd4$var$isSvg(url) ? 'url(#changeFillColor)' : ''
    }));
};
const $e8563bcd391eebd4$var$isSvg = (url)=>{
    const fileType = url.split(/\#|\?/)[0].split('.').pop();
    return !!fileType && fileType.trim() === 'svg';
};
module.exports["AppIcon"] = $e8563bcd391eebd4$export$5153830bdfb71453;

});

parcelRegister("g9Ghb", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $91ba7504cfad305c$export$e82a504f7cb45e99 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "PQ2oV",
    name: "ReverseTrialLozengeListItemExperiment",
    loader: async ()=>(await (parcelRequire("9Io6v"))).ReverseTrialListItemWithErrorBoundary
});
module.exports["ReverseTrialLozengeListItemExperiment"] = $91ba7504cfad305c$export$e82a504f7cb45e99;

});

parcelRegister("9Io6v", function(module, exports) {

let $712aeba539843bc5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $712aeba539843bc5$var$load("Wowvf"),
    $712aeba539843bc5$var$load("hhss7"),
    $712aeba539843bc5$var$load("fqBFU"),
    $712aeba539843bc5$var$load("1HAEl")
]).then(()=>parcelRequire('f3FIN'));

});

parcelRegister("2yoLO", function(module, exports) {

let $1dc1f892a40525fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1dc1f892a40525fc$var$load("9jGiN").then(()=>parcelRequire('kvRiJ'));

});

parcelRegister("h8IEo", function(module, exports) {

let $c7a5d1aa3c18c86a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c7a5d1aa3c18c86a$var$load("SepNY").then(()=>parcelRequire('7vGOX'));

});

parcelRegister("8dUjs", function(module, exports) {

var $d9tcB = parcelRequire("d9tcB");


var $eSLr0 = parcelRequire("eSLr0");


var $7Ndnw = parcelRequire("7Ndnw");


var $5tgcI = parcelRequire("5tgcI");

const $84cd59e06a85be4f$export$a9c446837cd59ef8 = [
    (0, $5tgcI.SPACES_KEY),
    (0, $5tgcI.PEOPLE_KEY),
    (0, $5tgcI.DISCOVER_KEY)
];
const $84cd59e06a85be4f$export$a56df56fab66279e = ({ edition: edition, accessStatus: accessStatus })=>{
    const isAdmin = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const hideAutomation = edition !== 'PREMIUM' || !isAdmin;
    const notAllowedWebItems = [
        ...$84cd59e06a85be4f$export$a9c446837cd59ef8,
        hideAutomation ? (0, $5tgcI.AUTOMATION_KEY) : ''
    ];
    return {
        webItemParams: {
            location: (0, $eSLr0.SYSTEM_HEADER_LEFT),
            notAllowedWebItems: notAllowedWebItems
        },
        forgeExtensionParams: {
            moduleType: (0, $7Ndnw.FORGE_MODULE_GLOBAL_PAGE),
            spaceKey: ''
        }
    };
};
module.exports["getGlobalAppsParams"] = $84cd59e06a85be4f$export$a56df56fab66279e;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("6JI2k", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $3b74fcc841254653$var$notesInitialState = {
    activeNoteId: undefined
};
const $3b74fcc841254653$var$noteEditorApiInitialState = {
    noteEditorApi: undefined
};
const $3b74fcc841254653$var$notesActions = {
    setActiveNoteId: (activeNoteId)=>({ setState: setState })=>{
            setState({
                activeNoteId: activeNoteId
            });
        },
    resetActiveNoteId: ()=>({ setState: setState })=>{
            setState({
                activeNoteId: undefined
            });
        }
};
const $3b74fcc841254653$var$noteEditorApiActions = {
    setNoteEditorApi: (noteEditorApi)=>({ setState: setState })=>{
            setState({
                noteEditorApi: noteEditorApi
            });
        },
    resetNoteEditorApi: ()=>({ setState: setState })=>{
            setState($3b74fcc841254653$var$noteEditorApiInitialState);
        }
};
const $3b74fcc841254653$var$NotesStore = (0, $1P1Tu.createStore)({
    initialState: $3b74fcc841254653$var$notesInitialState,
    actions: $3b74fcc841254653$var$notesActions,
    name: 'NotesStore'
});
const $3b74fcc841254653$var$NoteEditorApiStore = (0, $1P1Tu.createStore)({
    initialState: $3b74fcc841254653$var$noteEditorApiInitialState,
    actions: $3b74fcc841254653$var$noteEditorApiActions,
    name: 'NoteEditorApiStore'
});
const $3b74fcc841254653$export$ecce9ae725432b7b = (0, $9zUhf.createActionsHook)($3b74fcc841254653$var$NotesStore);
const $3b74fcc841254653$var$selectActiveNoteId = (state)=>state.activeNoteId;
const $3b74fcc841254653$export$2e974306a61c660e = (0, $9zUhf.createHook)($3b74fcc841254653$var$NotesStore, {
    selector: $3b74fcc841254653$var$selectActiveNoteId
});
const $3b74fcc841254653$export$b2bc9c556f5ab60 = (0, $9zUhf.createHook)($3b74fcc841254653$var$NoteEditorApiStore);
const $3b74fcc841254653$export$510fc84c2883e9ba = (0, $9zUhf.createActionsHook)($3b74fcc841254653$var$NoteEditorApiStore);
module.exports["useNotesActions"] = $3b74fcc841254653$export$ecce9ae725432b7b;
module.exports["useActiveNoteId"] = $3b74fcc841254653$export$2e974306a61c660e;
module.exports["useNoteEditorApi"] = $3b74fcc841254653$export$b2bc9c556f5ab60;
module.exports["useNoteEditorApiActions"] = $3b74fcc841254653$export$510fc84c2883e9ba;

});

parcelRegister("lKMTm", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $1KmJq = parcelRequire("1KmJq");

var $xQxzY = parcelRequire("xQxzY");


var $91csT = parcelRequire("91csT");


var $1Z9af = parcelRequire("1Z9af");

const $12fcc847cd6ca878$var$EAP_MAX_LIMIT_OF_NOTES = 50;
const $12fcc847cd6ca878$var$getNotesQueryOptions = {
    query: (0, $1Z9af.GetNotesQuery),
    variables: {
        limit: $12fcc847cd6ca878$var$EAP_MAX_LIMIT_OF_NOTES
    }
};
const $12fcc847cd6ca878$export$30b78dd9f3a45abb = ()=>{
    const { error: error, loading: loading, data: data } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useNotesDataNotesByCreatorQuery($limit:Int!){notesByCreator(input:{isAscending:true first:$limit}){nodes{ari title body bodyExcerpt createdAt updatedAt isPinned backgroundColor}}}`, {
        ...$12fcc847cd6ca878$var$getNotesQueryOptions,
        errorPolicy: 'all'
    });
    const transformDataToCacheFormat = (currentCache, dataToCache)=>{
        return {
            ...currentCache,
            notesByCreator: {
                ...currentCache.notesByCreator,
                nodes: dataToCache
            }
        };
    };
    const readCache = (cache)=>cache.readQuery($12fcc847cd6ca878$var$getNotesQueryOptions);
    const writeCache = (cache, notesByCreatorData)=>{
        cache.writeQuery({
            ...$12fcc847cd6ca878$var$getNotesQueryOptions,
            data: notesByCreatorData
        });
    };
    const [createNoteMutation, { loading: createNoteLoading }] = (0, $1KmJq.useMutation)((0, $eSUdr.default)`mutation useNotesDataCreateNoteMutation($title:String$body:String){createNote(input:{title:$title body:$body}){errors{message}success note{ari title body bodyExcerpt collectionName isPinned thumbnailId labels createdAt updatedAt backgroundColor extraProps{key value}}}}`, {
        update: (cache, { data: responseData })=>{
            const cachedData = readCache(cache);
            if (cachedData?.notesByCreator?.nodes && responseData?.createNote?.note) {
                const newCacheData = [
                    responseData.createNote.note,
                    ...cachedData.notesByCreator.nodes
                ];
                writeCache(cache, transformDataToCacheFormat(cachedData, newCacheData));
            }
        }
    });
    const [updateNoteMutation] = (0, $1KmJq.useMutation)((0, $eSUdr.default)`mutation useNotesDataUpdateNoteMutation($ari:String!$title:String$body:String$isPinned:Boolean=false$backgroundColor:String){updateNote(input:{title:$title body:$body backgroundColor:$backgroundColor metadata:{ari:$ari isPinned:$isPinned}}){errors{message extensions{errorType statusCode}}success note{ari title body bodyExcerpt collectionName isPinned updatedAt backgroundColor}}}`, {
        update: (cache, { data: responseData })=>{
            const cachedData = readCache(cache);
            if (cachedData?.notesByCreator?.nodes && responseData?.updateNote?.note?.ari) {
                // find old cache note index
                const cachedNoteIndex = cachedData.notesByCreator.nodes.findIndex((note)=>note?.ari === responseData.updateNote?.note?.ari);
                if (cachedNoteIndex >= 0) {
                    // if exist get the cache note data
                    const cachedNoteData = cachedData.notesByCreator.nodes[cachedNoteIndex];
                    if (cachedNoteData) {
                        // if data is not null, delete cache note and add updated note to top
                        const updatedNoteData = {
                            ...cachedNoteData,
                            ...responseData.updateNote?.note
                        }; // added null to keep types happy
                        const newCacheData = [
                            updatedNoteData
                        ].concat(cachedData.notesByCreator.nodes.slice(0, cachedNoteIndex), cachedData.notesByCreator.nodes.slice(cachedNoteIndex + 1));
                        writeCache(cache, transformDataToCacheFormat(cachedData, newCacheData));
                    }
                }
            }
        }
    });
    const [deleteNoteMutation, { error: deleteNoteError, loading: deleteNoteLoading, data: deleteNoteData }] = (0, $1KmJq.useMutation)((0, $eSUdr.default)`mutation useNotesDataDeleteNoteMutation($ari:String!){deleteNote(input:{ari:$ari}){errors{message}success ari}}`, {
        update: (cache, { data: responseData })=>{
            const cachedData = readCache(cache);
            if (cachedData?.notesByCreator?.nodes && responseData?.deleteNote?.ari) {
                const newCacheData = cachedData.notesByCreator.nodes.filter((note)=>note?.ari !== responseData?.deleteNote?.ari);
                writeCache(cache, transformDataToCacheFormat(cachedData, newCacheData));
            }
        }
    });
    const all = data?.notesByCreator;
    const notes = (all?.nodes || []).map((note)=>(0, $91csT.transformToNote)(note || undefined));
    // This has been created just for the early access program since we are limiting users to only 50 notes.
    const userHasMaxNumberOfNotes = notes.length >= $12fcc847cd6ca878$var$EAP_MAX_LIMIT_OF_NOTES;
    return {
        notesData: notes,
        createNote: createNoteMutation,
        createNoteLoading: createNoteLoading,
        deleteNote: deleteNoteMutation,
        deleteNoteError: deleteNoteError,
        deleteNoteLoading: deleteNoteLoading,
        deleteNoteData: deleteNoteData,
        updateNote: updateNoteMutation,
        loading: loading,
        error: error,
        userHasMaxNumberOfNotes: userHasMaxNumberOfNotes
    };
};
module.exports["useNotesData"] = $12fcc847cd6ca878$export$30b78dd9f3a45abb;

});

parcelRegister("91csT", function(module, exports) {
const $77980f4c3c79dff6$export$c24f25c953d270b8 = (payload)=>{
    if (!payload) return {};
    const { body: body, ...noteData } = payload;
    let adf;
    // This try catch has been added temporarily because plaintext non-adf/json was added to the DB
    // TODO: remove once we sanitize all of those test entries
    try {
        adf = body ? JSON.parse(body) : undefined;
    } catch (e) {
        adf = undefined;
    }
    return {
        ...noteData,
        adf: adf
    };
};
module.exports["transformToNote"] = $77980f4c3c79dff6$export$c24f25c953d270b8;

});

parcelRegister("1Z9af", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $b216a6ab139869d9$export$34a99364d28fe306 = (0, $eSUdr.default)`query NotesByCreator($limit:Int!){notesByCreator(input:{isAscending:true first:$limit}){nodes{ari title body bodyExcerpt createdAt updatedAt isPinned backgroundColor}}}`;
module.exports["GetNotesQuery"] = $b216a6ab139869d9$export$34a99364d28fe306;

});

parcelRegister("fyVkL", function(module, exports) {
const $7f2431231a8e8b7f$export$95a976ff8369850f = ({ createAnalyticsEvent: createAnalyticsEvent, noteId: noteId, entryPoint: entryPoint, contextualAttributes: contextualAttributes })=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            source: entryPoint,
            actionSubject: 'note',
            actionSubjectId: noteId,
            action: 'created',
            attributes: {
                ...contextualAttributes,
                flow: entryPoint
            }
        }
    }).fire();
};
const $7f2431231a8e8b7f$export$2a47394b64a7458a = ({ createAnalyticsEvent: createAnalyticsEvent, entryPoint: entryPoint, routeName: routeName, contextualAttributes: contextualAttributes })=>{
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            source: entryPoint,
            actionSubject: 'button',
            actionSubjectId: 'createNote',
            action: 'clicked',
            attributes: {
                ...contextualAttributes,
                routeName: routeName
            }
        }
    }).fire();
};
module.exports["triggerCreationTrackEvent"] = $7f2431231a8e8b7f$export$95a976ff8369850f;
module.exports["triggerCreationUIButtonClickEvent"] = $7f2431231a8e8b7f$export$2a47394b64a7458a;

});

parcelRegister("bxB0V", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $42omo = parcelRequire("42omo");


const $e62143ad7e34aa24$export$c09847f3a2ea8c56 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "vnIuw",
    name: "OnboardingNudge",
    loader: async ()=>(await (parcelRequire("6zHP0"))).OnboardingNudge,
    loading: ({ children: children, renderChildrenWhileLoading: renderChildrenWhileLoading })=>renderChildrenWhileLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children) : null
});
module.exports["OnboardingNudge"] = $e62143ad7e34aa24$export$c09847f3a2ea8c56;

});

parcelRegister("6zHP0", function(module, exports) {

let $4c98010e10280dfc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4c98010e10280dfc$var$load("jSdjl"),
    $4c98010e10280dfc$var$load("l2EUC"),
    $4c98010e10280dfc$var$load("k9ktU")
]).then(()=>parcelRequire('iFaMg'));

});

parcelRegister("ljgqo", function(module, exports) {

let $f8381ceb38cf9b62$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f8381ceb38cf9b62$var$load("nbjnv"),
    $f8381ceb38cf9b62$var$load("kIryJ")
]).then(()=>parcelRequire('j2TUq'));

});

parcelRegister("iydiV", function(module, exports) {

let $d815b8ef68c94156$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d815b8ef68c94156$var$load("k8XPW"),
    $d815b8ef68c94156$var$load("fWCRm"),
    $d815b8ef68c94156$var$load("FBIp4")
]).then(()=>parcelRequire('cHhL0'));

});

parcelRegister("335sG", function(module, exports) {

let $2385e37b34ddfa2d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2385e37b34ddfa2d$var$load("6wr18"),
    $2385e37b34ddfa2d$var$load("9JvEP"),
    $2385e37b34ddfa2d$var$load("3kUQf"),
    $2385e37b34ddfa2d$var$load("ffEVr"),
    $2385e37b34ddfa2d$var$load("borwc")
]).then(()=>parcelRequire('jhdHU'));

});

parcelRegister("7PLO8", function(module, exports) {
const $3009aa09d1bfedbe$export$93a0fdadbf6c055a = ()=>{
    return new URLSearchParams(window.location.search.substring(1)).get('draftShareId') || '';
};
module.exports["getDraftShareIdFromQueryParam"] = $3009aa09d1bfedbe$export$93a0fdadbf6c055a;

});

parcelRegister("fEmGS", function(module, exports) {

var $86okN = parcelRequire("86okN");

function $f0827a369f0dafa9$export$f97bd2548c77448c(params) {
    return $f0827a369f0dafa9$var$writeQueryInteropApollo(params);
}
function $f0827a369f0dafa9$var$writeQueryInteropRelay(params) {
    const relayEnv = window.GLOBAL_RELAY_ENV;
    const { query: query, data: data, variables: variables } = params;
    if (!data) return;
    relayEnv.commitUpdate((storeProxy)=>{
        const root = storeProxy.getRoot();
        if (!root) return;
        const queryNode = query;
        const queryFields = queryNode?.operation?.selections;
        if (queryFields) $f0827a369f0dafa9$var$writeQueryFields(storeProxy, root, queryFields, data, variables || {});
    });
}
function $f0827a369f0dafa9$var$writeQueryFields(storeProxy, record, fields, data, variables) {
    if (!record || !data) return;
    for (const field of fields){
        if (field.kind === 'LinkedField') {
            const linkedField = field;
            const fieldData = data[linkedField.name];
            if (fieldData !== undefined) {
                if (Array.isArray(fieldData)) {
                    const linkedRecords = fieldData.map((item)=>{
                        if (item && typeof item === 'object') {
                            const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                            const existingRecord = record.getLinkedRecord(fieldKey);
                            if (existingRecord && linkedField.selections) {
                                $f0827a369f0dafa9$var$writeQueryFields(storeProxy, existingRecord, linkedField.selections, item, variables);
                                return existingRecord;
                            }
                        }
                        return null;
                    }).filter((rec)=>rec !== null);
                    if (linkedRecords.length > 0) {
                        const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                        record.setLinkedRecords(linkedRecords, fieldKey);
                    }
                } else if (fieldData && typeof fieldData === 'object') {
                    const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                    const linkedRecord = record.getLinkedRecord(fieldKey);
                    // If no linked record exists but we have data with an ID, we can try to get the existing record,
                    // or create a new record based on __typename. However, this shouldn't be a common use-case across the codebase,
                    // so we'll skip these code paths for now
                    if (linkedRecord && linkedField.selections) $f0827a369f0dafa9$var$writeQueryFields(storeProxy, linkedRecord, linkedField.selections, fieldData, variables);
                }
            }
        } else if (field.kind === 'ScalarField') {
            const scalarField = field;
            if (data[scalarField.name] !== undefined) record.setValue(data[scalarField.name], scalarField.name);
        }
    }
}
function $f0827a369f0dafa9$var$getFieldKey(field, variables) {
    if (!field.args || field.args.length === 0) return field.name;
    // Compute storage key for fields with arguments
    const args = field.args.map((arg)=>{
        let value;
        if (arg.kind === 'Literal') value = JSON.stringify(arg.value);
        else if (arg.kind === 'Variable') value = JSON.stringify(variables[arg.variableName]);
        else // Fallback for other argument types
        value = JSON.stringify(arg.value);
        return `${arg.name}:${value}`;
    }).join(',');
    return `${field.name}(${args})`;
}
function $f0827a369f0dafa9$var$writeQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].writeQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["writeQueryInterop"] = $f0827a369f0dafa9$export$f97bd2548c77448c;

});

parcelRegister("l1uFv", function(module, exports) {

var $86okN = parcelRequire("86okN");

function $65c7b8940c778902$export$627cb922211284f(params) {
    return $65c7b8940c778902$var$readQueryInteropApollo(params);
}
function $65c7b8940c778902$var$readQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].readQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["readQueryInterop"] = $65c7b8940c778902$export$627cb922211284f;

});

parcelRegister("bedQP", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");

const $9aeacd26f36a9957$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $9aeacd26f36a9957$export$cf56d0f54cfcce4;

});

parcelRegister("9JpPs", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $c712b10e1cbb5738$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $c712b10e1cbb5738$export$6e8ea24b15199873;

});

parcelRegister("882hS", function(module, exports) {
$parcel$export(module.exports, "pointerOutsideOfPreview", () => (parcelRequire("85Mv7")).pointerOutsideOfPreview);

var $85Mv7 = parcelRequire("85Mv7");


});

parcelRegister("85Mv7", function(module, exports) {

var $ic3Jg = parcelRequire("ic3Jg");


var $iFRCn = parcelRequire("iFRCn");


var $76xc7 = parcelRequire("76xc7");

function $30069a8958953d8b$export$427e20518819fabc(point) {
    return function getOffset({ container: container }) {
        /**
		 * **Approach: transparent borders.**
		 *
		 * The only reliable cross browser technique found to push a
		 * drag preview away from the cursor is to use transparent borders on the container.
		 *
		 * **🙅📱 Not pushing the preview away on touch devices**
		 *
		 * _On iOS_
		 *
		 * Safari will set the transparent border color to be black
		 *
		 * `iOS@18.4.1` on May 7th 2025:
		 * - If you set the background color on the `container` the border color will be that
		 * - Setting a transparent background color on the `container` still results in a
		 *   black border
		 * - The `<body>` text or background color does not change the black border color
		 *
		 * While dragging, the drag preview will shift under the center of the users pointer.
		 * So if you start at {x: 0, y: 0} (top left), almost immediately the preview will move
		 * to be under the middle of the users pointer.
		 *
		 * _On Android_
		 *
		 * Chrome will put the center of the drag preview under the users pointer immediately.
		 *
		 * Tested on `Chrome@137` on `Android 14` on June 20th 2025
		 *
		 * _What we do_
		 *
		 * We don't add the transparent border
		 *
		 * - Avoid the black color on iOS
		 * - It isn't needed on Android anyway as the preview will be under the center
		 *   of the users pointer
		 *
		 * We put the center of the drag preview under the users pointer
		 *
		 * - Avoids the drag preview quickly moving from a top corner to be centered under
		 *   the users pointer on iOS
		 * - It will be under the center on Android no matter what we do
		 *
		 * We previously had a isTouchDevice() check, but it felt safer for now
		 * to have a more targeted check, as these are the devices that have been
		 * tested on.
		 */ if ((0, $iFRCn.isSafariOnIOS)() || (0, $ic3Jg.isAndroid)()) return (0, $76xc7.centerUnderPointer)({
            container: container
        });
        Object.assign(container.style, {
            borderInlineStart: `${point.x} solid transparent`,
            borderTop: `${point.y} solid transparent`
        });
        // Unfortunate that we need to use `getComputedStyle`,
        // but it's only a single call when the drag is starting.
        const computed = window.getComputedStyle(container);
        if (computed.direction === 'rtl') {
            // The DOMRect will include the new border we added
            const box = container.getBoundingClientRect();
            // Use the top right corner (including the new border) as the offset.
            // The border will push the preview away from the pointer.
            return {
                x: box.width,
                y: 0
            };
        }
        // Use the top left corner as the offset. The border will
        // push the preview away from the pointer.
        return {
            x: 0,
            y: 0
        };
    };
}
module.exports["pointerOutsideOfPreview"] = $30069a8958953d8b$export$427e20518819fabc;

});

parcelRegister("iFRCn", function(module, exports) {

var $aYpzB = parcelRequire("aYpzB");


var $e880Z = parcelRequire("e880Z");

const $3720fb1a551ae595$export$52fc40c68fea4952 = (0, $aYpzB.once)(function isSafariOnIOS() {
    return (0, $e880Z.isSafari)() && 'ontouchend' in document;
});
module.exports["isSafariOnIOS"] = $3720fb1a551ae595$export$52fc40c68fea4952;

});

parcelRegister("76xc7", function(module, exports) {
const $54acc06d1c628398$export$81d8e72a15eef435 = function centerUnderPointer({ container: container }) {
    const rect = container.getBoundingClientRect();
    return {
        x: rect.width / 2,
        y: rect.height / 2
    };
};
module.exports["centerUnderPointer"] = $54acc06d1c628398$export$81d8e72a15eef435;

});

parcelRegister("foQ4a", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $19052bf55936e796$export$e581bd1f88227e0a = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isExternalCollaborator: accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS
    };
};
module.exports["useIsExternalCollaborator"] = $19052bf55936e796$export$e581bd1f88227e0a;

});

parcelRegister("lyF5K", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $f7B1p = parcelRequire("f7B1p");


var $ebwTS = parcelRequire("ebwTS");

const $14503a2aea2a4136$export$1ee9ed72ffc111c1 = [
    // If a guest has "direct access", they will simply upgrade to a user immediately upon submitting a request without needing admin approval.
    (0, $ebwTS.CapabilityValues).DIRECT_ACCESS,
    // ... otherwise, they have the ability to request access, and wait for admin approval.
    (0, $ebwTS.CapabilityValues).REQUEST_ACCESS
];
const $14503a2aea2a4136$export$3ed095546414dc67 = [
    // The ones a Guest should never get, but technically exist on the endpoint:
    (0, $ebwTS.CapabilityValues).ACCESS_EXISTS,
    (0, $ebwTS.CapabilityValues).APPROVED_REQUEST_EXISTS,
    // The ones we expect to potentially get:
    (0, $ebwTS.CapabilityValues).DENIED_REQUEST_EXISTS,
    (0, $ebwTS.CapabilityValues).FORBIDDEN
];
const $14503a2aea2a4136$export$4e4260b083de0708 = 'product/member';
const $14503a2aea2a4136$export$d3e4104c62036f39 = (skip = false)=>{
    // if skip is true, we are not going to fetch the status, so we're not loading anything and it can be false
    // if skip is false, we are going to fetch the status and invoke API immediately, so loading can be true (same as previous implementation)
    const [loading, setLoading] = (0, $42omo.useState)(!skip);
    const [error, setError] = (0, $42omo.useState)();
    const [upgradeStatus, setUpgradeStatus] = (0, $42omo.useState)(undefined);
    const [upgradeStatusReason, setUpgradeStatusReason] = (0, $42omo.useState)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const fetchGuestUpgradeRequestStatus = (0, $42omo.useCallback)(async ()=>{
        setLoading(true);
        const resource = `ari:cloud:confluence::site/${cloudId}`;
        const params = new URLSearchParams({
            resource: resource
        });
        return (0, $f7B1p.cfetch)(`/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        }).then((response)=>response.json()).then((data)=>{
            const statusArray = data.resultsV2[resource];
            const userCapabilityEntry = statusArray.find((entry)=>entry.role === $14503a2aea2a4136$export$4e4260b083de0708) || {};
            const status = userCapabilityEntry.accessMode;
            setUpgradeStatusReason(status);
            if ($14503a2aea2a4136$export$3ed095546414dc67.includes(status)) setUpgradeStatus((0, $ebwTS.UpgradeStatus).NOT_ELIGIBLE_TO_UPGRADE_AT_ALL);
            else if (status === (0, $ebwTS.CapabilityValues).PENDING_REQUEST_EXISTS) setUpgradeStatus((0, $ebwTS.UpgradeStatus).AN_UPGRADE_REQUEST_IS_PENDING);
            else if ($14503a2aea2a4136$export$1ee9ed72ffc111c1.includes(status)) setUpgradeStatus((0, $ebwTS.UpgradeStatus).CAN_REQUEST);
            else // We didn't get a valid value
            throw Error(`Did not receive a valid value for the accessMode status: ${status}.`);
        }).catch((caughtError)=>{
            // If anything fails, we just state you're not eligible, because we can't confirm it.
            setUpgradeStatus((0, $ebwTS.UpgradeStatus).NOT_ELIGIBLE_TO_UPGRADE_AT_ALL);
            setError(caughtError instanceof Error ? caughtError : new Error('Guest request to upgrade status load error', {
                cause: caughtError
            }));
        }).finally(()=>setLoading(false));
    }, [
        cloudId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (skip) return;
        fetchGuestUpgradeRequestStatus();
    }, [
        fetchGuestUpgradeRequestStatus,
        skip
    ]);
    return {
        upgradeStatus: upgradeStatus,
        upgradeStatusReason: upgradeStatusReason,
        loading: loading,
        error: error
    };
};
module.exports["useGuestRequestToUpgradeStatus"] = $14503a2aea2a4136$export$d3e4104c62036f39;

});

parcelRegister("ebwTS", function(module, exports) {
const $2f24b685c1e47a17$export$408edfc5a854220e = {
    ACCESS_EXISTS: 'ACCESS_EXISTS',
    DIRECT_ACCESS: 'DIRECT_ACCESS',
    APPROVED_REQUEST_EXISTS: 'APPROVED_REQUEST_EXISTS',
    DENIED_REQUEST_EXISTS: 'DENIED_REQUEST_EXISTS',
    FORBIDDEN: 'FORBIDDEN',
    PENDING_REQUEST_EXISTS: 'PENDING_REQUEST_EXISTS',
    REQUEST_ACCESS: 'REQUEST_ACCESS'
};
var $2f24b685c1e47a17$export$309264bca7eef03f = /*#__PURE__*/ function(UpgradeStatus) {
    UpgradeStatus["CAN_REQUEST"] = "CAN_REQUEST";
    UpgradeStatus["AN_UPGRADE_REQUEST_IS_PENDING"] = "AN_UPGRADE_REQUEST_IS_PENDING";
    UpgradeStatus["NOT_ELIGIBLE_TO_UPGRADE_AT_ALL"] = "NOT_ELIGIBLE_TO_UPGRADE_AT_ALL";
    return UpgradeStatus;
}({});
module.exports["CapabilityValues"] = $2f24b685c1e47a17$export$408edfc5a854220e;
module.exports["UpgradeStatus"] = $2f24b685c1e47a17$export$309264bca7eef03f;

});

parcelRegister("eh0mb", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $4708f874261747c2$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        requestAccessState: undefined
    },
    actions: {
        setRequestAccessState: (value)=>({ setState: setState })=>{
                setState({
                    requestAccessState: value
                });
            }
    },
    name: 'guestRequestUpgradeStore'
});
const $4708f874261747c2$export$b72090e4288882db = (0, $9zUhf.createHook)($4708f874261747c2$var$Store);
module.exports["useGuestRequestUpgradeStore"] = $4708f874261747c2$export$b72090e4288882db;

});

parcelRegister("e0SBo", function(module, exports) {
$parcel$export(module.exports, "default", () => $a33b6ba3d9a58f3b$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $a33b6ba3d9a58f3b$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dateToCompare = (0, $egXhZ.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("jJDs8", function(module, exports) {

var $fYKLM = parcelRequire("fYKLM");

// using a symbol so we can guarantee a key with a unique value
const $b7b680fbf5b4f84f$var$uniqueKey = Symbol('tree-item-instruction');
function $b7b680fbf5b4f84f$var$getCenter(rect) {
    return {
        x: (rect.right + rect.left) / 2,
        y: (rect.bottom + rect.top) / 2
    };
}
function $b7b680fbf5b4f84f$var$standardHitbox({ client: client, borderBox: borderBox }) {
    const quarterOfHeight = borderBox.height / 4;
    // In the top 1/4: reorder-above
    // On the line = in the top 1/4 to give this zone a bit more space
    if (client.y <= borderBox.top + quarterOfHeight) return 'reorder-above';
    // In the bottom 1/4: reorder-below
    // On the line = in the bottom 1/4 to give this zone a bit more space
    if (client.y >= borderBox.bottom - quarterOfHeight) return 'reorder-below';
    return 'make-child';
}
function $b7b680fbf5b4f84f$var$getInstruction({ element: element, input: input, currentLevel: currentLevel, indentPerLevel: indentPerLevel, mode: mode }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const borderBox = element.getBoundingClientRect();
    if (mode === 'standard') {
        const type = $b7b680fbf5b4f84f$var$standardHitbox({
            borderBox: borderBox,
            client: client
        });
        return {
            type: type,
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    const center = $b7b680fbf5b4f84f$var$getCenter(borderBox);
    if (mode === 'expanded') {
        // leveraging "standard" hitbox to ensure that the 'reorder-above' hit zone is
        // exactly the same for "standard" and "expanded" items
        const type = $b7b680fbf5b4f84f$var$standardHitbox({
            borderBox: borderBox,
            client: client
        });
        return {
            // Use the "standard" hitbox for "reorder above",
            // The rest of the item is "make-child"
            type: type === 'reorder-above' ? type : 'make-child',
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    // `mode` is "last-in-group"
    const visibleInset = indentPerLevel * currentLevel;
    // Before the left edge of the visible item
    if (client.x < borderBox.left + visibleInset) {
        // Above the center: `reorder-above`
        if (client.y < center.y) return {
            type: 'reorder-above',
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
        // On or below the center: `reparent`
        // On the center = `reparent` as we are giving a slightly bigger hitbox to this
        // action as it is the only place a user can do it
        const rawLevel = (client.x - borderBox.left) / indentPerLevel;
        // We can get sub pixel negative numbers as getBoundingClientRect gives sub-pixel accuracy,
        // where as clientX is rounded to the nearest pixel.
        // Using Math.max() ensures we can never get a negative level
        const desiredLevel = Math.max(Math.floor(rawLevel), 0);
        return {
            type: 'reparent',
            desiredLevel: desiredLevel,
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    // On the visible item
    return {
        type: $b7b680fbf5b4f84f$var$standardHitbox({
            borderBox: borderBox,
            client: client
        }),
        indentPerLevel: indentPerLevel,
        currentLevel: currentLevel
    };
}
function $b7b680fbf5b4f84f$var$areInstructionsEqual(a, b) {
    // Shortcut
    if (a.type !== b.type) return false;
    if (a.type === 'instruction-blocked' && b.type === 'instruction-blocked') return $b7b680fbf5b4f84f$var$areInstructionsEqual(a.desired, b.desired);
    return (0, $fYKLM.isShallowEqual)(a, b);
}
// Note: not using `memoize-one` as all we need is a cached value.
// We do not need to avoid executing an expensive function.
const $b7b680fbf5b4f84f$var$memoizeInstruction = (0, $fYKLM.stable)($b7b680fbf5b4f84f$var$areInstructionsEqual);
function $b7b680fbf5b4f84f$var$applyInstructionBlock({ desired: desired, block: block }) {
    if (block?.includes(desired.type) && desired.type !== 'instruction-blocked') {
        const blocked = {
            type: 'instruction-blocked',
            desired: desired
        };
        return blocked;
    }
    return desired;
}
function $b7b680fbf5b4f84f$export$267ad49d812c2c7f(userData, { block: block, ...rest }) {
    const desired = $b7b680fbf5b4f84f$var$getInstruction(rest);
    const withBlock = $b7b680fbf5b4f84f$var$applyInstructionBlock({
        desired: desired,
        block: block
    });
    const memoized = $b7b680fbf5b4f84f$var$memoizeInstruction(withBlock);
    return {
        ...userData,
        [$b7b680fbf5b4f84f$var$uniqueKey]: memoized
    };
}
function $b7b680fbf5b4f84f$export$c8ffecbe249dc8f8(userData) {
    return userData[$b7b680fbf5b4f84f$var$uniqueKey] ?? null;
}
module.exports["attachInstruction"] = $b7b680fbf5b4f84f$export$267ad49d812c2c7f;
module.exports["extractInstruction"] = $b7b680fbf5b4f84f$export$c8ffecbe249dc8f8;

});

parcelRegister("fYKLM", function(module, exports) {
function $440eac8f72738c8c$export$2225b4c39d37f8b3(a, b) {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    return aKeys.every((key)=>Object.is(a[key], b[key]));
}
function $440eac8f72738c8c$export$3f55479a3469259f(isEqual = $440eac8f72738c8c$export$2225b4c39d37f8b3) {
    let cache = null;
    return (value)=>{
        if (cache && isEqual(cache.value, value)) return cache.value;
        cache = {
            value: value
        };
        return cache.value;
    };
}
module.exports["isShallowEqual"] = $440eac8f72738c8c$export$2225b4c39d37f8b3;
module.exports["stable"] = $440eac8f72738c8c$export$3f55479a3469259f;

});

parcelRegister("ft7TS", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $aTio4 = parcelRequire("aTio4");


var $2n8po = parcelRequire("2n8po");

function $51f217e12c7a77e2$var$getElement({ instruction: instruction, isBlocked: isBlocked }) {
    const indent = `${instruction.currentLevel * instruction.indentPerLevel}px`;
    const appearance = isBlocked ? 'warning' : 'default';
    if (instruction.type === 'reorder-above') return /*#__PURE__*/ (0, $l998X.jsx)((0, $2n8po.DropIndicator), {
        edge: "top",
        appearance: appearance,
        indent: indent
    });
    if (instruction.type === 'reorder-below') return /*#__PURE__*/ (0, $l998X.jsx)((0, $2n8po.DropIndicator), {
        edge: "bottom",
        appearance: appearance,
        indent: indent
    });
    if (instruction.type === 'make-child') return /*#__PURE__*/ (0, $l998X.jsx)((0, $aTio4.DropIndicator), {
        appearance: appearance,
        indent: indent
    });
    if (instruction.type === 'reparent') {
        const reparentIndent = `${instruction.desiredLevel * instruction.indentPerLevel}px`;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $2n8po.DropIndicator), {
            edge: "bottom",
            appearance: appearance,
            indent: reparentIndent
        });
    }
    return null;
}
function $51f217e12c7a77e2$export$62ed72bc21f6b8a6({ instruction: instruction }) {
    if (instruction.type === 'instruction-blocked') return $51f217e12c7a77e2$var$getElement({
        instruction: instruction.desired,
        isBlocked: true
    });
    return $51f217e12c7a77e2$var$getElement({
        instruction: instruction,
        isBlocked: false
    });
}
module.exports["DropIndicator"] = $51f217e12c7a77e2$export$62ed72bc21f6b8a6;

});

parcelRegister("aTio4", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8Mgg9 = parcelRequire("8Mgg9");


var $9JSVA = parcelRequire("9JSVA");

function $f32cc2f93c269bf0$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', indent: indent }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8Mgg9.Border), {
        strokeColor: (0, $9JSVA.presetStrokeColors)[appearance],
        indent: indent
    });
}
var // For React.lazy
$f32cc2f93c269bf0$export$2e2bcd8739ae039 = $f32cc2f93c269bf0$export$62ed72bc21f6b8a6;
module.exports["DropIndicator"] = $f32cc2f93c269bf0$export$62ed72bc21f6b8a6;

});

parcelRegister("8Mgg9", function(module, exports) {
/* border.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9JSVA = parcelRequire("9JSVA");

const $e9c9b85493bf64c6$var$styles = null;
function $e9c9b85493bf64c6$export$d8e9c9d63e86d41e({ strokeColor: strokeColor = (0, $9JSVA.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $9JSVA.presetStrokeWidth), borderRadius: borderRadius = '3px', indent: // TODO: update to radius.small (4px) token
indent = '0px' }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            '--border-radius': borderRadius,
            '--indent': indent
        },
        className: (0, $gMc0m.default)([
            "_19it1ebc _2rko1koq _kqswstnw _152tidpf _u7coidpf _rjxpidpf _1e02armj _lcxvglyw"
        ])
    });
} // For React.lazy
var $e9c9b85493bf64c6$export$2e2bcd8739ae039 = $e9c9b85493bf64c6$export$d8e9c9d63e86d41e;
module.exports["Border"] = $e9c9b85493bf64c6$export$d8e9c9d63e86d41e;

});

parcelRegister("4yBJM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $898892faf0a0a598$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $898892faf0a0a598$export$2e2bcd8739ae039 = {
    'navigation.global-shortcuts.all-sites': 'All sites',
    'navigation.global-shortcuts.apps.align': 'Align',
    'navigation.global-shortcuts.apps.analytics': 'Analytics',
    'navigation.global-shortcuts.apps.assets': 'Assets',
    'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
    'navigation.global-shortcuts.apps.company-hub': 'Company Hub',
    'navigation.global-shortcuts.apps.compass': 'Compass',
    'navigation.global-shortcuts.apps.confluence': 'Confluence',
    'navigation.global-shortcuts.apps.focus': 'Focus',
    'navigation.global-shortcuts.apps.goals': 'Goals',
    'navigation.global-shortcuts.apps.home': 'Home',
    'navigation.global-shortcuts.apps.jira': 'Jira',
    'navigation.global-shortcuts.apps.jira-product-discovery': 'Jira Product Discovery',
    'navigation.global-shortcuts.apps.jira-service-management': 'Jira Service Management',
    'navigation.global-shortcuts.apps.loom': 'Loom',
    'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
    'navigation.global-shortcuts.apps.projects': 'Projects',
    'navigation.global-shortcuts.apps.projects-galaxia': 'Spaces',
    'navigation.global-shortcuts.apps.studio': 'Studio',
    'navigation.global-shortcuts.apps.talent': 'Talent',
    'navigation.global-shortcuts.apps.teams': 'Teams',
    'navigation.global-shortcuts.apps.trello': 'Trello',
    'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': 'Close',
    'navigation.global-shortcuts.menu-expand-item.site-aria-label': '{name} site',
    'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': '(currently unavailable)',
    'navigation.global-shortcuts.menu-link-item.link-external-item-label': 'Open external link icon',
    'navigation.global-shortcuts.menu-link-item.loading-item-aria-label': '(loading)',
    'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label': '(loading)',
    'navigation.global-shortcuts.shortcut-action.open-menu-label': 'open menu',
    'navigation.global-shortcuts.shortcut-link-item.aria-label': '{appName}{siteName}',
    'navigation.global-shortcuts.sites': '{productName} sites'
};

});

parcelRegister("Rk8D3", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $ecnYn = parcelRequire("ecnYn");

function $4fc8a07657df7a02$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4fc8a07657df7a02$var$baseStyles = {
    name: "1khn195",
    styles: "box-sizing:border-box"
};
const $4fc8a07657df7a02$var$blockBleedMap = {
    'space.025': {
        name: "9w2fxh",
        styles: "margin-block:var(--ds-space-negative-025, -0.125rem)"
    },
    'space.050': {
        name: "1qhe0y6",
        styles: "margin-block:var(--ds-space-negative-050, -0.25rem)"
    },
    'space.100': {
        name: "s0o2nz",
        styles: "margin-block:var(--ds-space-negative-100, -0.5rem)"
    },
    'space.150': {
        name: "151e4o3",
        styles: "margin-block:var(--ds-space-negative-150, -0.75rem)"
    },
    'space.200': {
        name: "16sn062",
        styles: "margin-block:var(--ds-space-negative-200, -1rem)"
    }
};
const $4fc8a07657df7a02$var$inlineBleedMap = {
    'space.025': {
        name: "16oxh68",
        styles: "margin-inline:var(--ds-space-negative-025, -0.125rem)"
    },
    'space.050': {
        name: "tdc6fz",
        styles: "margin-inline:var(--ds-space-negative-050, -0.25rem)"
    },
    'space.100': {
        name: "crujrn",
        styles: "margin-inline:var(--ds-space-negative-100, -0.5rem)"
    },
    'space.150': {
        name: "y28d58",
        styles: "margin-inline:var(--ds-space-negative-150, -0.75rem)"
    },
    'space.200': {
        name: "1vfkteg",
        styles: "margin-inline:var(--ds-space-negative-200, -1rem)"
    }
};
/**
 * __Bleed__
 *
 * `Bleed` is a primitive layout component that controls negative whitespace.
 *
 * - [Examples](https://atlassian.design/components/primitives/bleed/examples)
 * - [Code](https://atlassian.design/components/primitives/bleed/code)
 */ const $4fc8a07657df7a02$var$Bleed = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ children: children, testId: testId, inline: inline, block: block, all: all, xcss: xcss })=>{
    const resolvedStyles = (0, $ecnYn.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $4fc8a07657df7a02$var$baseStyles,
            (inline || all) && $4fc8a07657df7a02$var$inlineBleedMap[inline || all],
            (block || all) && $4fc8a07657df7a02$var$blockBleedMap[block || all],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId
    }, children);
});
$4fc8a07657df7a02$var$Bleed.displayName = 'Bleed';
var $4fc8a07657df7a02$export$2e2bcd8739ae039 = $4fc8a07657df7a02$var$Bleed;
module.exports["default"] = $4fc8a07657df7a02$export$2e2bcd8739ae039;

});

parcelRegister("aDe4X", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $922yL = parcelRequire("922yL");

var $e0SBo = parcelRequire("e0SBo");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $ivb8S = parcelRequire("ivb8S");


var $b4VFP = parcelRequire("b4VFP");

var $dBcar = parcelRequire("dBcar");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $2FNNv = parcelRequire("2FNNv");


var $30D0J = parcelRequire("30D0J");

const $d12c0291e106b88f$var$HOME_ONBOARDING_TAKEOVER_NTH_USER_DAYS = 14;
const $d12c0291e106b88f$export$de7bc1ba49cd35c5 = ()=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { accessStatus: accessStatus, userId: userId } = (0, $bQm3c.useSessionData)();
    const isEstablishedUserTraitName = (0, $2FNNv.useIsEstablishedUserTraitName)();
    // User is licensed (site admin or nth user)
    const hasAdminOrUseAccess = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    (0, $42omo.useEffect)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.ONBOARDING_NTH_USER_HOME_ONBOARDING_TAKEOVER)
        });
    }, [
        experienceTracker
    ]);
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN,
        ...Object.values((0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS))
    ], !hasAdminOrUseAccess);
    const { isFoundingAdmin: isFoundingAdmin, takeoverSeenAt: takeoverSeenAt } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const takeoverExpired = Boolean(takeoverSeenAt) && (0, $e0SBo.default)(Date.now(), (0, $922yL.default)(new Date(takeoverSeenAt), $d12c0291e106b88f$var$HOME_ONBOARDING_TAKEOVER_NTH_USER_DAYS));
    const { data: userPersonalizationQueryData, loading: userPersonalizationQueryLoading, error: userPersonalizationQueryError } = (0, $30D0J.useExperimentalUserPersonalizationQuery)({
        skip: !hasAdminOrUseAccess || takeoverExpired,
        variables: {
            userId: userId
        }
    });
    const attributes = userPersonalizationQueryData?.experimentalUserPersonalization?.attributes ?? [];
    const isEstablishedUser = attributes.find((attr)=>attr?.name === isEstablishedUserTraitName)?.value === 'true';
    const isEstablishedUserReady = !userPersonalizationQueryLoading && !userPersonalizationQueryError;
    const isNotEstablishedUser = isEstablishedUserReady && !isEstablishedUser;
    const isEligible = Boolean(hasAdminOrUseAccess && (takeoverSeenAt ?? isNotEstablishedUser) && !isFoundingAdmin);
    if (onboardingStateError || userPersonalizationQueryError) experienceTracker.stopOnError({
        name: (0, $irVI7.ONBOARDING_NTH_USER_HOME_ONBOARDING_TAKEOVER),
        error: onboardingStateError || userPersonalizationQueryError
    });
    return {
        isEligible: isEligible,
        isVisible: isEligible && !takeoverExpired,
        loading: onboardingStateLoading || userPersonalizationQueryLoading
    };
};
module.exports["useNthUserHomeOnboardingTakeoverV2Eligibility"] = $d12c0291e106b88f$export$de7bc1ba49cd35c5;

});

parcelRegister("8BHAT", function(module, exports) {
/** @graphql agg **/ 
var $eSUdr = parcelRequire("eSUdr");

const $87679b46728de696$export$a62e7697f515af4e = (0, $eSUdr.default)`query RecentContentMenuQuery($cloudId:ID!$first:Int$after:String$eventTypes:[String!]$objectTypes:[String!]){activity{myActivity{all(filter:{type:AND rootContainerIds:[$cloudId]arguments:{products:["CONFLUENCE"]objectTypes:$objectTypes eventTypes:$eventTypes}}first:$first after:$after){edges{cursor node{id object{id data{...on ConfluencePage{id title type subtype pageStatus:status createdAt links{webUi editUi}viewer{favoritedSummary{isFavorite}}space{id alias key name}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}...on ConfluenceBlogPost{id title type blogStatus:status createdAt links{webUi editUi}viewer{favoritedSummary{isFavorite}}space{id alias key name}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}...on ConfluenceWhiteboard{id title type status links{webUi}viewer{favoritedSummary{isFavorite}}space{id alias key name}}...on ConfluenceDatabase{id title type status links{webUi}viewer{favoritedSummary{isFavorite}}space{id alias key name}}...on ConfluenceEmbed{id title type status links{webUi}viewer{favoritedSummary{isFavorite}}space{id alias key name}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}...on ConfluenceInlineComment{id commentId container{...on ConfluencePage{id title type subtype pageStatus:status createdAt links{webUi editUi}viewer{favoritedSummary{isFavorite}}space{id alias key name}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}...on ConfluenceBlogPost{id title type blogStatus:status createdAt links{webUi editUi}viewer{favoritedSummary{isFavorite}}space{id alias key name}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}...on ConfluenceWhiteboard{id title type status links{webUi}viewer{favoritedSummary{isFavorite}}space{id alias key name}}}}...on ConfluenceFooterComment{id commentId container{...on ConfluencePage{id title type subtype pageStatus:status createdAt links{webUi editUi}viewer{favoritedSummary{isFavorite}}space{id alias key name}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}...on ConfluenceBlogPost{id title type blogStatus:status createdAt links{webUi editUi}viewer{favoritedSummary{isFavorite}}space{id alias key name}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}}...on ConfluenceWhiteboard{id title type status links{webUi}viewer{favoritedSummary{isFavorite}}space{id alias key name}}}}}}event{id timestamp eventType}}}pageInfo{hasNextPage endCursor}}}}}`;
const $87679b46728de696$export$edfbeed0a6e5a970 = (0, $eSUdr.default)`query RecentlyCreatedByMeQuery($cql:String!$cqlcontext:String!$first:Int$after:String){search:confluence_search(cql:$cql cqlcontext:$cqlcontext first:$first after:$after){nodes{url content{id type subType title status space{id name}links{webui editui}metadata{currentuser{favourited{isFavourite favouritedDate}lastcontributed{status when}}}emoji:properties(keys:["emoji-title-published" "emoji-title-draft"]){nodes{id key value}}space{alias}}}pageInfo{hasNextPage endCursor}}}`;
module.exports["RecentContentMenuQuery"] = $87679b46728de696$export$a62e7697f515af4e;
module.exports["RecentlyCreatedByMeQuery"] = $87679b46728de696$export$edfbeed0a6e5a970;

});

parcelRegister("gSytF", function(module, exports) {
/**
 * @generated SignedSource<<c3487394d0e64b7f098c1e605be3986c>>
 * @relayHash 0913aa0e7f577fc63dfd041de0b5136e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ae0bd328ec8252dd2e2f88475c08a5447b0ace0d9051443e47deaca0e2dcd468
const $5baefebdfa73b4d2$var$node = function() {
    var v0 = [
        {
            "defaultValue": 30,
            "kind": "LocalArgument",
            "name": "limit"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "start"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "status"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "limit",
                    "variableName": "limit"
                },
                {
                    "kind": "Variable",
                    "name": "start",
                    "variableName": "start"
                }
            ],
            "concreteType": "PaginatedContentList",
            "kind": "LinkedField",
            "name": "favoriteContent",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        v2 /*: any*/ ,
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        },
                        {
                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "editui"
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                    "kind": "LinkedField",
                                    "name": "currentuser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "FavouritedSummary",
                                            "kind": "LinkedField",
                                            "name": "favourited",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "favouritedDate"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "ContributionStatusSummary",
                                            "kind": "LinkedField",
                                            "name": "lastcontributed",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "when"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "emoji",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "emoji-title-published",
                                        "emoji-title-draft"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"])"
                        }
                    ]
                },
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        }
                    ]
                },
                {
                    "concreteType": "ContentEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "cursor"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "StarredContentMenuQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "StarredContentMenuQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "0913aa0e7f577fc63dfd041de0b5136e",
            "id": "ae0bd328ec8252dd2e2f88475c08a5447b0ace0d9051443e47deaca0e2dcd468",
            "metadata": {},
            "name": "StarredContentMenuQuery",
            "operationKind": "query",
            "text": "query StarredContentMenuQuery($limit:Int=30,$start:Int!){favoriteContent(limit:$limit,start:$start){nodes{id,type,subType,title,status,space{id,name},links{webui,editui},metadata{currentuser{favourited{isFavourite,favouritedDate},lastcontributed{status,when}}},emoji:properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"]){nodes{id,key,value}}},pageInfo{hasNextPage},edges{cursor}}}"
        }
    };
}();
$5baefebdfa73b4d2$var$node.hash = "d919f41ac18e2cfc51a95f7043552fc1";
var $5baefebdfa73b4d2$export$2e2bcd8739ae039 = $5baefebdfa73b4d2$var$node;
module.exports["default"] = $5baefebdfa73b4d2$export$2e2bcd8739ae039;

});


//# sourceMappingURL=GlobalNavigationComponent.633042ee.js.map
